(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2169"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2169"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4tSb9", function(module, exports) {

$parcel$export(module.exports, "__decorate", function () { return $3433e5a3eb89c040$export$29e00dfd3077644b; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $3433e5a3eb89c040$var$extendStatics = function(d, b) {
    $3433e5a3eb89c040$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3433e5a3eb89c040$var$extendStatics(d, b);
};
function $3433e5a3eb89c040$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3433e5a3eb89c040$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3433e5a3eb89c040$export$18ce0697a983be9b = function() {
    $3433e5a3eb89c040$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3433e5a3eb89c040$export$18ce0697a983be9b.apply(this, arguments);
};
function $3433e5a3eb89c040$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3433e5a3eb89c040$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3433e5a3eb89c040$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3433e5a3eb89c040$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3433e5a3eb89c040$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3433e5a3eb89c040$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $3433e5a3eb89c040$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3433e5a3eb89c040$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3433e5a3eb89c040$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3433e5a3eb89c040$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3433e5a3eb89c040$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3433e5a3eb89c040$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3433e5a3eb89c040$export$45d3717a4c69092e(o, m, p);
}
function $3433e5a3eb89c040$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3433e5a3eb89c040$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3433e5a3eb89c040$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3433e5a3eb89c040$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3433e5a3eb89c040$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3433e5a3eb89c040$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3433e5a3eb89c040$export$10c90e4f7922046c(v) {
    return this instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? (this.v = v, this) : new $3433e5a3eb89c040$export$10c90e4f7922046c(v);
}
function $3433e5a3eb89c040$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3433e5a3eb89c040$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3433e5a3eb89c040$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3433e5a3eb89c040$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3433e5a3eb89c040$export$19a8beecd37a4c45 === "function" ? $3433e5a3eb89c040$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3433e5a3eb89c040$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3433e5a3eb89c040$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3433e5a3eb89c040$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3433e5a3eb89c040$export$45d3717a4c69092e(result, mod, k);
    }
    $3433e5a3eb89c040$var$__setModuleDefault(result, mod);
    return result;
}
function $3433e5a3eb89c040$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3433e5a3eb89c040$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3433e5a3eb89c040$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3433e5a3eb89c040$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3433e5a3eb89c040$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3433e5a3eb89c040$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3433e5a3eb89c040$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3433e5a3eb89c040$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $3433e5a3eb89c040$export$2e2bcd8739ae039 = {
    __extends: $3433e5a3eb89c040$export$a8ba968b8961cb8a,
    __assign: $3433e5a3eb89c040$export$18ce0697a983be9b,
    __rest: $3433e5a3eb89c040$export$3c9a16f847548506,
    __decorate: $3433e5a3eb89c040$export$29e00dfd3077644b,
    __param: $3433e5a3eb89c040$export$d5ad3fd78186038f,
    __metadata: $3433e5a3eb89c040$export$f1db080c865becb9,
    __awaiter: $3433e5a3eb89c040$export$1050f835b63b671e,
    __generator: $3433e5a3eb89c040$export$67ebef60e6f28a6,
    __createBinding: $3433e5a3eb89c040$export$45d3717a4c69092e,
    __exportStar: $3433e5a3eb89c040$export$f33643c0debef087,
    __values: $3433e5a3eb89c040$export$19a8beecd37a4c45,
    __read: $3433e5a3eb89c040$export$8d051b38c9118094,
    __spread: $3433e5a3eb89c040$export$afc72e2116322959,
    __spreadArrays: $3433e5a3eb89c040$export$6388937ca91ccae8,
    __spreadArray: $3433e5a3eb89c040$export$1216008129fb82ed,
    __await: $3433e5a3eb89c040$export$10c90e4f7922046c,
    __asyncGenerator: $3433e5a3eb89c040$export$e427f37a30a4de9b,
    __asyncDelegator: $3433e5a3eb89c040$export$bbd80228419bb833,
    __asyncValues: $3433e5a3eb89c040$export$e3b29a3d6162315f,
    __makeTemplateObject: $3433e5a3eb89c040$export$4fb47efe1390b86f,
    __importStar: $3433e5a3eb89c040$export$c21735bcef00d192,
    __importDefault: $3433e5a3eb89c040$export$da59b14a69baef04,
    __classPrivateFieldGet: $3433e5a3eb89c040$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3433e5a3eb89c040$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3433e5a3eb89c040$export$81fdc39f203e4e04,
    __addDisposableResource: $3433e5a3eb89c040$export$88ac25d8e944e405,
    __disposeResources: $3433e5a3eb89c040$export$8f076105dc360e92
};

});

parcelRegister("1mUAS", function(module, exports) {
$parcel$export(module.exports, "App", function () { return (parcelRequire("aHFKf")).App; });
$parcel$export(module.exports, "Component", function () { return (parcelRequire("aHFKf")).Component; });
$parcel$export(module.exports, "Layout", function () { return (parcelRequire("aHFKf")).Layout; });
$parcel$export(module.exports, "Page", function () { return (parcelRequire("aHFKf")).Page; });
$parcel$export(module.exports, "registerGlobalHook", function () { return (parcelRequire("3bQrU")).registerGlobalHook; });
$parcel$export(module.exports, "stylingWithBases", function () { return (parcelRequire("3bQrU")).stylingWithBases; });
$parcel$export(module.exports, "ComponentTypes", function () { return (parcelRequire("crJS3")).ComponentTypes; });
$parcel$export(module.exports, "GLOBAL_TINI", function () { return (parcelRequire("crJS3")).GLOBAL_TINI; });
$parcel$export(module.exports, "LifecycleHooks", function () { return (parcelRequire("crJS3")).LifecycleHooks; });
$parcel$export(module.exports, "TINI_APP_CONTEXT", function () { return (parcelRequire("crJS3")).TINI_APP_CONTEXT; });
$parcel$export(module.exports, "Output", function () { return (parcelRequire("ecjBI")).Output; });
$parcel$export(module.exports, "Input", function () { return (parcelRequire("2qQ1O")).Input; });
$parcel$export(module.exports, "Reactive", function () { return (parcelRequire("2qQ1O")).Reactive; });
$parcel$export(module.exports, "TiniComponent", function () { return (parcelRequire("2qQ1O")).TiniComponent; });
parcelRequire("aHFKf");
parcelRequire("7a15g");
parcelRequire("3bQrU");
parcelRequire("crJS3");
parcelRequire("iC587");
parcelRequire("ecjBI");
parcelRequire("emnHY");
parcelRequire("2qQ1O");

});
parcelRegister("aHFKf", function(module, exports) {

$parcel$export(module.exports, "App", function () { return $7cae4d375a6b63fc$export$86fbec116b87613f; });
$parcel$export(module.exports, "Component", function () { return $7cae4d375a6b63fc$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "Page", function () { return $7cae4d375a6b63fc$export$6955bcca4cd3539f; });
$parcel$export(module.exports, "Layout", function () { return $7cae4d375a6b63fc$export$c84671f46d6a1ca; });
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
parcelRequire("4MDiX");
var $9GF5G = parcelRequire("9GF5G");
parcelRequire("bsGWa");
var $gKqnD = parcelRequire("gKqnD");
var $2tid7 = parcelRequire("2tid7");

var $crJS3 = parcelRequire("crJS3");

var $3bQrU = parcelRequire("3bQrU");
parcelRequire("iiFM1");
var $7cae4d375a6b63fc$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
function $7cae4d375a6b63fc$export$86fbec116b87613f(options = {}) {
    return function(target) {
        var _a;
        var _b;
        // set app options
        (0, $crJS3.TINI_APP_CONTEXT).options = options;
        // ui options
        if (options.uiOptions) (0, $gKqnD.setUIOptions)(options.uiOptions);
        // register the exit of the app splashscreen
        if (options.splashscreen) (0, $3bQrU.registerGlobalHook)((0, $crJS3.ComponentTypes).Page, (0, $crJS3.LifecycleHooks).OnChildrenReady, ({ appContext: appContext })=>{
            var _a;
            if (((_a = appContext.options) === null || _a === void 0 ? void 0 : _a.splashscreen) !== "auto") return;
            (0, $3bQrU.hideSplashscreen)();
        });
        // dependencies management
        const dependencyRegistry = (0, $3bQrU.getDIRegistry)();
        const providers = options.providers || {};
        const providerIds = Object.keys(providers);
        for(let i = 0; i < providerIds.length; i++){
            const id = providerIds[i];
            const value = providers[id];
            // extract the provider and deps
            const { provider: provider, deps: deps } = !(value === null || value === void 0 ? void 0 : value.provider) ? {
                provider: value,
                deps: []
            } : value;
            // the register
            let theRegister = dependencyRegistry.registers.get(id);
            if (theRegister) return; // already registered
            theRegister = async ()=>{
                let result = dependencyRegistry.instances.get(id);
                // already initialized
                if (result) return;
                // resolve deps
                const depInstances = [];
                if (deps === null || deps === void 0 ? void 0 : deps.length) for(let j = 0; j < deps.length; j++){
                    const depId = deps[j];
                    let depInstance = dependencyRegistry.instances.get(depId);
                    if (!depInstance) {
                        const theDepRegister = dependencyRegistry.registers.get(depId);
                        if (!theDepRegister) throw (0, $crJS3.NO_REGISTER_ERROR)(depId);
                        depInstance = await theDepRegister();
                    }
                    depInstances.push(depInstance);
                }
                // result
                const m = await provider();
                const dependency = !m.default ? m : m.default;
                result = !(0, $3bQrU.isClass)(dependency) ? dependency : new dependency(...depInstances);
                // </DEVELOPMENT>
                return dependencyRegistry.instances.set(id, result).get(id);
            };
            dependencyRegistry.registers.set(id, theRegister).get(id);
        }
        // digest the await queue
        if ((_a = dependencyRegistry.awaiters) === null || _a === void 0 ? void 0 : _a.length) for(let i = 0; i < dependencyRegistry.awaiters.length; i++)dependencyRegistry.awaiters[i]();
        // target modifications
        const result = (_b = class extends target {
            constructor(...args){
                super(...args);
                // set the app & register components
                (0, $crJS3.GLOBAL_TINI).app = this;
                if (options.components) (0, $gKqnD.registerComponents)(options.components);
            }
        }, $7cae4d375a6b63fc$var$__setFunctionName(_b, "result"), _b.componentType = (0, $crJS3.ComponentTypes).App, _b);
        // forward the target
        return (0, $9GF5G.customElement)((0, $crJS3.APP_ROOT))(result);
    };
}
function $7cae4d375a6b63fc$export$16fa2f45be04daa8(options = {}) {
    return function(target) {
        var _a;
        // target modifications
        const result = (_a = class extends target {
            constructor(){
                super(...arguments);
                this.activeTheme = (0, $gKqnD.getTheme)();
                this.onThemeChange = (e)=>{
                    this.activeTheme = e.detail;
                    this.customAdoptStyles(this.shadowRoot || this);
                    this.customAdoptScripts();
                };
            }
            createRenderRoot() {
                var _b;
                const renderRoot = (_b = this.shadowRoot) !== null && _b !== void 0 ? _b : this.attachShadow(this.constructor.shadowRootOptions);
                this.customAdoptStyles(renderRoot);
                return renderRoot;
            }
            connectedCallback() {
                if (options.components) (0, $gKqnD.registerComponents)(options.components);
                super.connectedCallback();
                addEventListener((0, $2tid7.THEME_CHANGE_EVENT), this.onThemeChange);
            }
            disconnectedCallback() {
                super.disconnectedCallback();
                removeEventListener((0, $2tid7.THEME_CHANGE_EVENT), this.onThemeChange);
            }
            updated(changedProperties) {
                super.updated(changedProperties);
                this.customAdoptScripts();
            }
            customAdoptStyles(renderRoot) {
                var _b;
                const allStyles = [];
                // theme styles
                const styling = (_b = options.theming) === null || _b === void 0 ? void 0 : _b.styling;
                if (styling) {
                    const { soulId: soulId, themeId: themeId } = this.activeTheme;
                    allStyles.push(...styling[themeId] || styling[soulId] || Object.values(styling)[0] || []);
                }
                // element styles
                allStyles.push(...this.constructor.elementStyles);
                // adopt styles
                const styleText = (0, $gKqnD.processComponentStyles)(allStyles, this.activeTheme);
                (0, $cZ4os.adoptStyles)(renderRoot, [
                    (0, $cZ4os.getCompatibleStyle)((0, $cZ4os.unsafeCSS)(styleText))
                ]);
            }
            customAdoptScripts() {
                var _b;
                (0, $gKqnD.adoptScripts)(this, this.activeTheme, (_b = options.theming) === null || _b === void 0 ? void 0 : _b.scripting);
            }
        }, $7cae4d375a6b63fc$var$__setFunctionName(_a, "result"), _a.componentType = options.type || (0, $crJS3.ComponentTypes).Component, _a);
        // return or forward the target
        return !options.name ? result : (0, $9GF5G.customElement)(options.name)(result);
    };
}
function $7cae4d375a6b63fc$export$6955bcca4cd3539f(options) {
    return $7cae4d375a6b63fc$export$16fa2f45be04daa8({
        ...options,
        type: (0, $crJS3.ComponentTypes).Page
    });
}
function $7cae4d375a6b63fc$export$c84671f46d6a1ca(options) {
    return $7cae4d375a6b63fc$export$16fa2f45be04daa8({
        ...options,
        type: (0, $crJS3.ComponentTypes).Layout
    });
}
function $7cae4d375a6b63fc$export$117a1c764cae0d93(id) {
    return function(prototype, propertyName) {
        const depId = id || propertyName;
        const dependencyRegistry = (0, $3bQrU.getDIRegistry)();
        // the pending
        const pending = async ()=>{
            let result = dependencyRegistry.instances.get(depId);
            if (!result) {
                const register = dependencyRegistry.registers.get(depId);
                if (!register) throw (0, $crJS3.NO_REGISTER_ERROR)(depId);
                result = dependencyRegistry.instances.set(depId, await register()).get(depId);
            }
            return result;
        };
        // queue the dependencies
        const theRegister = dependencyRegistry.registers.get(depId);
        prototype.pendingDependencies || (prototype.pendingDependencies = []);
        if (!theRegister) {
            let resolveSchedule = ()=>{};
            const scheduledPending = new Promise((resolve)=>resolveSchedule = resolve);
            dependencyRegistry.awaiters.push(()=>resolveSchedule());
            prototype.pendingDependencies.push(()=>scheduledPending.then(()=>pending()));
        } else prototype.pendingDependencies.push(pending);
        // result
        Object.defineProperty(prototype, propertyName, {
            get: ()=>dependencyRegistry.instances.get(depId)
        });
    };
}
function $7cae4d375a6b63fc$export$9787dd2503888628(id) {
    return $7cae4d375a6b63fc$export$117a1c764cae0d93(id);
}
function $7cae4d375a6b63fc$export$6cef6d799223095b() {
    return function(prototype, propertyName) {
        Object.defineProperty(prototype, propertyName, {
            get: ()=>(0, $3bQrU.getContext)()
        });
    };
}
function $7cae4d375a6b63fc$export$e52557a220944d6() {
    return function(prototype, propertyName) {
        Object.defineProperty(prototype, propertyName, {
            get: ()=>(0, $3bQrU.getApp)()
        });
    };
}
function $7cae4d375a6b63fc$export$deea861ed756eda4() {
    return function(prototype, propertyName) {
        Object.defineProperty(prototype, propertyName, {
            get: ()=>(0, $3bQrU.getOptions)()
        });
    };
}
function $7cae4d375a6b63fc$export$c2197ddc0df9325d() {
    return function(prototype, propertyName) {
        Object.defineProperty(prototype, propertyName, {
            get: ()=>(0, $3bQrU.getConfigs)()
        });
    };
}
function $7cae4d375a6b63fc$export$5b824fee637e786b() {
    return function(prototype, propertyName) {
        Object.defineProperty(prototype, propertyName, {
            get: ()=>(0, $3bQrU.getSplashscreen)()
        });
    };
}

});
parcelRegister("lYoPT", function(module, exports) {
$parcel$export(module.exports, "adoptStyles", function () { return (parcelRequire("cZ4os")).adoptStyles; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("cZ4os")).css; });
$parcel$export(module.exports, "getCompatibleStyle", function () { return (parcelRequire("cZ4os")).getCompatibleStyle; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("fXA0k")).html; });
$parcel$export(module.exports, "LitElement", function () { return (parcelRequire("kXi80")).LitElement; });
$parcel$export(module.exports, "noChange", function () { return (parcelRequire("fXA0k")).noChange; });
$parcel$export(module.exports, "nothing", function () { return (parcelRequire("fXA0k")).nothing; });
$parcel$export(module.exports, "render", function () { return (parcelRequire("fXA0k")).render; });
$parcel$export(module.exports, "unsafeCSS", function () { return (parcelRequire("cZ4os")).unsafeCSS; });
parcelRequire("043af");
parcelRequire("fXA0k");
parcelRequire("kXi80");
parcelRequire("aw8zL");

});
parcelRegister("043af", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", function () { return $00c2d4318f6cb663$export$7312b35fbf521afb; });
$parcel$export(module.exports, "notEqual", function () { return $00c2d4318f6cb663$export$53a6892c50694894; });
$parcel$export(module.exports, "ReactiveElement", function () { return $00c2d4318f6cb663$export$c7c07a37856565d; });
$parcel$export(module.exports, "adoptStyles", function () { return (parcelRequire("cZ4os")).adoptStyles; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("cZ4os")).css; });
$parcel$export(module.exports, "getCompatibleStyle", function () { return (parcelRequire("cZ4os")).getCompatibleStyle; });
$parcel$export(module.exports, "unsafeCSS", function () { return (parcelRequire("cZ4os")).unsafeCSS; });

var $cZ4os = parcelRequire("cZ4os");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $00c2d4318f6cb663$var$i, defineProperty: $00c2d4318f6cb663$var$e, getOwnPropertyDescriptor: $00c2d4318f6cb663$var$r, getOwnPropertyNames: $00c2d4318f6cb663$var$h, getOwnPropertySymbols: $00c2d4318f6cb663$var$o, getPrototypeOf: $00c2d4318f6cb663$var$n } = Object, $00c2d4318f6cb663$var$a = globalThis, $00c2d4318f6cb663$var$c = $00c2d4318f6cb663$var$a.trustedTypes, $00c2d4318f6cb663$var$l = $00c2d4318f6cb663$var$c ? $00c2d4318f6cb663$var$c.emptyScript : "", $00c2d4318f6cb663$var$p = $00c2d4318f6cb663$var$a.reactiveElementPolyfillSupport, $00c2d4318f6cb663$var$d = (t, s)=>t, $00c2d4318f6cb663$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $00c2d4318f6cb663$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $00c2d4318f6cb663$export$53a6892c50694894 = (t, s)=>!$00c2d4318f6cb663$var$i(t, s), $00c2d4318f6cb663$var$y = {
    attribute: !0,
    type: String,
    converter: $00c2d4318f6cb663$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $00c2d4318f6cb663$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $00c2d4318f6cb663$var$a.litPropertyMetadata ??= new WeakMap;
class $00c2d4318f6cb663$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $00c2d4318f6cb663$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $00c2d4318f6cb663$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $00c2d4318f6cb663$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $00c2d4318f6cb663$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($00c2d4318f6cb663$var$d("elementProperties"))) return;
        const t = $00c2d4318f6cb663$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($00c2d4318f6cb663$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($00c2d4318f6cb663$var$d("properties"))) {
            const t = this.properties, s = [
                ...$00c2d4318f6cb663$var$h(t),
                ...$00c2d4318f6cb663$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $cZ4os.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, $cZ4os.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$Eg = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$ES(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$E_ ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$E_?.delete(t);
    }
    _$ES() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $cZ4os.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$E_?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$E_?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EO(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $00c2d4318f6cb663$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $00c2d4318f6cb663$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i, e = !1, r) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $00c2d4318f6cb663$export$53a6892c50694894)(e ? r : this[t], s)) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$Eg = this._$EP());
    }
    C(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$Eg;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.C(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$E_?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$ET();
        } catch (s) {
            throw t = !1, this._$ET(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$E_?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$ET() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$Eg;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EO(t, this[t])), this._$ET();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$00c2d4318f6cb663$export$c7c07a37856565d.elementStyles = [], $00c2d4318f6cb663$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $00c2d4318f6cb663$export$c7c07a37856565d[$00c2d4318f6cb663$var$d("elementProperties")] = new Map, $00c2d4318f6cb663$export$c7c07a37856565d[$00c2d4318f6cb663$var$d("finalized")] = new Map, $00c2d4318f6cb663$var$p?.({
    ReactiveElement: $00c2d4318f6cb663$export$c7c07a37856565d
}), ($00c2d4318f6cb663$var$a.reactiveElementVersions ??= []).push("2.0.2");

});
parcelRegister("cZ4os", function(module, exports) {

$parcel$export(module.exports, "unsafeCSS", function () { return $973e96fafe50735b$export$8d80f9cac07cdb3; });
$parcel$export(module.exports, "css", function () { return $973e96fafe50735b$export$dbf350e5966cf602; });
$parcel$export(module.exports, "adoptStyles", function () { return $973e96fafe50735b$export$2ca4a66ec4cecb90; });
$parcel$export(module.exports, "getCompatibleStyle", function () { return $973e96fafe50735b$export$ee69dfd951e24778; });
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $973e96fafe50735b$var$t = globalThis, $973e96fafe50735b$export$b4d10f6001c083c2 = $973e96fafe50735b$var$t.ShadowRoot && (void 0 === $973e96fafe50735b$var$t.ShadyCSS || $973e96fafe50735b$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $973e96fafe50735b$var$s = Symbol(), $973e96fafe50735b$var$o = new WeakMap;
class $973e96fafe50735b$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $973e96fafe50735b$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($973e96fafe50735b$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $973e96fafe50735b$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $973e96fafe50735b$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $973e96fafe50735b$export$8d80f9cac07cdb3 = (t)=>new $973e96fafe50735b$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $973e96fafe50735b$var$s), $973e96fafe50735b$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $973e96fafe50735b$export$505d1e8739bad805(o, t, $973e96fafe50735b$var$s);
}, $973e96fafe50735b$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($973e96fafe50735b$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $973e96fafe50735b$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $973e96fafe50735b$export$ee69dfd951e24778 = $973e96fafe50735b$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $973e96fafe50735b$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("fXA0k", function(module, exports) {

$parcel$export(module.exports, "html", function () { return $b9e84b64b17bc73d$export$c0bb0b647f701bb5; });
$parcel$export(module.exports, "svg", function () { return $b9e84b64b17bc73d$export$7ed1367e7fa1ad68; });
$parcel$export(module.exports, "noChange", function () { return $b9e84b64b17bc73d$export$9c068ae9cc5db4e8; });
$parcel$export(module.exports, "nothing", function () { return $b9e84b64b17bc73d$export$45b790e32b2810ee; });
$parcel$export(module.exports, "_$LH", function () { return $b9e84b64b17bc73d$export$8613d1ca9052b22e; });
$parcel$export(module.exports, "render", function () { return $b9e84b64b17bc73d$export$b3890eb0ae9dca99; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b9e84b64b17bc73d$var$t = globalThis, $b9e84b64b17bc73d$var$i = $b9e84b64b17bc73d$var$t.trustedTypes, $b9e84b64b17bc73d$var$s = $b9e84b64b17bc73d$var$i ? $b9e84b64b17bc73d$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $b9e84b64b17bc73d$var$e = "$lit$", $b9e84b64b17bc73d$var$h = `lit$${(Math.random() + "").slice(9)}$`, $b9e84b64b17bc73d$var$o = "?" + $b9e84b64b17bc73d$var$h, $b9e84b64b17bc73d$var$n = `<${$b9e84b64b17bc73d$var$o}>`, $b9e84b64b17bc73d$var$r = document, $b9e84b64b17bc73d$var$l = ()=>$b9e84b64b17bc73d$var$r.createComment(""), $b9e84b64b17bc73d$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $b9e84b64b17bc73d$var$a = Array.isArray, $b9e84b64b17bc73d$var$u = (t)=>$b9e84b64b17bc73d$var$a(t) || "function" == typeof t?.[Symbol.iterator], $b9e84b64b17bc73d$var$d = "[ 	\n\f\r]", $b9e84b64b17bc73d$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $b9e84b64b17bc73d$var$v = /-->/g, $b9e84b64b17bc73d$var$_ = />/g, $b9e84b64b17bc73d$var$m = RegExp(`>|${$b9e84b64b17bc73d$var$d}(?:([^\\s"'>=/]+)(${$b9e84b64b17bc73d$var$d}*=${$b9e84b64b17bc73d$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $b9e84b64b17bc73d$var$p = /'/g, $b9e84b64b17bc73d$var$g = /"/g, $b9e84b64b17bc73d$var$$ = /^(?:script|style|textarea|title)$/i, $b9e84b64b17bc73d$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $b9e84b64b17bc73d$export$c0bb0b647f701bb5 = $b9e84b64b17bc73d$var$y(1), $b9e84b64b17bc73d$export$7ed1367e7fa1ad68 = $b9e84b64b17bc73d$var$y(2), $b9e84b64b17bc73d$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $b9e84b64b17bc73d$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $b9e84b64b17bc73d$var$A = new WeakMap, $b9e84b64b17bc73d$var$E = $b9e84b64b17bc73d$var$r.createTreeWalker($b9e84b64b17bc73d$var$r, 129);
function $b9e84b64b17bc73d$var$C(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $b9e84b64b17bc73d$var$s ? $b9e84b64b17bc73d$var$s.createHTML(i) : i;
}
const $b9e84b64b17bc73d$var$P = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : "", c = $b9e84b64b17bc73d$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $b9e84b64b17bc73d$var$f ? "!--" === u[1] ? c = $b9e84b64b17bc73d$var$v : void 0 !== u[1] ? c = $b9e84b64b17bc73d$var$_ : void 0 !== u[2] ? ($b9e84b64b17bc73d$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $b9e84b64b17bc73d$var$m) : void 0 !== u[3] && (c = $b9e84b64b17bc73d$var$m) : c === $b9e84b64b17bc73d$var$m ? ">" === u[0] ? (c = r ?? $b9e84b64b17bc73d$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $b9e84b64b17bc73d$var$m : '"' === u[3] ? $b9e84b64b17bc73d$var$g : $b9e84b64b17bc73d$var$p) : c === $b9e84b64b17bc73d$var$g || c === $b9e84b64b17bc73d$var$p ? c = $b9e84b64b17bc73d$var$m : c === $b9e84b64b17bc73d$var$v || c === $b9e84b64b17bc73d$var$_ ? c = $b9e84b64b17bc73d$var$f : (c = $b9e84b64b17bc73d$var$m, r = void 0);
        const x = c === $b9e84b64b17bc73d$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $b9e84b64b17bc73d$var$f ? s + $b9e84b64b17bc73d$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $b9e84b64b17bc73d$var$e + s.slice(d) + $b9e84b64b17bc73d$var$h + x) : s + $b9e84b64b17bc73d$var$h + (-2 === d ? i : x);
    }
    return [
        $b9e84b64b17bc73d$var$C(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        o
    ];
};
class $b9e84b64b17bc73d$var$V {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $b9e84b64b17bc73d$var$P(t, s);
        if (this.el = $b9e84b64b17bc73d$var$V.createElement(f, n), $b9e84b64b17bc73d$var$E.currentNode = this.el.content, 2 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $b9e84b64b17bc73d$var$E.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($b9e84b64b17bc73d$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($b9e84b64b17bc73d$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $b9e84b64b17bc73d$var$k : "?" === e[1] ? $b9e84b64b17bc73d$var$H : "@" === e[1] ? $b9e84b64b17bc73d$var$I : $b9e84b64b17bc73d$var$R
                    }), r.removeAttribute(t);
                } else t.startsWith($b9e84b64b17bc73d$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($b9e84b64b17bc73d$var$$.test(r.tagName)) {
                    const t = r.textContent.split($b9e84b64b17bc73d$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $b9e84b64b17bc73d$var$i ? $b9e84b64b17bc73d$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $b9e84b64b17bc73d$var$l()), $b9e84b64b17bc73d$var$E.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $b9e84b64b17bc73d$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $b9e84b64b17bc73d$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($b9e84b64b17bc73d$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $b9e84b64b17bc73d$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $b9e84b64b17bc73d$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $b9e84b64b17bc73d$var$N(t, i, s = t, e) {
    if (i === $b9e84b64b17bc73d$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $b9e84b64b17bc73d$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $b9e84b64b17bc73d$var$N(t, h._$AS(t, i.values), h, e)), i;
}
class $b9e84b64b17bc73d$var$S {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $b9e84b64b17bc73d$var$r).importNode(i, !0);
        $b9e84b64b17bc73d$var$E.currentNode = e;
        let h = $b9e84b64b17bc73d$var$E.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $b9e84b64b17bc73d$var$M(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $b9e84b64b17bc73d$var$L(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $b9e84b64b17bc73d$var$E.nextNode(), o++);
        }
        return $b9e84b64b17bc73d$var$E.currentNode = $b9e84b64b17bc73d$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $b9e84b64b17bc73d$var$M {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $b9e84b64b17bc73d$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $b9e84b64b17bc73d$var$N(this, t, i), $b9e84b64b17bc73d$var$c(t) ? t === $b9e84b64b17bc73d$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $b9e84b64b17bc73d$export$45b790e32b2810ee && this._$AR(), this._$AH = $b9e84b64b17bc73d$export$45b790e32b2810ee) : t !== this._$AH && t !== $b9e84b64b17bc73d$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $b9e84b64b17bc73d$var$u(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $b9e84b64b17bc73d$export$45b790e32b2810ee && $b9e84b64b17bc73d$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.$($b9e84b64b17bc73d$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $b9e84b64b17bc73d$var$V.createElement($b9e84b64b17bc73d$var$C(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $b9e84b64b17bc73d$var$S(e, this), s = t.u(this.options);
            t.p(i), this.$(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $b9e84b64b17bc73d$var$A.get(t.strings);
        return void 0 === i && $b9e84b64b17bc73d$var$A.set(t.strings, i = new $b9e84b64b17bc73d$var$V(t)), i;
    }
    T(t) {
        $b9e84b64b17bc73d$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $b9e84b64b17bc73d$var$M(this.k($b9e84b64b17bc73d$var$l()), this.k($b9e84b64b17bc73d$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $b9e84b64b17bc73d$var$R {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $b9e84b64b17bc73d$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $b9e84b64b17bc73d$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $b9e84b64b17bc73d$var$N(this, t, i, 0), o = !$b9e84b64b17bc73d$var$c(t) || t !== this._$AH && t !== $b9e84b64b17bc73d$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $b9e84b64b17bc73d$var$N(this, e[s + n], i, n), r === $b9e84b64b17bc73d$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$b9e84b64b17bc73d$var$c(r) || r !== this._$AH[n], r === $b9e84b64b17bc73d$export$45b790e32b2810ee ? t = $b9e84b64b17bc73d$export$45b790e32b2810ee : t !== $b9e84b64b17bc73d$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.O(t);
    }
    O(t) {
        t === $b9e84b64b17bc73d$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $b9e84b64b17bc73d$var$k extends $b9e84b64b17bc73d$var$R {
    constructor(){
        super(...arguments), this.type = 3;
    }
    O(t) {
        this.element[this.name] = t === $b9e84b64b17bc73d$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $b9e84b64b17bc73d$var$H extends $b9e84b64b17bc73d$var$R {
    constructor(){
        super(...arguments), this.type = 4;
    }
    O(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $b9e84b64b17bc73d$export$45b790e32b2810ee);
    }
}
class $b9e84b64b17bc73d$var$I extends $b9e84b64b17bc73d$var$R {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $b9e84b64b17bc73d$var$N(this, t, i, 0) ?? $b9e84b64b17bc73d$export$45b790e32b2810ee) === $b9e84b64b17bc73d$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $b9e84b64b17bc73d$export$45b790e32b2810ee && s !== $b9e84b64b17bc73d$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $b9e84b64b17bc73d$export$45b790e32b2810ee && (s === $b9e84b64b17bc73d$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $b9e84b64b17bc73d$var$L {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $b9e84b64b17bc73d$var$N(this, t);
    }
}
const $b9e84b64b17bc73d$export$8613d1ca9052b22e = {
    j: $b9e84b64b17bc73d$var$e,
    P: $b9e84b64b17bc73d$var$h,
    A: $b9e84b64b17bc73d$var$o,
    C: 1,
    M: $b9e84b64b17bc73d$var$P,
    L: $b9e84b64b17bc73d$var$S,
    R: $b9e84b64b17bc73d$var$u,
    V: $b9e84b64b17bc73d$var$N,
    D: $b9e84b64b17bc73d$var$M,
    I: $b9e84b64b17bc73d$var$R,
    H: $b9e84b64b17bc73d$var$H,
    N: $b9e84b64b17bc73d$var$I,
    U: $b9e84b64b17bc73d$var$k,
    B: $b9e84b64b17bc73d$var$L
}, $b9e84b64b17bc73d$var$Z = $b9e84b64b17bc73d$var$t.litHtmlPolyfillSupport;
$b9e84b64b17bc73d$var$Z?.($b9e84b64b17bc73d$var$V, $b9e84b64b17bc73d$var$M), ($b9e84b64b17bc73d$var$t.litHtmlVersions ??= []).push("3.1.0");
const $b9e84b64b17bc73d$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $b9e84b64b17bc73d$var$M(i.insertBefore($b9e84b64b17bc73d$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("kXi80", function(module, exports) {
$parcel$export(module.exports, "adoptStyles", function () { return (parcelRequire("cZ4os")).adoptStyles; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("cZ4os")).css; });
$parcel$export(module.exports, "getCompatibleStyle", function () { return (parcelRequire("cZ4os")).getCompatibleStyle; });
$parcel$export(module.exports, "ReactiveElement", function () { return (parcelRequire("043af")).ReactiveElement; });
$parcel$export(module.exports, "unsafeCSS", function () { return (parcelRequire("cZ4os")).unsafeCSS; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("fXA0k")).html; });
$parcel$export(module.exports, "noChange", function () { return (parcelRequire("fXA0k")).noChange; });
$parcel$export(module.exports, "nothing", function () { return (parcelRequire("fXA0k")).nothing; });
$parcel$export(module.exports, "render", function () { return (parcelRequire("fXA0k")).render; });

$parcel$export(module.exports, "LitElement", function () { return $f4176139b59c7029$export$3f2f9f5909897157; });

var $043af = parcelRequire("043af");

var $fXA0k = parcelRequire("fXA0k");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $f4176139b59c7029$export$3f2f9f5909897157 extends (0, $043af.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $fXA0k.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $fXA0k.noChange;
    }
}
$f4176139b59c7029$export$3f2f9f5909897157._$litElement$ = !0, $f4176139b59c7029$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $f4176139b59c7029$export$3f2f9f5909897157
});
const $f4176139b59c7029$var$r = globalThis.litElementPolyfillSupport;
$f4176139b59c7029$var$r?.({
    LitElement: $f4176139b59c7029$export$3f2f9f5909897157
});
const $f4176139b59c7029$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.0.2");

});

parcelRegister("aw8zL", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $7a838b8aa8078617$export$6acf61af03e62db = !1;

});


parcelRegister("4MDiX", function(module, exports) {
$parcel$export(module.exports, "customElement", function () { return (parcelRequire("9GF5G")).customElement; });
$parcel$export(module.exports, "property", function () { return (parcelRequire("asvDI")).property; });
$parcel$export(module.exports, "state", function () { return (parcelRequire("22wWE")).state; });
$parcel$export(module.exports, "queryAll", function () { return (parcelRequire("jcHRM")).queryAll; });
$parcel$export(module.exports, "queryAssignedElements", function () { return (parcelRequire("5bKRU")).queryAssignedElements; });
parcelRequire("9GF5G");
parcelRequire("asvDI");
parcelRequire("22wWE");
parcelRequire("dDb6Q");
parcelRequire("lIT4e");
parcelRequire("jcHRM");
parcelRequire("4YM5J");
parcelRequire("5bKRU");
parcelRequire("ijpL6");

});
parcelRegister("9GF5G", function(module, exports) {

$parcel$export(module.exports, "customElement", function () { return $70d7e9127cacc5b7$export$da64fc29f17f9d0e; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $70d7e9127cacc5b7$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };

});

parcelRegister("asvDI", function(module, exports) {

$parcel$export(module.exports, "property", function () { return $79d50fddfd30b43a$export$d541bacb2bda4494; });

var $043af = parcelRequire("043af");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $79d50fddfd30b43a$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $043af.defaultConverter),
    reflect: !1,
    hasChanged: (0, $043af.notEqual)
}, $79d50fddfd30b43a$export$8d623b1670eb40f4 = (t = $79d50fddfd30b43a$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $79d50fddfd30b43a$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $79d50fddfd30b43a$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}

});

parcelRegister("22wWE", function(module, exports) {

$parcel$export(module.exports, "state", function () { return $17c552deda414e35$export$ca000e230c0caa3e; });

var $asvDI = parcelRequire("asvDI");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $17c552deda414e35$export$ca000e230c0caa3e(r) {
    return (0, $asvDI.property)({
        ...r,
        state: !0,
        attribute: !1
    });
}

});

parcelRegister("dDb6Q", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9ec788ffeb67d7a3$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

});

parcelRegister("lIT4e", function(module, exports) {

var $7yNSq = parcelRequire("7yNSq");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $fd086c42a5587852$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $7yNSq.desc)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $7yNSq.desc)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}

});
parcelRegister("7yNSq", function(module, exports) {

$parcel$export(module.exports, "desc", function () { return $581265df21c81517$export$51987bb50e1f6752; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $581265df21c81517$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);

});


parcelRegister("jcHRM", function(module, exports) {

$parcel$export(module.exports, "queryAll", function () { return $dfb12a4558214220$export$dcd0d083aa86c355; });

var $7yNSq = parcelRequire("7yNSq");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $dfb12a4558214220$var$e;
function $dfb12a4558214220$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $7yNSq.desc)(n, o, {
            get () {
                return (this.renderRoot ?? ($dfb12a4558214220$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}

});

parcelRegister("4YM5J", function(module, exports) {

var $7yNSq = parcelRequire("7yNSq");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $3a0211f7e1dac4ae$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $7yNSq.desc)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}

});

parcelRegister("5bKRU", function(module, exports) {

$parcel$export(module.exports, "queryAssignedElements", function () { return $3c7255ea9cb44078$export$4682af2d9ee91415; });

var $7yNSq = parcelRequire("7yNSq");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $3c7255ea9cb44078$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $7yNSq.desc)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}

});

parcelRegister("ijpL6", function(module, exports) {

var $7yNSq = parcelRequire("7yNSq");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $d54dfb800f24759d$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $7yNSq.desc)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}

});


parcelRegister("bsGWa", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_TINI", function () { return (parcelRequire("2tid7")).GLOBAL_TINI; });
$parcel$export(module.exports, "THEME_CHANGE_EVENT", function () { return (parcelRequire("2tid7")).THEME_CHANGE_EVENT; });
$parcel$export(module.exports, "TiniElement", function () { return (parcelRequire("8Zp5V")).TiniElement; });
$parcel$export(module.exports, "adoptScripts", function () { return (parcelRequire("gKqnD")).adoptScripts; });
$parcel$export(module.exports, "borderToClassInfo", function () { return (parcelRequire("gKqnD")).borderToClassInfo; });
$parcel$export(module.exports, "factorsToClassInfo", function () { return (parcelRequire("gKqnD")).factorsToClassInfo; });
$parcel$export(module.exports, "forwardEvents", function () { return (parcelRequire("gKqnD")).forwardEvents; });
$parcel$export(module.exports, "genericComponentBuildAndCacheStyles", function () { return (parcelRequire("gKqnD")).genericComponentBuildAndCacheStyles; });
$parcel$export(module.exports, "genericComponentBuildStyleTextFromAttributes", function () { return (parcelRequire("gKqnD")).genericComponentBuildStyleTextFromAttributes; });
$parcel$export(module.exports, "genericComponentBuildStyleTextFromStyling", function () { return (parcelRequire("gKqnD")).genericComponentBuildStyleTextFromStyling; });
$parcel$export(module.exports, "genericComponentProcessAttributes", function () { return (parcelRequire("gKqnD")).genericComponentProcessAttributes; });
$parcel$export(module.exports, "getTheme", function () { return (parcelRequire("gKqnD")).getTheme; });
$parcel$export(module.exports, "processComponentStyles", function () { return (parcelRequire("gKqnD")).processComponentStyles; });
$parcel$export(module.exports, "registerComponents", function () { return (parcelRequire("gKqnD")).registerComponents; });
$parcel$export(module.exports, "setTheme", function () { return (parcelRequire("gKqnD")).setTheme; });
$parcel$export(module.exports, "setUIOptions", function () { return (parcelRequire("gKqnD")).setUIOptions; });
$parcel$export(module.exports, "TiniElementComponents", function () { return (parcelRequire("8gdKM")).TiniElementComponents; });
$parcel$export(module.exports, "TiniElementTheming", function () { return (parcelRequire("8gdKM")).TiniElementTheming; });
$parcel$export(module.exports, "partAttrMap", function () { return (parcelRequire("aynjv")).partAttrMap; });
$parcel$export(module.exports, "BASE_COLORS", function () { return (parcelRequire("4fw8W")).BASE_COLORS; });
$parcel$export(module.exports, "BASE_COMMON_COLORS", function () { return (parcelRequire("4fw8W")).BASE_COMMON_COLORS; });
$parcel$export(module.exports, "BASE_COMMON_GRADIENTS", function () { return (parcelRequire("4fw8W")).BASE_COMMON_GRADIENTS; });
$parcel$export(module.exports, "BASE_GRADIENTS", function () { return (parcelRequire("4fw8W")).BASE_GRADIENTS; });
$parcel$export(module.exports, "BOX_SHADOWS", function () { return (parcelRequire("4fw8W")).BOX_SHADOWS; });
$parcel$export(module.exports, "Colors", function () { return (parcelRequire("4fw8W")).Colors; });
$parcel$export(module.exports, "FACTORS", function () { return (parcelRequire("4fw8W")).FACTORS; });
$parcel$export(module.exports, "FONT_TYPES", function () { return (parcelRequire("4fw8W")).FONT_TYPES; });
$parcel$export(module.exports, "FONT_WEIGHTS", function () { return (parcelRequire("4fw8W")).FONT_WEIGHTS; });
$parcel$export(module.exports, "generateBorderRadiusVaries", function () { return (parcelRequire("4fw8W")).generateBorderRadiusVaries; });
$parcel$export(module.exports, "generateBorderStyleVaries", function () { return (parcelRequire("4fw8W")).generateBorderStyleVaries; });
$parcel$export(module.exports, "generateBorderWidthVaries", function () { return (parcelRequire("4fw8W")).generateBorderWidthVaries; });
$parcel$export(module.exports, "generateBoxShadowVaries", function () { return (parcelRequire("4fw8W")).generateBoxShadowVaries; });
$parcel$export(module.exports, "generateColorVaries", function () { return (parcelRequire("4fw8W")).generateColorVaries; });
$parcel$export(module.exports, "generateFontSizeVaries", function () { return (parcelRequire("4fw8W")).generateFontSizeVaries; });
$parcel$export(module.exports, "generateFontTypeVaries", function () { return (parcelRequire("4fw8W")).generateFontTypeVaries; });
$parcel$export(module.exports, "generateFontWeightVaries", function () { return (parcelRequire("4fw8W")).generateFontWeightVaries; });
$parcel$export(module.exports, "generateGradientVaries", function () { return (parcelRequire("4fw8W")).generateGradientVaries; });
$parcel$export(module.exports, "generateJustifyContentVaries", function () { return (parcelRequire("4fw8W")).generateJustifyContentVaries; });
$parcel$export(module.exports, "generateScaleVaries", function () { return (parcelRequire("4fw8W")).generateScaleVaries; });
$parcel$export(module.exports, "generateSpaceVaries", function () { return (parcelRequire("4fw8W")).generateSpaceVaries; });
$parcel$export(module.exports, "generateTextTransformVaries", function () { return (parcelRequire("4fw8W")).generateTextTransformVaries; });
$parcel$export(module.exports, "SCALES", function () { return (parcelRequire("4fw8W")).SCALES; });
$parcel$export(module.exports, "TEXT_TRANSFORMS", function () { return (parcelRequire("4fw8W")).TEXT_TRANSFORMS; });
$parcel$export(module.exports, "VaryGroups", function () { return (parcelRequire("4fw8W")).VaryGroups; });
parcelRequire("2tid7");
parcelRequire("Pdzq5");
parcelRequire("8Zp5V");
parcelRequire("gKqnD");
parcelRequire("8gdKM");
parcelRequire("aynjv");
parcelRequire("4fw8W");

});
parcelRegister("2tid7", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_TINI", function () { return $1ccc6a738ff895a4$export$7e97b96280519fd9; });
$parcel$export(module.exports, "THEME_CHANGE_EVENT", function () { return $1ccc6a738ff895a4$export$ac0915eaf637c081; });
var $1ccc6a738ff895a4$var$_a;
const $1ccc6a738ff895a4$export$7e97b96280519fd9 = ($1ccc6a738ff895a4$var$_a = globalThis).TiniJS || ($1ccc6a738ff895a4$var$_a.TiniJS = {});
const $1ccc6a738ff895a4$export$ac0915eaf637c081 = "tini:theme-change";

});

parcelRegister("Pdzq5", function(module, exports) {

});

parcelRegister("8Zp5V", function(module, exports) {

$parcel$export(module.exports, "TiniElement", function () { return $68b77c7cec51bba2$export$8ebd9f4ec6d74879; });
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $kXi80 = parcelRequire("kXi80");
parcelRequire("2iOtH");
var $asvDI = parcelRequire("asvDI");

var $2tid7 = parcelRequire("2tid7");

var $gKqnD = parcelRequire("gKqnD");

var $4fw8W = parcelRequire("4fw8W");
var $68b77c7cec51bba2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class $68b77c7cec51bba2$export$8ebd9f4ec6d74879 extends (0, $kXi80.LitElement) {
    constructor(){
        super(...arguments);
        this.uiOptions = (0, $gKqnD.getUIOptions)();
        this.activeTheme = (0, $gKqnD.getTheme)();
        this.extraStyleAdopted = false;
        this.rootClasses = {
            root: true
        };
        this.onThemeChange = (e)=>{
            this.activeTheme = e.detail;
            return this.requestUpdate();
        };
    }
    /* eslint-enable prettier/prettier */ createRenderRoot() {
        var _a;
        const renderRoot = (_a = this.shadowRoot) !== null && _a !== void 0 ? _a : this.attachShadow(this.constructor.shadowRootOptions);
        this.customAdoptStyles(renderRoot);
        return renderRoot;
    }
    connectedCallback() {
        super.connectedCallback();
        addEventListener((0, $2tid7.THEME_CHANGE_EVENT), this.onThemeChange);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        removeEventListener((0, $2tid7.THEME_CHANGE_EVENT), this.onThemeChange);
    }
    willUpdate(changedProperties) {
        // re-style when deepStyle changed
        if (changedProperties.has("styleDeep")) {
            if (!this.extraStyleAdopted) this.extraStyleAdopted = true; // skip the first time, already adopted in createRenderRoot()
            else this.customAdoptStyles(this.shadowRoot || this);
        }
    }
    firstUpdated() {
        if (this.events) (0, $gKqnD.forwardEvents)(this, this.events);
    }
    updated() {
        this.customAdoptScripts();
    }
    extendRootClasses(input) {
        const { raw: raw = {}, pseudo: pseudo = {}, overridable: overridable = {} } = input;
        const { componentOptions: componentOptions } = this.getGlobalOptions();
        // build pseudo info
        const pseudoInfo = Object.entries(pseudo).reduce((result, [key, value])=>{
            return !value ? result : {
                ...result,
                ...Object.entries(value).reduce((r, [k, v])=>{
                    if (!v) return r;
                    r[`${k}-${v}-${key}`] = true;
                    return r;
                }, {})
            };
        }, {});
        // build overridable info
        const overridableFinalValues = {};
        const overridableInfo = Object.entries(overridable).reduce((result, [key, originalValue])=>{
            if (!originalValue) return result;
            const value = this.calculatePropertyValue(key, originalValue);
            overridableFinalValues[key] = value;
            result[`${key}-${value}`] = true;
            return result;
        }, {});
        // other info:
        // + refer gradient scheme on hover
        const otherInfo = {};
        const schemeValue = overridableFinalValues[(0, $4fw8W.VaryGroups).Scheme];
        if (componentOptions.referGradientSchemeOnHover && schemeValue && !~schemeValue.indexOf("gradient")) {
            const hoverScheme = (0, $4fw8W.COMMON_COLORS_TO_COMMON_GRADIENTS)[schemeValue] || `gradient-${schemeValue}`;
            otherInfo[`${(0, $4fw8W.VaryGroups).Scheme}-${hoverScheme}-hover`] = true;
        }
        // result
        return this.rootClasses = {
            ...this.rootClasses,
            ...raw,
            ...pseudoInfo,
            ...overridableInfo,
            ...otherInfo
        };
    }
    getGlobalOptions() {
        var _a, _b, _c;
        const themeOptions = ((_a = this.uiOptions) === null || _a === void 0 ? void 0 : _a[this.activeTheme.themeId]) || ((_b = this.uiOptions) === null || _b === void 0 ? void 0 : _b[this.activeTheme.soulId]) || {};
        const componentOptions = ((_c = themeOptions.perComponent) === null || _c === void 0 ? void 0 : _c[this.constructor.componentName]) || {};
        return {
            themeOptions: themeOptions,
            componentOptions: componentOptions
        };
    }
    calculatePropertyValue(name, originalValue) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const { themeOptions: themeOptions } = this.getGlobalOptions();
        // no theme
        if (!this.activeTheme) return originalValue;
        // refers
        const camelName = name.replace(/-(\w)/g, (_, letter)=>letter.toUpperCase());
        const referValue = ((_b = (_a = this.refers) === null || _a === void 0 ? void 0 : _a[this.activeTheme.themeId]) === null || _b === void 0 ? void 0 : _b[camelName]) || ((_d = (_c = this.refers) === null || _c === void 0 ? void 0 : _c[this.activeTheme.themeId]) === null || _d === void 0 ? void 0 : _d[name]) || ((_f = (_e = this.refers) === null || _e === void 0 ? void 0 : _e[this.activeTheme.soulId]) === null || _f === void 0 ? void 0 : _f[camelName]) || ((_h = (_g = this.refers) === null || _g === void 0 ? void 0 : _g[this.activeTheme.soulId]) === null || _h === void 0 ? void 0 : _h[name]);
        if (referValue) return referValue;
        // refer gradient scheme
        if (!((_j = this.constructor.componentMetas) === null || _j === void 0 ? void 0 : _j.colorOnlyScheme) && name === (0, $4fw8W.VaryGroups).Scheme && themeOptions.referGradientScheme) return ~originalValue.indexOf("gradient") ? originalValue : (0, $4fw8W.COMMON_COLORS_TO_COMMON_GRADIENTS)[originalValue] || `gradient-${originalValue}`;
        // default value
        return originalValue;
    }
    customAdoptStyles(renderRoot) {
        var _a;
        const allStyles = [];
        // theme styles (multiple themes, via @TiniElementTheming() only)
        const styling = (_a = this.constructor.theming) === null || _a === void 0 ? void 0 : _a.styling;
        if (styling) {
            const { soulId: soulId, themeId: themeId } = this.activeTheme;
            allStyles.push(...styling[themeId] || styling[soulId] || Object.values(styling)[0] || []);
        }
        // element styles
        allStyles.push(...this.constructor.elementStyles);
        // from styleDeep
        if (this.styleDeep) allStyles.push(this.styleDeep);
        // adopt styles
        const styleText = (0, $gKqnD.processComponentStyles)(allStyles, this.activeTheme);
        (0, $cZ4os.adoptStyles)(renderRoot, [
            (0, $cZ4os.getCompatibleStyle)((0, $cZ4os.unsafeCSS)(styleText))
        ]);
    }
    customAdoptScripts() {
        var _a;
        // theme scripts (multiple themes, via @TiniElementTheming() only)
        (0, $gKqnD.adoptScripts)(this, this.activeTheme, (_a = this.constructor.theming) === null || _a === void 0 ? void 0 : _a.scripting);
    }
}
$68b77c7cec51bba2$export$8ebd9f4ec6d74879.defaultTagName = "tini-element";
$68b77c7cec51bba2$export$8ebd9f4ec6d74879.componentName = "unnamed";
$68b77c7cec51bba2$export$8ebd9f4ec6d74879.componentMetas = {};
$68b77c7cec51bba2$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $68b77c7cec51bba2$export$8ebd9f4ec6d74879.prototype, "styleDeep", void 0);
$68b77c7cec51bba2$var$__decorate([
    (0, $asvDI.property)({
        type: Object
    })
], $68b77c7cec51bba2$export$8ebd9f4ec6d74879.prototype, "refers", void 0);
$68b77c7cec51bba2$var$__decorate([
    (0, $asvDI.property)()
], $68b77c7cec51bba2$export$8ebd9f4ec6d74879.prototype, "events", void 0);

});
parcelRegister("2iOtH", function(module, exports) {
$parcel$export(module.exports, "property", function () { return (parcelRequire("asvDI")).property; });
parcelRequire("asvDI");

});

parcelRegister("gKqnD", function(module, exports) {

$parcel$export(module.exports, "registerComponents", function () { return $c31567c153609748$export$e73a9d346ce244ee; });
$parcel$export(module.exports, "setUIOptions", function () { return $c31567c153609748$export$43a2e6879567eb1c; });
$parcel$export(module.exports, "getUIOptions", function () { return $c31567c153609748$export$cf7c5b242ee58bf; });
$parcel$export(module.exports, "forwardEvents", function () { return $c31567c153609748$export$a7b17b9113abe555; });
$parcel$export(module.exports, "adoptScripts", function () { return $c31567c153609748$export$28d3c0101b8a4efd; });
$parcel$export(module.exports, "getTheme", function () { return $c31567c153609748$export$89cbf1a0881c8b9c; });
$parcel$export(module.exports, "setTheme", function () { return $c31567c153609748$export$2e49b867b7a0847c; });
$parcel$export(module.exports, "processComponentStyles", function () { return $c31567c153609748$export$966e5ee432b1535b; });
$parcel$export(module.exports, "genericComponentProcessAttributes", function () { return $c31567c153609748$export$1c7aaabe0f8c64d0; });
$parcel$export(module.exports, "genericComponentBuildStyleTextFromAttributes", function () { return $c31567c153609748$export$450a7d863dc5b901; });
$parcel$export(module.exports, "genericComponentBuildStyleTextFromStyling", function () { return $c31567c153609748$export$db5e27aff89e800; });
$parcel$export(module.exports, "genericComponentBuildAndCacheStyles", function () { return $c31567c153609748$export$a52f7b6ce4acf43f; });
$parcel$export(module.exports, "factorsToClassInfo", function () { return $c31567c153609748$export$3dd3673ed755c85e; });
$parcel$export(module.exports, "borderToClassInfo", function () { return $c31567c153609748$export$ae2c76b09c5c871f; });

var $2tid7 = parcelRequire("2tid7");

var $4fw8W = parcelRequire("4fw8W");
function $c31567c153609748$export$e73a9d346ce244ee(items) {
    return items.forEach((item)=>{
        const useCustomTagName = item instanceof Array;
        const [constructor, tagName] = useCustomTagName ? item : [
            item,
            item.defaultTagName
        ];
        if (!tagName || !constructor || customElements.get(tagName)) return;
        customElements.define(tagName, !useCustomTagName ? constructor : class extends constructor {
        });
    });
}
function $c31567c153609748$export$43a2e6879567eb1c(options) {
    return (0, $2tid7.GLOBAL_TINI).uiOptions = options || {};
}
function $c31567c153609748$export$cf7c5b242ee58bf() {
    return (0, $2tid7.GLOBAL_TINI).uiOptions || {};
}
function $c31567c153609748$export$a7b17b9113abe555(host, events) {
    const renderRoot = host.shadowRoot || host;
    const cachedTargets = new Map();
    (typeof events !== "string" ? events : events.split(",").map((item)=>item.trim())).forEach((item)=>{
        const forwarding = typeof item !== "string" ? item : !~item.indexOf(":") ? {
            name: item
        } : (()=>{
            const [name, rename] = item.split(":").map((item)=>item.trim());
            return {
                name: name,
                rename: rename
            };
        })();
        const { name: name, rename: rename, keepPropagation: keepPropagation, preventDefault: preventDefault, dispatchOptions: dispatchOptions } = forwarding;
        const mainNonRootSelector = host.constructor.mainNonRootSelector;
        const target = !forwarding.target && mainNonRootSelector ? mainNonRootSelector : forwarding.target;
        const targetNodes = !target ? [
            renderRoot.firstElementChild
        ] : typeof target !== "string" ? target : cachedTargets.has(target) ? cachedTargets.get(target) : cachedTargets.set(target, renderRoot.querySelectorAll(target)).get(target);
        if (!(targetNodes === null || targetNodes === void 0 ? void 0 : targetNodes.length)) return;
        targetNodes.forEach((targetNode)=>{
            if (!targetNode) return;
            targetNode.addEventListener(name, (e)=>{
                if (!keepPropagation) e.stopPropagation();
                if (preventDefault) e.preventDefault();
                host.dispatchEvent(new CustomEvent(rename || name, {
                    ...dispatchOptions,
                    detail: e
                }));
            });
        });
    });
}
function $c31567c153609748$export$28d3c0101b8a4efd(host, activeTheme, scripting) {
    var _a, _b;
    if (!scripting || !activeTheme) return;
    const { soulId: soulId, themeId: themeId } = activeTheme;
    const scripts = scripting[themeId] || scripting[soulId] || Object.values(scripting)[0] || {};
    (_b = (_a = host).___themeUnscript) === null || _b === void 0 || _b.call(_a, host);
    host.___themeUnscript = scripts.unscript;
    if (scripts.script) scripts.script(host);
}
function $c31567c153609748$export$89cbf1a0881c8b9c(forced = false, prevData) {
    if (!forced && (0, $2tid7.GLOBAL_TINI).activeTheme) return (0, $2tid7.GLOBAL_TINI).activeTheme;
    // themeId, soulId, skinId
    const themeId = document.body.dataset.theme;
    if (!themeId) throw new Error("No Tini UI theme found!");
    const [soulId, skinId] = themeId.split("/");
    // breakpoints
    const computedStyle = getComputedStyle(document.body);
    const breakpoints = Object.entries((0, $4fw8W.Breakpoints)).reduce((result, [enumKey, defaultValue])=>{
        const key = enumKey.toLowerCase();
        const value = computedStyle.getPropertyValue(`--wide-${key}`);
        result[key] = value || defaultValue;
        return result;
    }, {});
    // result
    return (0, $2tid7.GLOBAL_TINI).activeTheme = {
        prevSoulId: (prevData === null || prevData === void 0 ? void 0 : prevData.prevSoulId) || soulId,
        prevSkinId: (prevData === null || prevData === void 0 ? void 0 : prevData.prevSkinId) || skinId,
        prevThemeId: (prevData === null || prevData === void 0 ? void 0 : prevData.prevThemeId) || themeId,
        soulId: soulId,
        skinId: skinId,
        themeId: themeId,
        breakpoints: breakpoints
    };
}
function $c31567c153609748$export$2e49b867b7a0847c({ soulId: soulId, skinId: skinId }) {
    const { soulId: currentSoulId, skinId: currentSkinId } = $c31567c153609748$export$89cbf1a0881c8b9c();
    soulId || (soulId = currentSoulId);
    skinId || (skinId = currentSkinId);
    if (!soulId || !skinId) throw new Error("Invalid soulId or skinId!");
    // 1. set <body data-theme="...">
    document.body.dataset.theme = `${soulId}/${skinId}`;
    // 2. dispatch a global event
    if (soulId !== currentSoulId || skinId !== currentSkinId) dispatchEvent(new CustomEvent((0, $2tid7.THEME_CHANGE_EVENT), {
        detail: $c31567c153609748$export$89cbf1a0881c8b9c(true, {
            prevSoulId: currentSoulId,
            prevSkinId: currentSkinId,
            prevThemeId: `${currentSoulId}/${currentSkinId}`
        })
    }));
}
function $c31567c153609748$export$966e5ee432b1535b(allStyles, activeTheme, additionalProcess) {
    // 1. combine all styles
    let styleText = allStyles.map((style)=>{
        if (typeof style === "string") return style;
        else if (style instanceof CSSStyleSheet) {
            let text = "";
            for (const rule of style.cssRules)text += "\n" + rule.cssText;
            return text;
        } else return style.cssText;
    }).join("\n");
    // 2. run additional process
    if (additionalProcess) styleText = additionalProcess(styleText, activeTheme);
    // 3. replace breakpoints
    Object.entries(activeTheme.breakpoints).forEach(([key, value])=>styleText = styleText.replace(new RegExp(`: ?(${key}|${key.toUpperCase()})\\)`, "g"), `: ${value})`));
    // result
    return styleText;
}
function $c31567c153609748$export$1c7aaabe0f8c64d0(component) {
    const attributes = component.attributes;
    const componentProps = component.constructor.observedAttributes || [];
    // process attributes
    let styleAttributes;
    let forwardAttributes;
    for(let i = 0; i < attributes.length; i++){
        const { name: name, value: value } = attributes[i];
        if (name in HTMLElement.prototype || ~componentProps.indexOf(name) || name.startsWith("data-") || name.startsWith("aria-")) continue;
        if (name.substring(name.length - 5) !== "-attr") {
            styleAttributes || (styleAttributes = new Map());
            styleAttributes.set(name, value);
        } else {
            forwardAttributes || (forwardAttributes = new Map());
            forwardAttributes.set(name.substring(0, name.length - 5), value);
        }
    }
    // set values
    component.styleAttributes = styleAttributes;
    component.forwardAttributes = forwardAttributes;
    return component;
}
function $c31567c153609748$export$450a7d863dc5b901(className, styleAttributes) {
    return !styleAttributes ? "" : `
    .${className} {
      ${Array.from(styleAttributes).map(([name, value])=>`${name}: ${value};`).join("\n")}
    }
  `;
}
function $c31567c153609748$export$db5e27aff89e800(styling, themeId) {
    if (!styling || !themeId) return "";
    if (styling[themeId]) return styling[themeId];
    const soulId = themeId.split("/")[0];
    return !styling[soulId] ? "" : styling[soulId];
}
function $c31567c153609748$export$a52f7b6ce4acf43f(precomputed, activeTheme, cacheStorage, buildStyles) {
    // ignore caching
    if (!precomputed) return buildStyles();
    // build styles and cache
    const buildCacheKey = (name)=>`${activeTheme.themeId} => ${name}`;
    // check cache
    const cacheKey = buildCacheKey(precomputed);
    if (cacheStorage[cacheKey] || !~precomputed.indexOf("/")) return cacheStorage[cacheKey] || (cacheStorage[cacheKey] = buildStyles());
    else {
        // get parent styles
        const parentStyles = [];
        const currentPaths = [];
        precomputed.split("/").forEach((item, i, list)=>{
            if (i === list.length - 1) return;
            currentPaths.push(item);
            const currentStyles = cacheStorage[buildCacheKey(currentPaths.join("/"))];
            if (currentStyles) parentStyles.push(...currentStyles);
        });
        // child styles
        const childStyles = buildStyles();
        // merge and cache
        return cacheStorage[cacheKey] = [
            ...parentStyles,
            ...childStyles
        ];
    }
}
function $c31567c153609748$export$3dd3673ed755c85e(prefix, factors) {
    if (!factors) return {};
    const list = factors.split(" ").filter((item)=>~(0, $4fw8W.FACTORS).indexOf(item));
    if (list.length === 4) return {
        [`${prefix}-top-${list[0]}`]: true,
        [`${prefix}-right-${list[1]}`]: true,
        [`${prefix}-bottom-${list[2]}`]: true,
        [`${prefix}-left-${list[3]}`]: true
    };
    else if (list.length === 3) return {
        [`${prefix}-top-${list[0]}`]: true,
        [`${prefix}-right-${list[1]}`]: true,
        [`${prefix}-bottom-${list[2]}`]: true,
        [`${prefix}-left-${list[1]}`]: true
    };
    else if (list.length === 2) return {
        [`${prefix}-top-${list[0]}`]: true,
        [`${prefix}-right-${list[1]}`]: true,
        [`${prefix}-bottom-${list[0]}`]: true,
        [`${prefix}-left-${list[1]}`]: true
    };
    else if (list.length === 1) return {
        [`${prefix}-top-${list[0]}`]: true,
        [`${prefix}-right-${list[0]}`]: true,
        [`${prefix}-bottom-${list[0]}`]: true,
        [`${prefix}-left-${list[0]}`]: true
    };
    else return {};
}
function $c31567c153609748$export$8f587d6fc76da408(outline) {
    if (!outline) return {};
    const list = outline.split(" ");
    if (list.length === 3 && ~(0, $4fw8W.OUTLINE_WIDTHS).indexOf(list[0]) && ~(0, $4fw8W.OUTLINE_STYLES).indexOf(list[1]) && ~(0, $4fw8W.COLORS).indexOf(list[2])) return {
        [`${(0, $4fw8W.VaryGroups).OutlineWidth}-${list[0]}`]: true,
        [`${(0, $4fw8W.VaryGroups).OutlineStyle}-${list[1]}`]: true,
        [`${(0, $4fw8W.VaryGroups).OutlineColor}-${list[2]}`]: true
    };
    else if (list.length === 2) {
        if (~(0, $4fw8W.OUTLINE_WIDTHS).indexOf(list[0]) && ~(0, $4fw8W.OUTLINE_STYLES).indexOf(list[1])) return {
            [`${(0, $4fw8W.VaryGroups).OutlineWidth}-${list[0]}`]: true,
            [`${(0, $4fw8W.VaryGroups).OutlineStyle}-${list[1]}`]: true
        };
        else if (~(0, $4fw8W.OUTLINE_STYLES).indexOf(list[0]) && ~(0, $4fw8W.COLORS).indexOf(list[1])) return {
            [`${(0, $4fw8W.VaryGroups).OutlineStyle}-${list[0]}`]: true,
            [`${(0, $4fw8W.VaryGroups).OutlineColor}-${list[1]}`]: true
        };
        else return {};
    } else if (list.length === 1) {
        if (~(0, $4fw8W.OUTLINE_WIDTHS).indexOf(list[0])) return {
            [`${(0, $4fw8W.VaryGroups).OutlineWidth}-${list[0]}`]: true
        };
        else if (~(0, $4fw8W.OUTLINE_STYLES).indexOf(list[0])) return {
            [`${(0, $4fw8W.VaryGroups).OutlineStyle}-${list[0]}`]: true
        };
        else if (~(0, $4fw8W.COLORS).indexOf(list[0])) return {
            [`${(0, $4fw8W.VaryGroups).OutlineColor}-${list[0]}`]: true
        };
        else return {};
    } else return {};
}
function $c31567c153609748$export$ae2c76b09c5c871f(border) {
    if (!border) return {};
    const list = border.split(" ");
    if (list.length === 3 && ~(0, $4fw8W.BORDER_WIDTHS).indexOf(list[0]) && ~(0, $4fw8W.BORDER_STYLES).indexOf(list[1]) && ~(0, $4fw8W.COLORS).indexOf(list[2])) return {
        [`${(0, $4fw8W.VaryGroups).BorderWidth}-${list[0]}`]: true,
        [`${(0, $4fw8W.VaryGroups).BorderStyle}-${list[1]}`]: true,
        [`${(0, $4fw8W.VaryGroups).BorderColor}-${list[2]}`]: true
    };
    else if (list.length === 2) {
        if (~(0, $4fw8W.BORDER_WIDTHS).indexOf(list[0]) && ~(0, $4fw8W.BORDER_STYLES).indexOf(list[1])) return {
            [`${(0, $4fw8W.VaryGroups).BorderWidth}-${list[0]}`]: true,
            [`${(0, $4fw8W.VaryGroups).BorderStyle}-${list[1]}`]: true
        };
        else if (~(0, $4fw8W.BORDER_STYLES).indexOf(list[0]) && ~(0, $4fw8W.COLORS).indexOf(list[1])) return {
            [`${(0, $4fw8W.VaryGroups).BorderStyle}-${list[0]}`]: true,
            [`${(0, $4fw8W.VaryGroups).BorderColor}-${list[1]}`]: true
        };
        else return {};
    } else if (list.length === 1) {
        if (~(0, $4fw8W.BORDER_WIDTHS).indexOf(list[0])) return {
            [`${(0, $4fw8W.VaryGroups).BorderWidth}-${list[0]}`]: true
        };
        else if (~(0, $4fw8W.BORDER_STYLES).indexOf(list[0])) return {
            [`${(0, $4fw8W.VaryGroups).BorderStyle}-${list[0]}`]: true
        };
        else if (~(0, $4fw8W.COLORS).indexOf(list[0])) return {
            [`${(0, $4fw8W.VaryGroups).BorderColor}-${list[0]}`]: true
        };
        else return {};
    } else return {};
}
function $c31567c153609748$export$2c9e8a9632a706b2(...params) {
    var _a;
    const method = ((_a = params[0]) === null || _a === void 0 ? void 0 : _a.substring(0, 3)) !== "in " ? "in oklab" : params.shift();
    return `color-mix(${method}, ${params.slice(0, 2).join(", ")})`;
}
function $c31567c153609748$export$4b073707ff63303(color, amount = 0.1) {
    return $c31567c153609748$export$2c9e8a9632a706b2(color, `black ${amount * 100}%`);
}
function $c31567c153609748$export$382cdde3a5b8f440(color, amount = 0.1) {
    return $c31567c153609748$export$2c9e8a9632a706b2(color, `white ${amount * 100}%`);
}
function $c31567c153609748$export$c17a3be1057836e(color, amount = 0.1) {
    return $c31567c153609748$export$2c9e8a9632a706b2(color, `transparent ${(1 - amount) * 100}%`);
}

});
parcelRegister("4fw8W", function(module, exports) {

$parcel$export(module.exports, "VaryGroups", function () { return $31817f166bdd4ef6$export$56042872fe5dcdae; });
$parcel$export(module.exports, "Colors", function () { return $31817f166bdd4ef6$export$c537fa0d021d010b; });
$parcel$export(module.exports, "COLORS", function () { return $31817f166bdd4ef6$export$56d196d2844d1ca1; });
$parcel$export(module.exports, "BASE_COLORS", function () { return $31817f166bdd4ef6$export$3798dd22f2e08b2a; });
$parcel$export(module.exports, "BASE_COMMON_COLORS", function () { return $31817f166bdd4ef6$export$27ee2f69f6d06601; });
$parcel$export(module.exports, "BASE_GRADIENTS", function () { return $31817f166bdd4ef6$export$af31cfeed62fcb47; });
$parcel$export(module.exports, "BASE_COMMON_GRADIENTS", function () { return $31817f166bdd4ef6$export$ef013a55c097e969; });
$parcel$export(module.exports, "COMMON_COLORS_TO_COMMON_GRADIENTS", function () { return $31817f166bdd4ef6$export$d1259b1a47bd44eb; });
$parcel$export(module.exports, "SCALES", function () { return $31817f166bdd4ef6$export$9c2218f463f17dc5; });
$parcel$export(module.exports, "Breakpoints", function () { return $31817f166bdd4ef6$export$c38d2c1bff643203; });
$parcel$export(module.exports, "FACTORS", function () { return $31817f166bdd4ef6$export$dbdb347f12e46d6c; });
$parcel$export(module.exports, "FONT_TYPES", function () { return $31817f166bdd4ef6$export$ee855184183fcaca; });
$parcel$export(module.exports, "FONT_WEIGHTS", function () { return $31817f166bdd4ef6$export$6d309717e7ca946d; });
$parcel$export(module.exports, "TEXT_TRANSFORMS", function () { return $31817f166bdd4ef6$export$893f936926e5a722; });
$parcel$export(module.exports, "OUTLINE_WIDTHS", function () { return $31817f166bdd4ef6$export$c774257ecbce75cb; });
$parcel$export(module.exports, "OUTLINE_STYLES", function () { return $31817f166bdd4ef6$export$cd60ed4835852415; });
$parcel$export(module.exports, "BORDER_WIDTHS", function () { return $31817f166bdd4ef6$export$e6fdeba4f9f068fa; });
$parcel$export(module.exports, "BORDER_STYLES", function () { return $31817f166bdd4ef6$export$b8bc7df7798bdc00; });
$parcel$export(module.exports, "BOX_SHADOWS", function () { return $31817f166bdd4ef6$export$bbca71bf5213eea8; });
$parcel$export(module.exports, "generateColorVaries", function () { return $31817f166bdd4ef6$export$c5abd6228eea3d7e; });
$parcel$export(module.exports, "generateGradientVaries", function () { return $31817f166bdd4ef6$export$717fe95f5467bc0b; });
$parcel$export(module.exports, "generateScaleVaries", function () { return $31817f166bdd4ef6$export$2d83c4cdf70e1f8b; });
$parcel$export(module.exports, "generateSpaceVaries", function () { return $31817f166bdd4ef6$export$fc87627ac7c62c95; });
$parcel$export(module.exports, "generateFontSizeVaries", function () { return $31817f166bdd4ef6$export$d4c68164bc342f6d; });
$parcel$export(module.exports, "generateFontTypeVaries", function () { return $31817f166bdd4ef6$export$ad6b92aa4fd963ec; });
$parcel$export(module.exports, "generateFontWeightVaries", function () { return $31817f166bdd4ef6$export$e4e1a84b000adb60; });
$parcel$export(module.exports, "generateTextTransformVaries", function () { return $31817f166bdd4ef6$export$3549c479e11ce32a; });
$parcel$export(module.exports, "generateJustifyContentVaries", function () { return $31817f166bdd4ef6$export$6b8e6b8554996890; });
$parcel$export(module.exports, "generateBorderWidthVaries", function () { return $31817f166bdd4ef6$export$19dafee75ede306d; });
$parcel$export(module.exports, "generateBorderStyleVaries", function () { return $31817f166bdd4ef6$export$4795c9a5009a5e3e; });
$parcel$export(module.exports, "generateBorderRadiusVaries", function () { return $31817f166bdd4ef6$export$dd755cfe6ed49f80; });
$parcel$export(module.exports, "generateBoxShadowVaries", function () { return $31817f166bdd4ef6$export$35eaa6ec761ba5d6; });
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $31817f166bdd4ef6$export$56042872fe5dcdae;
(function(VaryGroups) {
    VaryGroups["Mode"] = "mode";
    VaryGroups["Scheme"] = "scheme";
    VaryGroups["Background"] = "background";
    VaryGroups["Color"] = "color";
    VaryGroups["Scale"] = "scale";
    VaryGroups["Wide"] = "wide";
    VaryGroups["Breakpoint"] = "breakpoint";
    VaryGroups["Space"] = "space";
    VaryGroups["Margin"] = "margin";
    VaryGroups["Padding"] = "padding";
    VaryGroups["FontSize"] = "font-size";
    VaryGroups["FontType"] = "font-type";
    VaryGroups["FontWeight"] = "font-weight";
    VaryGroups["TextAlign"] = "text-align";
    VaryGroups["TextTransform"] = "text-transform";
    VaryGroups["Display"] = "display";
    VaryGroups["Position"] = "position";
    VaryGroups["AlignItems"] = "align-items";
    VaryGroups["JustifyContent"] = "justify-content";
    VaryGroups["OutlineWidth"] = "outline-width";
    VaryGroups["OutlineStyle"] = "outline-style";
    VaryGroups["OutlineColor"] = "outline-color";
    VaryGroups["OutlineOffset"] = "outline-offset";
    VaryGroups["BorderWidth"] = "border-width";
    VaryGroups["BorderStyle"] = "border-style";
    VaryGroups["BorderColor"] = "border-color";
    VaryGroups["BorderRadius"] = "border-radius";
    VaryGroups["BoxShadow"] = "box-shadow";
    VaryGroups["ContainerType"] = "container-type";
    VaryGroups["Visibility"] = "visibility";
    VaryGroups["MixBlendMode"] = "mix-blend-mode";
})($31817f166bdd4ef6$export$56042872fe5dcdae || ($31817f166bdd4ef6$export$56042872fe5dcdae = {}));
var $31817f166bdd4ef6$export$d64820bf5a686c09;
(function(ColorSuffixes) {
    ColorSuffixes["Subtle"] = "subtle";
    ColorSuffixes["Contrast"] = "contrast";
    ColorSuffixes["Shade"] = "shade";
    ColorSuffixes["Tint"] = "tint";
})($31817f166bdd4ef6$export$d64820bf5a686c09 || ($31817f166bdd4ef6$export$d64820bf5a686c09 = {}));
const $31817f166bdd4ef6$export$81526aa834726fe9 = Object.values($31817f166bdd4ef6$export$d64820bf5a686c09);
var $31817f166bdd4ef6$export$c537fa0d021d010b;
(function(Colors) {
    Colors["Primary"] = "primary";
    Colors["PrimarySubtle"] = "primary-subtle";
    Colors["PrimaryContrast"] = "primary-contrast";
    Colors["PrimaryShade"] = "primary-shade";
    Colors["PrimaryTint"] = "primary-tint";
    Colors["Secondary"] = "secondary";
    Colors["SecondarySubtle"] = "secondary-subtle";
    Colors["SecondaryContrast"] = "secondary-contrast";
    Colors["SecondaryShade"] = "secondary-shade";
    Colors["SecondaryTint"] = "secondary-tint";
    Colors["Tertiary"] = "tertiary";
    Colors["TertiarySubtle"] = "tertiary-subtle";
    Colors["TertiaryContrast"] = "tertiary-contrast";
    Colors["TertiaryShade"] = "tertiary-shade";
    Colors["TertiaryTint"] = "tertiary-tint";
    Colors["Success"] = "success";
    Colors["SuccessSubtle"] = "success-subtle";
    Colors["SuccessContrast"] = "success-contrast";
    Colors["SuccessShade"] = "success-shade";
    Colors["SuccessTint"] = "success-tint";
    Colors["Danger"] = "danger";
    Colors["DangerSubtle"] = "danger-subtle";
    Colors["DangerContrast"] = "danger-contrast";
    Colors["DangerShade"] = "danger-shade";
    Colors["DangerTint"] = "danger-tint";
    Colors["Warning"] = "warning";
    Colors["WarningSubtle"] = "warning-subtle";
    Colors["WarningContrast"] = "warning-contrast";
    Colors["WarningShade"] = "warning-shade";
    Colors["WarningTint"] = "warning-tint";
    Colors["Dark"] = "dark";
    Colors["DarkSubtle"] = "dark-subtle";
    Colors["DarkContrast"] = "dark-contrast";
    Colors["DarkShade"] = "dark-shade";
    Colors["DarkTint"] = "dark-tint";
    Colors["Medium"] = "medium";
    Colors["MediumSubtle"] = "medium-subtle";
    Colors["MediumContrast"] = "medium-contrast";
    Colors["MediumShade"] = "medium-shade";
    Colors["MediumTint"] = "medium-tint";
    Colors["Light"] = "light";
    Colors["LightSubtle"] = "light-subtle";
    Colors["LightContrast"] = "light-contrast";
    Colors["LightShade"] = "light-shade";
    Colors["LightTint"] = "light-tint";
    Colors["Background"] = "background";
    Colors["BackgroundSubtle"] = "background-subtle";
    Colors["BackgroundContrast"] = "background-contrast";
    Colors["BackgroundShade"] = "background-shade";
    Colors["BackgroundTint"] = "background-tint";
    Colors["Middleground"] = "middleground";
    Colors["MiddlegroundSubtle"] = "middleground-subtle";
    Colors["MiddlegroundContrast"] = "middleground-contrast";
    Colors["MiddlegroundShade"] = "middleground-shade";
    Colors["MiddlegroundTint"] = "middleground-tint";
    Colors["Foreground"] = "foreground";
    Colors["ForegroundSubtle"] = "foreground-subtle";
    Colors["ForegroundContrast"] = "foreground-contrast";
    Colors["ForegroundShade"] = "foreground-shade";
    Colors["ForegroundTint"] = "foreground-tint";
})($31817f166bdd4ef6$export$c537fa0d021d010b || ($31817f166bdd4ef6$export$c537fa0d021d010b = {}));
var $31817f166bdd4ef6$export$282c7ac153d663bf;
(function(CommonColors) {
    CommonColors["Gray"] = "gray";
    CommonColors["GraySubtle"] = "gray-subtle";
    CommonColors["GrayContrast"] = "gray-contrast";
    CommonColors["GrayShade"] = "gray-shade";
    CommonColors["GrayTint"] = "gray-tint";
    CommonColors["Zinc"] = "zinc";
    CommonColors["ZincSubtle"] = "zinc-subtle";
    CommonColors["ZincContrast"] = "zinc-contrast";
    CommonColors["ZincShade"] = "zinc-shade";
    CommonColors["ZincTint"] = "zinc-tint";
    CommonColors["Brown"] = "brown";
    CommonColors["BrownSubtle"] = "brown-subtle";
    CommonColors["BrownContrast"] = "brown-contrast";
    CommonColors["BrownShade"] = "brown-shade";
    CommonColors["BrownTint"] = "brown-tint";
    CommonColors["Amber"] = "amber";
    CommonColors["AmberSubtle"] = "amber-subtle";
    CommonColors["AmberContrast"] = "amber-contrast";
    CommonColors["AmberShade"] = "amber-shade";
    CommonColors["AmberTint"] = "amber-tint";
    CommonColors["Yellow"] = "yellow";
    CommonColors["YellowSubtle"] = "yellow-subtle";
    CommonColors["YellowContrast"] = "yellow-contrast";
    CommonColors["YellowShade"] = "yellow-shade";
    CommonColors["YellowTint"] = "yellow-tint";
    CommonColors["Orange"] = "orange";
    CommonColors["OrangeSubtle"] = "orange-subtle";
    CommonColors["OrangeContrast"] = "orange-contrast";
    CommonColors["OrangeShade"] = "orange-shade";
    CommonColors["OrangeTint"] = "orange-tint";
    CommonColors["Lime"] = "lime";
    CommonColors["LimeSubtle"] = "lime-subtle";
    CommonColors["LimeContrast"] = "lime-contrast";
    CommonColors["LimeShade"] = "lime-shade";
    CommonColors["LimeTint"] = "lime-tint";
    CommonColors["Green"] = "green";
    CommonColors["GreenSubtle"] = "green-subtle";
    CommonColors["GreenContrast"] = "green-contrast";
    CommonColors["GreenShade"] = "green-shade";
    CommonColors["GreenTint"] = "green-tint";
    CommonColors["Teal"] = "teal";
    CommonColors["TealSubtle"] = "teal-subtle";
    CommonColors["TealContrast"] = "teal-contrast";
    CommonColors["TealShade"] = "teal-shade";
    CommonColors["TealTint"] = "teal-tint";
    CommonColors["Cyan"] = "cyan";
    CommonColors["CyanSubtle"] = "cyan-subtle";
    CommonColors["CyanContrast"] = "cyan-contrast";
    CommonColors["CyanShade"] = "cyan-shade";
    CommonColors["CyanTint"] = "cyan-tint";
    CommonColors["Blue"] = "blue";
    CommonColors["BlueSubtle"] = "blue-subtle";
    CommonColors["BlueContrast"] = "blue-contrast";
    CommonColors["BlueShade"] = "blue-shade";
    CommonColors["BlueTint"] = "blue-tint";
    CommonColors["Navy"] = "navy";
    CommonColors["NavySubtle"] = "navy-subtle";
    CommonColors["NavyContrast"] = "navy-contrast";
    CommonColors["NavyShade"] = "navy-shade";
    CommonColors["NavyTint"] = "navy-tint";
    CommonColors["Indigo"] = "indigo";
    CommonColors["IndigoSubtle"] = "indigo-subtle";
    CommonColors["IndigoContrast"] = "indigo-contrast";
    CommonColors["IndigoShade"] = "indigo-shade";
    CommonColors["IndigoTint"] = "indigo-tint";
    CommonColors["Violet"] = "violet";
    CommonColors["VioletSubtle"] = "violet-subtle";
    CommonColors["VioletContrast"] = "violet-contrast";
    CommonColors["VioletShade"] = "violet-shade";
    CommonColors["VioletTint"] = "violet-tint";
    CommonColors["Purple"] = "purple";
    CommonColors["PurpleSubtle"] = "purple-subtle";
    CommonColors["PurpleContrast"] = "purple-contrast";
    CommonColors["PurpleShade"] = "purple-shade";
    CommonColors["PurpleTint"] = "purple-tint";
    CommonColors["Pink"] = "pink";
    CommonColors["PinkSubtle"] = "pink-subtle";
    CommonColors["PinkContrast"] = "pink-contrast";
    CommonColors["PinkShade"] = "pink-shade";
    CommonColors["PinkTint"] = "pink-tint";
    CommonColors["Red"] = "red";
    CommonColors["RedSubtle"] = "red-subtle";
    CommonColors["RedContrast"] = "red-contrast";
    CommonColors["RedShade"] = "red-shade";
    CommonColors["RedTint"] = "red-tint";
})($31817f166bdd4ef6$export$282c7ac153d663bf || ($31817f166bdd4ef6$export$282c7ac153d663bf = {}));
const $31817f166bdd4ef6$export$56d196d2844d1ca1 = Object.values($31817f166bdd4ef6$export$c537fa0d021d010b);
const $31817f166bdd4ef6$export$3798dd22f2e08b2a = $31817f166bdd4ef6$export$56d196d2844d1ca1.filter((item)=>!~item.indexOf("-"));
const $31817f166bdd4ef6$export$4565673469fb7a72 = Object.values($31817f166bdd4ef6$export$282c7ac153d663bf);
const $31817f166bdd4ef6$export$27ee2f69f6d06601 = $31817f166bdd4ef6$export$4565673469fb7a72.filter((item)=>!~item.indexOf("-"));
const $31817f166bdd4ef6$export$d1d53f2402c51dff = [
    ...$31817f166bdd4ef6$export$56d196d2844d1ca1,
    ...$31817f166bdd4ef6$export$4565673469fb7a72
];
const $31817f166bdd4ef6$export$23d2213ae8b91376 = [
    ...$31817f166bdd4ef6$export$3798dd22f2e08b2a,
    ...$31817f166bdd4ef6$export$27ee2f69f6d06601
];
var $31817f166bdd4ef6$export$98b06ed8231c52b6;
(function(GradientSuffixes) {
    GradientSuffixes["Subtle"] = "subtle";
    GradientSuffixes["Contrast"] = "contrast";
    GradientSuffixes["Shade"] = "shade";
    GradientSuffixes["Tint"] = "tint";
})($31817f166bdd4ef6$export$98b06ed8231c52b6 || ($31817f166bdd4ef6$export$98b06ed8231c52b6 = {}));
const $31817f166bdd4ef6$export$6d38fe7c9c2514d8 = Object.values($31817f166bdd4ef6$export$98b06ed8231c52b6);
var $31817f166bdd4ef6$export$c58087bb8c87b050;
(function(Gradients) {
    Gradients["Primary"] = "gradient-primary";
    Gradients["PrimarySubtle"] = "gradient-primary-subtle";
    Gradients["PrimaryContrast"] = "gradient-primary-contrast";
    Gradients["PrimaryShade"] = "gradient-primary-shade";
    Gradients["PrimaryTint"] = "gradient-primary-tint";
    Gradients["Secondary"] = "gradient-secondary";
    Gradients["SecondarySubtle"] = "gradient-secondary-subtle";
    Gradients["SecondaryContrast"] = "gradient-secondary-contrast";
    Gradients["SecondaryShade"] = "gradient-secondary-shade";
    Gradients["SecondaryTint"] = "gradient-secondary-tint";
    Gradients["Tertiary"] = "gradient-tertiary";
    Gradients["TertiarySubtle"] = "gradient-tertiary-subtle";
    Gradients["TertiaryContrast"] = "gradient-tertiary-contrast";
    Gradients["TertiaryShade"] = "gradient-tertiary-shade";
    Gradients["TertiaryTint"] = "gradient-tertiary-tint";
    Gradients["Success"] = "gradient-success";
    Gradients["SuccessSubtle"] = "gradient-success-subtle";
    Gradients["SuccessContrast"] = "gradient-success-contrast";
    Gradients["SuccessShade"] = "gradient-success-shade";
    Gradients["SuccessTint"] = "gradient-success-tint";
    Gradients["Danger"] = "gradient-danger";
    Gradients["DangerSubtle"] = "gradient-danger-subtle";
    Gradients["DangerContrast"] = "gradient-danger-contrast";
    Gradients["DangerShade"] = "gradient-danger-shade";
    Gradients["DangerTint"] = "gradient-danger-tint";
    Gradients["Warning"] = "gradient-warning";
    Gradients["WarningSubtle"] = "gradient-warning-subtle";
    Gradients["WarningContrast"] = "gradient-warning-contrast";
    Gradients["WarningShade"] = "gradient-warning-shade";
    Gradients["WarningTint"] = "gradient-warning-tint";
    Gradients["Dark"] = "gradient-dark";
    Gradients["DarkSubtle"] = "gradient-dark-subtle";
    Gradients["DarkContrast"] = "gradient-dark-contrast";
    Gradients["DarkShade"] = "gradient-dark-shade";
    Gradients["DarkTint"] = "gradient-dark-tint";
    Gradients["Medium"] = "gradient-medium";
    Gradients["MediumSubtle"] = "gradient-medium-subtle";
    Gradients["MediumContrast"] = "gradient-medium-contrast";
    Gradients["MediumShade"] = "gradient-medium-shade";
    Gradients["MediumTint"] = "gradient-medium-tint";
    Gradients["Light"] = "gradient-light";
    Gradients["LightSubtle"] = "gradient-light-subtle";
    Gradients["LightContrast"] = "gradient-light-contrast";
    Gradients["LightShade"] = "gradient-light-shade";
    Gradients["LightTint"] = "gradient-light-tint";
    Gradients["Background"] = "gradient-background";
    Gradients["BackgroundSubtle"] = "gradient-background-subtle";
    Gradients["BackgroundContrast"] = "gradient-background-contrast";
    Gradients["BackgroundShade"] = "gradient-background-shade";
    Gradients["BackgroundTint"] = "gradient-background-tint";
    Gradients["Middleground"] = "gradient-middleground";
    Gradients["MiddlegroundSubtle"] = "gradient-middleground-subtle";
    Gradients["MiddlegroundContrast"] = "gradient-middleground-contrast";
    Gradients["MiddlegroundShade"] = "gradient-middleground-shade";
    Gradients["MiddlegroundTint"] = "gradient-middleground-tint";
    Gradients["Foreground"] = "gradient-foreground";
    Gradients["ForegroundSubtle"] = "gradient-foreground-subtle";
    Gradients["ForegroundContrast"] = "gradient-foreground-contrast";
    Gradients["ForegroundShade"] = "gradient-foreground-shade";
    Gradients["ForegroundTint"] = "gradient-foreground-tint";
})($31817f166bdd4ef6$export$c58087bb8c87b050 || ($31817f166bdd4ef6$export$c58087bb8c87b050 = {}));
var $31817f166bdd4ef6$export$d7dbf737df2c1cf;
(function(CommonGradients) {
    CommonGradients["VitalOcean"] = "gradient-vital-ocean";
    CommonGradients["VitalOceanSubtle"] = "gradient-vital-ocean-subtle";
    CommonGradients["VitalOceanContrast"] = "gradient-vital-ocean-contrast";
    CommonGradients["VitalOceanShade"] = "gradient-vital-ocean-shade";
    CommonGradients["VitalOceanTint"] = "gradient-vital-ocean-tint";
    CommonGradients["KaleSalad"] = "gradient-kale-salad";
    CommonGradients["KaleSaladSubtle"] = "gradient-kale-salad-subtle";
    CommonGradients["KaleSaladContrast"] = "gradient-kale-salad-contrast";
    CommonGradients["KaleSaladShade"] = "gradient-kale-salad-shade";
    CommonGradients["KaleSaladTint"] = "gradient-kale-salad-tint";
    CommonGradients["DiscoClub"] = "gradient-disco-club";
    CommonGradients["DiscoClubSubtle"] = "gradient-disco-club-subtle";
    CommonGradients["DiscoClubContrast"] = "gradient-disco-club-contrast";
    CommonGradients["DiscoClubShade"] = "gradient-disco-club-shade";
    CommonGradients["DiscoClubTint"] = "gradient-disco-club-tint";
    CommonGradients["ShadyLane"] = "gradient-shady-lane";
    CommonGradients["ShadyLaneSubtle"] = "gradient-shady-lane-subtle";
    CommonGradients["ShadyLaneContrast"] = "gradient-shady-lane-contrast";
    CommonGradients["ShadyLaneShade"] = "gradient-shady-lane-shade";
    CommonGradients["ShadyLaneTint"] = "gradient-shady-lane-tint";
    CommonGradients["RetroWagon"] = "gradient-retro-wagon";
    CommonGradients["RetroWagonSubtle"] = "gradient-retro-wagon-subtle";
    CommonGradients["RetroWagonContrast"] = "gradient-retro-wagon-contrast";
    CommonGradients["RetroWagonShade"] = "gradient-retro-wagon-shade";
    CommonGradients["RetroWagonTint"] = "gradient-retro-wagon-tint";
    CommonGradients["FrescoCrush"] = "gradient-fresco-crush";
    CommonGradients["FrescoCrushSubtle"] = "gradient-fresco-crush-subtle";
    CommonGradients["FrescoCrushContrast"] = "gradient-fresco-crush-contrast";
    CommonGradients["FrescoCrushShade"] = "gradient-fresco-crush-shade";
    CommonGradients["FrescoCrushTint"] = "gradient-fresco-crush-tint";
    CommonGradients["CucumberWater"] = "gradient-cucumber-water";
    CommonGradients["CucumberWaterSubtle"] = "gradient-cucumber-water-subtle";
    CommonGradients["CucumberWaterContrast"] = "gradient-cucumber-water-contrast";
    CommonGradients["CucumberWaterShade"] = "gradient-cucumber-water-shade";
    CommonGradients["CucumberWaterTint"] = "gradient-cucumber-water-tint";
    CommonGradients["SeaSalt"] = "gradient-sea-salt";
    CommonGradients["SeaSaltSubtle"] = "gradient-sea-salt-subtle";
    CommonGradients["SeaSaltContrast"] = "gradient-sea-salt-contrast";
    CommonGradients["SeaSaltShade"] = "gradient-sea-salt-shade";
    CommonGradients["SeaSaltTint"] = "gradient-sea-salt-tint";
    CommonGradients["ParFour"] = "gradient-par-four";
    CommonGradients["ParFourSubtle"] = "gradient-par-four-subtle";
    CommonGradients["ParFourContrast"] = "gradient-par-four-contrast";
    CommonGradients["ParFourShade"] = "gradient-par-four-shade";
    CommonGradients["ParFourTint"] = "gradient-par-four-tint";
    CommonGradients["OoeyGooey"] = "gradient-ooey-gooey";
    CommonGradients["OoeyGooeySubtle"] = "gradient-ooey-gooey-subtle";
    CommonGradients["OoeyGooeyContrast"] = "gradient-ooey-gooey-contrast";
    CommonGradients["OoeyGooeyShade"] = "gradient-ooey-gooey-shade";
    CommonGradients["OoeyGooeyTint"] = "gradient-ooey-gooey-tint";
    CommonGradients["BloodyMimosa"] = "gradient-bloody-mimosa";
    CommonGradients["BloodyMimosaSubtle"] = "gradient-bloody-mimosa-subtle";
    CommonGradients["BloodyMimosaContrast"] = "gradient-bloody-mimosa-contrast";
    CommonGradients["BloodyMimosaShade"] = "gradient-bloody-mimosa-shade";
    CommonGradients["BloodyMimosaTint"] = "gradient-bloody-mimosa-tint";
    CommonGradients["LovelyLilly"] = "gradient-lovely-lilly";
    CommonGradients["LovelyLillySubtle"] = "gradient-lovely-lilly-subtle";
    CommonGradients["LovelyLillyContrast"] = "gradient-lovely-lilly-contrast";
    CommonGradients["LovelyLillyShade"] = "gradient-lovely-lilly-shade";
    CommonGradients["LovelyLillyTint"] = "gradient-lovely-lilly-tint";
    CommonGradients["AquaSpray"] = "gradient-aqua-spray";
    CommonGradients["AquaSpraySubtle"] = "gradient-aqua-spray-subtle";
    CommonGradients["AquaSprayContrast"] = "gradient-aqua-spray-contrast";
    CommonGradients["AquaSprayShade"] = "gradient-aqua-spray-shade";
    CommonGradients["AquaSprayTint"] = "gradient-aqua-spray-tint";
    CommonGradients["MelloYellow"] = "gradient-mello-yellow";
    CommonGradients["MelloYellowSubtle"] = "gradient-mello-yellow-subtle";
    CommonGradients["MelloYellowContrast"] = "gradient-mello-yellow-contrast";
    CommonGradients["MelloYellowShade"] = "gradient-mello-yellow-shade";
    CommonGradients["MelloYellowTint"] = "gradient-mello-yellow-tint";
    CommonGradients["DustyCactus"] = "gradient-dusty-cactus";
    CommonGradients["DustyCactusSubtle"] = "gradient-dusty-cactus-subtle";
    CommonGradients["DustyCactusContrast"] = "gradient-dusty-cactus-contrast";
    CommonGradients["DustyCactusShade"] = "gradient-dusty-cactus-shade";
    CommonGradients["DustyCactusTint"] = "gradient-dusty-cactus-tint";
    CommonGradients["PremiumDark"] = "gradient-premium-dark";
    CommonGradients["PremiumDarkSubtle"] = "gradient-premium-dark-subtle";
    CommonGradients["PremiumDarkContrast"] = "gradient-premium-dark-contrast";
    CommonGradients["PremiumDarkShade"] = "gradient-premium-dark-shade";
    CommonGradients["PremiumDarkTint"] = "gradient-premium-dark-tint";
    CommonGradients["PerfectWhite"] = "gradient-perfect-white";
    CommonGradients["PerfectWhiteSubtle"] = "gradient-perfect-white-subtle";
    CommonGradients["PerfectWhiteContrast"] = "gradient-perfect-white-contrast";
    CommonGradients["PerfectWhiteShade"] = "gradient-perfect-white-shade";
    CommonGradients["PerfectWhiteTint"] = "gradient-perfect-white-tint";
})($31817f166bdd4ef6$export$d7dbf737df2c1cf || ($31817f166bdd4ef6$export$d7dbf737df2c1cf = {}));
const $31817f166bdd4ef6$export$e579ddba40a2080c = Object.values($31817f166bdd4ef6$export$c58087bb8c87b050);
const $31817f166bdd4ef6$export$af31cfeed62fcb47 = $31817f166bdd4ef6$export$e579ddba40a2080c.filter((item)=>item.split("-").length <= 2);
const $31817f166bdd4ef6$export$56c30008fa8f17d8 = Object.values($31817f166bdd4ef6$export$d7dbf737df2c1cf);
const $31817f166bdd4ef6$export$ef013a55c097e969 = $31817f166bdd4ef6$export$56c30008fa8f17d8.filter((item)=>item.split("-").length <= 3);
const $31817f166bdd4ef6$export$1294c207fab87800 = [
    ...$31817f166bdd4ef6$export$e579ddba40a2080c,
    ...$31817f166bdd4ef6$export$56c30008fa8f17d8
];
const $31817f166bdd4ef6$export$d1737d8a9deb6091 = [
    ...$31817f166bdd4ef6$export$af31cfeed62fcb47,
    ...$31817f166bdd4ef6$export$ef013a55c097e969
];
const $31817f166bdd4ef6$export$d9d8493acaa33c8b = [
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.VitalOcean,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Blue
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.KaleSalad,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Cyan
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.DiscoClub,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Pink
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.ShadyLane,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Indigo
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.RetroWagon,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Lime
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.FrescoCrush,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Brown
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.CucumberWater,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Gray
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.SeaSalt,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Navy
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.ParFour,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Green
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.OoeyGooey,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Blue
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.BloodyMimosa,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Red
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.LovelyLilly,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Gray
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.AquaSpray,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Blue
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.MelloYellow,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Lime
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.DustyCactus,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Yellow
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.PremiumDark,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Zinc
    ],
    [
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.PerfectWhite,
        $31817f166bdd4ef6$export$282c7ac153d663bf.Gray
    ]
].reduce((result, [key, value])=>{
    result[key] = value;
    $31817f166bdd4ef6$export$6d38fe7c9c2514d8.forEach((suffix)=>result[`${key}-${suffix}`] = `${value}-${suffix}`);
    return result;
}, {});
const $31817f166bdd4ef6$export$d1259b1a47bd44eb = [
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Gray,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.CucumberWater
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Zinc,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.PremiumDark
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Brown,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.SeaSalt
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Amber,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.FrescoCrush
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Yellow,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.DustyCactus
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Orange,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.RetroWagon
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Lime,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.MelloYellow
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Green,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.ParFour
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Teal,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.OoeyGooey
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Cyan,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.KaleSalad
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Blue,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.AquaSpray
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Navy,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.VitalOcean
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Indigo,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.PerfectWhite
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Violet,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.ShadyLane
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Purple,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.LovelyLilly
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Pink,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.DiscoClub
    ],
    [
        $31817f166bdd4ef6$export$282c7ac153d663bf.Red,
        $31817f166bdd4ef6$export$d7dbf737df2c1cf.BloodyMimosa
    ]
].reduce((result, [key, value])=>{
    result[key] = value;
    $31817f166bdd4ef6$export$81526aa834726fe9.forEach((suffix)=>result[`${key}-${suffix}`] = `${value}-${suffix}`);
    return result;
}, {});
var $31817f166bdd4ef6$export$a5df81ad0ae1d0f4;
(function(Scales) {
    Scales["XXXS"] = "xxxs";
    Scales["XXS"] = "xxs";
    Scales["XS"] = "xs";
    Scales["SS"] = "ss";
    Scales["SM"] = "sm";
    Scales["MD"] = "md";
    Scales["ML"] = "ml";
    Scales["LG"] = "lg";
    Scales["SL"] = "sl";
    Scales["XL"] = "xl";
    Scales["XXL"] = "xxl";
    Scales["XXXL"] = "xxxl";
})($31817f166bdd4ef6$export$a5df81ad0ae1d0f4 || ($31817f166bdd4ef6$export$a5df81ad0ae1d0f4 = {}));
const $31817f166bdd4ef6$export$9c2218f463f17dc5 = Object.values($31817f166bdd4ef6$export$a5df81ad0ae1d0f4);
var $31817f166bdd4ef6$export$8925a2160c58a691;
(function(Wides) {
    Wides["XXXS"] = "xxxs";
    Wides["XXS"] = "xxs";
    Wides["XS"] = "xs";
    Wides["SS"] = "ss";
    Wides["SM"] = "sm";
    Wides["MD"] = "md";
    Wides["ML"] = "ml";
    Wides["LG"] = "lg";
    Wides["SL"] = "sl";
    Wides["XL"] = "xl";
    Wides["XXL"] = "xxl";
    Wides["XXXL"] = "xxxl";
})($31817f166bdd4ef6$export$8925a2160c58a691 || ($31817f166bdd4ef6$export$8925a2160c58a691 = {}));
const $31817f166bdd4ef6$export$9def4967710761b9 = Object.values($31817f166bdd4ef6$export$8925a2160c58a691);
var $31817f166bdd4ef6$export$c38d2c1bff643203;
(function(Breakpoints) {
    Breakpoints["XXXS"] = "150px";
    Breakpoints["XXS"] = "240px";
    Breakpoints["XS"] = "320px";
    Breakpoints["SS"] = "425px";
    Breakpoints["SM"] = "576px";
    Breakpoints["MD"] = "768px";
    Breakpoints["ML"] = "992px";
    Breakpoints["LG"] = "1024px";
    Breakpoints["SL"] = "1200px";
    Breakpoints["XL"] = "1440px";
    Breakpoints["XXL"] = "2560px";
    Breakpoints["XXXL"] = "3840px";
})($31817f166bdd4ef6$export$c38d2c1bff643203 || ($31817f166bdd4ef6$export$c38d2c1bff643203 = {}));
const $31817f166bdd4ef6$export$426e07cd0772984d = Object.values($31817f166bdd4ef6$export$c38d2c1bff643203);
var $31817f166bdd4ef6$export$51b80b579c3e8c37;
(function(Factors) {
    Factors["X0"] = "0x";
    Factors["X0_1"] = "0_1x";
    Factors["X0_2"] = "0_2x";
    Factors["X0_25"] = "0_25x";
    Factors["X0_3"] = "0_3x";
    Factors["X0_4"] = "0_4x";
    Factors["X0_5"] = "0_5x";
    Factors["X0_6"] = "0_6x";
    Factors["X0_7"] = "0_7x";
    Factors["X0_75"] = "0_75x";
    Factors["X0_8"] = "0_8x";
    Factors["X0_9"] = "0_9x";
    Factors["X1"] = "1x";
    Factors["X1_25"] = "1_25x";
    Factors["X1_5"] = "1_5x";
    Factors["X1_75"] = "1_75x";
    Factors["X2"] = "2x";
    Factors["X3"] = "3x";
    Factors["X4"] = "4x";
    Factors["X5"] = "5x";
    Factors["X6"] = "6x";
    Factors["X7"] = "7x";
    Factors["X8"] = "8x";
    Factors["X9"] = "9x";
    Factors["X10"] = "10x";
})($31817f166bdd4ef6$export$51b80b579c3e8c37 || ($31817f166bdd4ef6$export$51b80b579c3e8c37 = {}));
const $31817f166bdd4ef6$export$dbdb347f12e46d6c = Object.values($31817f166bdd4ef6$export$51b80b579c3e8c37);
var $31817f166bdd4ef6$export$9727071ea26870f1;
(function(FontTypes) {
    FontTypes["Head"] = "head";
    FontTypes["Body"] = "body";
    FontTypes["Quote"] = "quote";
    FontTypes["Code"] = "code";
})($31817f166bdd4ef6$export$9727071ea26870f1 || ($31817f166bdd4ef6$export$9727071ea26870f1 = {}));
const $31817f166bdd4ef6$export$ee855184183fcaca = Object.values($31817f166bdd4ef6$export$9727071ea26870f1);
var $31817f166bdd4ef6$export$32743b01f42d159e;
(function(FontWeights) {
    FontWeights["Thin"] = "100";
    FontWeights["ExtraLight"] = "200";
    FontWeights["Light"] = "300";
    FontWeights["Regular"] = "400";
    FontWeights["Medium"] = "500";
    FontWeights["SemiBold"] = "600";
    FontWeights["Bold"] = "700";
    FontWeights["ExtraBold"] = "800";
    FontWeights["Black"] = "900";
})($31817f166bdd4ef6$export$32743b01f42d159e || ($31817f166bdd4ef6$export$32743b01f42d159e = {}));
const $31817f166bdd4ef6$export$6d309717e7ca946d = Object.values($31817f166bdd4ef6$export$32743b01f42d159e);
var $31817f166bdd4ef6$export$9dfea9f7befa915b;
(function(TextAligns) {
    TextAligns["Start"] = "start";
    TextAligns["End"] = "end";
    TextAligns["Left"] = "left";
    TextAligns["Right"] = "right";
    TextAligns["Center"] = "center";
    TextAligns["Justify"] = "justify";
    TextAligns["JustifyAll"] = "justify-all";
    TextAligns["MatchParent"] = "match-parent";
})($31817f166bdd4ef6$export$9dfea9f7befa915b || ($31817f166bdd4ef6$export$9dfea9f7befa915b = {}));
const $31817f166bdd4ef6$export$da897c84fc20cce6 = Object.values($31817f166bdd4ef6$export$9dfea9f7befa915b);
var $31817f166bdd4ef6$export$3441de390a14d15e;
(function(TextTransforms) {
    TextTransforms["Capitalize"] = "capitalize";
    TextTransforms["Lowercase"] = "lowercase";
    TextTransforms["Uppercase"] = "uppercase";
})($31817f166bdd4ef6$export$3441de390a14d15e || ($31817f166bdd4ef6$export$3441de390a14d15e = {}));
const $31817f166bdd4ef6$export$893f936926e5a722 = Object.values($31817f166bdd4ef6$export$3441de390a14d15e);
var $31817f166bdd4ef6$export$1f00bafdc7314b42;
(function(AlignItems) {
    AlignItems["Normal"] = "normal";
    AlignItems["Center"] = "center";
    AlignItems["Start"] = "start";
    AlignItems["End"] = "end";
    AlignItems["FlexStart"] = "flex-start";
    AlignItems["FlexEnd"] = "flex-end";
    AlignItems["SelfStart"] = "self-start";
    AlignItems["SelfEnd"] = "self-end";
    AlignItems["Baseline"] = "baseline";
    AlignItems["Stretch"] = "stretch";
})($31817f166bdd4ef6$export$1f00bafdc7314b42 || ($31817f166bdd4ef6$export$1f00bafdc7314b42 = {}));
const $31817f166bdd4ef6$export$975fb9b7700405d4 = Object.values($31817f166bdd4ef6$export$1f00bafdc7314b42);
var $31817f166bdd4ef6$export$c53c21700e6d4214;
(function(JustifyContents) {
    JustifyContents["Normal"] = "normal";
    JustifyContents["Center"] = "center";
    JustifyContents["Left"] = "left";
    JustifyContents["Right"] = "right";
    JustifyContents["Start"] = "start";
    JustifyContents["End"] = "end";
    JustifyContents["FlexStart"] = "flex-start";
    JustifyContents["FlexEnd"] = "flex-end";
    JustifyContents["SpaceBetween"] = "space-between";
    JustifyContents["SpaceEvenly"] = "space-evenly";
    JustifyContents["SpaceAround"] = "space-around";
    JustifyContents["Stretch"] = "stretch";
})($31817f166bdd4ef6$export$c53c21700e6d4214 || ($31817f166bdd4ef6$export$c53c21700e6d4214 = {}));
const $31817f166bdd4ef6$export$c366c7e9ede6b57f = Object.values($31817f166bdd4ef6$export$c53c21700e6d4214);
var $31817f166bdd4ef6$export$5e1447b10f467566;
(function(OutlineWidths) {
    OutlineWidths["Zero"] = "zero";
    OutlineWidths["Tiny"] = "tiny";
    OutlineWidths["Small"] = "small";
    OutlineWidths["Base"] = "base";
    OutlineWidths["Big"] = "big";
    OutlineWidths["Huge"] = "huge";
    OutlineWidths["Massive"] = "massive";
})($31817f166bdd4ef6$export$5e1447b10f467566 || ($31817f166bdd4ef6$export$5e1447b10f467566 = {}));
const $31817f166bdd4ef6$export$c774257ecbce75cb = Object.values($31817f166bdd4ef6$export$5e1447b10f467566);
var $31817f166bdd4ef6$export$26b32a0f54887ac9;
(function(OutlineStyles) {
    OutlineStyles["Solid"] = "solid";
    OutlineStyles["Dashed"] = "dashed";
    OutlineStyles["Dotted"] = "dotted";
    OutlineStyles["Double"] = "double";
    OutlineStyles["Groove"] = "groove";
    OutlineStyles["Ridge"] = "ridge";
    OutlineStyles["Inset"] = "inset";
    OutlineStyles["Outset"] = "outset";
    OutlineStyles["Hidden"] = "hidden";
    OutlineStyles["None"] = "none";
})($31817f166bdd4ef6$export$26b32a0f54887ac9 || ($31817f166bdd4ef6$export$26b32a0f54887ac9 = {}));
const $31817f166bdd4ef6$export$cd60ed4835852415 = Object.values($31817f166bdd4ef6$export$26b32a0f54887ac9);
var $31817f166bdd4ef6$export$ca8bbdf99f3623b2;
(function(OutlineOffsets) {
    OutlineOffsets["Zero"] = "zero";
    OutlineOffsets["Tiny"] = "tiny";
    OutlineOffsets["Small"] = "small";
    OutlineOffsets["Base"] = "base";
    OutlineOffsets["Big"] = "big";
    OutlineOffsets["Huge"] = "huge";
    OutlineOffsets["Massive"] = "massive";
})($31817f166bdd4ef6$export$ca8bbdf99f3623b2 || ($31817f166bdd4ef6$export$ca8bbdf99f3623b2 = {}));
const $31817f166bdd4ef6$export$56dae581d36dd64a = Object.values($31817f166bdd4ef6$export$ca8bbdf99f3623b2);
var $31817f166bdd4ef6$export$c4cf3d80990a1d36;
(function(BorderWidths) {
    BorderWidths["Zero"] = "zero";
    BorderWidths["Tiny"] = "tiny";
    BorderWidths["Small"] = "small";
    BorderWidths["Base"] = "base";
    BorderWidths["Big"] = "big";
    BorderWidths["Huge"] = "huge";
    BorderWidths["Massive"] = "massive";
})($31817f166bdd4ef6$export$c4cf3d80990a1d36 || ($31817f166bdd4ef6$export$c4cf3d80990a1d36 = {}));
const $31817f166bdd4ef6$export$e6fdeba4f9f068fa = Object.values($31817f166bdd4ef6$export$c4cf3d80990a1d36);
var $31817f166bdd4ef6$export$abbc981f6afc30d7;
(function(BorderStyles) {
    BorderStyles["Solid"] = "solid";
    BorderStyles["Dashed"] = "dashed";
    BorderStyles["Dotted"] = "dotted";
    BorderStyles["Double"] = "double";
    BorderStyles["Groove"] = "groove";
    BorderStyles["Ridge"] = "ridge";
    BorderStyles["Inset"] = "inset";
    BorderStyles["Outset"] = "outset";
    BorderStyles["Hidden"] = "hidden";
    BorderStyles["None"] = "none";
})($31817f166bdd4ef6$export$abbc981f6afc30d7 || ($31817f166bdd4ef6$export$abbc981f6afc30d7 = {}));
const $31817f166bdd4ef6$export$b8bc7df7798bdc00 = Object.values($31817f166bdd4ef6$export$abbc981f6afc30d7);
var $31817f166bdd4ef6$export$23a3e522f25736ab;
(function(BorderRadiuses) {
    BorderRadiuses["Zero"] = "zero";
    BorderRadiuses["Tiny"] = "tiny";
    BorderRadiuses["Small"] = "small";
    BorderRadiuses["Base"] = "base";
    BorderRadiuses["Big"] = "big";
    BorderRadiuses["Huge"] = "huge";
    BorderRadiuses["Massive"] = "massive";
    BorderRadiuses["Quarter"] = "quarter";
    BorderRadiuses["Half"] = "half";
    BorderRadiuses["ThreeQuarters"] = "three-quarters";
    BorderRadiuses["Full"] = "full";
    BorderRadiuses["Max"] = "max";
})($31817f166bdd4ef6$export$23a3e522f25736ab || ($31817f166bdd4ef6$export$23a3e522f25736ab = {}));
const $31817f166bdd4ef6$export$f1ac48e766bced30 = Object.values($31817f166bdd4ef6$export$23a3e522f25736ab);
var $31817f166bdd4ef6$export$5681eac337822896;
(function(BoxShadows) {
    BoxShadows["None"] = "none";
    BoxShadows["Normal"] = "normal";
    BoxShadows["Least"] = "least";
    BoxShadows["Lesser"] = "lesser";
    BoxShadows["Greater"] = "greater";
    BoxShadows["Greatest"] = "greatest";
    BoxShadows["Scarcity"] = "scarcity";
    BoxShadows["Excess"] = "excess";
})($31817f166bdd4ef6$export$5681eac337822896 || ($31817f166bdd4ef6$export$5681eac337822896 = {}));
const $31817f166bdd4ef6$export$bbca71bf5213eea8 = Object.values($31817f166bdd4ef6$export$5681eac337822896);
var $31817f166bdd4ef6$export$6e383182a26455ff;
(function(ContainerTypes) {
    ContainerTypes["Normal"] = "normal";
    ContainerTypes["Size"] = "size";
    ContainerTypes["InlineSize"] = "inline-size";
})($31817f166bdd4ef6$export$6e383182a26455ff || ($31817f166bdd4ef6$export$6e383182a26455ff = {}));
const $31817f166bdd4ef6$export$631c5b7cfd9cc771 = Object.values($31817f166bdd4ef6$export$6e383182a26455ff);
var $31817f166bdd4ef6$export$972614fc43112105;
(function(Displays) {
    Displays["None"] = "none";
    Displays["Block"] = "block";
    Displays["Inline"] = "inline";
    Displays["InlineBlock"] = "inline-block";
    Displays["Flex"] = "flex";
    Displays["InlineFlex"] = "inline-flex";
    Displays["Grid"] = "grid";
    Displays["InlineGrid"] = "inline-grid";
    Displays["FlowRoot"] = "flow-root";
    Displays["Contents"] = "contents";
})($31817f166bdd4ef6$export$972614fc43112105 || ($31817f166bdd4ef6$export$972614fc43112105 = {}));
const $31817f166bdd4ef6$export$5894f50064620166 = Object.values($31817f166bdd4ef6$export$972614fc43112105);
var $31817f166bdd4ef6$export$53ba1d920b7b1325;
(function(Positions) {
    Positions["Static"] = "static";
    Positions["Relative"] = "relative";
    Positions["Absolute"] = "absolute";
    Positions["Fixed"] = "fixed";
    Positions["Sticky"] = "sticky";
})($31817f166bdd4ef6$export$53ba1d920b7b1325 || ($31817f166bdd4ef6$export$53ba1d920b7b1325 = {}));
const $31817f166bdd4ef6$export$1a1f61c9c4dd9df0 = Object.values($31817f166bdd4ef6$export$53ba1d920b7b1325);
var $31817f166bdd4ef6$export$878d96173d57e644;
(function(Visibilities) {
    Visibilities["Visible"] = "visible";
    Visibilities["Hidden"] = "hidden";
    Visibilities["Collapse"] = "collapse";
})($31817f166bdd4ef6$export$878d96173d57e644 || ($31817f166bdd4ef6$export$878d96173d57e644 = {}));
const $31817f166bdd4ef6$export$75a0240ba31fc504 = Object.values($31817f166bdd4ef6$export$878d96173d57e644);
var $31817f166bdd4ef6$export$9abb82bcc14b2771;
(function(MixBlendModes) {
    MixBlendModes["Normal"] = "normal";
    MixBlendModes["Multiply"] = "multiply";
    MixBlendModes["Screen"] = "screen";
    MixBlendModes["Overlay"] = "overlay";
    MixBlendModes["Darken"] = "darken";
    MixBlendModes["Lighten"] = "lighten";
    MixBlendModes["ColorDodge"] = "color-dodge";
    MixBlendModes["ColorBurn"] = "color-burn";
    MixBlendModes["HardLight"] = "hard-light";
    MixBlendModes["SoftLight"] = "soft-light";
    MixBlendModes["Difference"] = "difference";
    MixBlendModes["Exclusion"] = "exclusion";
    MixBlendModes["Hue"] = "hue";
    MixBlendModes["Saturation"] = "saturation";
    MixBlendModes["Color"] = "color";
    MixBlendModes["Luminosity"] = "luminosity";
})($31817f166bdd4ef6$export$9abb82bcc14b2771 || ($31817f166bdd4ef6$export$9abb82bcc14b2771 = {}));
const $31817f166bdd4ef6$export$df2a7b9efb3015a1 = Object.values($31817f166bdd4ef6$export$9abb82bcc14b2771);
function $31817f166bdd4ef6$export$c5abd6228eea3d7e(render, excludeCommon = false) {
    return (0, $cZ4os.unsafeCSS)((excludeCommon ? $31817f166bdd4ef6$export$56d196d2844d1ca1 : $31817f166bdd4ef6$export$d1d53f2402c51dff).map((name)=>{
        const nameSplits = name.split("-");
        const lastSegment = nameSplits[nameSplits.length - 1];
        const suffixName = nameSplits.length < 2 || !~$31817f166bdd4ef6$export$81526aa834726fe9.indexOf(lastSegment) ? "" : lastSegment;
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.Scheme;
        const fullName = `${groupName}-${name}`;
        const baseName = nameSplits.slice(0, !suffixName ? nameSplits.length : nameSplits.length - 1).join("-");
        const isContrast = suffixName === $31817f166bdd4ef6$export$d64820bf5a686c09.Contrast;
        const isSubtle = suffixName === $31817f166bdd4ef6$export$d64820bf5a686c09.Subtle;
        // colors
        const color = `var(--color-${name})`;
        const baseColor = `var(--color-${baseName})`;
        const baseContrast = `var(--color-${baseName}-contrast)`;
        const contrast = isSubtle ? "var(--color-foreground)" : isContrast ? baseColor : baseContrast;
        // render
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            baseName: baseName,
            suffixName: suffixName,
            isContrast: isContrast,
            isSubtle: isSubtle,
            baseColor: baseColor,
            baseContrast: baseContrast,
            color: color,
            contrast: contrast
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$717fe95f5467bc0b(render, excludeCommon = false) {
    return (0, $cZ4os.unsafeCSS)((excludeCommon ? $31817f166bdd4ef6$export$e579ddba40a2080c : $31817f166bdd4ef6$export$1294c207fab87800).map((name)=>{
        const nameSplits = name.replace("gradient-", "").split("-");
        const lastSegment = nameSplits[nameSplits.length - 1];
        const suffixName = nameSplits.length < 2 || !~$31817f166bdd4ef6$export$6d38fe7c9c2514d8.indexOf(lastSegment) ? "" : lastSegment;
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.Scheme;
        const fullName = `${groupName}-${name}`;
        const baseName = nameSplits.slice(0, !suffixName ? nameSplits.length : nameSplits.length - 1).join("-");
        const isContrast = suffixName === $31817f166bdd4ef6$export$98b06ed8231c52b6.Contrast;
        const isSubtle = suffixName === $31817f166bdd4ef6$export$98b06ed8231c52b6.Subtle;
        // colors
        const fallbackColorName = $31817f166bdd4ef6$export$d9d8493acaa33c8b[`gradient-${baseName}`];
        const colorName = fallbackColorName || baseName;
        const color = isSubtle ? `var(--color-${colorName}-subtle)` : `var(--color-${colorName})`;
        const baseColor = `var(--color-${colorName})`;
        const baseContrast = `var(--color-${colorName}-contrast)`;
        const contrast = isSubtle ? "var(--color-foreground)" : isContrast ? baseColor : baseContrast;
        // gradients
        const gradient = `var(--${name})`;
        const baseGradient = `var(--${name})`;
        const baseGradientContrast = `var(--${name}-contrast)`;
        const gradientContrast = isSubtle ? "var(--gradient-foreground)" : isContrast ? baseGradient : baseGradientContrast;
        // render
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            baseName: baseName,
            colorName: colorName,
            suffixName: suffixName,
            isContrast: isContrast,
            isSubtle: isSubtle,
            baseColor: baseColor,
            baseContrast: baseContrast,
            color: color,
            contrast: contrast,
            baseGradient: baseGradient,
            baseGradientContrast: baseGradientContrast,
            gradient: gradient,
            gradientContrast: gradientContrast
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$2d83c4cdf70e1f8b(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$9c2218f463f17dc5.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.Scale;
        const fullName = `${groupName}-${name}`;
        const scale = `var(--scale-${name})`;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            scale: scale
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$c3f2bc15ade16b63(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$9def4967710761b9.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.Wide;
        const fullName = `${groupName}-${name}`;
        const wide = `var(--wide-${name})`;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            wide: wide
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$310800e597c7c084(render) {
    return (0, $cZ4os.unsafeCSS)(Object.entries($31817f166bdd4ef6$export$c38d2c1bff643203).map(([name, breakpoint])=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.Breakpoint;
        const fullName = `${groupName}-${name}`;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            breakpoint: breakpoint
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$fc87627ac7c62c95(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$dbdb347f12e46d6c.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.Space;
        const fullName = `${groupName}-${name}`;
        const space = `var(--size-space-${name})`;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            space: space
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$d4c68164bc342f6d(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$dbdb347f12e46d6c.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.FontSize;
        const fullName = `${groupName}-${name}`;
        const size = `var(--size-text-${name})`;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            size: size
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$ad6b92aa4fd963ec(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$ee855184183fcaca.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.FontType;
        const fullName = `${groupName}-${name}`;
        const type = `var(--font-${name})`;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            type: type
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$e4e1a84b000adb60(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$6d309717e7ca946d.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.FontWeight;
        const fullName = `${groupName}-${name}`;
        const weight = name;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            weight: weight
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$3bdc141976062e38(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$da897c84fc20cce6.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.TextAlign;
        const fullName = `${groupName}-${name}`;
        const align = name;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            align: align
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$3549c479e11ce32a(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$893f936926e5a722.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.TextTransform;
        const fullName = `${groupName}-${name}`;
        const transform = name;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            transform: transform
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$6b8e6b8554996890(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$c366c7e9ede6b57f.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.JustifyContent;
        const fullName = `${groupName}-${name}`;
        const justify = name;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            justify: justify
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$42b537de7b3fb479(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$c774257ecbce75cb.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.OutlineWidth;
        const fullName = `${groupName}-${name}`;
        const width = `var(--size-outline-${name})`;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            width: width
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$3648134c26e01bdc(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$cd60ed4835852415.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.OutlineStyle;
        const fullName = `${groupName}-${name}`;
        const style = name;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            style: style
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$b993fe29496cc6e0(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$56dae581d36dd64a.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.OutlineOffset;
        const fullName = `${groupName}-${name}`;
        const offset = `var(--size-outline-${name})`;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            offset: offset
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$19dafee75ede306d(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$e6fdeba4f9f068fa.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.BorderWidth;
        const fullName = `${groupName}-${name}`;
        const width = `var(--size-border-${name})`;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            width: width
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$4795c9a5009a5e3e(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$b8bc7df7798bdc00.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.BorderStyle;
        const fullName = `${groupName}-${name}`;
        const style = name;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            style: style
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$dd755cfe6ed49f80(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$f1ac48e766bced30.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.BorderRadius;
        const fullName = `${groupName}-${name}`;
        const radius = `var(--size-radius-${name})`;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            radius: radius
        });
    }).join(""));
}
function $31817f166bdd4ef6$export$35eaa6ec761ba5d6(render) {
    return (0, $cZ4os.unsafeCSS)($31817f166bdd4ef6$export$bbca71bf5213eea8.map((name)=>{
        const groupName = $31817f166bdd4ef6$export$56042872fe5dcdae.BoxShadow;
        const fullName = `${groupName}-${name}`;
        const shadow = `var(--shadow-${name})`;
        return render({
            name: name,
            groupName: groupName,
            fullName: fullName,
            shadow: shadow
        });
    }).join(""));
}

});



parcelRegister("8gdKM", function(module, exports) {

$parcel$export(module.exports, "TiniElementComponents", function () { return $603a7c876d9d180a$export$bd2b635a48565f97; });
$parcel$export(module.exports, "TiniElementTheming", function () { return $603a7c876d9d180a$export$f85e165e96f38768; });

var $gKqnD = parcelRequire("gKqnD");
function $603a7c876d9d180a$export$bd2b635a48565f97(items) {
    return function(target) {
        return class extends target {
            connectedCallback() {
                (0, $gKqnD.registerComponents)(items);
                super.connectedCallback();
            }
        };
    };
}
function $603a7c876d9d180a$export$f85e165e96f38768(theming) {
    return function(target) {
        var _a;
        return _a = class extends target {
        }, _a.theming = theming, _a;
    };
}

});

parcelRegister("aynjv", function(module, exports) {

$parcel$export(module.exports, "partAttrMap", function () { return $7aef29ef2d8ae8f3$export$4d8f0184816291b7; });
function $7aef29ef2d8ae8f3$export$4d8f0184816291b7(info) {
    return Object.entries(info).reduce((result, [partAttr, truthy])=>{
        if (truthy) result += ` ${partAttr}`;
        return result;
    }, "");
}

});


parcelRegister("crJS3", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_TINI", function () { return $90fb96ab4fed0f9a$export$7e97b96280519fd9; });
$parcel$export(module.exports, "TINI_APP_CONTEXT", function () { return $90fb96ab4fed0f9a$export$3bdf553b2225e8f; });
$parcel$export(module.exports, "APP_ROOT", function () { return $90fb96ab4fed0f9a$export$7a0d0b5e26c56353; });
$parcel$export(module.exports, "SPLASHSCREEN_ID", function () { return $90fb96ab4fed0f9a$export$a2f67114b0344d2a; });
$parcel$export(module.exports, "NO_APP_ERROR", function () { return $90fb96ab4fed0f9a$export$b6628159a68cab98; });
$parcel$export(module.exports, "NO_REGISTER_ERROR", function () { return $90fb96ab4fed0f9a$export$7f5e2413156d2997; });
$parcel$export(module.exports, "ComponentTypes", function () { return $90fb96ab4fed0f9a$export$838a2fee7448e4aa; });
$parcel$export(module.exports, "LifecycleHooks", function () { return $90fb96ab4fed0f9a$export$933c4d0f2f1cd9f6; });
$parcel$export(module.exports, "RenderStatuses", function () { return $90fb96ab4fed0f9a$export$cc1afff23c08d218; });
parcelRequire("bsGWa");
var $2tid7 = parcelRequire("2tid7");
var $90fb96ab4fed0f9a$var$_a;
const $90fb96ab4fed0f9a$export$38c6526d67de94bb = "core";
const $90fb96ab4fed0f9a$export$59dbefa3c1eecdf = `tini:${$90fb96ab4fed0f9a$export$38c6526d67de94bb}`;
const $90fb96ab4fed0f9a$export$7e97b96280519fd9 = (0, $2tid7.GLOBAL_TINI);
const $90fb96ab4fed0f9a$export$3bdf553b2225e8f = ($90fb96ab4fed0f9a$var$_a = $90fb96ab4fed0f9a$export$7e97b96280519fd9).appContext || ($90fb96ab4fed0f9a$var$_a.appContext = {});
const $90fb96ab4fed0f9a$export$7a0d0b5e26c56353 = "app-root";
const $90fb96ab4fed0f9a$export$a2f67114b0344d2a = "splashscreen";
const $90fb96ab4fed0f9a$export$b6628159a68cab98 = new Error("No TiniJS app available.");
const $90fb96ab4fed0f9a$export$7f5e2413156d2997 = (id)=>new Error(`No register for the dependency "${id}".`);
var $90fb96ab4fed0f9a$export$838a2fee7448e4aa;
(function(ComponentTypes) {
    ComponentTypes["App"] = "app";
    ComponentTypes["Layout"] = "layout";
    ComponentTypes["Page"] = "page";
    ComponentTypes["Component"] = "component";
})($90fb96ab4fed0f9a$export$838a2fee7448e4aa || ($90fb96ab4fed0f9a$export$838a2fee7448e4aa = {}));
var $90fb96ab4fed0f9a$export$933c4d0f2f1cd9f6;
(function(LifecycleHooks) {
    LifecycleHooks["OnCreate"] = "onCreate";
    LifecycleHooks["OnDestroy"] = "onDestroy";
    LifecycleHooks["OnInit"] = "onInit";
    LifecycleHooks["OnReady"] = "onReady";
    LifecycleHooks["OnChanges"] = "onChanges";
    LifecycleHooks["OnFirstRender"] = "onFirstRender";
    LifecycleHooks["OnRenders"] = "onRenders";
    LifecycleHooks["OnChildrenRender"] = "onChildrenRender";
    LifecycleHooks["OnChildrenReady"] = "onChildrenReady";
})($90fb96ab4fed0f9a$export$933c4d0f2f1cd9f6 || ($90fb96ab4fed0f9a$export$933c4d0f2f1cd9f6 = {}));
var $90fb96ab4fed0f9a$export$cc1afff23c08d218;
(function(RenderStatuses) {
    RenderStatuses["Loading"] = "loading";
    RenderStatuses["Empty"] = "empty";
    RenderStatuses["Error"] = "error";
    RenderStatuses["Fulfilled"] = "fulfilled";
})($90fb96ab4fed0f9a$export$cc1afff23c08d218 || ($90fb96ab4fed0f9a$export$cc1afff23c08d218 = {}));

});

parcelRegister("3bQrU", function(module, exports) {

$parcel$export(module.exports, "isClass", function () { return $252b15782537095d$export$5578ef75f4140928; });
$parcel$export(module.exports, "getDIRegistry", function () { return $252b15782537095d$export$50c162ab235e71f; });
$parcel$export(module.exports, "getContext", function () { return $252b15782537095d$export$31553aaa555c1514; });
$parcel$export(module.exports, "getApp", function () { return $252b15782537095d$export$f9962582c9e66d99; });
$parcel$export(module.exports, "getOptions", function () { return $252b15782537095d$export$d2312e68e1f5ad00; });
$parcel$export(module.exports, "getConfigs", function () { return $252b15782537095d$export$18029fd8824da360; });
$parcel$export(module.exports, "registerGlobalHook", function () { return $252b15782537095d$export$21d92e09f371a2a8; });
$parcel$export(module.exports, "runGlobalHooks", function () { return $252b15782537095d$export$c22cae2e7b71ad16; });
$parcel$export(module.exports, "getSplashscreen", function () { return $252b15782537095d$export$ea63ddca4bab72bd; });
$parcel$export(module.exports, "hideSplashscreen", function () { return $252b15782537095d$export$199408ca5dbfdd6; });
$parcel$export(module.exports, "stylingWithBases", function () { return $252b15782537095d$export$aea7f2c51081131b; });

var $crJS3 = parcelRequire("crJS3");
function $252b15782537095d$export$c1d71edcdf967785(path) {
    return path;
}
function $252b15782537095d$export$5578ef75f4140928(input) {
    return typeof input === "function" && /^class\s/.test(Function.prototype.toString.call(input));
}
function $252b15782537095d$export$50c162ab235e71f() {
    return (0, $crJS3.GLOBAL_TINI).DIRegistry || ((0, $crJS3.GLOBAL_TINI).DIRegistry = {
        registers: new Map(),
        instances: new Map(),
        awaiters: []
    });
}
function $252b15782537095d$export$31553aaa555c1514() {
    return 0, $crJS3.TINI_APP_CONTEXT;
}
function $252b15782537095d$export$f9962582c9e66d99() {
    if (!(0, $crJS3.GLOBAL_TINI).app) throw 0, $crJS3.NO_APP_ERROR;
    return (0, $crJS3.GLOBAL_TINI).app;
}
function $252b15782537095d$export$d2312e68e1f5ad00() {
    return (0, $crJS3.TINI_APP_CONTEXT).options || {};
}
function $252b15782537095d$export$18029fd8824da360() {
    return (0, $crJS3.TINI_APP_CONTEXT).configs || {};
}
function $252b15782537095d$export$989e3317cffbaf8b(configs) {
    return (0, $crJS3.TINI_APP_CONTEXT).configs = configs;
}
function $252b15782537095d$export$21d92e09f371a2a8(componentTypeOrTypes, hookCycleOrCycles, hookAction) {
    // init the registry
    const registry = (0, $crJS3.GLOBAL_TINI).LHRegistry || ((0, $crJS3.GLOBAL_TINI).LHRegistry = {});
    // cycles & types
    const componentTypes = typeof componentTypeOrTypes === "string" ? [
        componentTypeOrTypes
    ] : componentTypeOrTypes;
    const hookCycles = typeof hookCycleOrCycles === "string" ? [
        hookCycleOrCycles
    ] : hookCycleOrCycles;
    // organize
    for(let i = 0; i < componentTypes.length; i++){
        const type = componentTypes[i];
        if (!registry[type]) registry[type] = {};
        for(let j = 0; j < hookCycles.length; j++){
            const cycle = hookCycles[j];
            if (!registry[type][cycle]) registry[type][cycle] = [];
            registry[type][cycle].push(hookAction);
        }
    }
    // result
    return registry;
}
function $252b15782537095d$export$ef800d0f6c42d381(type, cycle) {
    var _a, _b;
    return (_b = (_a = (0, $crJS3.GLOBAL_TINI).LHRegistry) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b[cycle];
}
function $252b15782537095d$export$c22cae2e7b71ad16(cycle, component) {
    const globalHooks = $252b15782537095d$export$ef800d0f6c42d381(component.constructor.componentType, cycle);
    const data = {
        source: component,
        app: $252b15782537095d$export$f9962582c9e66d99(),
        appContext: $252b15782537095d$export$31553aaa555c1514()
    };
    globalHooks === null || globalHooks === void 0 || globalHooks.forEach((action)=>action(data));
    return globalHooks;
}
function $252b15782537095d$export$ea63ddca4bab72bd() {
    return document.getElementById((0, $crJS3.SPLASHSCREEN_ID)) || undefined;
}
function $252b15782537095d$export$199408ca5dbfdd6() {
    const node = $252b15782537095d$export$ea63ddca4bab72bd();
    if (!node) return;
    if (node.hide instanceof Function) node.hide();
    else node.remove();
}
function $252b15782537095d$export$aea7f2c51081131b(bases, additionalStyling) {
    // bases
    const styling = bases.reduce((result, item)=>{
        Object.keys(item).forEach((key)=>{
            result[key] || (result[key] = []);
            result[key].push(item[key]);
        });
        return result;
    }, {});
    // more
    if (additionalStyling) Object.keys(additionalStyling).forEach((key)=>{
        styling[key] || (styling[key] = []);
        styling[key].push(...additionalStyling[key]);
    });
    // result
    return styling;
}

});

parcelRegister("iiFM1", function(module, exports) {

var $3bQrU = parcelRequire("3bQrU");
function $d52a4fc65c413948$export$2e2bcd8739ae039(id, dependency, instance) {
    const paramsMatchingArr = dependency.toString().match(/(constructor\()([\s\S]*?)\)/);
    if ((0, $3bQrU.isClass)(dependency) && paramsMatchingArr && paramsMatchingArr[2]) {
        const params = paramsMatchingArr[2].split(",").map((item)=>item.trim());
        const missingIds = [];
        for(let j = 0; j < params.length; j++){
            const param = params[j];
            const memberValue = instance[param];
            if (memberValue === undefined) missingIds.push(param);
        }
        if (missingIds.length) console.error(new Error(`
Dependencies are missing from the service [${id}] or provided in a wrong order.
Please provide them in 'app/providers.ts' or correcting its order:
      {
        ${id}: {
          provider: () => import('...'),
          deps: ['${params.join("', '")}']
        }
      }
`));
    }
}

});


parcelRegister("7a15g", function(module, exports) {
parcelRequire("lYoPT");
var $fXA0k = parcelRequire("fXA0k");
parcelRequire("giotI");
var $2smIZ = parcelRequire("2smIZ");
var $hz9ib = parcelRequire("hz9ib");
parcelRequire("aD8ND");
var $9XlTB = parcelRequire("9XlTB");

var $b1xHZ = parcelRequire("b1xHZ");
parcelRequire("bsGWa");
var $gKqnD = parcelRequire("gKqnD");
var $2tid7 = parcelRequire("2tid7");

var $crJS3 = parcelRequire("crJS3");
function $536a4ed35fa4631e$export$b3890eb0ae9dca99(dependencies, templates) {
    const main = templates.main;
    const loading = templates.loading || (0, $fXA0k.nothing);
    const empty = templates.empty || (0, $fXA0k.nothing);
    const error = templates.error || (0, $fXA0k.nothing);
    // check status
    const status = dependencies.every((item)=>item === undefined) ? (0, $crJS3.RenderStatuses).Loading : dependencies.every((item)=>item === null || item instanceof Array && !item.length || item instanceof Map && !item.size || item instanceof Object && !Object.keys(item).length) ? (0, $crJS3.RenderStatuses).Empty : dependencies.some((item)=>item instanceof Error) ? (0, $crJS3.RenderStatuses).Error : (0, $crJS3.RenderStatuses).Fulfilled;
    // render template accordingly
    return (0, $9XlTB.cache)(status === (0, $crJS3.RenderStatuses).Loading ? loading instanceof Function ? loading() : loading : status === (0, $crJS3.RenderStatuses).Empty ? empty instanceof Function ? empty() : empty : status === (0, $crJS3.RenderStatuses).Error ? error instanceof Function ? error(dependencies) : error : main instanceof Function ? main(dependencies) : main);
}
class $536a4ed35fa4631e$var$StyleDeepDirective extends (0, $2smIZ.AsyncDirective) {
    constructor(part){
        super(part);
        this.INTERNAL_ID = `_${(0, $b1xHZ.nanoid)(6)}`;
        this.activeTheme = (0, $gKqnD.getTheme)();
        this.onThemeChange = (e)=>{
            const newTheme = e.detail;
            if (this.activeTheme !== newTheme) {
                this.activeTheme = newTheme;
                this.injectStyle();
            }
        };
        this.part = part;
    }
    disconnected() {
        this.removeThemeListener();
    }
    reconnected() {
        this.addThemeListener();
    }
    render(textOrStyling) {
        var _a;
        if (this.checkForChanges(textOrStyling)) {
            (_a = this.removeThemeListener) === null || _a === void 0 || _a.call(this);
            this.textOrStyling = textOrStyling;
            if (this.isConnected) this.addThemeListener();
        }
        return 0, $fXA0k.noChange;
    }
    addThemeListener() {
        addEventListener((0, $2tid7.THEME_CHANGE_EVENT), this.onThemeChange);
        this.removeThemeListener = ()=>removeEventListener((0, $2tid7.THEME_CHANGE_EVENT), this.onThemeChange);
        return this.injectStyle();
    }
    checkForChanges(textOrStyling) {
        const currentTextOrStyling = this.textOrStyling || "";
        if (typeof textOrStyling !== typeof currentTextOrStyling) return true;
        else if (typeof textOrStyling === "string") return textOrStyling !== currentTextOrStyling;
        else return Object.keys(textOrStyling).some((key)=>textOrStyling[key] !== currentTextOrStyling[key]);
    }
    injectStyle() {
        var _a, _b;
        const { host: host } = ((_a = this.part) === null || _a === void 0 ? void 0 : _a.options) || {};
        const element = (_b = this.part) === null || _b === void 0 ? void 0 : _b.element;
        if (!host || !element) return;
        const renderRoot = host.shadowRoot || host || HTMLElement;
        const { soulId: soulId, themeId: themeId } = this.activeTheme;
        const rawStyleText = !this.textOrStyling ? "" : typeof this.textOrStyling === "string" ? this.textOrStyling : this.textOrStyling[themeId] || this.textOrStyling[soulId] || Object.values(this.textOrStyling)[0];
        const styleText = (0, $gKqnD.processComponentStyles)([
            rawStyleText
        ], this.activeTheme, (content)=>content.replace(/\.root/g, `.${this.INTERNAL_ID}`));
        // apply styles
        const currentStyleElement = renderRoot.getElementById(this.INTERNAL_ID);
        const styleElement = currentStyleElement || document.createElement("style");
        styleElement.textContent = styleText;
        if (!currentStyleElement) setTimeout(()=>{
            element.classList.add(this.INTERNAL_ID);
            styleElement.id = this.INTERNAL_ID;
            renderRoot.appendChild(styleElement);
        }, 0);
    }
}
const $536a4ed35fa4631e$export$59fea6da2f63f41 = (0, $hz9ib.directive)($536a4ed35fa4631e$var$StyleDeepDirective);

});
parcelRegister("giotI", function(module, exports) {
$parcel$export(module.exports, "AsyncDirective", function () { return (parcelRequire("2smIZ")).AsyncDirective; });
$parcel$export(module.exports, "directive", function () { return (parcelRequire("hz9ib")).directive; });
parcelRequire("2smIZ");

});
parcelRegister("2smIZ", function(module, exports) {

$parcel$export(module.exports, "AsyncDirective", function () { return $1c9fd2f19ef5e6b9$export$7d025501802325e; });
$parcel$export(module.exports, "directive", function () { return (parcelRequire("hz9ib")).directive; });

var $40A6J = parcelRequire("40A6J");

var $hz9ib = parcelRequire("hz9ib");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $1c9fd2f19ef5e6b9$var$s = (i, t)=>{
    const e = i._$AN;
    if (void 0 === e) return !1;
    for (const i of e)i._$AO?.(t, !1), $1c9fd2f19ef5e6b9$var$s(i, t);
    return !0;
}, $1c9fd2f19ef5e6b9$var$o = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === e?.size);
}, $1c9fd2f19ef5e6b9$var$r = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $1c9fd2f19ef5e6b9$var$c(t);
    }
};
function $1c9fd2f19ef5e6b9$var$h(i) {
    void 0 !== this._$AN ? ($1c9fd2f19ef5e6b9$var$o(this), this._$AM = i, $1c9fd2f19ef5e6b9$var$r(this)) : this._$AM = i;
}
function $1c9fd2f19ef5e6b9$var$n(i, t = !1, e = 0) {
    const r = this._$AH, h = this._$AN;
    if (void 0 !== h && 0 !== h.size) {
        if (t) {
            if (Array.isArray(r)) for(let i = e; i < r.length; i++)$1c9fd2f19ef5e6b9$var$s(r[i], !1), $1c9fd2f19ef5e6b9$var$o(r[i]);
            else null != r && ($1c9fd2f19ef5e6b9$var$s(r, !1), $1c9fd2f19ef5e6b9$var$o(r));
        } else $1c9fd2f19ef5e6b9$var$s(this, i);
    }
}
const $1c9fd2f19ef5e6b9$var$c = (i)=>{
    i.type == (0, $hz9ib.PartType).CHILD && (i._$AP ??= $1c9fd2f19ef5e6b9$var$n, i._$AQ ??= $1c9fd2f19ef5e6b9$var$h);
};
class $1c9fd2f19ef5e6b9$export$7d025501802325e extends (0, $hz9ib.Directive) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $1c9fd2f19ef5e6b9$var$r(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        i !== this.isConnected && (this.isConnected = i, i ? this.reconnected?.() : this.disconnected?.()), t && ($1c9fd2f19ef5e6b9$var$s(this, i), $1c9fd2f19ef5e6b9$var$o(this));
    }
    setValue(t) {
        if ((0, $40A6J.isSingleExpression)(this._$Ct)) this._$Ct._$AI(t, this);
        else {
            const i = [
                ...this._$Ct._$AH
            ];
            i[this._$Ci] = t, this._$Ct._$AI(i, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}

});
parcelRegister("40A6J", function(module, exports) {

$parcel$export(module.exports, "isPrimitive", function () { return $2eb32bb331da083c$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isTemplateResult", function () { return $2eb32bb331da083c$export$6b6d145ec2a44ca9; });
$parcel$export(module.exports, "isCompiledTemplateResult", function () { return $2eb32bb331da083c$export$6a0e8de894d2fcca; });
$parcel$export(module.exports, "isSingleExpression", function () { return $2eb32bb331da083c$export$7f431ad0fff82fd9; });
$parcel$export(module.exports, "insertPart", function () { return $2eb32bb331da083c$export$291b2338ad9b0b30; });
$parcel$export(module.exports, "setChildPartValue", function () { return $2eb32bb331da083c$export$cb8bf9562088e9f4; });
$parcel$export(module.exports, "setCommittedValue", function () { return $2eb32bb331da083c$export$ea70d9dd5965b1c8; });
$parcel$export(module.exports, "getCommittedValue", function () { return $2eb32bb331da083c$export$59e9bce518cde500; });
$parcel$export(module.exports, "removePart", function () { return $2eb32bb331da083c$export$3133b3144bbba267; });
$parcel$export(module.exports, "clearPart", function () { return $2eb32bb331da083c$export$7f600b8138c094dc; });

var $fXA0k = parcelRequire("fXA0k");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { D: $2eb32bb331da083c$var$t } = (0, $fXA0k._$LH), $2eb32bb331da083c$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $2eb32bb331da083c$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2
}, $2eb32bb331da083c$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $2eb32bb331da083c$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $2eb32bb331da083c$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $2eb32bb331da083c$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $2eb32bb331da083c$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $2eb32bb331da083c$var$s = ()=>document.createComment(""), $2eb32bb331da083c$export$291b2338ad9b0b30 = (o, i, n)=>{
    const e = o._$AA.parentNode, l = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = e.insertBefore($2eb32bb331da083c$var$s(), l), c = e.insertBefore($2eb32bb331da083c$var$s(), l);
        n = new $2eb32bb331da083c$var$t(i, c, o, o.options);
    } else {
        const t = n._$AB.nextSibling, i = n._$AM, c = i !== o;
        if (c) {
            let t;
            n._$AQ?.(o), n._$AM = o, void 0 !== n._$AP && (t = o._$AU) !== i._$AU && n._$AP(t);
        }
        if (t !== l || c) {
            let o = n._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                e.insertBefore(o, l), o = t;
            }
        }
    }
    return n;
}, $2eb32bb331da083c$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $2eb32bb331da083c$var$u = {}, $2eb32bb331da083c$export$ea70d9dd5965b1c8 = (o, t = $2eb32bb331da083c$var$u)=>o._$AH = t, $2eb32bb331da083c$export$59e9bce518cde500 = (o)=>o._$AH, $2eb32bb331da083c$export$3133b3144bbba267 = (o)=>{
    o._$AP?.(!1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $2eb32bb331da083c$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};

});

parcelRegister("hz9ib", function(module, exports) {

$parcel$export(module.exports, "PartType", function () { return $cc9ce9d329990519$export$9ba3b3f20a85bfa; });
$parcel$export(module.exports, "directive", function () { return $cc9ce9d329990519$export$99b43ad1ed32e735; });
$parcel$export(module.exports, "Directive", function () { return $cc9ce9d329990519$export$befdefbdce210f91; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $cc9ce9d329990519$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $cc9ce9d329990519$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $cc9ce9d329990519$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});



parcelRegister("aD8ND", function(module, exports) {
$parcel$export(module.exports, "cache", function () { return (parcelRequire("9XlTB")).cache; });
parcelRequire("9XlTB");

});
parcelRegister("9XlTB", function(module, exports) {

$parcel$export(module.exports, "cache", function () { return $73fa9bcc3f8341ee$export$69a3209f1a06c04d; });

var $fXA0k = parcelRequire("fXA0k");

var $hz9ib = parcelRequire("hz9ib");

var $40A6J = parcelRequire("40A6J");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $73fa9bcc3f8341ee$var$d = (t)=>(0, $40A6J.isCompiledTemplateResult)(t) ? t._$litType$.h : t.strings, $73fa9bcc3f8341ee$export$69a3209f1a06c04d = (0, $hz9ib.directive)(class extends (0, $hz9ib.Directive) {
    constructor(t){
        super(t), this.tt = new WeakMap;
    }
    render(t) {
        return [
            t
        ];
    }
    update(s, [e]) {
        const u = (0, $40A6J.isTemplateResult)(this.et) ? $73fa9bcc3f8341ee$var$d(this.et) : null, h = (0, $40A6J.isTemplateResult)(e) ? $73fa9bcc3f8341ee$var$d(e) : null;
        if (null !== u && (null === h || u !== h)) {
            const e = (0, $40A6J.getCommittedValue)(s).pop();
            let o = this.tt.get(u);
            if (void 0 === o) {
                const s = document.createDocumentFragment();
                o = (0, $fXA0k.render)((0, $fXA0k.nothing), s), o.setConnected(!1), this.tt.set(u, o);
            }
            (0, $40A6J.setCommittedValue)(o, [
                e
            ]), (0, $40A6J.insertPart)(o, void 0, e);
        }
        if (null !== h) {
            if (null === u || u !== h) {
                const t = this.tt.get(h);
                if (void 0 !== t) {
                    const i = (0, $40A6J.getCommittedValue)(t).pop();
                    (0, $40A6J.clearPart)(s), (0, $40A6J.insertPart)(s, void 0, i), (0, $40A6J.setCommittedValue)(s, [
                        i
                    ]);
                }
            }
            this.et = e;
        } else this.et = void 0;
        return this.render(e);
    }
});

});


parcelRegister("b1xHZ", function(module, exports) {

$parcel$export(module.exports, "nanoid", function () { return $8069ef7e6126e429$export$ac4959f4f1338dfc; });

let $8069ef7e6126e429$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $8069ef7e6126e429$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $8069ef7e6126e429$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$8069ef7e6126e429$export$a5cee9e955a615e5(alphabet, size, $8069ef7e6126e429$export$4385e60b38654f68);
let $8069ef7e6126e429$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");

});


parcelRegister("iC587", function(module, exports) {

});

parcelRegister("ecjBI", function(module, exports) {

$parcel$export(module.exports, "Output", function () { return $a5616549278a8ae1$export$670ff8da74c69da1; });
class $a5616549278a8ae1$export$4fae95256245c8c0 {
    constructor(host, eventName){
        this.host = host;
        this.eventName = eventName;
    }
    emit(payload, customEventInit = {}) {
        return this.host.dispatchEvent(new CustomEvent(this.eventName, {
            detail: payload,
            ...customEventInit
        }));
    }
}
function $a5616549278a8ae1$export$670ff8da74c69da1() {
    return function(prototype, propertyName) {
        const emitterKey = Symbol();
        Object.defineProperty(prototype, propertyName, {
            get: function() {
                return this[emitterKey] || (this[emitterKey] = new $a5616549278a8ae1$export$4fae95256245c8c0(this, propertyName));
            }
        });
    };
}

});

parcelRegister("emnHY", function(module, exports) {
class $a74582b8b060f0a1$export$806d624e623ac147 {
    constructor(host){
        this.unwatches = [];
        host.addController(this);
    }
    watch(...unwatches) {
        if (unwatches.length) this.unwatches.push(...unwatches);
        return this;
    }
    hostDisconnected() {
        this.unwatches.forEach((unwatch)=>unwatch());
        this.unwatches = [];
    }
}
function $a74582b8b060f0a1$export$8cbe6b8d88d088ab(handlerName, skipInitial) {
    return function(prototype, propertyName) {
        const valueKey = `___${propertyName}`;
        const handlerKey = handlerName || `${propertyName}Changes`;
        const callbacks = new Map();
        Object.defineProperty(prototype, valueKey, {
            value: prototype[propertyName],
            writable: true
        });
        Object.defineProperty(prototype, handlerKey, {
            value: (callback)=>{
                // initial
                const currentVal = prototype[valueKey];
                if (!skipInitial && currentVal !== undefined) callback(currentVal, undefined);
                // add callback & return unwatch
                const callbackId = Symbol();
                callbacks.set(callbackId, callback);
                return ()=>callbacks.delete(callbackId);
            }
        });
        Object.defineProperty(prototype, propertyName, {
            get: ()=>prototype[valueKey],
            set: (newValue)=>{
                let oldValue = prototype[valueKey];
                oldValue = !oldValue || typeof oldValue !== "object" ? oldValue : JSON.parse(JSON.stringify(oldValue));
                prototype[valueKey] = newValue;
                callbacks.forEach((callback)=>callback === null || callback === void 0 ? void 0 : callback(newValue, oldValue));
            }
        });
    };
}
function $a74582b8b060f0a1$export$4c68f1a79f88778c() {
    return function(prototype, propertyName) {
        const watcherKey = Symbol();
        Object.defineProperty(prototype, propertyName, {
            get: function() {
                const watching = this[watcherKey] || (this[watcherKey] = new $a74582b8b060f0a1$export$806d624e623ac147(this));
                return watching.watch.bind(watching);
            }
        });
    };
}

});

parcelRegister("2qQ1O", function(module, exports) {

$parcel$export(module.exports, "Input", function () { return $1c565e321bcdf7a7$export$f5b8910cec6cf069; });
$parcel$export(module.exports, "Reactive", function () { return $1c565e321bcdf7a7$export$69fef04fa539b17a; });
$parcel$export(module.exports, "TiniComponent", function () { return $1c565e321bcdf7a7$export$c31999485529ab1c; });
parcelRequire("lYoPT");
var $kXi80 = parcelRequire("kXi80");
parcelRequire("4MDiX");
var $asvDI = parcelRequire("asvDI");
var $22wWE = parcelRequire("22wWE");

var $crJS3 = parcelRequire("crJS3");

var $3bQrU = parcelRequire("3bQrU");
const $1c565e321bcdf7a7$export$f5b8910cec6cf069 = (0, $asvDI.property);
const $1c565e321bcdf7a7$export$69fef04fa539b17a = (0, $22wWE.state);
class $1c565e321bcdf7a7$export$c31999485529ab1c extends (0, $kXi80.LitElement) {
    constructor(){
        super(...arguments);
        this.initialized = false;
    }
    connectedCallback() {
        var _a, _b;
        super.connectedCallback();
        // subscribe store
        this.subscribeStore();
        // run hooks
        (0, $3bQrU.runGlobalHooks)((0, $crJS3.LifecycleHooks).OnCreate, this);
        (_b = (_a = this).onCreate) === null || _b === void 0 || _b.call(_a);
    }
    disconnectedCallback() {
        var _a, _b;
        super.disconnectedCallback();
        // run hooks
        (0, $3bQrU.runGlobalHooks)((0, $crJS3.LifecycleHooks).OnDestroy, this);
        (_b = (_a = this).onDestroy) === null || _b === void 0 || _b.call(_a);
        // unsubscribe store
        this.unsubscribeStore();
    }
    willUpdate(changedProperties) {
        var _a, _b;
        (0, $3bQrU.runGlobalHooks)((0, $crJS3.LifecycleHooks).OnChanges, this);
        (_b = (_a = this).onChanges) === null || _b === void 0 || _b.call(_a, changedProperties);
    }
    firstUpdated(changedProperties) {
        var _a, _b;
        // process children rendering
        const root = this.shadowRoot;
        const children = root.querySelectorAll("[await]");
        if (!children.length) {
            this.childrenRender();
            this.childrenReady();
        } else {
            const childrenList = Array.from(children);
            this.getChildrenLifecyclePromise(childrenList, "childrenRender").then(()=>this.childrenRender());
            this.getChildrenLifecyclePromise(childrenList, "childrenReady").then(()=>this.childrenReady());
        }
        // run hooks
        (0, $3bQrU.runGlobalHooks)((0, $crJS3.LifecycleHooks).OnFirstRender, this);
        (_b = (_a = this).onFirstRender) === null || _b === void 0 || _b.call(_a, changedProperties);
    }
    updated(changedProperties) {
        var _a, _b;
        (0, $3bQrU.runGlobalHooks)((0, $crJS3.LifecycleHooks).OnRenders, this);
        (_b = (_a = this).onRenders) === null || _b === void 0 || _b.call(_a, changedProperties);
    }
    childrenRender() {
        var _a, _b;
        (0, $3bQrU.runGlobalHooks)((0, $crJS3.LifecycleHooks).OnChildrenRender, this);
        (_b = (_a = this).onChildrenRender) === null || _b === void 0 || _b.call(_a);
    }
    childrenReady() {
        var _a, _b;
        (0, $3bQrU.runGlobalHooks)((0, $crJS3.LifecycleHooks).OnChildrenReady, this);
        (_b = (_a = this).onChildrenReady) === null || _b === void 0 || _b.call(_a);
    }
    async scheduleUpdate() {
        var _a;
        // A: subsequent updates
        if (this.initialized) super.scheduleUpdate();
        else if (!((_a = this.pendingDependencies) === null || _a === void 0 ? void 0 : _a.length)) this.digestDI();
        else {
            for(let i = 0; i < this.pendingDependencies.length; i++)await this.pendingDependencies[i]();
            this.digestDI();
        }
    }
    digestDI() {
        var _a, _b;
        this.initialized = true;
        this.pendingDependencies = [];
        // run hooks
        (0, $3bQrU.runGlobalHooks)((0, $crJS3.LifecycleHooks).OnInit, this);
        const onInit = (_b = (_a = this).onInit) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (!(onInit === null || onInit === void 0 ? void 0 : onInit.then)) this.digestOnInit();
        else onInit.then(()=>this.digestOnInit());
        // continue
        super.scheduleUpdate();
    }
    digestOnInit() {
        setTimeout(()=>{
            var _a, _b;
            (0, $3bQrU.runGlobalHooks)((0, $crJS3.LifecycleHooks).OnReady, this);
            (_b = (_a = this).onReady) === null || _b === void 0 || _b.call(_a);
        }, 0);
    }
    getChildrenLifecyclePromise(children, hookName) {
        const promises = children.filter((item)=>!!item[hookName]).map((item)=>{
            let resolve = ()=>{};
            const original = item[hookName];
            item[hookName] = ()=>{
                original.call(item);
                resolve();
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return new Promise((r)=>resolve = r);
        });
        return Promise.all(promises);
    }
    subscribeStore() {
        var _a, _b;
        var _c;
        if (!((_b = (_a = this.storeManager) === null || _a === void 0 ? void 0 : _a.pending) === null || _b === void 0 ? void 0 : _b.length)) return;
        const unsubscribes = (_c = this.storeManager).unsubscribes || (_c.unsubscribes = []);
        this.storeManager.pending.forEach(([store, stateKey, propertyName, reactive])=>{
            const unsubscribe = store.subscribe(stateKey, (value)=>{
                this[propertyName] = value;
                if (reactive) this.requestUpdate();
            });
            unsubscribes.push(unsubscribe);
        });
    }
    unsubscribeStore() {
        var _a, _b;
        if (!((_b = (_a = this.storeManager) === null || _a === void 0 ? void 0 : _a.unsubscribes) === null || _b === void 0 ? void 0 : _b.length)) return;
        this.storeManager.unsubscribes.forEach((unsubscribe)=>unsubscribe());
        this.storeManager.unsubscribes = [];
    }
}
$1c565e321bcdf7a7$export$c31999485529ab1c.defaultTagName = "tini-component";
$1c565e321bcdf7a7$export$c31999485529ab1c.componentName = "unnamed";
$1c565e321bcdf7a7$export$c31999485529ab1c.componentType = "component";

});


parcelRegister("eoQhH", function(module, exports) {

$parcel$export(module.exports, "Configurable", function () { return $6a46d546fd24529f$export$abda45806f5adbae; });

var $8HhXQ = parcelRequire("8HhXQ");

class $6a46d546fd24529f$export$abda45806f5adbae {
    static #_ = this.options = {
        appId: "ui",
        appName: "Tini UI",
        logoUrl: new URL((parcelRequire("ljOvj"))).toString(),
        repoUrl: "https://github.com/tinijs/ui",
        iconsRepoUrl: "https://github.com/tinijs/icons",
        packagePrefix: "@tinijs/ui",
        soulUrlResolver: undefined,
        skinUrlResolver: undefined,
        componentUrlResolver: undefined,
        soulList: [
            {
                id: "bootstrap",
                name: "Bootstrap",
                skins: [
                    {
                        id: "light",
                        name: "Light"
                    },
                    {
                        id: "dark",
                        name: "Dark"
                    },
                    {
                        id: "retro-light",
                        name: "Retro Light"
                    },
                    {
                        id: "retro-dark",
                        name: "Retro Dark"
                    }
                ]
            }
        ],
        routes: $8HhXQ.default
    };
    static setOptions(options) {
        return $6a46d546fd24529f$export$abda45806f5adbae.options = {
            ...$6a46d546fd24529f$export$abda45806f5adbae.options,
            ...options
        };
    }
    static getOption(key) {
        return $6a46d546fd24529f$export$abda45806f5adbae.options[key];
    }
}

});
parcelRegister("8HhXQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e833ef7ac45251c5$export$2e2bcd8739ae039; });
const $e833ef7ac45251c5$export$5eed2e9a6193436f = {
    path: "",
    component: "app-layout-default"
};

const $e833ef7ac45251c5$export$b96cf7884a9b2d13 = {
    path: "",
    component: "app-page-home",
    action: ()=>(parcelRequire("6MCMt")),
    title: "Introduction"
};

const $e833ef7ac45251c5$export$43696c09eec9e3a8 = {
    path: "get-started",
    component: "app-page-get-started",
    action: ()=>(parcelRequire("5ndsF"))
};
const $e833ef7ac45251c5$export$c0fecd4ea77b452b = [
    $e833ef7ac45251c5$export$b96cf7884a9b2d13,
    $e833ef7ac45251c5$export$43696c09eec9e3a8
];

const $e833ef7ac45251c5$export$6109c11d79acdf0c = {
    path: "guides/customization",
    component: "app-page-guides-customization",
    action: ()=>(parcelRequire("fv6X3"))
};
const $e833ef7ac45251c5$export$fa0f5ca78b4bbbb8 = [
    $e833ef7ac45251c5$export$6109c11d79acdf0c
];

const $e833ef7ac45251c5$export$c1f465e5e5f6dd15 = {
    path: "components/bases",
    component: "app-page-components-bases",
    action: ()=>(parcelRequire("dQy43"))
};

const $e833ef7ac45251c5$export$743d1d00d8e940a6 = {
    path: "components/generic",
    component: "app-page-components-generic",
    action: ()=>(parcelRequire("7ajAG"))
};

const $e833ef7ac45251c5$export$7823ca7c5bd897b8 = {
    path: "components/skeleton",
    component: "app-page-components-skeleton",
    action: ()=>(parcelRequire("dFA5h"))
};

const $e833ef7ac45251c5$export$eb507ab02871b158 = {
    path: "components/box",
    component: "app-page-components-box",
    action: ()=>(parcelRequire("8KfdL"))
};

const $e833ef7ac45251c5$export$9069aa0677ab3d08 = {
    path: "components/text",
    component: "app-page-components-text",
    action: ()=>(parcelRequire("1ntA1"))
};

const $e833ef7ac45251c5$export$b5a3535dfc11e7ba = {
    path: "components/link",
    component: "app-page-components-link",
    action: ()=>(parcelRequire("9RcFg"))
};

const $e833ef7ac45251c5$export$abbda0439460eb10 = {
    path: "components/icon",
    component: "app-page-components-icon",
    action: ()=>(parcelRequire("b3NiA"))
};

const $e833ef7ac45251c5$export$21468d1ff28dc948 = {
    path: "components/button",
    component: "app-page-components-button",
    action: ()=>(parcelRequire("irOaa"))
};

const $e833ef7ac45251c5$export$9c16114350193965 = {
    path: "components/badge",
    component: "app-page-components-badge",
    action: ()=>(parcelRequire("btUcE"))
};

const $e833ef7ac45251c5$export$78dbfabb72d23cc5 = {
    path: "components/breadcrumb",
    component: "app-page-components-breadcrumb",
    action: ()=>(parcelRequire("6YDty"))
};

const $e833ef7ac45251c5$export$5b42ee5a88335a62 = {
    path: "components/card",
    component: "app-page-components-card",
    action: ()=>(parcelRequire("bUCnx"))
};

const $e833ef7ac45251c5$export$f4c38bce8a489e1a = {
    path: "components/checkboxes",
    component: "app-page-components-checkboxes",
    action: ()=>(parcelRequire("c0cy8"))
};

const $e833ef7ac45251c5$export$f35f9a10ee903204 = {
    path: "components/dialog",
    component: "app-page-components-dialog",
    action: ()=>(parcelRequire("llE56"))
};

const $e833ef7ac45251c5$export$94d87f853f604c4a = {
    path: "components/input",
    component: "app-page-components-input",
    action: ()=>(parcelRequire("1npez"))
};

const $e833ef7ac45251c5$export$fc1d532659a0c744 = {
    path: "components/label",
    component: "app-page-components-label",
    action: ()=>(parcelRequire("83ba6"))
};

const $e833ef7ac45251c5$export$acbb92f1ea49cfe3 = {
    path: "components/message",
    component: "app-page-components-message",
    action: ()=>(parcelRequire("9Dkqx"))
};

const $e833ef7ac45251c5$export$7883914fe62baaad = {
    path: "components/modal",
    component: "app-page-components-modal",
    action: ()=>(parcelRequire("fox92"))
};

const $e833ef7ac45251c5$export$a9a89bbc6eb4b89 = {
    path: "components/pagination",
    component: "app-page-components-pagination",
    action: ()=>(parcelRequire("hZ7oj"))
};

const $e833ef7ac45251c5$export$100ca2be31d3743f = {
    path: "components/radios",
    component: "app-page-components-radios",
    action: ()=>(parcelRequire("9C56T"))
};

const $e833ef7ac45251c5$export$c1081a9d66cff77d = {
    path: "components/select",
    component: "app-page-components-select",
    action: ()=>(parcelRequire("jPQKo"))
};

const $e833ef7ac45251c5$export$75bf18ac3ee35211 = {
    path: "components/spinner",
    component: "app-page-components-spinner",
    action: ()=>(parcelRequire("7F2dx"))
};

const $e833ef7ac45251c5$export$97edbd204a69012 = {
    path: "components/switch",
    component: "app-page-components-switch",
    action: ()=>(parcelRequire("7Zi4S"))
};

const $e833ef7ac45251c5$export$27f8309c4dcaeedc = {
    path: "components/textarea",
    component: "app-page-components-textarea",
    action: ()=>(parcelRequire("5IRlC"))
};
const $e833ef7ac45251c5$export$1be64e80dfd9fdc1 = [
    $e833ef7ac45251c5$export$c1f465e5e5f6dd15,
    $e833ef7ac45251c5$export$743d1d00d8e940a6,
    $e833ef7ac45251c5$export$7823ca7c5bd897b8,
    $e833ef7ac45251c5$export$eb507ab02871b158,
    $e833ef7ac45251c5$export$9069aa0677ab3d08,
    $e833ef7ac45251c5$export$b5a3535dfc11e7ba,
    $e833ef7ac45251c5$export$abbda0439460eb10,
    $e833ef7ac45251c5$export$21468d1ff28dc948,
    $e833ef7ac45251c5$export$9c16114350193965,
    $e833ef7ac45251c5$export$fc1d532659a0c744,
    $e833ef7ac45251c5$export$acbb92f1ea49cfe3,
    $e833ef7ac45251c5$export$75bf18ac3ee35211,
    $e833ef7ac45251c5$export$5b42ee5a88335a62,
    $e833ef7ac45251c5$export$78dbfabb72d23cc5,
    $e833ef7ac45251c5$export$a9a89bbc6eb4b89,
    $e833ef7ac45251c5$export$f35f9a10ee903204,
    $e833ef7ac45251c5$export$7883914fe62baaad,
    $e833ef7ac45251c5$export$94d87f853f604c4a,
    $e833ef7ac45251c5$export$27f8309c4dcaeedc,
    $e833ef7ac45251c5$export$c1081a9d66cff77d,
    $e833ef7ac45251c5$export$f4c38bce8a489e1a,
    $e833ef7ac45251c5$export$100ca2be31d3743f,
    $e833ef7ac45251c5$export$97edbd204a69012
];















const $e833ef7ac45251c5$export$5ee3c25e6ca27e27 = [
    {
        path: "icons/bootstrap",
        component: "app-page-icons-bootstrap",
        action: ()=>(parcelRequire("fcTqi"))
    },
    {
        path: "icons/material-filled",
        component: "app-page-icons-material-filled",
        action: ()=>(parcelRequire("6awbA"))
    },
    {
        path: "icons/material-outlined",
        component: "app-page-icons-material-outlined",
        action: ()=>(parcelRequire("hX5FP"))
    },
    {
        path: "icons/material-round",
        component: "app-page-icons-material-round",
        action: ()=>(parcelRequire("fPMeN"))
    },
    {
        path: "icons/material-sharp",
        component: "app-page-icons-material-sharp",
        action: ()=>(parcelRequire("Vgnwo"))
    },
    {
        path: "icons/material-two-tone",
        component: "app-page-icons-material-two-tone",
        action: ()=>(parcelRequire("wplS3"))
    },
    {
        path: "icons/mdi",
        component: "app-page-icons-mdi",
        action: ()=>(parcelRequire("fKbCa"))
    },
    {
        path: "icons/ionic",
        component: "app-page-icons-ionic",
        action: ()=>(parcelRequire("kaj67"))
    },
    {
        path: "icons/fluent",
        component: "app-page-icons-fluent",
        action: ()=>(parcelRequire("aG51o"))
    },
    {
        path: "icons/ant-filled",
        component: "app-page-icons-ant-filled",
        action: ()=>(parcelRequire("tquug"))
    },
    {
        path: "icons/ant-outlined",
        component: "app-page-icons-ant-outlined",
        action: ()=>(parcelRequire("6z7L1"))
    },
    {
        path: "icons/ant-twotone",
        component: "app-page-icons-ant-twotone",
        action: ()=>(parcelRequire("dKLMk"))
    },
    {
        path: "icons/fontawesome-brands",
        component: "app-page-icons-fontawesome-brands",
        action: ()=>(parcelRequire("loGtT")),
        title: "Font Awesome Brands"
    },
    {
        path: "icons/fontawesome-regular",
        component: "app-page-icons-fontawesome-regular",
        action: ()=>(parcelRequire("7Xadq")),
        title: "Font Awesome Regular"
    },
    {
        path: "icons/fontawesome-solid",
        component: "app-page-icons-fontawesome-solid",
        action: ()=>(parcelRequire("6VniJ")),
        title: "Font Awesome Solid"
    }
];

const $e833ef7ac45251c5$export$4dc84672b833126 = {
    path: "**",
    component: "app-page-404",
    action: ()=>(parcelRequire("6JRAO"))
};
var /*
 * All Routes
 */ $e833ef7ac45251c5$export$2e2bcd8739ae039 = [
    {
        ...$e833ef7ac45251c5$export$5eed2e9a6193436f,
        children: [
            ...$e833ef7ac45251c5$export$c0fecd4ea77b452b,
            // guides
            ...$e833ef7ac45251c5$export$fa0f5ca78b4bbbb8,
            // components
            ...$e833ef7ac45251c5$export$1be64e80dfd9fdc1,
            // icons
            ...$e833ef7ac45251c5$export$5ee3c25e6ca27e27,
            // 404
            $e833ef7ac45251c5$export$4dc84672b833126
        ]
    }
];

});
parcelRegister("6MCMt", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("eWmpg")).then(()=>parcelRequire("gpFGe"));

});
parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case "preload":
            return $1c132cac09cd18d9$var$cachedPreloads;
        case "prefetch":
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("5ndsF", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("9cAGp"))
]).then(()=>parcelRequire("gFflh"));

});

parcelRegister("fv6X3", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("exY20"))
]).then(()=>parcelRequire("a8mzp"));

});

parcelRegister("dQy43", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hlmTJ"))
]).then(()=>parcelRequire("jD6p1"));

});

parcelRegister("7ajAG", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("eKsrU"))
]).then(()=>parcelRequire("ajpnB"));

});

parcelRegister("dFA5h", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("eyQUf"))
]).then(()=>parcelRequire("8HS7R"));

});

parcelRegister("8KfdL", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("jNI5s"))
]).then(()=>parcelRequire("iki6N"));

});

parcelRegister("1ntA1", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("94tQO"))
]).then(()=>parcelRequire("5QsUJ"));

});

parcelRegister("9RcFg", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("bI7AS"))
]).then(()=>parcelRequire("gjSoO"));

});

parcelRegister("b3NiA", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("gP816"))
]).then(()=>parcelRequire("gf84y"));

});

parcelRegister("irOaa", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("4vEXC"))
]).then(()=>parcelRequire("kgvNV"));

});

parcelRegister("btUcE", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("dPaQN"))
]).then(()=>parcelRequire("btZFk"));

});

parcelRegister("6YDty", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("lwWZN"))
]).then(()=>parcelRequire("9cDmf"));

});

parcelRegister("bUCnx", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("2AguK"))
]).then(()=>parcelRequire("cNDdO"));

});

parcelRegister("c0cy8", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("kt101"))
]).then(()=>parcelRequire("lvBxd"));

});

parcelRegister("llE56", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("4l9yG"))
]).then(()=>parcelRequire("iSsey"));

});

parcelRegister("1npez", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("aNdbr"))
]).then(()=>parcelRequire("ebPIN"));

});

parcelRegister("83ba6", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("bVHE5"))
]).then(()=>parcelRequire("d7Gqx"));

});

parcelRegister("9Dkqx", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("8ufZN"))
]).then(()=>parcelRequire("dFDg9"));

});

parcelRegister("fox92", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("jfAy9"))
]).then(()=>parcelRequire("QDDKb"));

});

parcelRegister("hZ7oj", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("cy4ix"))
]).then(()=>parcelRequire("7vMhV"));

});

parcelRegister("9C56T", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("bZhQw"))
]).then(()=>parcelRequire("3xazf"));

});

parcelRegister("jPQKo", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("dXq1Q"))
]).then(()=>parcelRequire("dm4Vz"));

});

parcelRegister("7F2dx", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("50G5l"))
]).then(()=>parcelRequire("faiLg"));

});

parcelRegister("7Zi4S", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("en49a"))
]).then(()=>parcelRequire("3MnaS"));

});

parcelRegister("5IRlC", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hedB2")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("5Jcnw"))
]).then(()=>parcelRequire("hMnst"));

});

parcelRegister("fcTqi", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("kSqjo"))
]).then(()=>parcelRequire("ldPqz"));

});

parcelRegister("6awbA", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("bZMDU"))
]).then(()=>parcelRequire("9i0vW"));

});

parcelRegister("hX5FP", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("4M89Y"))
]).then(()=>parcelRequire("1kXcL"));

});

parcelRegister("fPMeN", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("dHYGq"))
]).then(()=>parcelRequire("lmxOV"));

});

parcelRegister("Vgnwo", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ktdKA"))
]).then(()=>parcelRequire("99DOS"));

});

parcelRegister("wplS3", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("b73kE"))
]).then(()=>parcelRequire("7X6pi"));

});

parcelRegister("fKbCa", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("9YPbv"))
]).then(()=>parcelRequire("hJQgs"));

});

parcelRegister("kaj67", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("gPdBQ"))
]).then(()=>parcelRequire("j00uN"));

});

parcelRegister("aG51o", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("6ouB1"))
]).then(()=>parcelRequire("85nWK"));

});

parcelRegister("tquug", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("gVCZa"))
]).then(()=>parcelRequire("agFm1"));

});

parcelRegister("6z7L1", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("6VSHP"))
]).then(()=>parcelRequire("700AB"));

});

parcelRegister("dKLMk", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("kXVnv"))
]).then(()=>parcelRequire("azbRs"));

});

parcelRegister("loGtT", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("lNEYZ"))
]).then(()=>parcelRequire("42pFE"));

});

parcelRegister("7Xadq", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("22CGz"))
]).then(()=>parcelRequire("j5XVn"));

});

parcelRegister("6VniJ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("ajMio")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("Sap2a"))
]).then(()=>parcelRequire("1meLK"));

});

parcelRegister("6JRAO", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("9mSUz")).then(()=>parcelRequire("5l8Hp"));

});


parcelRegister("ljOvj", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("gaxWV") + "logo.92d607e0.svg";

});


parcelRegister("laxZI", function(module, exports) {

$parcel$export(module.exports, "mainStore", function () { return $c861ea8fa637427b$export$c6b176a5a7d01b54; });
parcelRequire("pLkRZ");
var $ckRLp = parcelRequire("ckRLp");

var $5kxRk = parcelRequire("5kxRk");
const $c861ea8fa637427b$export$c6b176a5a7d01b54 = (0, $ckRLp.createStore)({
    activeSoulId: "unknown",
    activeSkinId: "unknown",
    referImport: (0, $5kxRk.ImportMethods).Tini,
    referPlatform: (0, $5kxRk.ConsumerPlatforms).Tini,
    referIconsImport: (0, $5kxRk.IconsImportMethods).Tini,
    skinEditorShown: false
});

});
parcelRegister("pLkRZ", function(module, exports) {
$parcel$export(module.exports, "Subscribe", function () { return (parcelRequire("9xVr6")).Subscribe; });
$parcel$export(module.exports, "createStore", function () { return (parcelRequire("ckRLp")).createStore; });
parcelRequire("gzmyX");
parcelRequire("9xVr6");
parcelRequire("leuaV");
parcelRequire("ckRLp");

});
parcelRegister("gzmyX", function(module, exports) {
const $c1016ac0116a2954$export$38c6526d67de94bb = "store";
const $c1016ac0116a2954$export$59dbefa3c1eecdf = `tini:${$c1016ac0116a2954$export$38c6526d67de94bb}`;

});

parcelRegister("9xVr6", function(module, exports) {

$parcel$export(module.exports, "Subscribe", function () { return $6f33bfc04fbb0c00$export$b5b6bb8bb5273115; });
function $6f33bfc04fbb0c00$export$b5b6bb8bb5273115(store, stateKey, reactive = true) {
    return function(prototype, propertyName) {
        prototype.storeManager || (prototype.storeManager = {
            pending: []
        });
        prototype.storeManager.pending.push([
            store,
            stateKey || propertyName,
            propertyName,
            reactive
        ]);
    };
}

});

parcelRegister("leuaV", function(module, exports) {

});

parcelRegister("ckRLp", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $8fb10ea87e928d03$export$f51a9068ac82ea43; });
function $8fb10ea87e928d03$export$f51a9068ac82ea43(states, options = {}) {
    const store = new Proxy(states, {
        get (target, prop) {
            if (prop === "subscribe") return (stateKey, callback)=>{
                var _a, _b;
                if (stateKey in target) {
                    // subscribe
                    const subscriptions = (_a = target)[_b = `___${stateKey}$`] || (_a[_b] = new Map());
                    const subscriptionId = Symbol();
                    subscriptions.set(subscriptionId, callback);
                    // unsubscribe
                    return ()=>subscriptions.delete(subscriptionId);
                } else throw new Error(`Unknown state: ${stateKey}`);
            };
            else if (prop === "commit") return (stateKey, value)=>store[stateKey] = value;
            else return target[prop];
        },
        set (target, prop, value) {
            const subscriptions = target[`___${prop}$`];
            // set value
            const currentValue = target[prop];
            const oldValue = !options.preserveOldValue ? currentValue : !(currentValue instanceof Object) ? currentValue : structuredClone(currentValue);
            target[prop] = value;
            // notify subscribers
            subscriptions === null || subscriptions === void 0 || subscriptions.forEach((callback)=>callback(value, oldValue));
            // success
            return true;
        }
    });
    return store;
}

});


parcelRegister("5kxRk", function(module, exports) {

$parcel$export(module.exports, "OFFICIAL_REPO_URL", function () { return $6eeb03e0838e1091$export$f1b5a82609c3f348; });
$parcel$export(module.exports, "ConsumerPlatforms", function () { return $6eeb03e0838e1091$export$ecb0d946d6fc95f5; });
$parcel$export(module.exports, "ImportMethods", function () { return $6eeb03e0838e1091$export$18aace910511cf0c; });
$parcel$export(module.exports, "IconsImportMethods", function () { return $6eeb03e0838e1091$export$df58ce7e9a0ad83f; });
const $6eeb03e0838e1091$export$f1b5a82609c3f348 = "https://github.com/tinijs/ui";
var $6eeb03e0838e1091$export$ecb0d946d6fc95f5;
(function(ConsumerPlatforms) {
    ConsumerPlatforms["Tini"] = "Tini";
    ConsumerPlatforms["Vue"] = "Vue";
    ConsumerPlatforms["React"] = "React";
    ConsumerPlatforms["Angular"] = "Angular";
    ConsumerPlatforms["Svelte"] = "Svelte";
    ConsumerPlatforms["HTML"] = "HTML";
})($6eeb03e0838e1091$export$ecb0d946d6fc95f5 || ($6eeb03e0838e1091$export$ecb0d946d6fc95f5 = {}));
var $6eeb03e0838e1091$export$18aace910511cf0c;
(function(ImportMethods) {
    ImportMethods["Tini"] = "Tini CLI";
    ImportMethods["Specific"] = "Specific Package";
    ImportMethods["Standalone"] = "Standalone/CDN";
})($6eeb03e0838e1091$export$18aace910511cf0c || ($6eeb03e0838e1091$export$18aace910511cf0c = {}));
var $6eeb03e0838e1091$export$df58ce7e9a0ad83f;
(function(IconsImportMethods) {
    IconsImportMethods["Tini"] = "Tini Framework";
    IconsImportMethods["Others"] = "Other Frameworks";
    IconsImportMethods["Source"] = "Base64 URI / SVG Code";
})($6eeb03e0838e1091$export$df58ce7e9a0ad83f || ($6eeb03e0838e1091$export$df58ce7e9a0ad83f = {}));

});


parcelRegister("eD4R9", function(module, exports) {

$parcel$export(module.exports, "buttonBases", function () { return $aa68798a42210144$export$a5aec69d55513b4f; });
$parcel$export(module.exports, "codeBases", function () { return $aa68798a42210144$export$90c0031976dd0deb; });
$parcel$export(module.exports, "commonBases", function () { return $aa68798a42210144$export$56d7d45dcbc32710; });
$parcel$export(module.exports, "formBases", function () { return $aa68798a42210144$export$2f51ea6d96dc2488; });
$parcel$export(module.exports, "headingsBases", function () { return $aa68798a42210144$export$74b14dd1305fd974; });
$parcel$export(module.exports, "linkBases", function () { return $aa68798a42210144$export$d157f9a22e67d5d1; });
$parcel$export(module.exports, "textBases", function () { return $aa68798a42210144$export$31b192b5358aeac4; });

var $dAuML = parcelRequire("dAuML");

var $9O3QY = parcelRequire("9O3QY");

var $3mn2W = parcelRequire("3mn2W");

var $73KYx = parcelRequire("73KYx");

var $gTQKJ = parcelRequire("gTQKJ");

var $jNFcx = parcelRequire("jNFcx");

var $dxIuy = parcelRequire("dxIuy");
const $aa68798a42210144$export$a5aec69d55513b4f = {
    bootstrap: (0, $dAuML.default)
};
const $aa68798a42210144$export$90c0031976dd0deb = {
    bootstrap: (0, $9O3QY.default)
};
const $aa68798a42210144$export$56d7d45dcbc32710 = {
    bootstrap: (0, $3mn2W.default)
};
const $aa68798a42210144$export$2f51ea6d96dc2488 = {
    bootstrap: (0, $73KYx.default)
};
const $aa68798a42210144$export$74b14dd1305fd974 = {
    bootstrap: (0, $gTQKJ.default)
};
const $aa68798a42210144$export$d157f9a22e67d5d1 = {
    bootstrap: (0, $jNFcx.default)
};
const $aa68798a42210144$export$31b192b5358aeac4 = {
    bootstrap: (0, $dxIuy.default)
};

});
parcelRegister("dAuML", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19cff02966960354$export$2e2bcd8739ae039; });
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $19cff02966960354$export$2e2bcd8739ae039 = (0, $cZ4os.css)`
  button,
  input[type='button'],
  input[type='reset'],
  input[type='submit'] {
    font-family: var(--font-body);
    font-size: var(--size-text);
    background: var(--color-background);
    color: var(--color-foreground);
  }
`;

});

parcelRegister("9O3QY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02775eff7ac6692d$export$2e2bcd8739ae039; });
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $02775eff7ac6692d$export$2e2bcd8739ae039 = (0, $cZ4os.css)`
  pre,
  code,
  kbd,
  samp {
    font-family: var(--font-code) !important;
    font-size: 0.9em;
    direction: ltr /* rtl:ignore */;
    unicode-bidi: bidi-override;
  }

  pre *,
  code *,
  kbd *,
  samp * {
    font-family: var(--font-code) !important;
    font-size: 1em;
  }

  pre {
    display: block;
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto;
  }
  pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal;
  }

  code {
    padding: 0.15rem 0.35rem;
    color: var(--color-tertiary);
    background: color-mix(in oklab, var(--color-tertiary), transparent 90%);
    word-wrap: break-word;
    border-radius: 0.2rem;
  }
  a > code {
    color: inherit;
  }

  kbd {
    padding: 0.2rem 0.4rem;
    color: var(--color-foreground-contrast);
    background-color: var(--color-foreground);
    border-radius: 0.2rem;
  }
  kbd kbd {
    padding: 0;
    font-weight: 700;
  }
`;

});

parcelRegister("3mn2W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66e4ce2049f90a24$export$2e2bcd8739ae039; });
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $66e4ce2049f90a24$export$2e2bcd8739ae039 = (0, $cZ4os.css)`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  :host {
    display: block;
    margin: 0;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -webkit-text-size-adjust: 100%;
  }
`;

});

parcelRegister("73KYx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fe7838f93b53f27$export$2e2bcd8739ae039; });
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $0fe7838f93b53f27$export$2e2bcd8739ae039 = (0, $cZ4os.css)`
  form,
  fieldset,
  legend,
  label,
  input,
  select,
  option,
  optgroup,
  textarea {
    font-family: var(--font-body);
    font-size: var(--size-text);
    color: var(--color-foreground);
  }

  input,
  select,
  textarea {
    background: var(--color-background-tint);
  }
`;

});

parcelRegister("gTQKJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $731f9b049057d472$export$2e2bcd8739ae039; });
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $731f9b049057d472$export$2e2bcd8739ae039 = (0, $cZ4os.css)`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: var(--font-head);
    font-weight: 500;
  }

  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1.75rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  h5 {
    font-size: 1.25rem;
  }

  h6 {
    font-size: 1rem;
  }
`;

});

parcelRegister("jNFcx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9274e6c60525450$export$2e2bcd8739ae039; });
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $c9274e6c60525450$export$2e2bcd8739ae039 = (0, $cZ4os.css)`
  a {
    color: var(--color-primary);
    text-decoration: none;
  }

  a:hover,
  a:focus,
  a:active {
    color: var(--color-primary-shade);
    text-decoration: underline;
  }

  a[target='_blank'] {
    cursor: alias;
  }
`;

});

parcelRegister("dxIuy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48ef40a9070606b5$export$2e2bcd8739ae039; });
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $48ef40a9070606b5$export$2e2bcd8739ae039 = (0, $cZ4os.css)`
  p,
  span,
  strong,
  em {
    line-height: 1.5;
  }
`;

});


parcelRegister("3IANd", function(module, exports) {
$parcel$export(module.exports, "classMap", function () { return (parcelRequire("ogP7Y")).classMap; });
parcelRequire("ogP7Y");

});
parcelRegister("ogP7Y", function(module, exports) {

$parcel$export(module.exports, "classMap", function () { return $048f4ad472bdf6e5$export$56cc687933817664; });

var $fXA0k = parcelRequire("fXA0k");

var $hz9ib = parcelRequire("hz9ib");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $048f4ad472bdf6e5$export$56cc687933817664 = (0, $hz9ib.directive)(class extends (0, $hz9ib.Directive) {
    constructor(t){
        if (super(t), t.type !== (0, $hz9ib.PartType).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== s.strings && (this.st = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.st?.has(t) && this.it.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.it)t in i || (r.remove(t), this.it.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.it.has(t) || this.st?.has(t) || (s ? (r.add(t), this.it.add(t)) : (r.remove(t), this.it.delete(t)));
        }
        return 0, $fXA0k.noChange;
    }
});

});


parcelRegister("6uvK4", function(module, exports) {

$parcel$export(module.exports, "IconGithubComponent", function () { return $4b9e2ac0d6790c1b$export$5dec0133077a3083; });
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $fXA0k = parcelRequire("fXA0k");
parcelRequire("4MDiX");
var $asvDI = parcelRequire("asvDI");
parcelRequire("3IANd");
var $ogP7Y = parcelRequire("ogP7Y");
parcelRequire("bsGWa");
var $4fw8W = parcelRequire("4fw8W");
var $aynjv = parcelRequire("aynjv");
var $8Zp5V = parcelRequire("8Zp5V");
var $4b9e2ac0d6790c1b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class $4b9e2ac0d6790c1b$export$5dec0133077a3083 extends (0, $8Zp5V.TiniElement) {
    static #_ = this.defaultTagName = "icon-github";
    static #_1 = this.componentName = "icon";
    static #_2 = this.styles = (0, $cZ4os.css)`:host{--icon-width:var(--scale-md-2x);--icon-height:var(--scale-md-2x);--icon-scheme:none;--icon-image:url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9ImN1cnJlbnRDb2xvciIgY2xhc3M9ImJpIGJpLWdpdGh1YiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBkPSJNOCAwQzMuNTggMCAwIDMuNTggMCA4YzAgMy41NCAyLjI5IDYuNTMgNS40NyA3LjU5LjQuMDcuNTUtLjE3LjU1LS4zOCAwLS4xOS0uMDEtLjgyLS4wMS0xLjQ5LTIuMDEuMzctMi41My0uNDktMi42OS0uOTQtLjA5LS4yMy0uNDgtLjk0LS44Mi0xLjEzLS4yOC0uMTUtLjY4LS41Mi0uMDEtLjUzLjYzLS4wMSAxLjA4LjU4IDEuMjMuODIuNzIgMS4yMSAxLjg3Ljg3IDIuMzMuNjYuMDctLjUyLjI4LS44Ny41MS0xLjA3LTEuNzgtLjItMy42NC0uODktMy42NC0zLjk1IDAtLjg3LjMxLTEuNTkuODItMi4xNS0uMDgtLjItLjM2LTEuMDIuMDgtMi4xMiAwIDAgLjY3LS4yMSAyLjIuODIuNjQtLjE4IDEuMzItLjI3IDItLjI3LjY4IDAgMS4zNi4wOSAyIC4yNyAxLjUzLTEuMDQgMi4yLS44MiAyLjItLjgyLjQ0IDEuMS4xNiAxLjkyLjA4IDIuMTIuNTEuNTYuODIgMS4yNy44MiAyLjE1IDAgMy4wNy0xLjg3IDMuNzUtMy42NSAzLjk1LjI5LjI1LjU0LjczLjU0IDEuNDggMCAxLjA3LS4wMSAxLjkzLS4wMSAyLjIgMCAuMjEuMTUuNDYuNTUuMzhBOC4wMTIgOC4wMTIgMCAwIDAgMTYgOGMwLTQuNDItMy41OC04LTgtOCIvPjwvc3ZnPg==');display:inline-block}i{display:flex;align-items:center;justify-content:center;background-image:var(--icon-image);background-repeat:no-repeat;background-size:contain;background-position:center;width:var(--icon-width);height:var(--icon-height)}.scheme{background:var(--icon-scheme);-webkit-mask-image:var(--icon-image);-webkit-mask-size:var(--icon-width) var(--icon-height);-webkit-mask-repeat:no-repeat;-webkit-mask-position:center;mask-image:var(--icon-image);mask-size:var(--icon-width) var(--icon-height);mask-repeat:no-repeat;mask-position:center}${(0, $4fw8W.generateColorVaries)(({ fullName: fullName, color: color })=>`.${fullName} {--icon-scheme: ${color};}`)}${(0, $4fw8W.generateGradientVaries)(({ fullName: fullName, gradient: gradient })=>`.${fullName} {--icon-scheme: ${gradient};}`)}${(0, $4fw8W.generateScaleVaries)(({ name: name, fullName: fullName })=>`.${fullName} {--icon-width: var(--scale-${name}-2x);--icon-height: var(--scale-${name}-2x);}`)}`;
    willUpdate() {
        this.extendRootClasses({
            raw: {
                scheme: !!this.scheme
            },
            overridable: {
                [(0, $4fw8W.VaryGroups).Scale]: this.scale,
                [(0, $4fw8W.VaryGroups).Scheme]: this.scheme
            }
        });
    }
    render() {
        return (0, $fXA0k.html)`<i class=${(0, $ogP7Y.classMap)(this.rootClasses)} part=${(0, $aynjv.partAttrMap)(this.rootClasses)}></i>`;
    }
}
$4b9e2ac0d6790c1b$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $4b9e2ac0d6790c1b$export$5dec0133077a3083.prototype, "scale", void 0);
$4b9e2ac0d6790c1b$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $4b9e2ac0d6790c1b$export$5dec0133077a3083.prototype, "scheme", void 0); //# sourceMappingURL=github.js.map

});

parcelRegister("9aegR", function(module, exports) {
$parcel$export(module.exports, "repeat", function () { return (parcelRequire("tysjU")).repeat; });
parcelRequire("tysjU");

});
parcelRegister("tysjU", function(module, exports) {

$parcel$export(module.exports, "repeat", function () { return $058d6fbf580d5cd7$export$76d90c956114f2c2; });

var $fXA0k = parcelRequire("fXA0k");

var $hz9ib = parcelRequire("hz9ib");

var $40A6J = parcelRequire("40A6J");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $058d6fbf580d5cd7$var$u = (e, s, t)=>{
    const r = new Map;
    for(let l = s; l <= t; l++)r.set(e[l], l);
    return r;
}, $058d6fbf580d5cd7$export$76d90c956114f2c2 = (0, $hz9ib.directive)(class extends (0, $hz9ib.Directive) {
    constructor(e){
        if (super(e), e.type !== (0, $hz9ib.PartType).CHILD) throw Error("repeat() can only be used in text expressions");
    }
    ht(e, s, t) {
        let r;
        void 0 === t ? t = s : void 0 !== s && (r = s);
        const l = [], o = [];
        let i = 0;
        for (const s of e)l[i] = r ? r(s, i) : i, o[i] = t(s, i), i++;
        return {
            values: o,
            keys: l
        };
    }
    render(e, s, t) {
        return this.ht(e, s, t).values;
    }
    update(s, [t, r, c]) {
        const d = (0, $40A6J.getCommittedValue)(s), { values: p, keys: a } = this.ht(t, r, c);
        if (!Array.isArray(d)) return this.dt = a, p;
        const h = this.dt ??= [], v = [];
        let m, y, x = 0, j = d.length - 1, k = 0, w = p.length - 1;
        for(; x <= j && k <= w;)if (null === d[x]) x++;
        else if (null === d[j]) j--;
        else if (h[x] === a[k]) v[k] = (0, $40A6J.setChildPartValue)(d[x], p[k]), x++, k++;
        else if (h[j] === a[w]) v[w] = (0, $40A6J.setChildPartValue)(d[j], p[w]), j--, w--;
        else if (h[x] === a[w]) v[w] = (0, $40A6J.setChildPartValue)(d[x], p[w]), (0, $40A6J.insertPart)(s, v[w + 1], d[x]), x++, w--;
        else if (h[j] === a[k]) v[k] = (0, $40A6J.setChildPartValue)(d[j], p[k]), (0, $40A6J.insertPart)(s, d[x], d[j]), j--, k++;
        else if (void 0 === m && (m = $058d6fbf580d5cd7$var$u(a, k, w), y = $058d6fbf580d5cd7$var$u(h, x, j)), m.has(h[x])) {
            if (m.has(h[j])) {
                const e = y.get(a[k]), t = void 0 !== e ? d[e] : null;
                if (null === t) {
                    const e = (0, $40A6J.insertPart)(s, d[x]);
                    (0, $40A6J.setChildPartValue)(e, p[k]), v[k] = e;
                } else v[k] = (0, $40A6J.setChildPartValue)(t, p[k]), (0, $40A6J.insertPart)(s, d[x], t), d[e] = null;
                k++;
            } else (0, $40A6J.removePart)(d[j]), j--;
        } else (0, $40A6J.removePart)(d[x]), x++;
        for(; k <= w;){
            const e = (0, $40A6J.insertPart)(s, v[w + 1]);
            (0, $40A6J.setChildPartValue)(e, p[k]), v[k++] = e;
        }
        for(; x <= j;){
            const e = d[x++];
            null !== e && (0, $40A6J.removePart)(e);
        }
        return this.dt = a, (0, $40A6J.setCommittedValue)(s, v), $fXA0k.noChange;
    }
});

});


parcelRegister("2xFp3", function(module, exports) {
$parcel$export(module.exports, "createRef", function () { return (parcelRequire("aShgn")).createRef; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("aShgn")).ref; });
parcelRequire("aShgn");

});
parcelRegister("aShgn", function(module, exports) {

$parcel$export(module.exports, "createRef", function () { return $7eac56a3e0e36855$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "ref", function () { return $7eac56a3e0e36855$export$eff4d24c3ff7876e; });

var $fXA0k = parcelRequire("fXA0k");

var $2smIZ = parcelRequire("2smIZ");

var $hz9ib = parcelRequire("hz9ib");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $7eac56a3e0e36855$export$7d1e3a5e95ceca43 = ()=>new $7eac56a3e0e36855$var$h;
class $7eac56a3e0e36855$var$h {
}
const $7eac56a3e0e36855$var$o = new WeakMap, $7eac56a3e0e36855$export$eff4d24c3ff7876e = (0, $hz9ib.directive)(class extends (0, $2smIZ.AsyncDirective) {
    render(i) {
        return 0, $fXA0k.nothing;
    }
    update(i, [s]) {
        const e = s !== this.G;
        return e && void 0 !== this.G && this.ot(void 0), (e || this.rt !== this.lt) && (this.G = s, this.ct = i.options?.host, this.ot(this.lt = i.element)), $fXA0k.nothing;
    }
    ot(t) {
        if ("function" == typeof this.G) {
            const i = this.ct ?? globalThis;
            let s = $7eac56a3e0e36855$var$o.get(i);
            void 0 === s && (s = new WeakMap, $7eac56a3e0e36855$var$o.set(i, s)), void 0 !== s.get(this.G) && this.G.call(this.ct, void 0), s.set(this.G, t), void 0 !== t && this.G.call(this.ct, t);
        } else this.G.value = t;
    }
    get rt() {
        return "function" == typeof this.G ? $7eac56a3e0e36855$var$o.get(this.ct ?? globalThis)?.get(this.G) : this.G?.value;
    }
    disconnected() {
        this.rt === this.lt && this.ot(void 0);
    }
    reconnected() {
        this.ot(this.lt);
    }
});

});


parcelRegister("8108p", function(module, exports) {

$parcel$export(module.exports, "IconCodeComponent", function () { return $5d5e857b98548c37$export$111946c382d22039; });
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $fXA0k = parcelRequire("fXA0k");
parcelRequire("4MDiX");
var $asvDI = parcelRequire("asvDI");
parcelRequire("3IANd");
var $ogP7Y = parcelRequire("ogP7Y");
parcelRequire("bsGWa");
var $4fw8W = parcelRequire("4fw8W");
var $aynjv = parcelRequire("aynjv");
var $8Zp5V = parcelRequire("8Zp5V");
var $5d5e857b98548c37$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class $5d5e857b98548c37$export$111946c382d22039 extends (0, $8Zp5V.TiniElement) {
    static #_ = this.defaultTagName = "icon-code";
    static #_1 = this.componentName = "icon";
    static #_2 = this.styles = (0, $cZ4os.css)`:host{--icon-width:var(--scale-md-2x);--icon-height:var(--scale-md-2x);--icon-scheme:none;--icon-image:url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9ImN1cnJlbnRDb2xvciIgY2xhc3M9ImJpIGJpLWNvZGUiIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTTUuODU0IDQuODU0YS41LjUgMCAxIDAtLjcwOC0uNzA4bC0zLjUgMy41YS41LjUgMCAwIDAgMCAuNzA4bDMuNSAzLjVhLjUuNSAwIDAgMCAuNzA4LS43MDhMMi43MDcgOGwzLjE0Ny0zLjE0NnptNC4yOTIgMGEuNS41IDAgMCAxIC43MDgtLjcwOGwzLjUgMy41YS41LjUgMCAwIDEgMCAuNzA4bC0zLjUgMy41YS41LjUgMCAwIDEtLjcwOC0uNzA4TDEzLjI5MyA4bC0zLjE0Ny0zLjE0NnoiLz48L3N2Zz4=');display:inline-block}i{display:flex;align-items:center;justify-content:center;background-image:var(--icon-image);background-repeat:no-repeat;background-size:contain;background-position:center;width:var(--icon-width);height:var(--icon-height)}.scheme{background:var(--icon-scheme);-webkit-mask-image:var(--icon-image);-webkit-mask-size:var(--icon-width) var(--icon-height);-webkit-mask-repeat:no-repeat;-webkit-mask-position:center;mask-image:var(--icon-image);mask-size:var(--icon-width) var(--icon-height);mask-repeat:no-repeat;mask-position:center}${(0, $4fw8W.generateColorVaries)(({ fullName: fullName, color: color })=>`.${fullName} {--icon-scheme: ${color};}`)}${(0, $4fw8W.generateGradientVaries)(({ fullName: fullName, gradient: gradient })=>`.${fullName} {--icon-scheme: ${gradient};}`)}${(0, $4fw8W.generateScaleVaries)(({ name: name, fullName: fullName })=>`.${fullName} {--icon-width: var(--scale-${name}-2x);--icon-height: var(--scale-${name}-2x);}`)}`;
    willUpdate() {
        this.extendRootClasses({
            raw: {
                scheme: !!this.scheme
            },
            overridable: {
                [(0, $4fw8W.VaryGroups).Scale]: this.scale,
                [(0, $4fw8W.VaryGroups).Scheme]: this.scheme
            }
        });
    }
    render() {
        return (0, $fXA0k.html)`<i class=${(0, $ogP7Y.classMap)(this.rootClasses)} part=${(0, $aynjv.partAttrMap)(this.rootClasses)}></i>`;
    }
}
$5d5e857b98548c37$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $5d5e857b98548c37$export$111946c382d22039.prototype, "scale", void 0);
$5d5e857b98548c37$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $5d5e857b98548c37$export$111946c382d22039.prototype, "scheme", void 0); //# sourceMappingURL=code.js.map

});

parcelRegister("72ISR", function(module, exports) {

$parcel$export(module.exports, "TiniButtonComponent", function () { return $520b894be1d9b75d$export$dbd92c8e6d17eaa9; });

var $3mn2W = parcelRequire("3mn2W");

var $jYuPj = parcelRequire("jYuPj");
parcelRequire("bsGWa");
var $gKqnD = parcelRequire("gKqnD");
var $aynjv = parcelRequire("aynjv");
var $8Zp5V = parcelRequire("8Zp5V");
var $8gdKM = parcelRequire("8gdKM");
var $4fw8W = parcelRequire("4fw8W");
parcelRequire("lYoPT");
var $fXA0k = parcelRequire("fXA0k");
parcelRequire("4MDiX");
var $asvDI = parcelRequire("asvDI");
parcelRequire("3IANd");
var $ogP7Y = parcelRequire("ogP7Y");
var $520b894be1d9b75d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $520b894be1d9b75d$export$b3a351d88cea1c3a;
(function(ButtonModes) {
    ButtonModes["Filled"] = "filled";
    ButtonModes["Outline"] = "outline";
    ButtonModes["Bordered"] = "bordered";
    ButtonModes["Clear"] = "clear";
})($520b894be1d9b75d$export$b3a351d88cea1c3a || ($520b894be1d9b75d$export$b3a351d88cea1c3a = {}));
let $520b894be1d9b75d$export$dbd92c8e6d17eaa9 = class TiniButtonComponent extends (0, $8Zp5V.TiniElement) {
    static #_ = this.defaultTagName = "tini-button";
    static #_1 = this.componentName = "button";
    /* eslint-enable prettier/prettier */ willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        // root classes parts
        this.extendRootClasses({
            raw: {
                block: !!this.block,
                disabled: !!this.disabled,
                ...(0, $gKqnD.borderToClassInfo)(this.border)
            },
            pseudo: {
                hover: {
                    [(0, $4fw8W.VaryGroups).Scheme]: this.hoverScheme
                }
            },
            overridable: {
                [(0, $4fw8W.VaryGroups).Mode]: this.mode,
                [(0, $4fw8W.VaryGroups).Scheme]: this.scheme,
                [(0, $4fw8W.VaryGroups).Scale]: this.scale,
                [(0, $4fw8W.VaryGroups).Color]: this.color,
                [(0, $4fw8W.VaryGroups).FontSize]: this.fontSize,
                [(0, $4fw8W.VaryGroups).JustifyContent]: this.justifyContent,
                [(0, $4fw8W.VaryGroups).BorderRadius]: this.borderRadius,
                [(0, $4fw8W.VaryGroups).BoxShadow]: this.shadow
            }
        });
    }
    render() {
        return (0, $fXA0k.html)`<button
      class=${(0, $ogP7Y.classMap)(this.rootClasses)}
      part=${(0, $aynjv.partAttrMap)(this.rootClasses)}
      ?disabled=${this.disabled}
    >
      <slot></slot>
    </button>`;
    }
};
$520b894be1d9b75d$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $520b894be1d9b75d$export$dbd92c8e6d17eaa9.prototype, "mode", void 0);
$520b894be1d9b75d$var$__decorate([
    (0, $asvDI.property)({
        type: Boolean,
        reflect: true
    })
], $520b894be1d9b75d$export$dbd92c8e6d17eaa9.prototype, "block", void 0);
$520b894be1d9b75d$var$__decorate([
    (0, $asvDI.property)({
        type: Boolean,
        reflect: true
    })
], $520b894be1d9b75d$export$dbd92c8e6d17eaa9.prototype, "disabled", void 0);
$520b894be1d9b75d$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $520b894be1d9b75d$export$dbd92c8e6d17eaa9.prototype, "scheme", void 0);
$520b894be1d9b75d$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $520b894be1d9b75d$export$dbd92c8e6d17eaa9.prototype, "scale", void 0);
$520b894be1d9b75d$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $520b894be1d9b75d$export$dbd92c8e6d17eaa9.prototype, "color", void 0);
$520b894be1d9b75d$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $520b894be1d9b75d$export$dbd92c8e6d17eaa9.prototype, "fontSize", void 0);
$520b894be1d9b75d$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $520b894be1d9b75d$export$dbd92c8e6d17eaa9.prototype, "justifyContent", void 0);
$520b894be1d9b75d$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $520b894be1d9b75d$export$dbd92c8e6d17eaa9.prototype, "border", void 0);
$520b894be1d9b75d$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $520b894be1d9b75d$export$dbd92c8e6d17eaa9.prototype, "borderRadius", void 0);
$520b894be1d9b75d$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $520b894be1d9b75d$export$dbd92c8e6d17eaa9.prototype, "shadow", void 0);
$520b894be1d9b75d$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true,
        attribute: "hover:scheme"
    })
], $520b894be1d9b75d$export$dbd92c8e6d17eaa9.prototype, "hoverScheme", void 0);
$520b894be1d9b75d$export$dbd92c8e6d17eaa9 = $520b894be1d9b75d$var$__decorate([
    (0, $8gdKM.TiniElementTheming)({
        styling: {
            bootstrap: [
                (0, $3mn2W.default),
                (0, $jYuPj.buttonStyle)
            ]
        },
        scripting: {
            bootstrap: {
                script: (0, $jYuPj.buttonScript),
                unscript: (0, $jYuPj.buttonUnscript)
            }
        }
    })
], $520b894be1d9b75d$export$dbd92c8e6d17eaa9);

});
parcelRegister("jYuPj", function(module, exports) {

$parcel$export(module.exports, "buttonStyle", function () { return $16b30bc35ca39a25$export$fd4d27a26b4854f3; });
$parcel$export(module.exports, "buttonScript", function () { return $16b30bc35ca39a25$export$8479c50b6cb0c540; });
$parcel$export(module.exports, "buttonUnscript", function () { return $16b30bc35ca39a25$export$68f59e11a7334b68; });
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
parcelRequire("bsGWa");
var $4fw8W = parcelRequire("4fw8W");
const $16b30bc35ca39a25$export$fd4d27a26b4854f3 = (0, $cZ4os.css)`
  :host {
    --button-base-color: var(--color-medium);
    --button-color: var(--color-medium);
    --button-background: var(--color-medium) /* Background color */;
    --button-scale: var(--scale-md) /* Base scale */;
    --button-text-color: var(--color-medium-contrast) /* Text color */;
    --button-border-size: var(--size-border) /* Border size */;
    --button-border-radius: var(--size-radius) /* Border radius */;
    --button-shadow: var(--shadow-none) /* Box shadow */;
    --button-disabled-opacity: 0.5 /* Disabled opacity */;
    --button-focus-visible-shadow-size: var(--scale-md-0_3x)
      /* Focus visible shadow size */;
  }

  :host {
    display: inline;
  }

  /*
   * Root
   */

  button {
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: calc(var(--button-scale) * 0.5);
    padding: calc(var(--button-scale) * 0.5) var(--button-scale);
    background: var(--button-background);
    color: var(--button-text-color);
    font-family: var(--font-body);
    font-size: calc(var(--button-scale) * 1.1);
    line-height: 1.4;
    border-radius: var(--button-border-radius);
    outline: 0 !important;
    box-shadow: var(--button-shadow);
    transition: all 0.15s ease-in-out;
  }

  button:hover {
    opacity: 0.8;
  }

  button:active {
    opacity: 1;
  }

  button:focus-visible {
    box-shadow: 0 0 0 var(--button-focus-visible-shadow-size)
      color-mix(in oklab, var(--button-color), transparent 70%);
  }

  button:disabled,
  button:disabled:hover,
  button:disabled:active,
  button:disabled:focus-visible {
    cursor: not-allowed;
    pointer-events: none;
    box-shadow: none;
    background: var(--button-background);
    opacity: var(--button-disabled-opacity);
  }

  /*
   * Slot util classes
   */

  ::slotted(*) {
    pointer-events: none;
    line-height: 1.4 !important;
  }

  ::slotted(.content-group) {
    display: inline-flex;
    align-items: center;
    gap: calc(var(--button-scale) * 0.5);
  }

  /*
   * [?block]
   */

  :host([block]),
  .block {
    width: 100%;
    display: flex;
    align-items: center;
  }

  /*
   * [mode=outline]
   */

  button.mode-outline {
    background: none;
    color: var(
      --button-text-color-specific,
      var(--button-text-color-contrast, var(--button-base-color))
    );
    border-radius: var(--button-border-radius);
  }

  button.mode-outline::before {
    pointer-events: none;
    content: '';
    position: absolute;
    inset: 0;
    border: var(--button-border-size) solid transparent;
    border-radius: var(--button-border-radius);
    background: var(--button-background) border-box;
    -webkit-mask:
      linear-gradient(white 0 0) padding-box,
      linear-gradient(white 0 0);
    mask-composite: exclude;
    -webkit-mask-composite: destination-out;
  }

  button.mode-outline:hover {
    background: var(--button-background);
    color: var(--button-text-color);
    opacity: 1;
  }

  button.mode-outline:active {
    opacity: 0.9 !important;
  }

  /*
   * [mode=bordered]
   */

  button.mode-bordered {
    background: none;
    color: var(
      --button-text-color-specific,
      var(--button-text-color-contrast, var(--button-base-color))
    );
    border: var(--button-border-size) solid var(--button-color);
  }

  button.mode-bordered:hover {
    background: var(--button-background);
    color: var(--button-text-color);
    opacity: 1;
  }

  button.mode-bordered:active {
    opacity: 0.8;
  }

  /*
   * [mode=clear]
   */

  button.mode-clear {
    background: transparent;
    color: var(
      --button-text-color-specific,
      var(--button-text-color-contrast, var(--button-base-color))
    );
  }

  button.mode-clear:hover {
    background: var(--button-background);
    color: var(--button-text-color);
    opacity: 1;
  }

  button.mode-clear:hover {
    opacity: 1;
  }

  button.mode-clear:active {
    opacity: 0.8;
  }

  /*
   * [border/width]
   */

  ${(0, $4fw8W.generateBorderWidthVaries)(({ fullName: fullName, width: width })=>`
    button.${fullName} {
      border-width: ${width} !important;
      border-color: var(--button-color);
      border-style: solid;
    }
  `)}

  /*
   * [border/style]
   */

  ${(0, $4fw8W.generateBorderStyleVaries)(({ fullName: fullName, style: style })=>`
    button.${fullName} {
      border-style: ${style} !important;
      border-width: var(--size-border);
      border-color: var(--button-color);
    }
  `)}

  /*
   * [borderRadius]
   */

  ${(0, $4fw8W.generateBorderRadiusVaries)(({ fullName: fullName, radius: radius })=>`
    button.${fullName} {
      --button-border-radius: ${radius};
    }
  `)}

  /*
   * [scheme] & [color] & [border/color]
   */

  ${(0, $4fw8W.generateColorVaries)(({ name: name, fullName: fullName, isContrast: isContrast, baseColor: baseColor, color: color, baseContrast: baseContrast, contrast: contrast })=>`
    button.${fullName}-hover {
      transition: none;
      opacity: 1;
    }

    button.${fullName}-hover:active {
      opacity: 0.9;
    }

    button.${fullName},
    button.${fullName}-hover:hover {
      --button-background: ${color};
      --button-text-color: ${contrast};
      --button-color: ${color};
      --button-base-color: ${baseColor};
      ${!isContrast ? "" : `--button-text-color-contrast: ${baseContrast};`}
    }

    button.${(0, $4fw8W.VaryGroups).Color}-${name} {
      --button-text-color: ${color} !important;
      --button-text-color-specific: ${color} !important;
    }

    button.${(0, $4fw8W.VaryGroups).BorderColor}-${name} {
      border-color: ${color} !important;
      border-width: var(--size-border);
      border-style: solid;
    }
  `)}

  ${(0, $4fw8W.generateGradientVaries)(({ fullName: fullName, isContrast: isContrast, gradient: gradient, baseColor: baseColor, color: color, baseContrast: baseContrast, contrast: contrast })=>`
    button.${fullName}.mode-outline,
    button.${fullName}-hover {
      opacity: 1;
      transition: none;
    }

    button.${fullName}-hover:active {
      opacity: 0.9;
    }

    button.${fullName},
    button.${fullName}-hover:hover {
      --button-background: ${gradient};
      --button-text-color: ${contrast};
      --button-color: ${color};
      --button-base-color: ${baseColor};
      ${!isContrast ? "" : `--button-text-color-contrast: ${baseContrast};`}
    }
  `)}

  /*
   * [scale]
   */

  ${(0, $4fw8W.generateScaleVaries)(({ name: name, fullName: fullName, scale: scale })=>`
    button.${fullName} {
      --button-scale: ${scale};
      --button-focus-visible-shadow-size: var(--scale-${name}-0_3x);
    }
  `)}

  /*
   * [fontSize]
   */

  ${(0, $4fw8W.generateFontSizeVaries)(({ fullName: fullName, size: size })=>`
    button.${fullName} {
      font-size: ${size} !important;
    }
  `)}

  /*
   * [justifyContent]
   */

  ${(0, $4fw8W.generateJustifyContentVaries)(({ fullName: fullName, justify: justify })=>`
    button.${fullName} {
      justify-content: ${justify};
    }
  `)}

  /*
   * [shadow]
   */

  ${(0, $4fw8W.generateBoxShadowVaries)(({ fullName: fullName, shadow: shadow })=>`
    button.${fullName} {
      --button-shadow: ${shadow};
    }
  `)}
`;
const $16b30bc35ca39a25$export$8479c50b6cb0c540 = undefined;
const $16b30bc35ca39a25$export$68f59e11a7334b68 = undefined;

});


parcelRegister("10mzZ", function(module, exports) {

$parcel$export(module.exports, "AppCodeComponent", function () { return $0996acc6b69f18fe$export$bfd206932507c38a; });

var $4tSb9 = parcelRequire("4tSb9");
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $fXA0k = parcelRequire("fXA0k");
parcelRequire("3IANd");
var $ogP7Y = parcelRequire("ogP7Y");
parcelRequire("2xFp3");
var $aShgn = parcelRequire("aShgn");
parcelRequire("1mUAS");
var $aHFKf = parcelRequire("aHFKf");
var $2qQ1O = parcelRequire("2qQ1O");
var $3bQrU = parcelRequire("3bQrU");

var $eD4R9 = parcelRequire("eD4R9");

var $6fXMv = parcelRequire("6fXMv");
let $0996acc6b69f18fe$export$bfd206932507c38a = class AppCodeComponent extends (0, $2qQ1O.TiniComponent) {
    static #_ = this.defaultTagName = "app-code";
    onRenders() {
        this.codeRef.value.textContent = this.code;
        this.codeRef.value.dataset.highlighted = "";
        (0, $6fXMv.default).highlightElement(this.codeRef.value);
    }
    render() {
        return (0, $fXA0k.html)`<pre><code class="${(0, $ogP7Y.classMap)({
            [`language-${this.language}`]: !!this.language
        })}" ${(0, $aShgn.ref)(this.codeRef)}></code></pre>`;
    }
    static #_1 = this.styles = (0, $cZ4os.css)`pre code.hljs{display:block;overflow-x:auto;padding:1em;font-size:.9rem}code.hljs{padding:3px 5px}.hljs{color:#adbac7;background:#22272e}.hljs-doctag,.hljs-keyword,.hljs-meta .hljs-keyword,.hljs-template-tag,.hljs-template-variable,.hljs-type,.hljs-variable.language_{color:#f47067}.hljs-title,.hljs-title.class_,.hljs-title.class_.inherited__,.hljs-title.function_{color:#dcbdfb}.hljs-attr,.hljs-attribute,.hljs-literal,.hljs-meta,.hljs-number,.hljs-operator,.hljs-selector-attr,.hljs-selector-class,.hljs-selector-id,.hljs-variable{color:#6cb6ff}.hljs-meta .hljs-string,.hljs-regexp,.hljs-string{color:#96d0ff}.hljs-built_in,.hljs-symbol{color:#f69d50}.hljs-code,.hljs-comment,.hljs-formula{color:#768390}.hljs-name,.hljs-quote,.hljs-selector-pseudo,.hljs-selector-tag{color:#8ddb8c}.hljs-subst{color:#adbac7}.hljs-section{color:#316dca;font-weight:700}.hljs-bullet{color:#eac55f}.hljs-emphasis{color:#adbac7;font-style:italic}.hljs-strong{color:#adbac7;font-weight:700}.hljs-addition{color:#b4f1b4;background-color:#1b4721}.hljs-deletion{color:#ffd8d3;background-color:#78191b}pre{font-size:14px;margin-top:0;border-radius:var(--size-radius);overflow:hidden}`;
    constructor(...args){
        super(...args);
        this.codeRef = (0, $aShgn.createRef)();
    }
};
(0, $4tSb9.__decorate)([
    (0, $2qQ1O.Input)({
        type: String
    })
], $0996acc6b69f18fe$export$bfd206932507c38a.prototype, "code", void 0);
(0, $4tSb9.__decorate)([
    (0, $2qQ1O.Input)({
        type: String
    })
], $0996acc6b69f18fe$export$bfd206932507c38a.prototype, "language", void 0);
$0996acc6b69f18fe$export$bfd206932507c38a = (0, $4tSb9.__decorate)([
    (0, $aHFKf.Component)({
        theming: {
            styling: (0, $3bQrU.stylingWithBases)([
                (0, $eD4R9.commonBases),
                (0, $eD4R9.codeBases)
            ])
        }
    })
], $0996acc6b69f18fe$export$bfd206932507c38a);

});
parcelRegister("6fXMv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0bc0891c0aa12e9$export$2e2bcd8739ae039; });

var $jHmWQ = parcelRequire("jHmWQ");

var $epnql = parcelRequire("epnql");

var $amFZG = parcelRequire("amFZG");

var $3pFcp = parcelRequire("3pFcp");

var $38p48 = parcelRequire("38p48");

var $9Grm6 = parcelRequire("9Grm6");

var $kM5iW = parcelRequire("kM5iW");
(0, (/*@__PURE__*/$parcel$interopDefault($jHmWQ))).registerLanguage("xml", (0, (/*@__PURE__*/$parcel$interopDefault($epnql))));
(0, (/*@__PURE__*/$parcel$interopDefault($jHmWQ))).registerLanguage("css", (0, (/*@__PURE__*/$parcel$interopDefault($amFZG))));
(0, (/*@__PURE__*/$parcel$interopDefault($jHmWQ))).registerLanguage("scss", (0, (/*@__PURE__*/$parcel$interopDefault($3pFcp))));
(0, (/*@__PURE__*/$parcel$interopDefault($jHmWQ))).registerLanguage("javascript", (0, (/*@__PURE__*/$parcel$interopDefault($38p48))));
(0, (/*@__PURE__*/$parcel$interopDefault($jHmWQ))).registerLanguage("typescript", (0, (/*@__PURE__*/$parcel$interopDefault($9Grm6))));
(0, (/*@__PURE__*/$parcel$interopDefault($jHmWQ))).registerLanguage("bash", (0, (/*@__PURE__*/$parcel$interopDefault($kM5iW))));
var $b0bc0891c0aa12e9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($jHmWQ)));

});
parcelRegister("jHmWQ", function(module, exports) {
/* eslint-disable no-multi-assign */ function $e573d579511d10ff$var$deepFreeze(obj) {
    if (obj instanceof Map) obj.clear = obj.delete = obj.set = function() {
        throw new Error("map is read-only");
    };
    else if (obj instanceof Set) obj.add = obj.clear = obj.delete = function() {
        throw new Error("set is read-only");
    };
    // Freeze self
    Object.freeze(obj);
    Object.getOwnPropertyNames(obj).forEach((name)=>{
        const prop = obj[name];
        const type = typeof prop;
        // Freeze prop if it is an object or function and also not already frozen
        if ((type === "object" || type === "function") && !Object.isFrozen(prop)) $e573d579511d10ff$var$deepFreeze(prop);
    });
    return obj;
}
/** @typedef {import('highlight.js').CallbackResponse} CallbackResponse */ /** @typedef {import('highlight.js').CompiledMode} CompiledMode */ /** @implements CallbackResponse */ class $e573d579511d10ff$var$Response {
    /**
   * @param {CompiledMode} mode
   */ constructor(mode){
        // eslint-disable-next-line no-undefined
        if (mode.data === undefined) mode.data = {};
        this.data = mode.data;
        this.isMatchIgnored = false;
    }
    ignoreMatch() {
        this.isMatchIgnored = true;
    }
}
/**
 * @param {string} value
 * @returns {string}
 */ function $e573d579511d10ff$var$escapeHTML(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}
/**
 * performs a shallow merge of multiple objects into one
 *
 * @template T
 * @param {T} original
 * @param {Record<string,any>[]} objects
 * @returns {T} a single new object
 */ function $e573d579511d10ff$var$inherit$1(original, ...objects) {
    /** @type Record<string,any> */ const result = Object.create(null);
    for(const key in original)result[key] = original[key];
    objects.forEach(function(obj) {
        for(const key in obj)result[key] = obj[key];
    });
    return /** @type {T} */ result;
}
/**
 * @typedef {object} Renderer
 * @property {(text: string) => void} addText
 * @property {(node: Node) => void} openNode
 * @property {(node: Node) => void} closeNode
 * @property {() => string} value
 */ /** @typedef {{scope?: string, language?: string, sublanguage?: boolean}} Node */ /** @typedef {{walk: (r: Renderer) => void}} Tree */ /** */ const $e573d579511d10ff$var$SPAN_CLOSE = "</span>";
/**
 * Determines if a node needs to be wrapped in <span>
 *
 * @param {Node} node */ const $e573d579511d10ff$var$emitsWrappingTags = (node)=>{
    // rarely we can have a sublanguage where language is undefined
    // TODO: track down why
    return !!node.scope;
};
/**
 *
 * @param {string} name
 * @param {{prefix:string}} options
 */ const $e573d579511d10ff$var$scopeToCSSClass = (name, { prefix: prefix })=>{
    // sub-language
    if (name.startsWith("language:")) return name.replace("language:", "language-");
    // tiered scope: comment.line
    if (name.includes(".")) {
        const pieces = name.split(".");
        return [
            `${prefix}${pieces.shift()}`,
            ...pieces.map((x, i)=>`${x}${"_".repeat(i + 1)}`)
        ].join(" ");
    }
    // simple scope
    return `${prefix}${name}`;
};
/** @type {Renderer} */ class $e573d579511d10ff$var$HTMLRenderer {
    /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */ constructor(parseTree, options){
        this.buffer = "";
        this.classPrefix = options.classPrefix;
        parseTree.walk(this);
    }
    /**
   * Adds texts to the output stream
   *
   * @param {string} text */ addText(text) {
        this.buffer += $e573d579511d10ff$var$escapeHTML(text);
    }
    /**
   * Adds a node open to the output stream (if needed)
   *
   * @param {Node} node */ openNode(node) {
        if (!$e573d579511d10ff$var$emitsWrappingTags(node)) return;
        const className = $e573d579511d10ff$var$scopeToCSSClass(node.scope, {
            prefix: this.classPrefix
        });
        this.span(className);
    }
    /**
   * Adds a node close to the output stream (if needed)
   *
   * @param {Node} node */ closeNode(node) {
        if (!$e573d579511d10ff$var$emitsWrappingTags(node)) return;
        this.buffer += $e573d579511d10ff$var$SPAN_CLOSE;
    }
    /**
   * returns the accumulated buffer
  */ value() {
        return this.buffer;
    }
    // helpers
    /**
   * Builds a span element
   *
   * @param {string} className */ span(className) {
        this.buffer += `<span class="${className}">`;
    }
}
/** @typedef {{scope?: string, language?: string, children: Node[]} | string} Node */ /** @typedef {{scope?: string, language?: string, children: Node[]} } DataNode */ /** @typedef {import('highlight.js').Emitter} Emitter */ /**  */ /** @returns {DataNode} */ const $e573d579511d10ff$var$newNode = (opts = {})=>{
    /** @type DataNode */ const result = {
        children: []
    };
    Object.assign(result, opts);
    return result;
};
class $e573d579511d10ff$var$TokenTree {
    constructor(){
        /** @type DataNode */ this.rootNode = $e573d579511d10ff$var$newNode();
        this.stack = [
            this.rootNode
        ];
    }
    get top() {
        return this.stack[this.stack.length - 1];
    }
    get root() {
        return this.rootNode;
    }
    /** @param {Node} node */ add(node) {
        this.top.children.push(node);
    }
    /** @param {string} scope */ openNode(scope) {
        /** @type Node */ const node = $e573d579511d10ff$var$newNode({
            scope: scope
        });
        this.add(node);
        this.stack.push(node);
    }
    closeNode() {
        if (this.stack.length > 1) return this.stack.pop();
        // eslint-disable-next-line no-undefined
        return undefined;
    }
    closeAllNodes() {
        while(this.closeNode());
    }
    toJSON() {
        return JSON.stringify(this.rootNode, null, 4);
    }
    /**
   * @typedef { import("./html_renderer").Renderer } Renderer
   * @param {Renderer} builder
   */ walk(builder) {
        // this does not
        return this.constructor._walk(builder, this.rootNode);
    // this works
    // return TokenTree._walk(builder, this.rootNode);
    }
    /**
   * @param {Renderer} builder
   * @param {Node} node
   */ static _walk(builder, node) {
        if (typeof node === "string") builder.addText(node);
        else if (node.children) {
            builder.openNode(node);
            node.children.forEach((child)=>this._walk(builder, child));
            builder.closeNode(node);
        }
        return builder;
    }
    /**
   * @param {Node} node
   */ static _collapse(node) {
        if (typeof node === "string") return;
        if (!node.children) return;
        if (node.children.every((el)=>typeof el === "string")) // node.text = node.children.join("");
        // delete node.children;
        node.children = [
            node.children.join("")
        ];
        else node.children.forEach((child)=>{
            $e573d579511d10ff$var$TokenTree._collapse(child);
        });
    }
}
/**
  Currently this is all private API, but this is the minimal API necessary
  that an Emitter must implement to fully support the parser.

  Minimal interface:

  - addText(text)
  - __addSublanguage(emitter, subLanguageName)
  - startScope(scope)
  - endScope()
  - finalize()
  - toHTML()

*/ /**
 * @implements {Emitter}
 */ class $e573d579511d10ff$var$TokenTreeEmitter extends $e573d579511d10ff$var$TokenTree {
    /**
   * @param {*} options
   */ constructor(options){
        super();
        this.options = options;
    }
    /**
   * @param {string} text
   */ addText(text) {
        if (text === "") return;
        this.add(text);
    }
    /** @param {string} scope */ startScope(scope) {
        this.openNode(scope);
    }
    endScope() {
        this.closeNode();
    }
    /**
   * @param {Emitter & {root: DataNode}} emitter
   * @param {string} name
   */ __addSublanguage(emitter, name) {
        /** @type DataNode */ const node = emitter.root;
        if (name) node.scope = `language:${name}`;
        this.add(node);
    }
    toHTML() {
        const renderer = new $e573d579511d10ff$var$HTMLRenderer(this, this.options);
        return renderer.value();
    }
    finalize() {
        this.closeAllNodes();
        return true;
    }
}
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $e573d579511d10ff$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $e573d579511d10ff$var$lookahead(re) {
    return $e573d579511d10ff$var$concat("(?=", re, ")");
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $e573d579511d10ff$var$anyNumberOfTimes(re) {
    return $e573d579511d10ff$var$concat("(?:", re, ")*");
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $e573d579511d10ff$var$optional(re) {
    return $e573d579511d10ff$var$concat("(?:", re, ")?");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $e573d579511d10ff$var$concat(...args) {
    const joined = args.map((x)=>$e573d579511d10ff$var$source(x)).join("");
    return joined;
}
/**
 * @param { Array<string | RegExp | Object> } args
 * @returns {object}
 */ function $e573d579511d10ff$var$stripOptionsFromArgs(args) {
    const opts = args[args.length - 1];
    if (typeof opts === "object" && opts.constructor === Object) {
        args.splice(args.length - 1, 1);
        return opts;
    } else return {};
}
/** @typedef { {capture?: boolean} } RegexEitherOptions */ /**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] | [...(RegExp | string)[], RegexEitherOptions]} args
 * @returns {string}
 */ function $e573d579511d10ff$var$either(...args) {
    /** @type { object & {capture?: boolean} }  */ const opts = $e573d579511d10ff$var$stripOptionsFromArgs(args);
    const joined = "(" + (opts.capture ? "" : "?:") + args.map((x)=>$e573d579511d10ff$var$source(x)).join("|") + ")";
    return joined;
}
/**
 * @param {RegExp | string} re
 * @returns {number}
 */ function $e573d579511d10ff$var$countMatchGroups(re) {
    return new RegExp(re.toString() + "|").exec("").length - 1;
}
/**
 * Does lexeme start with a regular expression match at the beginning
 * @param {RegExp} re
 * @param {string} lexeme
 */ function $e573d579511d10ff$var$startsWith(re, lexeme) {
    const match = re && re.exec(lexeme);
    return match && match.index === 0;
}
// BACKREF_RE matches an open parenthesis or backreference. To avoid
// an incorrect parse, it additionally matches the following:
// - [...] elements, where the meaning of parentheses and escapes change
// - other escape sequences, so we do not misparse escape sequences as
//   interesting elements
// - non-matching or lookahead parentheses, which do not capture. These
//   follow the '(' with a '?'.
const $e573d579511d10ff$var$BACKREF_RE = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
// **INTERNAL** Not intended for outside usage
// join logically computes regexps.join(separator), but fixes the
// backreferences so they continue to match.
// it also places each individual regular expression into it's own
// match group, keeping track of the sequencing of those match groups
// is currently an exercise for the caller. :-)
/**
 * @param {(string | RegExp)[]} regexps
 * @param {{joinWith: string}} opts
 * @returns {string}
 */ function $e573d579511d10ff$var$_rewriteBackreferences(regexps, { joinWith: joinWith }) {
    let numCaptures = 0;
    return regexps.map((regex)=>{
        numCaptures += 1;
        const offset = numCaptures;
        let re = $e573d579511d10ff$var$source(regex);
        let out = "";
        while(re.length > 0){
            const match = $e573d579511d10ff$var$BACKREF_RE.exec(re);
            if (!match) {
                out += re;
                break;
            }
            out += re.substring(0, match.index);
            re = re.substring(match.index + match[0].length);
            if (match[0][0] === "\\" && match[1]) // Adjust the backreference.
            out += "\\" + String(Number(match[1]) + offset);
            else {
                out += match[0];
                if (match[0] === "(") numCaptures++;
            }
        }
        return out;
    }).map((re)=>`(${re})`).join(joinWith);
}
/** @typedef {import('highlight.js').Mode} Mode */ /** @typedef {import('highlight.js').ModeCallback} ModeCallback */ // Common regexps
const $e573d579511d10ff$var$MATCH_NOTHING_RE = /\b\B/;
const $e573d579511d10ff$var$IDENT_RE = "[a-zA-Z]\\w*";
const $e573d579511d10ff$var$UNDERSCORE_IDENT_RE = "[a-zA-Z_]\\w*";
const $e573d579511d10ff$var$NUMBER_RE = "\\b\\d+(\\.\\d+)?";
const $e573d579511d10ff$var$C_NUMBER_RE = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)"; // 0x..., 0..., decimal, float
const $e573d579511d10ff$var$BINARY_NUMBER_RE = "\\b(0b[01]+)"; // 0b...
const $e573d579511d10ff$var$RE_STARTERS_RE = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~";
/**
* @param { Partial<Mode> & {binary?: string | RegExp} } opts
*/ const $e573d579511d10ff$var$SHEBANG = (opts = {})=>{
    const beginShebang = /^#![ ]*\//;
    if (opts.binary) opts.begin = $e573d579511d10ff$var$concat(beginShebang, /.*\b/, opts.binary, /\b.*/);
    return $e573d579511d10ff$var$inherit$1({
        scope: "meta",
        begin: beginShebang,
        end: /$/,
        relevance: 0,
        /** @type {ModeCallback} */ "on:begin": (m, resp)=>{
            if (m.index !== 0) resp.ignoreMatch();
        }
    }, opts);
};
// Common modes
const $e573d579511d10ff$var$BACKSLASH_ESCAPE = {
    begin: "\\\\[\\s\\S]",
    relevance: 0
};
const $e573d579511d10ff$var$APOS_STRING_MODE = {
    scope: "string",
    begin: "'",
    end: "'",
    illegal: "\\n",
    contains: [
        $e573d579511d10ff$var$BACKSLASH_ESCAPE
    ]
};
const $e573d579511d10ff$var$QUOTE_STRING_MODE = {
    scope: "string",
    begin: '"',
    end: '"',
    illegal: "\\n",
    contains: [
        $e573d579511d10ff$var$BACKSLASH_ESCAPE
    ]
};
const $e573d579511d10ff$var$PHRASAL_WORDS_MODE = {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
};
/**
 * Creates a comment mode
 *
 * @param {string | RegExp} begin
 * @param {string | RegExp} end
 * @param {Mode | {}} [modeOptions]
 * @returns {Partial<Mode>}
 */ const $e573d579511d10ff$var$COMMENT = function(begin, end, modeOptions = {}) {
    const mode = $e573d579511d10ff$var$inherit$1({
        scope: "comment",
        begin: begin,
        end: end,
        contains: []
    }, modeOptions);
    mode.contains.push({
        scope: "doctag",
        // hack to avoid the space from being included. the space is necessary to
        // match here to prevent the plain text rule below from gobbling up doctags
        begin: "[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)",
        end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
        excludeBegin: true,
        relevance: 0
    });
    const ENGLISH_WORD = $e573d579511d10ff$var$either(// list of common 1 and 2 letter words in English
    "I", "a", "is", "so", "us", "to", "at", "if", "in", "it", "on", // note: this is not an exhaustive list of contractions, just popular ones
    /[A-Za-z]+['](d|ve|re|ll|t|s|n)/, /[A-Za-z]+[-][a-z]+/, /[A-Za-z][a-z]{2,}/ // allow capitalized words at beginning of sentences
    );
    // looking like plain text, more likely to be a comment
    mode.contains.push({
        // TODO: how to include ", (, ) without breaking grammars that use these for
        // comment delimiters?
        // begin: /[ ]+([()"]?([A-Za-z'-]{3,}|is|a|I|so|us|[tT][oO]|at|if|in|it|on)[.]?[()":]?([.][ ]|[ ]|\))){3}/
        // ---
        // this tries to find sequences of 3 english words in a row (without any
        // "programming" type syntax) this gives us a strong signal that we've
        // TRULY found a comment - vs perhaps scanning with the wrong language.
        // It's possible to find something that LOOKS like the start of the
        // comment - but then if there is no readable text - good chance it is a
        // false match and not a comment.
        //
        // for a visual example please see:
        // https://github.com/highlightjs/highlight.js/issues/2827
        begin: $e573d579511d10ff$var$concat(/[ ]+/, "(", ENGLISH_WORD, /[.]?[:]?([.][ ]|[ ])/, "){3}") // look for 3 words in a row
    });
    return mode;
};
const $e573d579511d10ff$var$C_LINE_COMMENT_MODE = $e573d579511d10ff$var$COMMENT("//", "$");
const $e573d579511d10ff$var$C_BLOCK_COMMENT_MODE = $e573d579511d10ff$var$COMMENT("/\\*", "\\*/");
const $e573d579511d10ff$var$HASH_COMMENT_MODE = $e573d579511d10ff$var$COMMENT("#", "$");
const $e573d579511d10ff$var$NUMBER_MODE = {
    scope: "number",
    begin: $e573d579511d10ff$var$NUMBER_RE,
    relevance: 0
};
const $e573d579511d10ff$var$C_NUMBER_MODE = {
    scope: "number",
    begin: $e573d579511d10ff$var$C_NUMBER_RE,
    relevance: 0
};
const $e573d579511d10ff$var$BINARY_NUMBER_MODE = {
    scope: "number",
    begin: $e573d579511d10ff$var$BINARY_NUMBER_RE,
    relevance: 0
};
const $e573d579511d10ff$var$REGEXP_MODE = {
    scope: "regexp",
    begin: /\/(?=[^/\n]*\/)/,
    end: /\/[gimuy]*/,
    contains: [
        $e573d579511d10ff$var$BACKSLASH_ESCAPE,
        {
            begin: /\[/,
            end: /\]/,
            relevance: 0,
            contains: [
                $e573d579511d10ff$var$BACKSLASH_ESCAPE
            ]
        }
    ]
};
const $e573d579511d10ff$var$TITLE_MODE = {
    scope: "title",
    begin: $e573d579511d10ff$var$IDENT_RE,
    relevance: 0
};
const $e573d579511d10ff$var$UNDERSCORE_TITLE_MODE = {
    scope: "title",
    begin: $e573d579511d10ff$var$UNDERSCORE_IDENT_RE,
    relevance: 0
};
const $e573d579511d10ff$var$METHOD_GUARD = {
    // excludes method names from keyword processing
    begin: "\\.\\s*" + $e573d579511d10ff$var$UNDERSCORE_IDENT_RE,
    relevance: 0
};
/**
 * Adds end same as begin mechanics to a mode
 *
 * Your mode must include at least a single () match group as that first match
 * group is what is used for comparison
 * @param {Partial<Mode>} mode
 */ const $e573d579511d10ff$var$END_SAME_AS_BEGIN = function(mode) {
    return Object.assign(mode, {
        /** @type {ModeCallback} */ "on:begin": (m, resp)=>{
            resp.data._beginMatch = m[1];
        },
        /** @type {ModeCallback} */ "on:end": (m, resp)=>{
            if (resp.data._beginMatch !== m[1]) resp.ignoreMatch();
        }
    });
};
var $e573d579511d10ff$var$MODES = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    APOS_STRING_MODE: $e573d579511d10ff$var$APOS_STRING_MODE,
    BACKSLASH_ESCAPE: $e573d579511d10ff$var$BACKSLASH_ESCAPE,
    BINARY_NUMBER_MODE: $e573d579511d10ff$var$BINARY_NUMBER_MODE,
    BINARY_NUMBER_RE: $e573d579511d10ff$var$BINARY_NUMBER_RE,
    COMMENT: $e573d579511d10ff$var$COMMENT,
    C_BLOCK_COMMENT_MODE: $e573d579511d10ff$var$C_BLOCK_COMMENT_MODE,
    C_LINE_COMMENT_MODE: $e573d579511d10ff$var$C_LINE_COMMENT_MODE,
    C_NUMBER_MODE: $e573d579511d10ff$var$C_NUMBER_MODE,
    C_NUMBER_RE: $e573d579511d10ff$var$C_NUMBER_RE,
    END_SAME_AS_BEGIN: $e573d579511d10ff$var$END_SAME_AS_BEGIN,
    HASH_COMMENT_MODE: $e573d579511d10ff$var$HASH_COMMENT_MODE,
    IDENT_RE: $e573d579511d10ff$var$IDENT_RE,
    MATCH_NOTHING_RE: $e573d579511d10ff$var$MATCH_NOTHING_RE,
    METHOD_GUARD: $e573d579511d10ff$var$METHOD_GUARD,
    NUMBER_MODE: $e573d579511d10ff$var$NUMBER_MODE,
    NUMBER_RE: $e573d579511d10ff$var$NUMBER_RE,
    PHRASAL_WORDS_MODE: $e573d579511d10ff$var$PHRASAL_WORDS_MODE,
    QUOTE_STRING_MODE: $e573d579511d10ff$var$QUOTE_STRING_MODE,
    REGEXP_MODE: $e573d579511d10ff$var$REGEXP_MODE,
    RE_STARTERS_RE: $e573d579511d10ff$var$RE_STARTERS_RE,
    SHEBANG: $e573d579511d10ff$var$SHEBANG,
    TITLE_MODE: $e573d579511d10ff$var$TITLE_MODE,
    UNDERSCORE_IDENT_RE: $e573d579511d10ff$var$UNDERSCORE_IDENT_RE,
    UNDERSCORE_TITLE_MODE: $e573d579511d10ff$var$UNDERSCORE_TITLE_MODE
});
/**
@typedef {import('highlight.js').CallbackResponse} CallbackResponse
@typedef {import('highlight.js').CompilerExt} CompilerExt
*/ // Grammar extensions / plugins
// See: https://github.com/highlightjs/highlight.js/issues/2833
// Grammar extensions allow "syntactic sugar" to be added to the grammar modes
// without requiring any underlying changes to the compiler internals.
// `compileMatch` being the perfect small example of now allowing a grammar
// author to write `match` when they desire to match a single expression rather
// than being forced to use `begin`.  The extension then just moves `match` into
// `begin` when it runs.  Ie, no features have been added, but we've just made
// the experience of writing (and reading grammars) a little bit nicer.
// ------
// TODO: We need negative look-behind support to do this properly
/**
 * Skip a match if it has a preceding dot
 *
 * This is used for `beginKeywords` to prevent matching expressions such as
 * `bob.keyword.do()`. The mode compiler automatically wires this up as a
 * special _internal_ 'on:begin' callback for modes with `beginKeywords`
 * @param {RegExpMatchArray} match
 * @param {CallbackResponse} response
 */ function $e573d579511d10ff$var$skipIfHasPrecedingDot(match, response) {
    const before = match.input[match.index - 1];
    if (before === ".") response.ignoreMatch();
}
/**
 *
 * @type {CompilerExt}
 */ function $e573d579511d10ff$var$scopeClassName(mode, _parent) {
    // eslint-disable-next-line no-undefined
    if (mode.className !== undefined) {
        mode.scope = mode.className;
        delete mode.className;
    }
}
/**
 * `beginKeywords` syntactic sugar
 * @type {CompilerExt}
 */ function $e573d579511d10ff$var$beginKeywords(mode, parent) {
    if (!parent) return;
    if (!mode.beginKeywords) return;
    // for languages with keywords that include non-word characters checking for
    // a word boundary is not sufficient, so instead we check for a word boundary
    // or whitespace - this does no harm in any case since our keyword engine
    // doesn't allow spaces in keywords anyways and we still check for the boundary
    // first
    mode.begin = "\\b(" + mode.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)";
    mode.__beforeBegin = $e573d579511d10ff$var$skipIfHasPrecedingDot;
    mode.keywords = mode.keywords || mode.beginKeywords;
    delete mode.beginKeywords;
    // prevents double relevance, the keywords themselves provide
    // relevance, the mode doesn't need to double it
    // eslint-disable-next-line no-undefined
    if (mode.relevance === undefined) mode.relevance = 0;
}
/**
 * Allow `illegal` to contain an array of illegal values
 * @type {CompilerExt}
 */ function $e573d579511d10ff$var$compileIllegal(mode, _parent) {
    if (!Array.isArray(mode.illegal)) return;
    mode.illegal = $e573d579511d10ff$var$either(...mode.illegal);
}
/**
 * `match` to match a single expression for readability
 * @type {CompilerExt}
 */ function $e573d579511d10ff$var$compileMatch(mode, _parent) {
    if (!mode.match) return;
    if (mode.begin || mode.end) throw new Error("begin & end are not supported with match");
    mode.begin = mode.match;
    delete mode.match;
}
/**
 * provides the default 1 relevance to all modes
 * @type {CompilerExt}
 */ function $e573d579511d10ff$var$compileRelevance(mode, _parent) {
    // eslint-disable-next-line no-undefined
    if (mode.relevance === undefined) mode.relevance = 1;
}
// allow beforeMatch to act as a "qualifier" for the match
// the full match begin must be [beforeMatch][begin]
const $e573d579511d10ff$var$beforeMatchExt = (mode, parent)=>{
    if (!mode.beforeMatch) return;
    // starts conflicts with endsParent which we need to make sure the child
    // rule is not matched multiple times
    if (mode.starts) throw new Error("beforeMatch cannot be used with starts");
    const originalMode = Object.assign({}, mode);
    Object.keys(mode).forEach((key)=>{
        delete mode[key];
    });
    mode.keywords = originalMode.keywords;
    mode.begin = $e573d579511d10ff$var$concat(originalMode.beforeMatch, $e573d579511d10ff$var$lookahead(originalMode.begin));
    mode.starts = {
        relevance: 0,
        contains: [
            Object.assign(originalMode, {
                endsParent: true
            })
        ]
    };
    mode.relevance = 0;
    delete originalMode.beforeMatch;
};
// keywords that should have no default relevance value
const $e573d579511d10ff$var$COMMON_KEYWORDS = [
    "of",
    "and",
    "for",
    "in",
    "not",
    "or",
    "if",
    "then",
    "parent",
    "list",
    "value" // common variable name
];
const $e573d579511d10ff$var$DEFAULT_KEYWORD_SCOPE = "keyword";
/**
 * Given raw keywords from a language definition, compile them.
 *
 * @param {string | Record<string,string|string[]> | Array<string>} rawKeywords
 * @param {boolean} caseInsensitive
 */ function $e573d579511d10ff$var$compileKeywords(rawKeywords, caseInsensitive, scopeName = $e573d579511d10ff$var$DEFAULT_KEYWORD_SCOPE) {
    /** @type {import("highlight.js/private").KeywordDict} */ const compiledKeywords = Object.create(null);
    // input can be a string of keywords, an array of keywords, or a object with
    // named keys representing scopeName (which can then point to a string or array)
    if (typeof rawKeywords === "string") compileList(scopeName, rawKeywords.split(" "));
    else if (Array.isArray(rawKeywords)) compileList(scopeName, rawKeywords);
    else Object.keys(rawKeywords).forEach(function(scopeName) {
        // collapse all our objects back into the parent object
        Object.assign(compiledKeywords, $e573d579511d10ff$var$compileKeywords(rawKeywords[scopeName], caseInsensitive, scopeName));
    });
    return compiledKeywords;
    // ---
    /**
   * Compiles an individual list of keywords
   *
   * Ex: "for if when while|5"
   *
   * @param {string} scopeName
   * @param {Array<string>} keywordList
   */ function compileList(scopeName, keywordList) {
        if (caseInsensitive) keywordList = keywordList.map((x)=>x.toLowerCase());
        keywordList.forEach(function(keyword) {
            const pair = keyword.split("|");
            compiledKeywords[pair[0]] = [
                scopeName,
                $e573d579511d10ff$var$scoreForKeyword(pair[0], pair[1])
            ];
        });
    }
}
/**
 * Returns the proper score for a given keyword
 *
 * Also takes into account comment keywords, which will be scored 0 UNLESS
 * another score has been manually assigned.
 * @param {string} keyword
 * @param {string} [providedScore]
 */ function $e573d579511d10ff$var$scoreForKeyword(keyword, providedScore) {
    // manual scores always win over common keywords
    // so you can force a score of 1 if you really insist
    if (providedScore) return Number(providedScore);
    return $e573d579511d10ff$var$commonKeyword(keyword) ? 0 : 1;
}
/**
 * Determines if a given keyword is common or not
 *
 * @param {string} keyword */ function $e573d579511d10ff$var$commonKeyword(keyword) {
    return $e573d579511d10ff$var$COMMON_KEYWORDS.includes(keyword.toLowerCase());
}
/*

For the reasoning behind this please see:
https://github.com/highlightjs/highlight.js/issues/2880#issuecomment-747275419

*/ /**
 * @type {Record<string, boolean>}
 */ const $e573d579511d10ff$var$seenDeprecations = {};
/**
 * @param {string} message
 */ const $e573d579511d10ff$var$error = (message)=>{
    console.error(message);
};
/**
 * @param {string} message
 * @param {any} args
 */ const $e573d579511d10ff$var$warn = (message, ...args)=>{
    console.log(`WARN: ${message}`, ...args);
};
/**
 * @param {string} version
 * @param {string} message
 */ const $e573d579511d10ff$var$deprecated = (version, message)=>{
    if ($e573d579511d10ff$var$seenDeprecations[`${version}/${message}`]) return;
    console.log(`Deprecated as of ${version}. ${message}`);
    $e573d579511d10ff$var$seenDeprecations[`${version}/${message}`] = true;
};
/* eslint-disable no-throw-literal */ /**
@typedef {import('highlight.js').CompiledMode} CompiledMode
*/ const $e573d579511d10ff$var$MultiClassError = new Error();
/**
 * Renumbers labeled scope names to account for additional inner match
 * groups that otherwise would break everything.
 *
 * Lets say we 3 match scopes:
 *
 *   { 1 => ..., 2 => ..., 3 => ... }
 *
 * So what we need is a clean match like this:
 *
 *   (a)(b)(c) => [ "a", "b", "c" ]
 *
 * But this falls apart with inner match groups:
 *
 * (a)(((b)))(c) => ["a", "b", "b", "b", "c" ]
 *
 * Our scopes are now "out of alignment" and we're repeating `b` 3 times.
 * What needs to happen is the numbers are remapped:
 *
 *   { 1 => ..., 2 => ..., 5 => ... }
 *
 * We also need to know that the ONLY groups that should be output
 * are 1, 2, and 5.  This function handles this behavior.
 *
 * @param {CompiledMode} mode
 * @param {Array<RegExp | string>} regexes
 * @param {{key: "beginScope"|"endScope"}} opts
 */ function $e573d579511d10ff$var$remapScopeNames(mode, regexes, { key: key }) {
    let offset = 0;
    const scopeNames = mode[key];
    /** @type Record<number,boolean> */ const emit = {};
    /** @type Record<number,string> */ const positions = {};
    for(let i = 1; i <= regexes.length; i++){
        positions[i + offset] = scopeNames[i];
        emit[i + offset] = true;
        offset += $e573d579511d10ff$var$countMatchGroups(regexes[i - 1]);
    }
    // we use _emit to keep track of which match groups are "top-level" to avoid double
    // output from inside match groups
    mode[key] = positions;
    mode[key]._emit = emit;
    mode[key]._multi = true;
}
/**
 * @param {CompiledMode} mode
 */ function $e573d579511d10ff$var$beginMultiClass(mode) {
    if (!Array.isArray(mode.begin)) return;
    if (mode.skip || mode.excludeBegin || mode.returnBegin) {
        $e573d579511d10ff$var$error("skip, excludeBegin, returnBegin not compatible with beginScope: {}");
        throw $e573d579511d10ff$var$MultiClassError;
    }
    if (typeof mode.beginScope !== "object" || mode.beginScope === null) {
        $e573d579511d10ff$var$error("beginScope must be object");
        throw $e573d579511d10ff$var$MultiClassError;
    }
    $e573d579511d10ff$var$remapScopeNames(mode, mode.begin, {
        key: "beginScope"
    });
    mode.begin = $e573d579511d10ff$var$_rewriteBackreferences(mode.begin, {
        joinWith: ""
    });
}
/**
 * @param {CompiledMode} mode
 */ function $e573d579511d10ff$var$endMultiClass(mode) {
    if (!Array.isArray(mode.end)) return;
    if (mode.skip || mode.excludeEnd || mode.returnEnd) {
        $e573d579511d10ff$var$error("skip, excludeEnd, returnEnd not compatible with endScope: {}");
        throw $e573d579511d10ff$var$MultiClassError;
    }
    if (typeof mode.endScope !== "object" || mode.endScope === null) {
        $e573d579511d10ff$var$error("endScope must be object");
        throw $e573d579511d10ff$var$MultiClassError;
    }
    $e573d579511d10ff$var$remapScopeNames(mode, mode.end, {
        key: "endScope"
    });
    mode.end = $e573d579511d10ff$var$_rewriteBackreferences(mode.end, {
        joinWith: ""
    });
}
/**
 * this exists only to allow `scope: {}` to be used beside `match:`
 * Otherwise `beginScope` would necessary and that would look weird

  {
    match: [ /def/, /\w+/ ]
    scope: { 1: "keyword" , 2: "title" }
  }

 * @param {CompiledMode} mode
 */ function $e573d579511d10ff$var$scopeSugar(mode) {
    if (mode.scope && typeof mode.scope === "object" && mode.scope !== null) {
        mode.beginScope = mode.scope;
        delete mode.scope;
    }
}
/**
 * @param {CompiledMode} mode
 */ function $e573d579511d10ff$var$MultiClass(mode) {
    $e573d579511d10ff$var$scopeSugar(mode);
    if (typeof mode.beginScope === "string") mode.beginScope = {
        _wrap: mode.beginScope
    };
    if (typeof mode.endScope === "string") mode.endScope = {
        _wrap: mode.endScope
    };
    $e573d579511d10ff$var$beginMultiClass(mode);
    $e573d579511d10ff$var$endMultiClass(mode);
}
/**
@typedef {import('highlight.js').Mode} Mode
@typedef {import('highlight.js').CompiledMode} CompiledMode
@typedef {import('highlight.js').Language} Language
@typedef {import('highlight.js').HLJSPlugin} HLJSPlugin
@typedef {import('highlight.js').CompiledLanguage} CompiledLanguage
*/ // compilation
/**
 * Compiles a language definition result
 *
 * Given the raw result of a language definition (Language), compiles this so
 * that it is ready for highlighting code.
 * @param {Language} language
 * @returns {CompiledLanguage}
 */ function $e573d579511d10ff$var$compileLanguage(language) {
    /**
   * Builds a regex with the case sensitivity of the current language
   *
   * @param {RegExp | string} value
   * @param {boolean} [global]
   */ function langRe(value, global) {
        return new RegExp($e573d579511d10ff$var$source(value), "m" + (language.case_insensitive ? "i" : "") + (language.unicodeRegex ? "u" : "") + (global ? "g" : ""));
    }
    /**
    Stores multiple regular expressions and allows you to quickly search for
    them all in a string simultaneously - returning the first match.  It does
    this by creating a huge (a|b|c) regex - each individual item wrapped with ()
    and joined by `|` - using match groups to track position.  When a match is
    found checking which position in the array has content allows us to figure
    out which of the original regexes / match groups triggered the match.

    The match object itself (the result of `Regex.exec`) is returned but also
    enhanced by merging in any meta-data that was registered with the regex.
    This is how we keep track of which mode matched, and what type of rule
    (`illegal`, `begin`, end, etc).
  */ class MultiRegex {
        constructor(){
            this.matchIndexes = {};
            // @ts-ignore
            this.regexes = [];
            this.matchAt = 1;
            this.position = 0;
        }
        // @ts-ignore
        addRule(re, opts) {
            opts.position = this.position++;
            // @ts-ignore
            this.matchIndexes[this.matchAt] = opts;
            this.regexes.push([
                opts,
                re
            ]);
            this.matchAt += $e573d579511d10ff$var$countMatchGroups(re) + 1;
        }
        compile() {
            if (this.regexes.length === 0) // avoids the need to check length every time exec is called
            // @ts-ignore
            this.exec = ()=>null;
            const terminators = this.regexes.map((el)=>el[1]);
            this.matcherRe = langRe($e573d579511d10ff$var$_rewriteBackreferences(terminators, {
                joinWith: "|"
            }), true);
            this.lastIndex = 0;
        }
        /** @param {string} s */ exec(s) {
            this.matcherRe.lastIndex = this.lastIndex;
            const match = this.matcherRe.exec(s);
            if (!match) return null;
            // eslint-disable-next-line no-undefined
            const i = match.findIndex((el, i)=>i > 0 && el !== undefined);
            // @ts-ignore
            const matchData = this.matchIndexes[i];
            // trim off any earlier non-relevant match groups (ie, the other regex
            // match groups that make up the multi-matcher)
            match.splice(0, i);
            return Object.assign(match, matchData);
        }
    }
    /*
    Created to solve the key deficiently with MultiRegex - there is no way to
    test for multiple matches at a single location.  Why would we need to do
    that?  In the future a more dynamic engine will allow certain matches to be
    ignored.  An example: if we matched say the 3rd regex in a large group but
    decided to ignore it - we'd need to started testing again at the 4th
    regex... but MultiRegex itself gives us no real way to do that.

    So what this class creates MultiRegexs on the fly for whatever search
    position they are needed.

    NOTE: These additional MultiRegex objects are created dynamically.  For most
    grammars most of the time we will never actually need anything more than the
    first MultiRegex - so this shouldn't have too much overhead.

    Say this is our search group, and we match regex3, but wish to ignore it.

      regex1 | regex2 | regex3 | regex4 | regex5    ' ie, startAt = 0

    What we need is a new MultiRegex that only includes the remaining
    possibilities:

      regex4 | regex5                               ' ie, startAt = 3

    This class wraps all that complexity up in a simple API... `startAt` decides
    where in the array of expressions to start doing the matching. It
    auto-increments, so if a match is found at position 2, then startAt will be
    set to 3.  If the end is reached startAt will return to 0.

    MOST of the time the parser will be setting startAt manually to 0.
  */ class ResumableMultiRegex {
        constructor(){
            // @ts-ignore
            this.rules = [];
            // @ts-ignore
            this.multiRegexes = [];
            this.count = 0;
            this.lastIndex = 0;
            this.regexIndex = 0;
        }
        // @ts-ignore
        getMatcher(index) {
            if (this.multiRegexes[index]) return this.multiRegexes[index];
            const matcher = new MultiRegex();
            this.rules.slice(index).forEach(([re, opts])=>matcher.addRule(re, opts));
            matcher.compile();
            this.multiRegexes[index] = matcher;
            return matcher;
        }
        resumingScanAtSamePosition() {
            return this.regexIndex !== 0;
        }
        considerAll() {
            this.regexIndex = 0;
        }
        // @ts-ignore
        addRule(re, opts) {
            this.rules.push([
                re,
                opts
            ]);
            if (opts.type === "begin") this.count++;
        }
        /** @param {string} s */ exec(s) {
            const m = this.getMatcher(this.regexIndex);
            m.lastIndex = this.lastIndex;
            let result = m.exec(s);
            // The following is because we have no easy way to say "resume scanning at the
            // existing position but also skip the current rule ONLY". What happens is
            // all prior rules are also skipped which can result in matching the wrong
            // thing. Example of matching "booger":
            // our matcher is [string, "booger", number]
            //
            // ....booger....
            // if "booger" is ignored then we'd really need a regex to scan from the
            // SAME position for only: [string, number] but ignoring "booger" (if it
            // was the first match), a simple resume would scan ahead who knows how
            // far looking only for "number", ignoring potential string matches (or
            // future "booger" matches that might be valid.)
            // So what we do: We execute two matchers, one resuming at the same
            // position, but the second full matcher starting at the position after:
            //     /--- resume first regex match here (for [number])
            //     |/---- full match here for [string, "booger", number]
            //     vv
            // ....booger....
            // Which ever results in a match first is then used. So this 3-4 step
            // process essentially allows us to say "match at this position, excluding
            // a prior rule that was ignored".
            //
            // 1. Match "booger" first, ignore. Also proves that [string] does non match.
            // 2. Resume matching for [number]
            // 3. Match at index + 1 for [string, "booger", number]
            // 4. If #2 and #3 result in matches, which came first?
            if (this.resumingScanAtSamePosition()) {
                if (result && result.index === this.lastIndex) ;
                else {
                    const m2 = this.getMatcher(0);
                    m2.lastIndex = this.lastIndex + 1;
                    result = m2.exec(s);
                }
            }
            if (result) {
                this.regexIndex += result.position + 1;
                if (this.regexIndex === this.count) // wrap-around to considering all matches again
                this.considerAll();
            }
            return result;
        }
    }
    /**
   * Given a mode, builds a huge ResumableMultiRegex that can be used to walk
   * the content and find matches.
   *
   * @param {CompiledMode} mode
   * @returns {ResumableMultiRegex}
   */ function buildModeRegex(mode) {
        const mm = new ResumableMultiRegex();
        mode.contains.forEach((term)=>mm.addRule(term.begin, {
                rule: term,
                type: "begin"
            }));
        if (mode.terminatorEnd) mm.addRule(mode.terminatorEnd, {
            type: "end"
        });
        if (mode.illegal) mm.addRule(mode.illegal, {
            type: "illegal"
        });
        return mm;
    }
    /** skip vs abort vs ignore
   *
   * @skip   - The mode is still entered and exited normally (and contains rules apply),
   *           but all content is held and added to the parent buffer rather than being
   *           output when the mode ends.  Mostly used with `sublanguage` to build up
   *           a single large buffer than can be parsed by sublanguage.
   *
   *             - The mode begin ands ends normally.
   *             - Content matched is added to the parent mode buffer.
   *             - The parser cursor is moved forward normally.
   *
   * @abort  - A hack placeholder until we have ignore.  Aborts the mode (as if it
   *           never matched) but DOES NOT continue to match subsequent `contains`
   *           modes.  Abort is bad/suboptimal because it can result in modes
   *           farther down not getting applied because an earlier rule eats the
   *           content but then aborts.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is added to the mode buffer.
   *             - The parser cursor is moved forward accordingly.
   *
   * @ignore - Ignores the mode (as if it never matched) and continues to match any
   *           subsequent `contains` modes.  Ignore isn't technically possible with
   *           the current parser implementation.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is ignored.
   *             - The parser cursor is not moved forward.
   */ /**
   * Compiles an individual mode
   *
   * This can raise an error if the mode contains certain detectable known logic
   * issues.
   * @param {Mode} mode
   * @param {CompiledMode | null} [parent]
   * @returns {CompiledMode | never}
   */ function compileMode(mode, parent) {
        const cmode = /** @type CompiledMode */ mode;
        if (mode.isCompiled) return cmode;
        [
            $e573d579511d10ff$var$scopeClassName,
            // do this early so compiler extensions generally don't have to worry about
            // the distinction between match/begin
            $e573d579511d10ff$var$compileMatch,
            $e573d579511d10ff$var$MultiClass,
            $e573d579511d10ff$var$beforeMatchExt
        ].forEach((ext)=>ext(mode, parent));
        language.compilerExtensions.forEach((ext)=>ext(mode, parent));
        // __beforeBegin is considered private API, internal use only
        mode.__beforeBegin = null;
        [
            $e573d579511d10ff$var$beginKeywords,
            // do this later so compiler extensions that come earlier have access to the
            // raw array if they wanted to perhaps manipulate it, etc.
            $e573d579511d10ff$var$compileIllegal,
            // default to 1 relevance if not specified
            $e573d579511d10ff$var$compileRelevance
        ].forEach((ext)=>ext(mode, parent));
        mode.isCompiled = true;
        let keywordPattern = null;
        if (typeof mode.keywords === "object" && mode.keywords.$pattern) {
            // we need a copy because keywords might be compiled multiple times
            // so we can't go deleting $pattern from the original on the first
            // pass
            mode.keywords = Object.assign({}, mode.keywords);
            keywordPattern = mode.keywords.$pattern;
            delete mode.keywords.$pattern;
        }
        keywordPattern = keywordPattern || /\w+/;
        if (mode.keywords) mode.keywords = $e573d579511d10ff$var$compileKeywords(mode.keywords, language.case_insensitive);
        cmode.keywordPatternRe = langRe(keywordPattern, true);
        if (parent) {
            if (!mode.begin) mode.begin = /\B|\b/;
            cmode.beginRe = langRe(cmode.begin);
            if (!mode.end && !mode.endsWithParent) mode.end = /\B|\b/;
            if (mode.end) cmode.endRe = langRe(cmode.end);
            cmode.terminatorEnd = $e573d579511d10ff$var$source(cmode.end) || "";
            if (mode.endsWithParent && parent.terminatorEnd) cmode.terminatorEnd += (mode.end ? "|" : "") + parent.terminatorEnd;
        }
        if (mode.illegal) cmode.illegalRe = langRe(/** @type {RegExp | string} */ mode.illegal);
        if (!mode.contains) mode.contains = [];
        mode.contains = [].concat(...mode.contains.map(function(c) {
            return $e573d579511d10ff$var$expandOrCloneMode(c === "self" ? mode : c);
        }));
        mode.contains.forEach(function(c) {
            compileMode(/** @type Mode */ c, cmode);
        });
        if (mode.starts) compileMode(mode.starts, parent);
        cmode.matcher = buildModeRegex(cmode);
        return cmode;
    }
    if (!language.compilerExtensions) language.compilerExtensions = [];
    // self is not valid at the top-level
    if (language.contains && language.contains.includes("self")) throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
    // we need a null object, which inherit will guarantee
    language.classNameAliases = $e573d579511d10ff$var$inherit$1(language.classNameAliases || {});
    return compileMode(/** @type Mode */ language);
}
/**
 * Determines if a mode has a dependency on it's parent or not
 *
 * If a mode does have a parent dependency then often we need to clone it if
 * it's used in multiple places so that each copy points to the correct parent,
 * where-as modes without a parent can often safely be re-used at the bottom of
 * a mode chain.
 *
 * @param {Mode | null} mode
 * @returns {boolean} - is there a dependency on the parent?
 * */ function $e573d579511d10ff$var$dependencyOnParent(mode) {
    if (!mode) return false;
    return mode.endsWithParent || $e573d579511d10ff$var$dependencyOnParent(mode.starts);
}
/**
 * Expands a mode or clones it if necessary
 *
 * This is necessary for modes with parental dependenceis (see notes on
 * `dependencyOnParent`) and for nodes that have `variants` - which must then be
 * exploded into their own individual modes at compile time.
 *
 * @param {Mode} mode
 * @returns {Mode | Mode[]}
 * */ function $e573d579511d10ff$var$expandOrCloneMode(mode) {
    if (mode.variants && !mode.cachedVariants) mode.cachedVariants = mode.variants.map(function(variant) {
        return $e573d579511d10ff$var$inherit$1(mode, {
            variants: null
        }, variant);
    });
    // EXPAND
    // if we have variants then essentially "replace" the mode with the variants
    // this happens in compileMode, where this function is called from
    if (mode.cachedVariants) return mode.cachedVariants;
    // CLONE
    // if we have dependencies on parents then we need a unique
    // instance of ourselves, so we can be reused with many
    // different parents without issue
    if ($e573d579511d10ff$var$dependencyOnParent(mode)) return $e573d579511d10ff$var$inherit$1(mode, {
        starts: mode.starts ? $e573d579511d10ff$var$inherit$1(mode.starts) : null
    });
    if (Object.isFrozen(mode)) return $e573d579511d10ff$var$inherit$1(mode);
    // no special dependency issues, just return ourselves
    return mode;
}
var $e573d579511d10ff$var$version = "11.9.0";
class $e573d579511d10ff$var$HTMLInjectionError extends Error {
    constructor(reason, html){
        super(reason);
        this.name = "HTMLInjectionError";
        this.html = html;
    }
}
/*
Syntax highlighting with language autodetection.
https://highlightjs.org/
*/ /**
@typedef {import('highlight.js').Mode} Mode
@typedef {import('highlight.js').CompiledMode} CompiledMode
@typedef {import('highlight.js').CompiledScope} CompiledScope
@typedef {import('highlight.js').Language} Language
@typedef {import('highlight.js').HLJSApi} HLJSApi
@typedef {import('highlight.js').HLJSPlugin} HLJSPlugin
@typedef {import('highlight.js').PluginEvent} PluginEvent
@typedef {import('highlight.js').HLJSOptions} HLJSOptions
@typedef {import('highlight.js').LanguageFn} LanguageFn
@typedef {import('highlight.js').HighlightedHTMLElement} HighlightedHTMLElement
@typedef {import('highlight.js').BeforeHighlightContext} BeforeHighlightContext
@typedef {import('highlight.js/private').MatchType} MatchType
@typedef {import('highlight.js/private').KeywordData} KeywordData
@typedef {import('highlight.js/private').EnhancedMatch} EnhancedMatch
@typedef {import('highlight.js/private').AnnotatedError} AnnotatedError
@typedef {import('highlight.js').AutoHighlightResult} AutoHighlightResult
@typedef {import('highlight.js').HighlightOptions} HighlightOptions
@typedef {import('highlight.js').HighlightResult} HighlightResult
*/ const $e573d579511d10ff$var$escape = $e573d579511d10ff$var$escapeHTML;
const $e573d579511d10ff$var$inherit = $e573d579511d10ff$var$inherit$1;
const $e573d579511d10ff$var$NO_MATCH = Symbol("nomatch");
const $e573d579511d10ff$var$MAX_KEYWORD_HITS = 7;
/**
 * @param {any} hljs - object that is extended (legacy)
 * @returns {HLJSApi}
 */ const $e573d579511d10ff$var$HLJS = function(hljs) {
    // Global internal variables used within the highlight.js library.
    /** @type {Record<string, Language>} */ const languages = Object.create(null);
    /** @type {Record<string, string>} */ const aliases = Object.create(null);
    /** @type {HLJSPlugin[]} */ const plugins = [];
    // safe/production mode - swallows more errors, tries to keep running
    // even if a single syntax or parse hits a fatal error
    let SAFE_MODE = true;
    const LANGUAGE_NOT_FOUND = "Could not find the language '{}', did you forget to load/include a language module?";
    /** @type {Language} */ const PLAINTEXT_LANGUAGE = {
        disableAutodetect: true,
        name: "Plain text",
        contains: []
    };
    // Global options used when within external APIs. This is modified when
    // calling the `hljs.configure` function.
    /** @type HLJSOptions */ let options = {
        ignoreUnescapedHTML: false,
        throwUnescapedHTML: false,
        noHighlightRe: /^(no-?highlight)$/i,
        languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
        classPrefix: "hljs-",
        cssSelector: "pre code",
        languages: null,
        // beta configuration options, subject to change, welcome to discuss
        // https://github.com/highlightjs/highlight.js/issues/1086
        __emitter: $e573d579511d10ff$var$TokenTreeEmitter
    };
    /* Utility functions */ /**
   * Tests a language name to see if highlighting should be skipped
   * @param {string} languageName
   */ function shouldNotHighlight(languageName) {
        return options.noHighlightRe.test(languageName);
    }
    /**
   * @param {HighlightedHTMLElement} block - the HTML element to determine language for
   */ function blockLanguage(block) {
        let classes = block.className + " ";
        classes += block.parentNode ? block.parentNode.className : "";
        // language-* takes precedence over non-prefixed class names.
        const match = options.languageDetectRe.exec(classes);
        if (match) {
            const language = getLanguage(match[1]);
            if (!language) {
                $e573d579511d10ff$var$warn(LANGUAGE_NOT_FOUND.replace("{}", match[1]));
                $e573d579511d10ff$var$warn("Falling back to no-highlight mode for this block.", block);
            }
            return language ? match[1] : "no-highlight";
        }
        return classes.split(/\s+/).find((_class)=>shouldNotHighlight(_class) || getLanguage(_class));
    }
    /**
   * Core highlighting function.
   *
   * OLD API
   * highlight(lang, code, ignoreIllegals, continuation)
   *
   * NEW API
   * highlight(code, {lang, ignoreIllegals})
   *
   * @param {string} codeOrLanguageName - the language to use for highlighting
   * @param {string | HighlightOptions} optionsOrCode - the code to highlight
   * @param {boolean} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   *
   * @returns {HighlightResult} Result - an object that represents the result
   * @property {string} language - the language name
   * @property {number} relevance - the relevance score
   * @property {string} value - the highlighted HTML code
   * @property {string} code - the original raw code
   * @property {CompiledMode} top - top of the current mode stack
   * @property {boolean} illegal - indicates whether any illegal matches were found
  */ function highlight(codeOrLanguageName, optionsOrCode, ignoreIllegals) {
        let code = "";
        let languageName = "";
        if (typeof optionsOrCode === "object") {
            code = codeOrLanguageName;
            ignoreIllegals = optionsOrCode.ignoreIllegals;
            languageName = optionsOrCode.language;
        } else {
            // old API
            $e573d579511d10ff$var$deprecated("10.7.0", "highlight(lang, code, ...args) has been deprecated.");
            $e573d579511d10ff$var$deprecated("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277");
            languageName = codeOrLanguageName;
            code = optionsOrCode;
        }
        // https://github.com/highlightjs/highlight.js/issues/3149
        // eslint-disable-next-line no-undefined
        if (ignoreIllegals === undefined) ignoreIllegals = true;
        /** @type {BeforeHighlightContext} */ const context = {
            code: code,
            language: languageName
        };
        // the plugin can change the desired language or the code to be highlighted
        // just be changing the object it was passed
        fire("before:highlight", context);
        // a before plugin can usurp the result completely by providing it's own
        // in which case we don't even need to call highlight
        const result = context.result ? context.result : _highlight(context.language, context.code, ignoreIllegals);
        result.code = context.code;
        // the plugin can change anything in result to suite it
        fire("after:highlight", result);
        return result;
    }
    /**
   * private highlight that's used internally and does not fire callbacks
   *
   * @param {string} languageName - the language to use for highlighting
   * @param {string} codeToHighlight - the code to highlight
   * @param {boolean?} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   * @param {CompiledMode?} [continuation] - current continuation mode, if any
   * @returns {HighlightResult} - result of the highlight operation
  */ function _highlight(languageName, codeToHighlight, ignoreIllegals, continuation) {
        const keywordHits = Object.create(null);
        /**
     * Return keyword data if a match is a keyword
     * @param {CompiledMode} mode - current mode
     * @param {string} matchText - the textual match
     * @returns {KeywordData | false}
     */ function keywordData(mode, matchText) {
            return mode.keywords[matchText];
        }
        function processKeywords() {
            if (!top.keywords) {
                emitter.addText(modeBuffer);
                return;
            }
            let lastIndex = 0;
            top.keywordPatternRe.lastIndex = 0;
            let match = top.keywordPatternRe.exec(modeBuffer);
            let buf = "";
            while(match){
                buf += modeBuffer.substring(lastIndex, match.index);
                const word = language.case_insensitive ? match[0].toLowerCase() : match[0];
                const data = keywordData(top, word);
                if (data) {
                    const [kind, keywordRelevance] = data;
                    emitter.addText(buf);
                    buf = "";
                    keywordHits[word] = (keywordHits[word] || 0) + 1;
                    if (keywordHits[word] <= $e573d579511d10ff$var$MAX_KEYWORD_HITS) relevance += keywordRelevance;
                    if (kind.startsWith("_")) // _ implied for relevance only, do not highlight
                    // by applying a class name
                    buf += match[0];
                    else {
                        const cssClass = language.classNameAliases[kind] || kind;
                        emitKeyword(match[0], cssClass);
                    }
                } else buf += match[0];
                lastIndex = top.keywordPatternRe.lastIndex;
                match = top.keywordPatternRe.exec(modeBuffer);
            }
            buf += modeBuffer.substring(lastIndex);
            emitter.addText(buf);
        }
        function processSubLanguage() {
            if (modeBuffer === "") return;
            /** @type HighlightResult */ let result = null;
            if (typeof top.subLanguage === "string") {
                if (!languages[top.subLanguage]) {
                    emitter.addText(modeBuffer);
                    return;
                }
                result = _highlight(top.subLanguage, modeBuffer, true, continuations[top.subLanguage]);
                continuations[top.subLanguage] = /** @type {CompiledMode} */ result._top;
            } else result = highlightAuto(modeBuffer, top.subLanguage.length ? top.subLanguage : null);
            // Counting embedded language score towards the host language may be disabled
            // with zeroing the containing mode relevance. Use case in point is Markdown that
            // allows XML everywhere and makes every XML snippet to have a much larger Markdown
            // score.
            if (top.relevance > 0) relevance += result.relevance;
            emitter.__addSublanguage(result._emitter, result.language);
        }
        function processBuffer() {
            if (top.subLanguage != null) processSubLanguage();
            else processKeywords();
            modeBuffer = "";
        }
        /**
     * @param {string} text
     * @param {string} scope
     */ function emitKeyword(keyword, scope) {
            if (keyword === "") return;
            emitter.startScope(scope);
            emitter.addText(keyword);
            emitter.endScope();
        }
        /**
     * @param {CompiledScope} scope
     * @param {RegExpMatchArray} match
     */ function emitMultiClass(scope, match) {
            let i = 1;
            const max = match.length - 1;
            while(i <= max){
                if (!scope._emit[i]) {
                    i++;
                    continue;
                }
                const klass = language.classNameAliases[scope[i]] || scope[i];
                const text = match[i];
                if (klass) emitKeyword(text, klass);
                else {
                    modeBuffer = text;
                    processKeywords();
                    modeBuffer = "";
                }
                i++;
            }
        }
        /**
     * @param {CompiledMode} mode - new mode to start
     * @param {RegExpMatchArray} match
     */ function startNewMode(mode, match) {
            if (mode.scope && typeof mode.scope === "string") emitter.openNode(language.classNameAliases[mode.scope] || mode.scope);
            if (mode.beginScope) {
                // beginScope just wraps the begin match itself in a scope
                if (mode.beginScope._wrap) {
                    emitKeyword(modeBuffer, language.classNameAliases[mode.beginScope._wrap] || mode.beginScope._wrap);
                    modeBuffer = "";
                } else if (mode.beginScope._multi) {
                    // at this point modeBuffer should just be the match
                    emitMultiClass(mode.beginScope, match);
                    modeBuffer = "";
                }
            }
            top = Object.create(mode, {
                parent: {
                    value: top
                }
            });
            return top;
        }
        /**
     * @param {CompiledMode } mode - the mode to potentially end
     * @param {RegExpMatchArray} match - the latest match
     * @param {string} matchPlusRemainder - match plus remainder of content
     * @returns {CompiledMode | void} - the next mode, or if void continue on in current mode
     */ function endOfMode(mode, match, matchPlusRemainder) {
            let matched = $e573d579511d10ff$var$startsWith(mode.endRe, matchPlusRemainder);
            if (matched) {
                if (mode["on:end"]) {
                    const resp = new $e573d579511d10ff$var$Response(mode);
                    mode["on:end"](match, resp);
                    if (resp.isMatchIgnored) matched = false;
                }
                if (matched) {
                    while(mode.endsParent && mode.parent)mode = mode.parent;
                    return mode;
                }
            }
            // even if on:end fires an `ignore` it's still possible
            // that we might trigger the end node because of a parent mode
            if (mode.endsWithParent) return endOfMode(mode.parent, match, matchPlusRemainder);
        }
        /**
     * Handle matching but then ignoring a sequence of text
     *
     * @param {string} lexeme - string containing full match text
     */ function doIgnore(lexeme) {
            if (top.matcher.regexIndex === 0) {
                // no more regexes to potentially match here, so we move the cursor forward one
                // space
                modeBuffer += lexeme[0];
                return 1;
            } else {
                // no need to move the cursor, we still have additional regexes to try and
                // match at this very spot
                resumeScanAtSamePosition = true;
                return 0;
            }
        }
        /**
     * Handle the start of a new potential mode match
     *
     * @param {EnhancedMatch} match - the current match
     * @returns {number} how far to advance the parse cursor
     */ function doBeginMatch(match) {
            const lexeme = match[0];
            const newMode = match.rule;
            const resp = new $e573d579511d10ff$var$Response(newMode);
            // first internal before callbacks, then the public ones
            const beforeCallbacks = [
                newMode.__beforeBegin,
                newMode["on:begin"]
            ];
            for (const cb of beforeCallbacks){
                if (!cb) continue;
                cb(match, resp);
                if (resp.isMatchIgnored) return doIgnore(lexeme);
            }
            if (newMode.skip) modeBuffer += lexeme;
            else {
                if (newMode.excludeBegin) modeBuffer += lexeme;
                processBuffer();
                if (!newMode.returnBegin && !newMode.excludeBegin) modeBuffer = lexeme;
            }
            startNewMode(newMode, match);
            return newMode.returnBegin ? 0 : lexeme.length;
        }
        /**
     * Handle the potential end of mode
     *
     * @param {RegExpMatchArray} match - the current match
     */ function doEndMatch(match) {
            const lexeme = match[0];
            const matchPlusRemainder = codeToHighlight.substring(match.index);
            const endMode = endOfMode(top, match, matchPlusRemainder);
            if (!endMode) return $e573d579511d10ff$var$NO_MATCH;
            const origin = top;
            if (top.endScope && top.endScope._wrap) {
                processBuffer();
                emitKeyword(lexeme, top.endScope._wrap);
            } else if (top.endScope && top.endScope._multi) {
                processBuffer();
                emitMultiClass(top.endScope, match);
            } else if (origin.skip) modeBuffer += lexeme;
            else {
                if (!(origin.returnEnd || origin.excludeEnd)) modeBuffer += lexeme;
                processBuffer();
                if (origin.excludeEnd) modeBuffer = lexeme;
            }
            do {
                if (top.scope) emitter.closeNode();
                if (!top.skip && !top.subLanguage) relevance += top.relevance;
                top = top.parent;
            }while (top !== endMode.parent);
            if (endMode.starts) startNewMode(endMode.starts, match);
            return origin.returnEnd ? 0 : lexeme.length;
        }
        function processContinuations() {
            const list = [];
            for(let current = top; current !== language; current = current.parent)if (current.scope) list.unshift(current.scope);
            list.forEach((item)=>emitter.openNode(item));
        }
        /** @type {{type?: MatchType, index?: number, rule?: Mode}}} */ let lastMatch = {};
        /**
     *  Process an individual match
     *
     * @param {string} textBeforeMatch - text preceding the match (since the last match)
     * @param {EnhancedMatch} [match] - the match itself
     */ function processLexeme(textBeforeMatch, match) {
            const lexeme = match && match[0];
            // add non-matched text to the current mode buffer
            modeBuffer += textBeforeMatch;
            if (lexeme == null) {
                processBuffer();
                return 0;
            }
            // we've found a 0 width match and we're stuck, so we need to advance
            // this happens when we have badly behaved rules that have optional matchers to the degree that
            // sometimes they can end up matching nothing at all
            // Ref: https://github.com/highlightjs/highlight.js/issues/2140
            if (lastMatch.type === "begin" && match.type === "end" && lastMatch.index === match.index && lexeme === "") {
                // spit the "skipped" character that our regex choked on back into the output sequence
                modeBuffer += codeToHighlight.slice(match.index, match.index + 1);
                if (!SAFE_MODE) {
                    /** @type {AnnotatedError} */ const err = new Error(`0 width match regex (${languageName})`);
                    err.languageName = languageName;
                    err.badRule = lastMatch.rule;
                    throw err;
                }
                return 1;
            }
            lastMatch = match;
            if (match.type === "begin") return doBeginMatch(match);
            else if (match.type === "illegal" && !ignoreIllegals) {
                // illegal match, we do not continue processing
                /** @type {AnnotatedError} */ const err = new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.scope || "<unnamed>") + '"');
                err.mode = top;
                throw err;
            } else if (match.type === "end") {
                const processed = doEndMatch(match);
                if (processed !== $e573d579511d10ff$var$NO_MATCH) return processed;
            }
            // edge case for when illegal matches $ (end of line) which is technically
            // a 0 width match but not a begin/end match so it's not caught by the
            // first handler (when ignoreIllegals is true)
            if (match.type === "illegal" && lexeme === "") // advance so we aren't stuck in an infinite loop
            return 1;
            // infinite loops are BAD, this is a last ditch catch all. if we have a
            // decent number of iterations yet our index (cursor position in our
            // parsing) still 3x behind our index then something is very wrong
            // so we bail
            if (iterations > 100000 && iterations > match.index * 3) {
                const err = new Error("potential infinite loop, way more iterations than matches");
                throw err;
            }
            /*
      Why might be find ourselves here?  An potential end match that was
      triggered but could not be completed.  IE, `doEndMatch` returned NO_MATCH.
      (this could be because a callback requests the match be ignored, etc)

      This causes no real harm other than stopping a few times too many.
      */ modeBuffer += lexeme;
            return lexeme.length;
        }
        const language = getLanguage(languageName);
        if (!language) {
            $e573d579511d10ff$var$error(LANGUAGE_NOT_FOUND.replace("{}", languageName));
            throw new Error('Unknown language: "' + languageName + '"');
        }
        const md = $e573d579511d10ff$var$compileLanguage(language);
        let result = "";
        /** @type {CompiledMode} */ let top = continuation || md;
        /** @type Record<string,CompiledMode> */ const continuations = {}; // keep continuations for sub-languages
        const emitter = new options.__emitter(options);
        processContinuations();
        let modeBuffer = "";
        let relevance = 0;
        let index = 0;
        let iterations = 0;
        let resumeScanAtSamePosition = false;
        try {
            if (!language.__emitTokens) {
                top.matcher.considerAll();
                for(;;){
                    iterations++;
                    if (resumeScanAtSamePosition) // only regexes not matched previously will now be
                    // considered for a potential match
                    resumeScanAtSamePosition = false;
                    else top.matcher.considerAll();
                    top.matcher.lastIndex = index;
                    const match = top.matcher.exec(codeToHighlight);
                    // console.log("match", match[0], match.rule && match.rule.begin)
                    if (!match) break;
                    const beforeMatch = codeToHighlight.substring(index, match.index);
                    const processedCount = processLexeme(beforeMatch, match);
                    index = match.index + processedCount;
                }
                processLexeme(codeToHighlight.substring(index));
            } else language.__emitTokens(codeToHighlight, emitter);
            emitter.finalize();
            result = emitter.toHTML();
            return {
                language: languageName,
                value: result,
                relevance: relevance,
                illegal: false,
                _emitter: emitter,
                _top: top
            };
        } catch (err) {
            if (err.message && err.message.includes("Illegal")) return {
                language: languageName,
                value: $e573d579511d10ff$var$escape(codeToHighlight),
                illegal: true,
                relevance: 0,
                _illegalBy: {
                    message: err.message,
                    index: index,
                    context: codeToHighlight.slice(index - 100, index + 100),
                    mode: err.mode,
                    resultSoFar: result
                },
                _emitter: emitter
            };
            else if (SAFE_MODE) return {
                language: languageName,
                value: $e573d579511d10ff$var$escape(codeToHighlight),
                illegal: false,
                relevance: 0,
                errorRaised: err,
                _emitter: emitter,
                _top: top
            };
            else throw err;
        }
    }
    /**
   * returns a valid highlight result, without actually doing any actual work,
   * auto highlight starts with this and it's possible for small snippets that
   * auto-detection may not find a better match
   * @param {string} code
   * @returns {HighlightResult}
   */ function justTextHighlightResult(code) {
        const result = {
            value: $e573d579511d10ff$var$escape(code),
            illegal: false,
            relevance: 0,
            _top: PLAINTEXT_LANGUAGE,
            _emitter: new options.__emitter(options)
        };
        result._emitter.addText(code);
        return result;
    }
    /**
  Highlighting with language detection. Accepts a string with the code to
  highlight. Returns an object with the following properties:

  - language (detected language)
  - relevance (int)
  - value (an HTML string with highlighting markup)
  - secondBest (object with the same structure for second-best heuristically
    detected language, may be absent)

    @param {string} code
    @param {Array<string>} [languageSubset]
    @returns {AutoHighlightResult}
  */ function highlightAuto(code, languageSubset) {
        languageSubset = languageSubset || options.languages || Object.keys(languages);
        const plaintext = justTextHighlightResult(code);
        const results = languageSubset.filter(getLanguage).filter(autoDetection).map((name)=>_highlight(name, code, false));
        results.unshift(plaintext); // plaintext is always an option
        const sorted = results.sort((a, b)=>{
            // sort base on relevance
            if (a.relevance !== b.relevance) return b.relevance - a.relevance;
            // always award the tie to the base language
            // ie if C++ and Arduino are tied, it's more likely to be C++
            if (a.language && b.language) {
                if (getLanguage(a.language).supersetOf === b.language) return 1;
                else if (getLanguage(b.language).supersetOf === a.language) return -1;
            }
            // otherwise say they are equal, which has the effect of sorting on
            // relevance while preserving the original ordering - which is how ties
            // have historically been settled, ie the language that comes first always
            // wins in the case of a tie
            return 0;
        });
        const [best, secondBest] = sorted;
        /** @type {AutoHighlightResult} */ const result = best;
        result.secondBest = secondBest;
        return result;
    }
    /**
   * Builds new class name for block given the language name
   *
   * @param {HTMLElement} element
   * @param {string} [currentLang]
   * @param {string} [resultLang]
   */ function updateClassName(element, currentLang, resultLang) {
        const language = currentLang && aliases[currentLang] || resultLang;
        element.classList.add("hljs");
        element.classList.add(`language-${language}`);
    }
    /**
   * Applies highlighting to a DOM node containing code.
   *
   * @param {HighlightedHTMLElement} element - the HTML element to highlight
  */ function highlightElement(element) {
        /** @type HTMLElement */ let node = null;
        const language = blockLanguage(element);
        if (shouldNotHighlight(language)) return;
        fire("before:highlightElement", {
            el: element,
            language: language
        });
        if (element.dataset.highlighted) {
            console.log("Element previously highlighted. To highlight again, first unset `dataset.highlighted`.", element);
            return;
        }
        // we should be all text, no child nodes (unescaped HTML) - this is possibly
        // an HTML injection attack - it's likely too late if this is already in
        // production (the code has likely already done its damage by the time
        // we're seeing it)... but we yell loudly about this so that hopefully it's
        // more likely to be caught in development before making it to production
        if (element.children.length > 0) {
            if (!options.ignoreUnescapedHTML) {
                console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk.");
                console.warn("https://github.com/highlightjs/highlight.js/wiki/security");
                console.warn("The element with unescaped HTML:");
                console.warn(element);
            }
            if (options.throwUnescapedHTML) {
                const err = new $e573d579511d10ff$var$HTMLInjectionError("One of your code blocks includes unescaped HTML.", element.innerHTML);
                throw err;
            }
        }
        node = element;
        const text = node.textContent;
        const result = language ? highlight(text, {
            language: language,
            ignoreIllegals: true
        }) : highlightAuto(text);
        element.innerHTML = result.value;
        element.dataset.highlighted = "yes";
        updateClassName(element, language, result.language);
        element.result = {
            language: result.language,
            // TODO: remove with version 11.0
            re: result.relevance,
            relevance: result.relevance
        };
        if (result.secondBest) element.secondBest = {
            language: result.secondBest.language,
            relevance: result.secondBest.relevance
        };
        fire("after:highlightElement", {
            el: element,
            result: result,
            text: text
        });
    }
    /**
   * Updates highlight.js global options with the passed options
   *
   * @param {Partial<HLJSOptions>} userOptions
   */ function configure(userOptions) {
        options = $e573d579511d10ff$var$inherit(options, userOptions);
    }
    // TODO: remove v12, deprecated
    const initHighlighting = ()=>{
        highlightAll();
        $e573d579511d10ff$var$deprecated("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
    };
    // TODO: remove v12, deprecated
    function initHighlightingOnLoad() {
        highlightAll();
        $e573d579511d10ff$var$deprecated("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
    }
    let wantsHighlight = false;
    /**
   * auto-highlights all pre>code elements on the page
   */ function highlightAll() {
        // if we are called too early in the loading process
        if (document.readyState === "loading") {
            wantsHighlight = true;
            return;
        }
        const blocks = document.querySelectorAll(options.cssSelector);
        blocks.forEach(highlightElement);
    }
    function boot() {
        // if a highlight was requested before DOM was loaded, do now
        if (wantsHighlight) highlightAll();
    }
    // make sure we are in the browser environment
    if (typeof window !== "undefined" && window.addEventListener) window.addEventListener("DOMContentLoaded", boot, false);
    /**
   * Register a language grammar module
   *
   * @param {string} languageName
   * @param {LanguageFn} languageDefinition
   */ function registerLanguage(languageName, languageDefinition) {
        let lang = null;
        try {
            lang = languageDefinition(hljs);
        } catch (error$1) {
            $e573d579511d10ff$var$error("Language definition for '{}' could not be registered.".replace("{}", languageName));
            // hard or soft error
            if (!SAFE_MODE) throw error$1;
            else $e573d579511d10ff$var$error(error$1);
            // languages that have serious errors are replaced with essentially a
            // "plaintext" stand-in so that the code blocks will still get normal
            // css classes applied to them - and one bad language won't break the
            // entire highlighter
            lang = PLAINTEXT_LANGUAGE;
        }
        // give it a temporary name if it doesn't have one in the meta-data
        if (!lang.name) lang.name = languageName;
        languages[languageName] = lang;
        lang.rawDefinition = languageDefinition.bind(null, hljs);
        if (lang.aliases) registerAliases(lang.aliases, {
            languageName: languageName
        });
    }
    /**
   * Remove a language grammar module
   *
   * @param {string} languageName
   */ function unregisterLanguage(languageName) {
        delete languages[languageName];
        for (const alias of Object.keys(aliases))if (aliases[alias] === languageName) delete aliases[alias];
    }
    /**
   * @returns {string[]} List of language internal names
   */ function listLanguages() {
        return Object.keys(languages);
    }
    /**
   * @param {string} name - name of the language to retrieve
   * @returns {Language | undefined}
   */ function getLanguage(name) {
        name = (name || "").toLowerCase();
        return languages[name] || languages[aliases[name]];
    }
    /**
   *
   * @param {string|string[]} aliasList - single alias or list of aliases
   * @param {{languageName: string}} opts
   */ function registerAliases(aliasList, { languageName: languageName }) {
        if (typeof aliasList === "string") aliasList = [
            aliasList
        ];
        aliasList.forEach((alias)=>{
            aliases[alias.toLowerCase()] = languageName;
        });
    }
    /**
   * Determines if a given language has auto-detection enabled
   * @param {string} name - name of the language
   */ function autoDetection(name) {
        const lang = getLanguage(name);
        return lang && !lang.disableAutodetect;
    }
    /**
   * Upgrades the old highlightBlock plugins to the new
   * highlightElement API
   * @param {HLJSPlugin} plugin
   */ function upgradePluginAPI(plugin) {
        // TODO: remove with v12
        if (plugin["before:highlightBlock"] && !plugin["before:highlightElement"]) plugin["before:highlightElement"] = (data)=>{
            plugin["before:highlightBlock"](Object.assign({
                block: data.el
            }, data));
        };
        if (plugin["after:highlightBlock"] && !plugin["after:highlightElement"]) plugin["after:highlightElement"] = (data)=>{
            plugin["after:highlightBlock"](Object.assign({
                block: data.el
            }, data));
        };
    }
    /**
   * @param {HLJSPlugin} plugin
   */ function addPlugin(plugin) {
        upgradePluginAPI(plugin);
        plugins.push(plugin);
    }
    /**
   * @param {HLJSPlugin} plugin
   */ function removePlugin(plugin) {
        const index = plugins.indexOf(plugin);
        if (index !== -1) plugins.splice(index, 1);
    }
    /**
   *
   * @param {PluginEvent} event
   * @param {any} args
   */ function fire(event, args) {
        const cb = event;
        plugins.forEach(function(plugin) {
            if (plugin[cb]) plugin[cb](args);
        });
    }
    /**
   * DEPRECATED
   * @param {HighlightedHTMLElement} el
   */ function deprecateHighlightBlock(el) {
        $e573d579511d10ff$var$deprecated("10.7.0", "highlightBlock will be removed entirely in v12.0");
        $e573d579511d10ff$var$deprecated("10.7.0", "Please use highlightElement now.");
        return highlightElement(el);
    }
    /* Interface definition */ Object.assign(hljs, {
        highlight: highlight,
        highlightAuto: highlightAuto,
        highlightAll: highlightAll,
        highlightElement: highlightElement,
        // TODO: Remove with v12 API
        highlightBlock: deprecateHighlightBlock,
        configure: configure,
        initHighlighting: initHighlighting,
        initHighlightingOnLoad: initHighlightingOnLoad,
        registerLanguage: registerLanguage,
        unregisterLanguage: unregisterLanguage,
        listLanguages: listLanguages,
        getLanguage: getLanguage,
        registerAliases: registerAliases,
        autoDetection: autoDetection,
        inherit: $e573d579511d10ff$var$inherit,
        addPlugin: addPlugin,
        removePlugin: removePlugin
    });
    hljs.debugMode = function() {
        SAFE_MODE = false;
    };
    hljs.safeMode = function() {
        SAFE_MODE = true;
    };
    hljs.versionString = $e573d579511d10ff$var$version;
    hljs.regex = {
        concat: $e573d579511d10ff$var$concat,
        lookahead: $e573d579511d10ff$var$lookahead,
        either: $e573d579511d10ff$var$either,
        optional: $e573d579511d10ff$var$optional,
        anyNumberOfTimes: $e573d579511d10ff$var$anyNumberOfTimes
    };
    for(const key in $e573d579511d10ff$var$MODES)// @ts-ignore
    if (typeof $e573d579511d10ff$var$MODES[key] === "object") // @ts-ignore
    $e573d579511d10ff$var$deepFreeze($e573d579511d10ff$var$MODES[key]);
    // merge all the modes/regexes into our main object
    Object.assign(hljs, $e573d579511d10ff$var$MODES);
    return hljs;
};
// Other names for the variable may break build script
const $e573d579511d10ff$var$highlight = $e573d579511d10ff$var$HLJS({});
// returns a new instance of the highlighter to be used for extensions
// check https://github.com/wooorm/lowlight/issues/47
$e573d579511d10ff$var$highlight.newInstance = ()=>$e573d579511d10ff$var$HLJS({});
module.exports = $e573d579511d10ff$var$highlight;
$e573d579511d10ff$var$highlight.HighlightJS = $e573d579511d10ff$var$highlight;
$e573d579511d10ff$var$highlight.default = $e573d579511d10ff$var$highlight;

});

parcelRegister("epnql", function(module, exports) {
/*
Language: HTML, XML
Website: https://www.w3.org/XML/
Category: common, web
Audit: 2020
*/ /** @type LanguageFn */ function $a7d591fbb223c43c$var$xml(hljs) {
    const regex = hljs.regex;
    // XML names can have the following additional letters: https://www.w3.org/TR/xml/#NT-NameChar
    // OTHER_NAME_CHARS = /[:\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]/;
    // Element names start with NAME_START_CHAR followed by optional other Unicode letters, ASCII digits, hyphens, underscores, and periods
    // const TAG_NAME_RE = regex.concat(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, regex.optional(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*:/), /[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*/);;
    // const XML_IDENT_RE = /[A-Z_a-z:\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]+/;
    // const TAG_NAME_RE = regex.concat(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, regex.optional(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*:/), /[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*/);
    // however, to cater for performance and more Unicode support rely simply on the Unicode letter class
    const TAG_NAME_RE = regex.concat(/[\p{L}_]/u, regex.optional(/[\p{L}0-9_.-]*:/u), /[\p{L}0-9_.-]*/u);
    const XML_IDENT_RE = /[\p{L}0-9._:-]+/u;
    const XML_ENTITIES = {
        className: "symbol",
        begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
    };
    const XML_META_KEYWORDS = {
        begin: /\s/,
        contains: [
            {
                className: "keyword",
                begin: /#?[a-z_][a-z1-9_-]+/,
                illegal: /\n/
            }
        ]
    };
    const XML_META_PAR_KEYWORDS = hljs.inherit(XML_META_KEYWORDS, {
        begin: /\(/,
        end: /\)/
    });
    const APOS_META_STRING_MODE = hljs.inherit(hljs.APOS_STRING_MODE, {
        className: "string"
    });
    const QUOTE_META_STRING_MODE = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        className: "string"
    });
    const TAG_INTERNALS = {
        endsWithParent: true,
        illegal: /</,
        relevance: 0,
        contains: [
            {
                className: "attr",
                begin: XML_IDENT_RE,
                relevance: 0
            },
            {
                begin: /=\s*/,
                relevance: 0,
                contains: [
                    {
                        className: "string",
                        endsParent: true,
                        variants: [
                            {
                                begin: /"/,
                                end: /"/,
                                contains: [
                                    XML_ENTITIES
                                ]
                            },
                            {
                                begin: /'/,
                                end: /'/,
                                contains: [
                                    XML_ENTITIES
                                ]
                            },
                            {
                                begin: /[^\s"'=<>`]+/
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        name: "HTML, XML",
        aliases: [
            "html",
            "xhtml",
            "rss",
            "atom",
            "xjb",
            "xsd",
            "xsl",
            "plist",
            "wsf",
            "svg"
        ],
        case_insensitive: true,
        unicodeRegex: true,
        contains: [
            {
                className: "meta",
                begin: /<![a-z]/,
                end: />/,
                relevance: 10,
                contains: [
                    XML_META_KEYWORDS,
                    QUOTE_META_STRING_MODE,
                    APOS_META_STRING_MODE,
                    XML_META_PAR_KEYWORDS,
                    {
                        begin: /\[/,
                        end: /\]/,
                        contains: [
                            {
                                className: "meta",
                                begin: /<![a-z]/,
                                end: />/,
                                contains: [
                                    XML_META_KEYWORDS,
                                    XML_META_PAR_KEYWORDS,
                                    QUOTE_META_STRING_MODE,
                                    APOS_META_STRING_MODE
                                ]
                            }
                        ]
                    }
                ]
            },
            hljs.COMMENT(/<!--/, /-->/, {
                relevance: 10
            }),
            {
                begin: /<!\[CDATA\[/,
                end: /\]\]>/,
                relevance: 10
            },
            XML_ENTITIES,
            // xml processing instructions
            {
                className: "meta",
                end: /\?>/,
                variants: [
                    {
                        begin: /<\?xml/,
                        relevance: 10,
                        contains: [
                            QUOTE_META_STRING_MODE
                        ]
                    },
                    {
                        begin: /<\?[a-z][a-z0-9]+/
                    }
                ]
            },
            {
                className: "tag",
                /*
        The lookahead pattern (?=...) ensures that 'begin' only matches
        '<style' as a single word, followed by a whitespace or an
        ending bracket.
        */ begin: /<style(?=\s|>)/,
                end: />/,
                keywords: {
                    name: "style"
                },
                contains: [
                    TAG_INTERNALS
                ],
                starts: {
                    end: /<\/style>/,
                    returnEnd: true,
                    subLanguage: [
                        "css",
                        "xml"
                    ]
                }
            },
            {
                className: "tag",
                // See the comment in the <style tag about the lookahead pattern
                begin: /<script(?=\s|>)/,
                end: />/,
                keywords: {
                    name: "script"
                },
                contains: [
                    TAG_INTERNALS
                ],
                starts: {
                    end: /<\/script>/,
                    returnEnd: true,
                    subLanguage: [
                        "javascript",
                        "handlebars",
                        "xml"
                    ]
                }
            },
            // we need this for now for jSX
            {
                className: "tag",
                begin: /<>|<\/>/
            },
            // open tag
            {
                className: "tag",
                begin: regex.concat(/</, regex.lookahead(regex.concat(TAG_NAME_RE, // <tag/>
                // <tag>
                // <tag ...
                regex.either(/\/>/, />/, /\s/)))),
                end: /\/?>/,
                contains: [
                    {
                        className: "name",
                        begin: TAG_NAME_RE,
                        relevance: 0,
                        starts: TAG_INTERNALS
                    }
                ]
            },
            // close tag
            {
                className: "tag",
                begin: regex.concat(/<\//, regex.lookahead(regex.concat(TAG_NAME_RE, />/))),
                contains: [
                    {
                        className: "name",
                        begin: TAG_NAME_RE,
                        relevance: 0
                    },
                    {
                        begin: />/,
                        relevance: 0,
                        endsParent: true
                    }
                ]
            }
        ]
    };
}
module.exports = $a7d591fbb223c43c$var$xml;

});

parcelRegister("amFZG", function(module, exports) {
const $78bc888fdde2d72c$var$MODES = (hljs)=>{
    return {
        IMPORTANT: {
            scope: "meta",
            begin: "!important"
        },
        BLOCK_COMMENT: hljs.C_BLOCK_COMMENT_MODE,
        HEXCOLOR: {
            scope: "number",
            begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
        },
        FUNCTION_DISPATCH: {
            className: "built_in",
            begin: /[\w-]+(?=\()/
        },
        ATTRIBUTE_SELECTOR_MODE: {
            scope: "selector-attr",
            begin: /\[/,
            end: /\]/,
            illegal: "$",
            contains: [
                hljs.APOS_STRING_MODE,
                hljs.QUOTE_STRING_MODE
            ]
        },
        CSS_NUMBER_MODE: {
            scope: "number",
            begin: hljs.NUMBER_RE + "(" + "%|em|ex|ch|rem" + "|vw|vh|vmin|vmax" + "|cm|mm|in|pt|pc|px" + "|deg|grad|rad|turn" + "|s|ms" + "|Hz|kHz" + "|dpi|dpcm|dppx" + ")?",
            relevance: 0
        },
        CSS_VARIABLE: {
            className: "attr",
            begin: /--[A-Za-z_][A-Za-z0-9_-]*/
        }
    };
};
const $78bc888fdde2d72c$var$TAGS = [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "audio",
    "b",
    "blockquote",
    "body",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "dd",
    "del",
    "details",
    "dfn",
    "div",
    "dl",
    "dt",
    "em",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "mark",
    "menu",
    "nav",
    "object",
    "ol",
    "p",
    "q",
    "quote",
    "samp",
    "section",
    "span",
    "strong",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "ul",
    "var",
    "video"
];
const $78bc888fdde2d72c$var$MEDIA_FEATURES = [
    "any-hover",
    "any-pointer",
    "aspect-ratio",
    "color",
    "color-gamut",
    "color-index",
    "device-aspect-ratio",
    "device-height",
    "device-width",
    "display-mode",
    "forced-colors",
    "grid",
    "height",
    "hover",
    "inverted-colors",
    "monochrome",
    "orientation",
    "overflow-block",
    "overflow-inline",
    "pointer",
    "prefers-color-scheme",
    "prefers-contrast",
    "prefers-reduced-motion",
    "prefers-reduced-transparency",
    "resolution",
    "scan",
    "scripting",
    "update",
    "width",
    // TODO: find a better solution?
    "min-width",
    "max-width",
    "min-height",
    "max-height"
];
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes
const $78bc888fdde2d72c$var$PSEUDO_CLASSES = [
    "active",
    "any-link",
    "blank",
    "checked",
    "current",
    "default",
    "defined",
    "dir",
    "disabled",
    "drop",
    "empty",
    "enabled",
    "first",
    "first-child",
    "first-of-type",
    "fullscreen",
    "future",
    "focus",
    "focus-visible",
    "focus-within",
    "has",
    "host",
    "host-context",
    "hover",
    "indeterminate",
    "in-range",
    "invalid",
    "is",
    "lang",
    "last-child",
    "last-of-type",
    "left",
    "link",
    "local-link",
    "not",
    "nth-child",
    "nth-col",
    "nth-last-child",
    "nth-last-col",
    "nth-last-of-type",
    "nth-of-type",
    "only-child",
    "only-of-type",
    "optional",
    "out-of-range",
    "past",
    "placeholder-shown",
    "read-only",
    "read-write",
    "required",
    "right",
    "root",
    "scope",
    "target",
    "target-within",
    "user-invalid",
    "valid",
    "visited",
    "where" // where()
];
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-elements
const $78bc888fdde2d72c$var$PSEUDO_ELEMENTS = [
    "after",
    "backdrop",
    "before",
    "cue",
    "cue-region",
    "first-letter",
    "first-line",
    "grammar-error",
    "marker",
    "part",
    "placeholder",
    "selection",
    "slotted",
    "spelling-error"
];
const $78bc888fdde2d72c$var$ATTRIBUTES = [
    "align-content",
    "align-items",
    "align-self",
    "all",
    "animation",
    "animation-delay",
    "animation-direction",
    "animation-duration",
    "animation-fill-mode",
    "animation-iteration-count",
    "animation-name",
    "animation-play-state",
    "animation-timing-function",
    "backface-visibility",
    "background",
    "background-attachment",
    "background-blend-mode",
    "background-clip",
    "background-color",
    "background-image",
    "background-origin",
    "background-position",
    "background-repeat",
    "background-size",
    "block-size",
    "border",
    "border-block",
    "border-block-color",
    "border-block-end",
    "border-block-end-color",
    "border-block-end-style",
    "border-block-end-width",
    "border-block-start",
    "border-block-start-color",
    "border-block-start-style",
    "border-block-start-width",
    "border-block-style",
    "border-block-width",
    "border-bottom",
    "border-bottom-color",
    "border-bottom-left-radius",
    "border-bottom-right-radius",
    "border-bottom-style",
    "border-bottom-width",
    "border-collapse",
    "border-color",
    "border-image",
    "border-image-outset",
    "border-image-repeat",
    "border-image-slice",
    "border-image-source",
    "border-image-width",
    "border-inline",
    "border-inline-color",
    "border-inline-end",
    "border-inline-end-color",
    "border-inline-end-style",
    "border-inline-end-width",
    "border-inline-start",
    "border-inline-start-color",
    "border-inline-start-style",
    "border-inline-start-width",
    "border-inline-style",
    "border-inline-width",
    "border-left",
    "border-left-color",
    "border-left-style",
    "border-left-width",
    "border-radius",
    "border-right",
    "border-right-color",
    "border-right-style",
    "border-right-width",
    "border-spacing",
    "border-style",
    "border-top",
    "border-top-color",
    "border-top-left-radius",
    "border-top-right-radius",
    "border-top-style",
    "border-top-width",
    "border-width",
    "bottom",
    "box-decoration-break",
    "box-shadow",
    "box-sizing",
    "break-after",
    "break-before",
    "break-inside",
    "caption-side",
    "caret-color",
    "clear",
    "clip",
    "clip-path",
    "clip-rule",
    "color",
    "column-count",
    "column-fill",
    "column-gap",
    "column-rule",
    "column-rule-color",
    "column-rule-style",
    "column-rule-width",
    "column-span",
    "column-width",
    "columns",
    "contain",
    "content",
    "content-visibility",
    "counter-increment",
    "counter-reset",
    "cue",
    "cue-after",
    "cue-before",
    "cursor",
    "direction",
    "display",
    "empty-cells",
    "filter",
    "flex",
    "flex-basis",
    "flex-direction",
    "flex-flow",
    "flex-grow",
    "flex-shrink",
    "flex-wrap",
    "float",
    "flow",
    "font",
    "font-display",
    "font-family",
    "font-feature-settings",
    "font-kerning",
    "font-language-override",
    "font-size",
    "font-size-adjust",
    "font-smoothing",
    "font-stretch",
    "font-style",
    "font-synthesis",
    "font-variant",
    "font-variant-caps",
    "font-variant-east-asian",
    "font-variant-ligatures",
    "font-variant-numeric",
    "font-variant-position",
    "font-variation-settings",
    "font-weight",
    "gap",
    "glyph-orientation-vertical",
    "grid",
    "grid-area",
    "grid-auto-columns",
    "grid-auto-flow",
    "grid-auto-rows",
    "grid-column",
    "grid-column-end",
    "grid-column-start",
    "grid-gap",
    "grid-row",
    "grid-row-end",
    "grid-row-start",
    "grid-template",
    "grid-template-areas",
    "grid-template-columns",
    "grid-template-rows",
    "hanging-punctuation",
    "height",
    "hyphens",
    "icon",
    "image-orientation",
    "image-rendering",
    "image-resolution",
    "ime-mode",
    "inline-size",
    "isolation",
    "justify-content",
    "left",
    "letter-spacing",
    "line-break",
    "line-height",
    "list-style",
    "list-style-image",
    "list-style-position",
    "list-style-type",
    "margin",
    "margin-block",
    "margin-block-end",
    "margin-block-start",
    "margin-bottom",
    "margin-inline",
    "margin-inline-end",
    "margin-inline-start",
    "margin-left",
    "margin-right",
    "margin-top",
    "marks",
    "mask",
    "mask-border",
    "mask-border-mode",
    "mask-border-outset",
    "mask-border-repeat",
    "mask-border-slice",
    "mask-border-source",
    "mask-border-width",
    "mask-clip",
    "mask-composite",
    "mask-image",
    "mask-mode",
    "mask-origin",
    "mask-position",
    "mask-repeat",
    "mask-size",
    "mask-type",
    "max-block-size",
    "max-height",
    "max-inline-size",
    "max-width",
    "min-block-size",
    "min-height",
    "min-inline-size",
    "min-width",
    "mix-blend-mode",
    "nav-down",
    "nav-index",
    "nav-left",
    "nav-right",
    "nav-up",
    "none",
    "normal",
    "object-fit",
    "object-position",
    "opacity",
    "order",
    "orphans",
    "outline",
    "outline-color",
    "outline-offset",
    "outline-style",
    "outline-width",
    "overflow",
    "overflow-wrap",
    "overflow-x",
    "overflow-y",
    "padding",
    "padding-block",
    "padding-block-end",
    "padding-block-start",
    "padding-bottom",
    "padding-inline",
    "padding-inline-end",
    "padding-inline-start",
    "padding-left",
    "padding-right",
    "padding-top",
    "page-break-after",
    "page-break-before",
    "page-break-inside",
    "pause",
    "pause-after",
    "pause-before",
    "perspective",
    "perspective-origin",
    "pointer-events",
    "position",
    "quotes",
    "resize",
    "rest",
    "rest-after",
    "rest-before",
    "right",
    "row-gap",
    "scroll-margin",
    "scroll-margin-block",
    "scroll-margin-block-end",
    "scroll-margin-block-start",
    "scroll-margin-bottom",
    "scroll-margin-inline",
    "scroll-margin-inline-end",
    "scroll-margin-inline-start",
    "scroll-margin-left",
    "scroll-margin-right",
    "scroll-margin-top",
    "scroll-padding",
    "scroll-padding-block",
    "scroll-padding-block-end",
    "scroll-padding-block-start",
    "scroll-padding-bottom",
    "scroll-padding-inline",
    "scroll-padding-inline-end",
    "scroll-padding-inline-start",
    "scroll-padding-left",
    "scroll-padding-right",
    "scroll-padding-top",
    "scroll-snap-align",
    "scroll-snap-stop",
    "scroll-snap-type",
    "scrollbar-color",
    "scrollbar-gutter",
    "scrollbar-width",
    "shape-image-threshold",
    "shape-margin",
    "shape-outside",
    "speak",
    "speak-as",
    "src",
    "tab-size",
    "table-layout",
    "text-align",
    "text-align-all",
    "text-align-last",
    "text-combine-upright",
    "text-decoration",
    "text-decoration-color",
    "text-decoration-line",
    "text-decoration-style",
    "text-emphasis",
    "text-emphasis-color",
    "text-emphasis-position",
    "text-emphasis-style",
    "text-indent",
    "text-justify",
    "text-orientation",
    "text-overflow",
    "text-rendering",
    "text-shadow",
    "text-transform",
    "text-underline-position",
    "top",
    "transform",
    "transform-box",
    "transform-origin",
    "transform-style",
    "transition",
    "transition-delay",
    "transition-duration",
    "transition-property",
    "transition-timing-function",
    "unicode-bidi",
    "vertical-align",
    "visibility",
    "voice-balance",
    "voice-duration",
    "voice-family",
    "voice-pitch",
    "voice-range",
    "voice-rate",
    "voice-stress",
    "voice-volume",
    "white-space",
    "widows",
    "width",
    "will-change",
    "word-break",
    "word-spacing",
    "word-wrap",
    "writing-mode",
    "z-index"
].reverse();
/*
Language: CSS
Category: common, css, web
Website: https://developer.mozilla.org/en-US/docs/Web/CSS
*/ /** @type LanguageFn */ function $78bc888fdde2d72c$var$css(hljs) {
    const regex = hljs.regex;
    const modes = $78bc888fdde2d72c$var$MODES(hljs);
    const VENDOR_PREFIX = {
        begin: /-(webkit|moz|ms|o)-(?=[a-z])/
    };
    const AT_MODIFIERS = "and or not only";
    const AT_PROPERTY_RE = /@-?\w[\w]*(-\w+)*/; // @-webkit-keyframes
    const IDENT_RE = "[a-zA-Z-][a-zA-Z0-9_-]*";
    const STRINGS = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE
    ];
    return {
        name: "CSS",
        case_insensitive: true,
        illegal: /[=|'\$]/,
        keywords: {
            keyframePosition: "from to"
        },
        classNameAliases: {
            // for visual continuity with `tag {}` and because we
            // don't have a great class for this?
            keyframePosition: "selector-tag"
        },
        contains: [
            modes.BLOCK_COMMENT,
            VENDOR_PREFIX,
            // to recognize keyframe 40% etc which are outside the scope of our
            // attribute value mode
            modes.CSS_NUMBER_MODE,
            {
                className: "selector-id",
                begin: /#[A-Za-z0-9_-]+/,
                relevance: 0
            },
            {
                className: "selector-class",
                begin: "\\." + IDENT_RE,
                relevance: 0
            },
            modes.ATTRIBUTE_SELECTOR_MODE,
            {
                className: "selector-pseudo",
                variants: [
                    {
                        begin: ":(" + $78bc888fdde2d72c$var$PSEUDO_CLASSES.join("|") + ")"
                    },
                    {
                        begin: ":(:)?(" + $78bc888fdde2d72c$var$PSEUDO_ELEMENTS.join("|") + ")"
                    }
                ]
            },
            // we may actually need this (12/2020)
            // { // pseudo-selector params
            //   begin: /\(/,
            //   end: /\)/,
            //   contains: [ hljs.CSS_NUMBER_MODE ]
            // },
            modes.CSS_VARIABLE,
            {
                className: "attribute",
                begin: "\\b(" + $78bc888fdde2d72c$var$ATTRIBUTES.join("|") + ")\\b"
            },
            // attribute values
            {
                begin: /:/,
                end: /[;}{]/,
                contains: [
                    modes.BLOCK_COMMENT,
                    modes.HEXCOLOR,
                    modes.IMPORTANT,
                    modes.CSS_NUMBER_MODE,
                    ...STRINGS,
                    // needed to highlight these as strings and to avoid issues with
                    // illegal characters that might be inside urls that would tigger the
                    // languages illegal stack
                    {
                        begin: /(url|data-uri)\(/,
                        end: /\)/,
                        relevance: 0,
                        keywords: {
                            built_in: "url data-uri"
                        },
                        contains: [
                            ...STRINGS,
                            {
                                className: "string",
                                // any character other than `)` as in `url()` will be the start
                                // of a string, which ends with `)` (from the parent mode)
                                begin: /[^)]/,
                                endsWithParent: true,
                                excludeEnd: true
                            }
                        ]
                    },
                    modes.FUNCTION_DISPATCH
                ]
            },
            {
                begin: regex.lookahead(/@/),
                end: "[{;]",
                relevance: 0,
                illegal: /:/,
                contains: [
                    {
                        className: "keyword",
                        begin: AT_PROPERTY_RE
                    },
                    {
                        begin: /\s/,
                        endsWithParent: true,
                        excludeEnd: true,
                        relevance: 0,
                        keywords: {
                            $pattern: /[a-z-]+/,
                            keyword: AT_MODIFIERS,
                            attribute: $78bc888fdde2d72c$var$MEDIA_FEATURES.join(" ")
                        },
                        contains: [
                            {
                                begin: /[a-z-]+(?=:)/,
                                className: "attribute"
                            },
                            ...STRINGS,
                            modes.CSS_NUMBER_MODE
                        ]
                    }
                ]
            },
            {
                className: "selector-tag",
                begin: "\\b(" + $78bc888fdde2d72c$var$TAGS.join("|") + ")\\b"
            }
        ]
    };
}
module.exports = $78bc888fdde2d72c$var$css;

});

parcelRegister("3pFcp", function(module, exports) {
const $27c3aa3483aa829d$var$MODES = (hljs)=>{
    return {
        IMPORTANT: {
            scope: "meta",
            begin: "!important"
        },
        BLOCK_COMMENT: hljs.C_BLOCK_COMMENT_MODE,
        HEXCOLOR: {
            scope: "number",
            begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
        },
        FUNCTION_DISPATCH: {
            className: "built_in",
            begin: /[\w-]+(?=\()/
        },
        ATTRIBUTE_SELECTOR_MODE: {
            scope: "selector-attr",
            begin: /\[/,
            end: /\]/,
            illegal: "$",
            contains: [
                hljs.APOS_STRING_MODE,
                hljs.QUOTE_STRING_MODE
            ]
        },
        CSS_NUMBER_MODE: {
            scope: "number",
            begin: hljs.NUMBER_RE + "(" + "%|em|ex|ch|rem" + "|vw|vh|vmin|vmax" + "|cm|mm|in|pt|pc|px" + "|deg|grad|rad|turn" + "|s|ms" + "|Hz|kHz" + "|dpi|dpcm|dppx" + ")?",
            relevance: 0
        },
        CSS_VARIABLE: {
            className: "attr",
            begin: /--[A-Za-z_][A-Za-z0-9_-]*/
        }
    };
};
const $27c3aa3483aa829d$var$TAGS = [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "audio",
    "b",
    "blockquote",
    "body",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "dd",
    "del",
    "details",
    "dfn",
    "div",
    "dl",
    "dt",
    "em",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "mark",
    "menu",
    "nav",
    "object",
    "ol",
    "p",
    "q",
    "quote",
    "samp",
    "section",
    "span",
    "strong",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "ul",
    "var",
    "video"
];
const $27c3aa3483aa829d$var$MEDIA_FEATURES = [
    "any-hover",
    "any-pointer",
    "aspect-ratio",
    "color",
    "color-gamut",
    "color-index",
    "device-aspect-ratio",
    "device-height",
    "device-width",
    "display-mode",
    "forced-colors",
    "grid",
    "height",
    "hover",
    "inverted-colors",
    "monochrome",
    "orientation",
    "overflow-block",
    "overflow-inline",
    "pointer",
    "prefers-color-scheme",
    "prefers-contrast",
    "prefers-reduced-motion",
    "prefers-reduced-transparency",
    "resolution",
    "scan",
    "scripting",
    "update",
    "width",
    // TODO: find a better solution?
    "min-width",
    "max-width",
    "min-height",
    "max-height"
];
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes
const $27c3aa3483aa829d$var$PSEUDO_CLASSES = [
    "active",
    "any-link",
    "blank",
    "checked",
    "current",
    "default",
    "defined",
    "dir",
    "disabled",
    "drop",
    "empty",
    "enabled",
    "first",
    "first-child",
    "first-of-type",
    "fullscreen",
    "future",
    "focus",
    "focus-visible",
    "focus-within",
    "has",
    "host",
    "host-context",
    "hover",
    "indeterminate",
    "in-range",
    "invalid",
    "is",
    "lang",
    "last-child",
    "last-of-type",
    "left",
    "link",
    "local-link",
    "not",
    "nth-child",
    "nth-col",
    "nth-last-child",
    "nth-last-col",
    "nth-last-of-type",
    "nth-of-type",
    "only-child",
    "only-of-type",
    "optional",
    "out-of-range",
    "past",
    "placeholder-shown",
    "read-only",
    "read-write",
    "required",
    "right",
    "root",
    "scope",
    "target",
    "target-within",
    "user-invalid",
    "valid",
    "visited",
    "where" // where()
];
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-elements
const $27c3aa3483aa829d$var$PSEUDO_ELEMENTS = [
    "after",
    "backdrop",
    "before",
    "cue",
    "cue-region",
    "first-letter",
    "first-line",
    "grammar-error",
    "marker",
    "part",
    "placeholder",
    "selection",
    "slotted",
    "spelling-error"
];
const $27c3aa3483aa829d$var$ATTRIBUTES = [
    "align-content",
    "align-items",
    "align-self",
    "all",
    "animation",
    "animation-delay",
    "animation-direction",
    "animation-duration",
    "animation-fill-mode",
    "animation-iteration-count",
    "animation-name",
    "animation-play-state",
    "animation-timing-function",
    "backface-visibility",
    "background",
    "background-attachment",
    "background-blend-mode",
    "background-clip",
    "background-color",
    "background-image",
    "background-origin",
    "background-position",
    "background-repeat",
    "background-size",
    "block-size",
    "border",
    "border-block",
    "border-block-color",
    "border-block-end",
    "border-block-end-color",
    "border-block-end-style",
    "border-block-end-width",
    "border-block-start",
    "border-block-start-color",
    "border-block-start-style",
    "border-block-start-width",
    "border-block-style",
    "border-block-width",
    "border-bottom",
    "border-bottom-color",
    "border-bottom-left-radius",
    "border-bottom-right-radius",
    "border-bottom-style",
    "border-bottom-width",
    "border-collapse",
    "border-color",
    "border-image",
    "border-image-outset",
    "border-image-repeat",
    "border-image-slice",
    "border-image-source",
    "border-image-width",
    "border-inline",
    "border-inline-color",
    "border-inline-end",
    "border-inline-end-color",
    "border-inline-end-style",
    "border-inline-end-width",
    "border-inline-start",
    "border-inline-start-color",
    "border-inline-start-style",
    "border-inline-start-width",
    "border-inline-style",
    "border-inline-width",
    "border-left",
    "border-left-color",
    "border-left-style",
    "border-left-width",
    "border-radius",
    "border-right",
    "border-right-color",
    "border-right-style",
    "border-right-width",
    "border-spacing",
    "border-style",
    "border-top",
    "border-top-color",
    "border-top-left-radius",
    "border-top-right-radius",
    "border-top-style",
    "border-top-width",
    "border-width",
    "bottom",
    "box-decoration-break",
    "box-shadow",
    "box-sizing",
    "break-after",
    "break-before",
    "break-inside",
    "caption-side",
    "caret-color",
    "clear",
    "clip",
    "clip-path",
    "clip-rule",
    "color",
    "column-count",
    "column-fill",
    "column-gap",
    "column-rule",
    "column-rule-color",
    "column-rule-style",
    "column-rule-width",
    "column-span",
    "column-width",
    "columns",
    "contain",
    "content",
    "content-visibility",
    "counter-increment",
    "counter-reset",
    "cue",
    "cue-after",
    "cue-before",
    "cursor",
    "direction",
    "display",
    "empty-cells",
    "filter",
    "flex",
    "flex-basis",
    "flex-direction",
    "flex-flow",
    "flex-grow",
    "flex-shrink",
    "flex-wrap",
    "float",
    "flow",
    "font",
    "font-display",
    "font-family",
    "font-feature-settings",
    "font-kerning",
    "font-language-override",
    "font-size",
    "font-size-adjust",
    "font-smoothing",
    "font-stretch",
    "font-style",
    "font-synthesis",
    "font-variant",
    "font-variant-caps",
    "font-variant-east-asian",
    "font-variant-ligatures",
    "font-variant-numeric",
    "font-variant-position",
    "font-variation-settings",
    "font-weight",
    "gap",
    "glyph-orientation-vertical",
    "grid",
    "grid-area",
    "grid-auto-columns",
    "grid-auto-flow",
    "grid-auto-rows",
    "grid-column",
    "grid-column-end",
    "grid-column-start",
    "grid-gap",
    "grid-row",
    "grid-row-end",
    "grid-row-start",
    "grid-template",
    "grid-template-areas",
    "grid-template-columns",
    "grid-template-rows",
    "hanging-punctuation",
    "height",
    "hyphens",
    "icon",
    "image-orientation",
    "image-rendering",
    "image-resolution",
    "ime-mode",
    "inline-size",
    "isolation",
    "justify-content",
    "left",
    "letter-spacing",
    "line-break",
    "line-height",
    "list-style",
    "list-style-image",
    "list-style-position",
    "list-style-type",
    "margin",
    "margin-block",
    "margin-block-end",
    "margin-block-start",
    "margin-bottom",
    "margin-inline",
    "margin-inline-end",
    "margin-inline-start",
    "margin-left",
    "margin-right",
    "margin-top",
    "marks",
    "mask",
    "mask-border",
    "mask-border-mode",
    "mask-border-outset",
    "mask-border-repeat",
    "mask-border-slice",
    "mask-border-source",
    "mask-border-width",
    "mask-clip",
    "mask-composite",
    "mask-image",
    "mask-mode",
    "mask-origin",
    "mask-position",
    "mask-repeat",
    "mask-size",
    "mask-type",
    "max-block-size",
    "max-height",
    "max-inline-size",
    "max-width",
    "min-block-size",
    "min-height",
    "min-inline-size",
    "min-width",
    "mix-blend-mode",
    "nav-down",
    "nav-index",
    "nav-left",
    "nav-right",
    "nav-up",
    "none",
    "normal",
    "object-fit",
    "object-position",
    "opacity",
    "order",
    "orphans",
    "outline",
    "outline-color",
    "outline-offset",
    "outline-style",
    "outline-width",
    "overflow",
    "overflow-wrap",
    "overflow-x",
    "overflow-y",
    "padding",
    "padding-block",
    "padding-block-end",
    "padding-block-start",
    "padding-bottom",
    "padding-inline",
    "padding-inline-end",
    "padding-inline-start",
    "padding-left",
    "padding-right",
    "padding-top",
    "page-break-after",
    "page-break-before",
    "page-break-inside",
    "pause",
    "pause-after",
    "pause-before",
    "perspective",
    "perspective-origin",
    "pointer-events",
    "position",
    "quotes",
    "resize",
    "rest",
    "rest-after",
    "rest-before",
    "right",
    "row-gap",
    "scroll-margin",
    "scroll-margin-block",
    "scroll-margin-block-end",
    "scroll-margin-block-start",
    "scroll-margin-bottom",
    "scroll-margin-inline",
    "scroll-margin-inline-end",
    "scroll-margin-inline-start",
    "scroll-margin-left",
    "scroll-margin-right",
    "scroll-margin-top",
    "scroll-padding",
    "scroll-padding-block",
    "scroll-padding-block-end",
    "scroll-padding-block-start",
    "scroll-padding-bottom",
    "scroll-padding-inline",
    "scroll-padding-inline-end",
    "scroll-padding-inline-start",
    "scroll-padding-left",
    "scroll-padding-right",
    "scroll-padding-top",
    "scroll-snap-align",
    "scroll-snap-stop",
    "scroll-snap-type",
    "scrollbar-color",
    "scrollbar-gutter",
    "scrollbar-width",
    "shape-image-threshold",
    "shape-margin",
    "shape-outside",
    "speak",
    "speak-as",
    "src",
    "tab-size",
    "table-layout",
    "text-align",
    "text-align-all",
    "text-align-last",
    "text-combine-upright",
    "text-decoration",
    "text-decoration-color",
    "text-decoration-line",
    "text-decoration-style",
    "text-emphasis",
    "text-emphasis-color",
    "text-emphasis-position",
    "text-emphasis-style",
    "text-indent",
    "text-justify",
    "text-orientation",
    "text-overflow",
    "text-rendering",
    "text-shadow",
    "text-transform",
    "text-underline-position",
    "top",
    "transform",
    "transform-box",
    "transform-origin",
    "transform-style",
    "transition",
    "transition-delay",
    "transition-duration",
    "transition-property",
    "transition-timing-function",
    "unicode-bidi",
    "vertical-align",
    "visibility",
    "voice-balance",
    "voice-duration",
    "voice-family",
    "voice-pitch",
    "voice-range",
    "voice-rate",
    "voice-stress",
    "voice-volume",
    "white-space",
    "widows",
    "width",
    "will-change",
    "word-break",
    "word-spacing",
    "word-wrap",
    "writing-mode",
    "z-index"
].reverse();
/*
Language: SCSS
Description: Scss is an extension of the syntax of CSS.
Author: Kurt Emch <kurt@kurtemch.com>
Website: https://sass-lang.com
Category: common, css, web
*/ /** @type LanguageFn */ function $27c3aa3483aa829d$var$scss(hljs) {
    const modes = $27c3aa3483aa829d$var$MODES(hljs);
    const PSEUDO_ELEMENTS$1 = $27c3aa3483aa829d$var$PSEUDO_ELEMENTS;
    const PSEUDO_CLASSES$1 = $27c3aa3483aa829d$var$PSEUDO_CLASSES;
    const AT_IDENTIFIER = "@[a-z-]+"; // @font-face
    const AT_MODIFIERS = "and or not only";
    const IDENT_RE = "[a-zA-Z-][a-zA-Z0-9_-]*";
    const VARIABLE = {
        className: "variable",
        begin: "(\\$" + IDENT_RE + ")\\b",
        relevance: 0
    };
    return {
        name: "SCSS",
        case_insensitive: true,
        illegal: "[=/|']",
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            // to recognize keyframe 40% etc which are outside the scope of our
            // attribute value mode
            modes.CSS_NUMBER_MODE,
            {
                className: "selector-id",
                begin: "#[A-Za-z0-9_-]+",
                relevance: 0
            },
            {
                className: "selector-class",
                begin: "\\.[A-Za-z0-9_-]+",
                relevance: 0
            },
            modes.ATTRIBUTE_SELECTOR_MODE,
            {
                className: "selector-tag",
                begin: "\\b(" + $27c3aa3483aa829d$var$TAGS.join("|") + ")\\b",
                // was there, before, but why?
                relevance: 0
            },
            {
                className: "selector-pseudo",
                begin: ":(" + PSEUDO_CLASSES$1.join("|") + ")"
            },
            {
                className: "selector-pseudo",
                begin: ":(:)?(" + PSEUDO_ELEMENTS$1.join("|") + ")"
            },
            VARIABLE,
            {
                begin: /\(/,
                end: /\)/,
                contains: [
                    modes.CSS_NUMBER_MODE
                ]
            },
            modes.CSS_VARIABLE,
            {
                className: "attribute",
                begin: "\\b(" + $27c3aa3483aa829d$var$ATTRIBUTES.join("|") + ")\\b"
            },
            {
                begin: "\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b"
            },
            {
                begin: /:/,
                end: /[;}{]/,
                relevance: 0,
                contains: [
                    modes.BLOCK_COMMENT,
                    VARIABLE,
                    modes.HEXCOLOR,
                    modes.CSS_NUMBER_MODE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    modes.IMPORTANT,
                    modes.FUNCTION_DISPATCH
                ]
            },
            // matching these here allows us to treat them more like regular CSS
            // rules so everything between the {} gets regular rule highlighting,
            // which is what we want for page and font-face
            {
                begin: "@(page|font-face)",
                keywords: {
                    $pattern: AT_IDENTIFIER,
                    keyword: "@page @font-face"
                }
            },
            {
                begin: "@",
                end: "[{;]",
                returnBegin: true,
                keywords: {
                    $pattern: /[a-z-]+/,
                    keyword: AT_MODIFIERS,
                    attribute: $27c3aa3483aa829d$var$MEDIA_FEATURES.join(" ")
                },
                contains: [
                    {
                        begin: AT_IDENTIFIER,
                        className: "keyword"
                    },
                    {
                        begin: /[a-z-]+(?=:)/,
                        className: "attribute"
                    },
                    VARIABLE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    modes.HEXCOLOR,
                    modes.CSS_NUMBER_MODE
                ]
            },
            modes.FUNCTION_DISPATCH
        ]
    };
}
module.exports = $27c3aa3483aa829d$var$scss;

});

parcelRegister("38p48", function(module, exports) {
const $248590006b4d3a1c$var$IDENT_RE = "[A-Za-z$_][0-9A-Za-z$_]*";
const $248590006b4d3a1c$var$KEYWORDS = [
    "as",
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
];
const $248590006b4d3a1c$var$LITERALS = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
];
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
const $248590006b4d3a1c$var$TYPES = [
    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    // numbers and dates
    "Math",
    "Date",
    "Number",
    "BigInt",
    // text
    "String",
    "RegExp",
    // Indexed collections
    "Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Int32Array",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array",
    // Keyed collections
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer",
    "Atomics",
    "DataView",
    "JSON",
    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",
    "AsyncFunction",
    // Reflection
    "Reflect",
    "Proxy",
    // Internationalization
    "Intl",
    // WebAssembly
    "WebAssembly"
];
const $248590006b4d3a1c$var$ERROR_TYPES = [
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
const $248590006b4d3a1c$var$BUILT_IN_GLOBALS = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
];
const $248590006b4d3a1c$var$BUILT_IN_VARIABLES = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "sessionStorage",
    "module",
    "global" // Node.js
];
const $248590006b4d3a1c$var$BUILT_INS = [].concat($248590006b4d3a1c$var$BUILT_IN_GLOBALS, $248590006b4d3a1c$var$TYPES, $248590006b4d3a1c$var$ERROR_TYPES);
/*
Language: JavaScript
Description: JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions.
Category: common, scripting, web
Website: https://developer.mozilla.org/en-US/docs/Web/JavaScript
*/ /** @type LanguageFn */ function $248590006b4d3a1c$var$javascript(hljs) {
    const regex = hljs.regex;
    /**
   * Takes a string like "<Booger" and checks to see
   * if we can find a matching "</Booger" later in the
   * content.
   * @param {RegExpMatchArray} match
   * @param {{after:number}} param1
   */ const hasClosingTag = (match, { after: after })=>{
        const tag = "</" + match[0].slice(1);
        const pos = match.input.indexOf(tag, after);
        return pos !== -1;
    };
    const IDENT_RE$1 = $248590006b4d3a1c$var$IDENT_RE;
    const FRAGMENT = {
        begin: "<>",
        end: "</>"
    };
    // to avoid some special cases inside isTrulyOpeningTag
    const XML_SELF_CLOSING = /<[A-Za-z0-9\\._:-]+\s*\/>/;
    const XML_TAG = {
        begin: /<[A-Za-z0-9\\._:-]+/,
        end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
        /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */ isTrulyOpeningTag: (match, response)=>{
            const afterMatchIndex = match[0].length + match.index;
            const nextChar = match.input[afterMatchIndex];
            if (// HTML should not include another raw `<` inside a tag
            // nested type?
            // `<Array<Array<number>>`, etc.
            nextChar === "<" || // the , gives away that this is not HTML
            // `<T, A extends keyof T, V>`
            nextChar === ",") {
                response.ignoreMatch();
                return;
            }
            // `<something>`
            // Quite possibly a tag, lets look for a matching closing tag...
            if (nextChar === ">") // if we cannot find a matching closing tag, then we
            // will ignore it
            {
                if (!hasClosingTag(match, {
                    after: afterMatchIndex
                })) response.ignoreMatch();
            }
            // `<blah />` (self-closing)
            // handled by simpleSelfClosing rule
            let m;
            const afterMatch = match.input.substring(afterMatchIndex);
            // some more template typing stuff
            //  <T = any>(key?: string) => Modify<
            if (m = afterMatch.match(/^\s*=/)) {
                response.ignoreMatch();
                return;
            }
            // `<From extends string>`
            // technically this could be HTML, but it smells like a type
            // NOTE: This is ugh, but added specifically for https://github.com/highlightjs/highlight.js/issues/3276
            if (m = afterMatch.match(/^\s+extends\s+/)) {
                if (m.index === 0) {
                    response.ignoreMatch();
                    // eslint-disable-next-line no-useless-return
                    return;
                }
            }
        }
    };
    const KEYWORDS$1 = {
        $pattern: $248590006b4d3a1c$var$IDENT_RE,
        keyword: $248590006b4d3a1c$var$KEYWORDS,
        literal: $248590006b4d3a1c$var$LITERALS,
        built_in: $248590006b4d3a1c$var$BUILT_INS,
        "variable.language": $248590006b4d3a1c$var$BUILT_IN_VARIABLES
    };
    // https://tc39.es/ecma262/#sec-literals-numeric-literals
    const decimalDigits = "[0-9](_?[0-9])*";
    const frac = `\\.(${decimalDigits})`;
    // DecimalIntegerLiteral, including Annex B NonOctalDecimalIntegerLiteral
    // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
    const decimalInteger = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`;
    const NUMBER = {
        className: "number",
        variants: [
            // DecimalLiteral
            {
                begin: `(\\b(${decimalInteger})((${frac})|\\.)?|(${frac}))` + `[eE][+-]?(${decimalDigits})\\b`
            },
            {
                begin: `\\b(${decimalInteger})\\b((${frac})\\b|\\.)?|(${frac})\\b`
            },
            // DecimalBigIntegerLiteral
            {
                begin: `\\b(0|[1-9](_?[0-9])*)n\\b`
            },
            // NonDecimalIntegerLiteral
            {
                begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
            },
            {
                begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
            },
            {
                begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
            },
            // LegacyOctalIntegerLiteral (does not include underscore separators)
            // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
            {
                begin: "\\b0[0-7]+n?\\b"
            }
        ],
        relevance: 0
    };
    const SUBST = {
        className: "subst",
        begin: "\\$\\{",
        end: "\\}",
        keywords: KEYWORDS$1,
        contains: [] // defined later
    };
    const HTML_TEMPLATE = {
        begin: "html`",
        end: "",
        starts: {
            end: "`",
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: "xml"
        }
    };
    const CSS_TEMPLATE = {
        begin: "css`",
        end: "",
        starts: {
            end: "`",
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: "css"
        }
    };
    const GRAPHQL_TEMPLATE = {
        begin: "gql`",
        end: "",
        starts: {
            end: "`",
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: "graphql"
        }
    };
    const TEMPLATE_STRING = {
        className: "string",
        begin: "`",
        end: "`",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ]
    };
    const JSDOC_COMMENT = hljs.COMMENT(/\/\*\*(?!\/)/, "\\*/", {
        relevance: 0,
        contains: [
            {
                begin: "(?=@[A-Za-z]+)",
                relevance: 0,
                contains: [
                    {
                        className: "doctag",
                        begin: "@[A-Za-z]+"
                    },
                    {
                        className: "type",
                        begin: "\\{",
                        end: "\\}",
                        excludeEnd: true,
                        excludeBegin: true,
                        relevance: 0
                    },
                    {
                        className: "variable",
                        begin: IDENT_RE$1 + "(?=\\s*(-)|$)",
                        endsParent: true,
                        relevance: 0
                    },
                    // eat spaces (not newlines) so we can find
                    // types or variables
                    {
                        begin: /(?=[^\n])\s/,
                        relevance: 0
                    }
                ]
            }
        ]
    });
    const COMMENT = {
        className: "comment",
        variants: [
            JSDOC_COMMENT,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_LINE_COMMENT_MODE
        ]
    };
    const SUBST_INTERNALS = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        HTML_TEMPLATE,
        CSS_TEMPLATE,
        GRAPHQL_TEMPLATE,
        TEMPLATE_STRING,
        // Skip numbers when they are part of a variable name
        {
            match: /\$\d+/
        },
        NUMBER
    ];
    SUBST.contains = SUBST_INTERNALS.concat({
        // we need to pair up {} inside our subst to prevent
        // it from ending too early by matching another }
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS$1,
        contains: [
            "self"
        ].concat(SUBST_INTERNALS)
    });
    const SUBST_AND_COMMENTS = [].concat(COMMENT, SUBST.contains);
    const PARAMS_CONTAINS = SUBST_AND_COMMENTS.concat([
        // eat recursive parens in sub expressions
        {
            begin: /\(/,
            end: /\)/,
            keywords: KEYWORDS$1,
            contains: [
                "self"
            ].concat(SUBST_AND_COMMENTS)
        }
    ]);
    const PARAMS = {
        className: "params",
        begin: /\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        keywords: KEYWORDS$1,
        contains: PARAMS_CONTAINS
    };
    // ES6 classes
    const CLASS_OR_EXTENDS = {
        variants: [
            // class Car extends vehicle
            {
                match: [
                    /class/,
                    /\s+/,
                    IDENT_RE$1,
                    /\s+/,
                    /extends/,
                    /\s+/,
                    regex.concat(IDENT_RE$1, "(", regex.concat(/\./, IDENT_RE$1), ")*")
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    5: "keyword",
                    7: "title.class.inherited"
                }
            },
            // class Car
            {
                match: [
                    /class/,
                    /\s+/,
                    IDENT_RE$1
                ],
                scope: {
                    1: "keyword",
                    3: "title.class"
                }
            }
        ]
    };
    const CLASS_REFERENCE = {
        relevance: 0,
        match: regex.either(// Hard coded exceptions
        /\bJSON/, // Float32Array, OutT
        /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, // CSSFactory, CSSFactoryT
        /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, // FPs, FPsT
        /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
        className: "title.class",
        keywords: {
            _: [
                // se we still get relevance credit for JS library classes
                ...$248590006b4d3a1c$var$TYPES,
                ...$248590006b4d3a1c$var$ERROR_TYPES
            ]
        }
    };
    const USE_STRICT = {
        label: "use_strict",
        className: "meta",
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
    };
    const FUNCTION_DEFINITION = {
        variants: [
            {
                match: [
                    /function/,
                    /\s+/,
                    IDENT_RE$1,
                    /(?=\s*\()/
                ]
            },
            // anonymous function
            {
                match: [
                    /function/,
                    /\s*(?=\()/
                ]
            }
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        label: "func.def",
        contains: [
            PARAMS
        ],
        illegal: /%/
    };
    const UPPER_CASE_CONSTANT = {
        relevance: 0,
        match: /\b[A-Z][A-Z_0-9]+\b/,
        className: "variable.constant"
    };
    function noneOf(list) {
        return regex.concat("(?!", list.join("|"), ")");
    }
    const FUNCTION_CALL = {
        match: regex.concat(/\b/, noneOf([
            ...$248590006b4d3a1c$var$BUILT_IN_GLOBALS,
            "super",
            "import"
        ]), IDENT_RE$1, regex.lookahead(/\(/)),
        className: "title.function",
        relevance: 0
    };
    const PROPERTY_ACCESS = {
        begin: regex.concat(/\./, regex.lookahead(regex.concat(IDENT_RE$1, /(?![0-9A-Za-z$_(])/))),
        end: IDENT_RE$1,
        excludeBegin: true,
        keywords: "prototype",
        className: "property",
        relevance: 0
    };
    const GETTER_OR_SETTER = {
        match: [
            /get|set/,
            /\s+/,
            IDENT_RE$1,
            /(?=\()/
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            {
                begin: /\(\)/
            },
            PARAMS
        ]
    };
    const FUNC_LEAD_IN_RE = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + hljs.UNDERSCORE_IDENT_RE + ")\\s*=>";
    const FUNCTION_VARIABLE = {
        match: [
            /const|var|let/,
            /\s+/,
            IDENT_RE$1,
            /\s*/,
            /=\s*/,
            /(async\s*)?/,
            regex.lookahead(FUNC_LEAD_IN_RE)
        ],
        keywords: "async",
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            PARAMS
        ]
    };
    return {
        name: "JavaScript",
        aliases: [
            "js",
            "jsx",
            "mjs",
            "cjs"
        ],
        keywords: KEYWORDS$1,
        // this will be extended by TypeScript
        exports: {
            PARAMS_CONTAINS: PARAMS_CONTAINS,
            CLASS_REFERENCE: CLASS_REFERENCE
        },
        illegal: /#(?![$_A-z])/,
        contains: [
            hljs.SHEBANG({
                label: "shebang",
                binary: "node",
                relevance: 5
            }),
            USE_STRICT,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            HTML_TEMPLATE,
            CSS_TEMPLATE,
            GRAPHQL_TEMPLATE,
            TEMPLATE_STRING,
            COMMENT,
            // Skip numbers when they are part of a variable name
            {
                match: /\$\d+/
            },
            NUMBER,
            CLASS_REFERENCE,
            {
                className: "attr",
                begin: IDENT_RE$1 + regex.lookahead(":"),
                relevance: 0
            },
            FUNCTION_VARIABLE,
            {
                begin: "(" + hljs.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                keywords: "return throw case",
                relevance: 0,
                contains: [
                    COMMENT,
                    hljs.REGEXP_MODE,
                    {
                        className: "function",
                        // we have to count the parens to make sure we actually have the
                        // correct bounding ( ) before the =>.  There could be any number of
                        // sub-expressions inside also surrounded by parens.
                        begin: FUNC_LEAD_IN_RE,
                        returnBegin: true,
                        end: "\\s*=>",
                        contains: [
                            {
                                className: "params",
                                variants: [
                                    {
                                        begin: hljs.UNDERSCORE_IDENT_RE,
                                        relevance: 0
                                    },
                                    {
                                        className: null,
                                        begin: /\(\s*\)/,
                                        skip: true
                                    },
                                    {
                                        begin: /\(/,
                                        end: /\)/,
                                        excludeBegin: true,
                                        excludeEnd: true,
                                        keywords: KEYWORDS$1,
                                        contains: PARAMS_CONTAINS
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        begin: /,/,
                        relevance: 0
                    },
                    {
                        match: /\s+/,
                        relevance: 0
                    },
                    {
                        variants: [
                            {
                                begin: FRAGMENT.begin,
                                end: FRAGMENT.end
                            },
                            {
                                match: XML_SELF_CLOSING
                            },
                            {
                                begin: XML_TAG.begin,
                                // we carefully check the opening tag to see if it truly
                                // is a tag and not a false positive
                                "on:begin": XML_TAG.isTrulyOpeningTag,
                                end: XML_TAG.end
                            }
                        ],
                        subLanguage: "xml",
                        contains: [
                            {
                                begin: XML_TAG.begin,
                                end: XML_TAG.end,
                                skip: true,
                                contains: [
                                    "self"
                                ]
                            }
                        ]
                    }
                ]
            },
            FUNCTION_DEFINITION,
            {
                // prevent this from getting swallowed up by function
                // since they appear "function like"
                beginKeywords: "while if switch catch for"
            },
            {
                // we have to count the parens to make sure we actually have the correct
                // bounding ( ).  There could be any number of sub-expressions inside
                // also surrounded by parens.
                begin: "\\b(?!function)" + hljs.UNDERSCORE_IDENT_RE + "\\(" + // first parens
                "[^()]*(\\(" + "[^()]*(\\(" + "[^()]*" + "\\)[^()]*)*" + "\\)[^()]*)*" + "\\)\\s*\\{",
                returnBegin: true,
                label: "func.def",
                contains: [
                    PARAMS,
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE$1,
                        className: "title.function"
                    })
                ]
            },
            // catch ... so it won't trigger the property rule below
            {
                match: /\.\.\./,
                relevance: 0
            },
            PROPERTY_ACCESS,
            // hack: prevents detection of keywords in some circumstances
            // .keyword()
            // $keyword = x
            {
                match: "\\$" + IDENT_RE$1,
                relevance: 0
            },
            {
                match: [
                    /\bconstructor(?=\s*\()/
                ],
                className: {
                    1: "title.function"
                },
                contains: [
                    PARAMS
                ]
            },
            FUNCTION_CALL,
            UPPER_CASE_CONSTANT,
            CLASS_OR_EXTENDS,
            GETTER_OR_SETTER,
            {
                match: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
            }
        ]
    };
}
module.exports = $248590006b4d3a1c$var$javascript;

});

parcelRegister("9Grm6", function(module, exports) {
const $70cd4182ff0f8a42$var$IDENT_RE = "[A-Za-z$_][0-9A-Za-z$_]*";
const $70cd4182ff0f8a42$var$KEYWORDS = [
    "as",
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
];
const $70cd4182ff0f8a42$var$LITERALS = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
];
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
const $70cd4182ff0f8a42$var$TYPES = [
    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    // numbers and dates
    "Math",
    "Date",
    "Number",
    "BigInt",
    // text
    "String",
    "RegExp",
    // Indexed collections
    "Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Int32Array",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array",
    // Keyed collections
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer",
    "Atomics",
    "DataView",
    "JSON",
    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",
    "AsyncFunction",
    // Reflection
    "Reflect",
    "Proxy",
    // Internationalization
    "Intl",
    // WebAssembly
    "WebAssembly"
];
const $70cd4182ff0f8a42$var$ERROR_TYPES = [
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
const $70cd4182ff0f8a42$var$BUILT_IN_GLOBALS = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
];
const $70cd4182ff0f8a42$var$BUILT_IN_VARIABLES = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "sessionStorage",
    "module",
    "global" // Node.js
];
const $70cd4182ff0f8a42$var$BUILT_INS = [].concat($70cd4182ff0f8a42$var$BUILT_IN_GLOBALS, $70cd4182ff0f8a42$var$TYPES, $70cd4182ff0f8a42$var$ERROR_TYPES);
/*
Language: JavaScript
Description: JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions.
Category: common, scripting, web
Website: https://developer.mozilla.org/en-US/docs/Web/JavaScript
*/ /** @type LanguageFn */ function $70cd4182ff0f8a42$var$javascript(hljs) {
    const regex = hljs.regex;
    /**
   * Takes a string like "<Booger" and checks to see
   * if we can find a matching "</Booger" later in the
   * content.
   * @param {RegExpMatchArray} match
   * @param {{after:number}} param1
   */ const hasClosingTag = (match, { after: after })=>{
        const tag = "</" + match[0].slice(1);
        const pos = match.input.indexOf(tag, after);
        return pos !== -1;
    };
    const IDENT_RE$1 = $70cd4182ff0f8a42$var$IDENT_RE;
    const FRAGMENT = {
        begin: "<>",
        end: "</>"
    };
    // to avoid some special cases inside isTrulyOpeningTag
    const XML_SELF_CLOSING = /<[A-Za-z0-9\\._:-]+\s*\/>/;
    const XML_TAG = {
        begin: /<[A-Za-z0-9\\._:-]+/,
        end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
        /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */ isTrulyOpeningTag: (match, response)=>{
            const afterMatchIndex = match[0].length + match.index;
            const nextChar = match.input[afterMatchIndex];
            if (// HTML should not include another raw `<` inside a tag
            // nested type?
            // `<Array<Array<number>>`, etc.
            nextChar === "<" || // the , gives away that this is not HTML
            // `<T, A extends keyof T, V>`
            nextChar === ",") {
                response.ignoreMatch();
                return;
            }
            // `<something>`
            // Quite possibly a tag, lets look for a matching closing tag...
            if (nextChar === ">") // if we cannot find a matching closing tag, then we
            // will ignore it
            {
                if (!hasClosingTag(match, {
                    after: afterMatchIndex
                })) response.ignoreMatch();
            }
            // `<blah />` (self-closing)
            // handled by simpleSelfClosing rule
            let m;
            const afterMatch = match.input.substring(afterMatchIndex);
            // some more template typing stuff
            //  <T = any>(key?: string) => Modify<
            if (m = afterMatch.match(/^\s*=/)) {
                response.ignoreMatch();
                return;
            }
            // `<From extends string>`
            // technically this could be HTML, but it smells like a type
            // NOTE: This is ugh, but added specifically for https://github.com/highlightjs/highlight.js/issues/3276
            if (m = afterMatch.match(/^\s+extends\s+/)) {
                if (m.index === 0) {
                    response.ignoreMatch();
                    // eslint-disable-next-line no-useless-return
                    return;
                }
            }
        }
    };
    const KEYWORDS$1 = {
        $pattern: $70cd4182ff0f8a42$var$IDENT_RE,
        keyword: $70cd4182ff0f8a42$var$KEYWORDS,
        literal: $70cd4182ff0f8a42$var$LITERALS,
        built_in: $70cd4182ff0f8a42$var$BUILT_INS,
        "variable.language": $70cd4182ff0f8a42$var$BUILT_IN_VARIABLES
    };
    // https://tc39.es/ecma262/#sec-literals-numeric-literals
    const decimalDigits = "[0-9](_?[0-9])*";
    const frac = `\\.(${decimalDigits})`;
    // DecimalIntegerLiteral, including Annex B NonOctalDecimalIntegerLiteral
    // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
    const decimalInteger = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`;
    const NUMBER = {
        className: "number",
        variants: [
            // DecimalLiteral
            {
                begin: `(\\b(${decimalInteger})((${frac})|\\.)?|(${frac}))` + `[eE][+-]?(${decimalDigits})\\b`
            },
            {
                begin: `\\b(${decimalInteger})\\b((${frac})\\b|\\.)?|(${frac})\\b`
            },
            // DecimalBigIntegerLiteral
            {
                begin: `\\b(0|[1-9](_?[0-9])*)n\\b`
            },
            // NonDecimalIntegerLiteral
            {
                begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
            },
            {
                begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
            },
            {
                begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
            },
            // LegacyOctalIntegerLiteral (does not include underscore separators)
            // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
            {
                begin: "\\b0[0-7]+n?\\b"
            }
        ],
        relevance: 0
    };
    const SUBST = {
        className: "subst",
        begin: "\\$\\{",
        end: "\\}",
        keywords: KEYWORDS$1,
        contains: [] // defined later
    };
    const HTML_TEMPLATE = {
        begin: "html`",
        end: "",
        starts: {
            end: "`",
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: "xml"
        }
    };
    const CSS_TEMPLATE = {
        begin: "css`",
        end: "",
        starts: {
            end: "`",
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: "css"
        }
    };
    const GRAPHQL_TEMPLATE = {
        begin: "gql`",
        end: "",
        starts: {
            end: "`",
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: "graphql"
        }
    };
    const TEMPLATE_STRING = {
        className: "string",
        begin: "`",
        end: "`",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ]
    };
    const JSDOC_COMMENT = hljs.COMMENT(/\/\*\*(?!\/)/, "\\*/", {
        relevance: 0,
        contains: [
            {
                begin: "(?=@[A-Za-z]+)",
                relevance: 0,
                contains: [
                    {
                        className: "doctag",
                        begin: "@[A-Za-z]+"
                    },
                    {
                        className: "type",
                        begin: "\\{",
                        end: "\\}",
                        excludeEnd: true,
                        excludeBegin: true,
                        relevance: 0
                    },
                    {
                        className: "variable",
                        begin: IDENT_RE$1 + "(?=\\s*(-)|$)",
                        endsParent: true,
                        relevance: 0
                    },
                    // eat spaces (not newlines) so we can find
                    // types or variables
                    {
                        begin: /(?=[^\n])\s/,
                        relevance: 0
                    }
                ]
            }
        ]
    });
    const COMMENT = {
        className: "comment",
        variants: [
            JSDOC_COMMENT,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_LINE_COMMENT_MODE
        ]
    };
    const SUBST_INTERNALS = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        HTML_TEMPLATE,
        CSS_TEMPLATE,
        GRAPHQL_TEMPLATE,
        TEMPLATE_STRING,
        // Skip numbers when they are part of a variable name
        {
            match: /\$\d+/
        },
        NUMBER
    ];
    SUBST.contains = SUBST_INTERNALS.concat({
        // we need to pair up {} inside our subst to prevent
        // it from ending too early by matching another }
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS$1,
        contains: [
            "self"
        ].concat(SUBST_INTERNALS)
    });
    const SUBST_AND_COMMENTS = [].concat(COMMENT, SUBST.contains);
    const PARAMS_CONTAINS = SUBST_AND_COMMENTS.concat([
        // eat recursive parens in sub expressions
        {
            begin: /\(/,
            end: /\)/,
            keywords: KEYWORDS$1,
            contains: [
                "self"
            ].concat(SUBST_AND_COMMENTS)
        }
    ]);
    const PARAMS = {
        className: "params",
        begin: /\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        keywords: KEYWORDS$1,
        contains: PARAMS_CONTAINS
    };
    // ES6 classes
    const CLASS_OR_EXTENDS = {
        variants: [
            // class Car extends vehicle
            {
                match: [
                    /class/,
                    /\s+/,
                    IDENT_RE$1,
                    /\s+/,
                    /extends/,
                    /\s+/,
                    regex.concat(IDENT_RE$1, "(", regex.concat(/\./, IDENT_RE$1), ")*")
                ],
                scope: {
                    1: "keyword",
                    3: "title.class",
                    5: "keyword",
                    7: "title.class.inherited"
                }
            },
            // class Car
            {
                match: [
                    /class/,
                    /\s+/,
                    IDENT_RE$1
                ],
                scope: {
                    1: "keyword",
                    3: "title.class"
                }
            }
        ]
    };
    const CLASS_REFERENCE = {
        relevance: 0,
        match: regex.either(// Hard coded exceptions
        /\bJSON/, // Float32Array, OutT
        /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, // CSSFactory, CSSFactoryT
        /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, // FPs, FPsT
        /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
        className: "title.class",
        keywords: {
            _: [
                // se we still get relevance credit for JS library classes
                ...$70cd4182ff0f8a42$var$TYPES,
                ...$70cd4182ff0f8a42$var$ERROR_TYPES
            ]
        }
    };
    const USE_STRICT = {
        label: "use_strict",
        className: "meta",
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
    };
    const FUNCTION_DEFINITION = {
        variants: [
            {
                match: [
                    /function/,
                    /\s+/,
                    IDENT_RE$1,
                    /(?=\s*\()/
                ]
            },
            // anonymous function
            {
                match: [
                    /function/,
                    /\s*(?=\()/
                ]
            }
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        label: "func.def",
        contains: [
            PARAMS
        ],
        illegal: /%/
    };
    const UPPER_CASE_CONSTANT = {
        relevance: 0,
        match: /\b[A-Z][A-Z_0-9]+\b/,
        className: "variable.constant"
    };
    function noneOf(list) {
        return regex.concat("(?!", list.join("|"), ")");
    }
    const FUNCTION_CALL = {
        match: regex.concat(/\b/, noneOf([
            ...$70cd4182ff0f8a42$var$BUILT_IN_GLOBALS,
            "super",
            "import"
        ]), IDENT_RE$1, regex.lookahead(/\(/)),
        className: "title.function",
        relevance: 0
    };
    const PROPERTY_ACCESS = {
        begin: regex.concat(/\./, regex.lookahead(regex.concat(IDENT_RE$1, /(?![0-9A-Za-z$_(])/))),
        end: IDENT_RE$1,
        excludeBegin: true,
        keywords: "prototype",
        className: "property",
        relevance: 0
    };
    const GETTER_OR_SETTER = {
        match: [
            /get|set/,
            /\s+/,
            IDENT_RE$1,
            /(?=\()/
        ],
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            {
                begin: /\(\)/
            },
            PARAMS
        ]
    };
    const FUNC_LEAD_IN_RE = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + hljs.UNDERSCORE_IDENT_RE + ")\\s*=>";
    const FUNCTION_VARIABLE = {
        match: [
            /const|var|let/,
            /\s+/,
            IDENT_RE$1,
            /\s*/,
            /=\s*/,
            /(async\s*)?/,
            regex.lookahead(FUNC_LEAD_IN_RE)
        ],
        keywords: "async",
        className: {
            1: "keyword",
            3: "title.function"
        },
        contains: [
            PARAMS
        ]
    };
    return {
        name: "JavaScript",
        aliases: [
            "js",
            "jsx",
            "mjs",
            "cjs"
        ],
        keywords: KEYWORDS$1,
        // this will be extended by TypeScript
        exports: {
            PARAMS_CONTAINS: PARAMS_CONTAINS,
            CLASS_REFERENCE: CLASS_REFERENCE
        },
        illegal: /#(?![$_A-z])/,
        contains: [
            hljs.SHEBANG({
                label: "shebang",
                binary: "node",
                relevance: 5
            }),
            USE_STRICT,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            HTML_TEMPLATE,
            CSS_TEMPLATE,
            GRAPHQL_TEMPLATE,
            TEMPLATE_STRING,
            COMMENT,
            // Skip numbers when they are part of a variable name
            {
                match: /\$\d+/
            },
            NUMBER,
            CLASS_REFERENCE,
            {
                className: "attr",
                begin: IDENT_RE$1 + regex.lookahead(":"),
                relevance: 0
            },
            FUNCTION_VARIABLE,
            {
                begin: "(" + hljs.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                keywords: "return throw case",
                relevance: 0,
                contains: [
                    COMMENT,
                    hljs.REGEXP_MODE,
                    {
                        className: "function",
                        // we have to count the parens to make sure we actually have the
                        // correct bounding ( ) before the =>.  There could be any number of
                        // sub-expressions inside also surrounded by parens.
                        begin: FUNC_LEAD_IN_RE,
                        returnBegin: true,
                        end: "\\s*=>",
                        contains: [
                            {
                                className: "params",
                                variants: [
                                    {
                                        begin: hljs.UNDERSCORE_IDENT_RE,
                                        relevance: 0
                                    },
                                    {
                                        className: null,
                                        begin: /\(\s*\)/,
                                        skip: true
                                    },
                                    {
                                        begin: /\(/,
                                        end: /\)/,
                                        excludeBegin: true,
                                        excludeEnd: true,
                                        keywords: KEYWORDS$1,
                                        contains: PARAMS_CONTAINS
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        begin: /,/,
                        relevance: 0
                    },
                    {
                        match: /\s+/,
                        relevance: 0
                    },
                    {
                        variants: [
                            {
                                begin: FRAGMENT.begin,
                                end: FRAGMENT.end
                            },
                            {
                                match: XML_SELF_CLOSING
                            },
                            {
                                begin: XML_TAG.begin,
                                // we carefully check the opening tag to see if it truly
                                // is a tag and not a false positive
                                "on:begin": XML_TAG.isTrulyOpeningTag,
                                end: XML_TAG.end
                            }
                        ],
                        subLanguage: "xml",
                        contains: [
                            {
                                begin: XML_TAG.begin,
                                end: XML_TAG.end,
                                skip: true,
                                contains: [
                                    "self"
                                ]
                            }
                        ]
                    }
                ]
            },
            FUNCTION_DEFINITION,
            {
                // prevent this from getting swallowed up by function
                // since they appear "function like"
                beginKeywords: "while if switch catch for"
            },
            {
                // we have to count the parens to make sure we actually have the correct
                // bounding ( ).  There could be any number of sub-expressions inside
                // also surrounded by parens.
                begin: "\\b(?!function)" + hljs.UNDERSCORE_IDENT_RE + "\\(" + // first parens
                "[^()]*(\\(" + "[^()]*(\\(" + "[^()]*" + "\\)[^()]*)*" + "\\)[^()]*)*" + "\\)\\s*\\{",
                returnBegin: true,
                label: "func.def",
                contains: [
                    PARAMS,
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE$1,
                        className: "title.function"
                    })
                ]
            },
            // catch ... so it won't trigger the property rule below
            {
                match: /\.\.\./,
                relevance: 0
            },
            PROPERTY_ACCESS,
            // hack: prevents detection of keywords in some circumstances
            // .keyword()
            // $keyword = x
            {
                match: "\\$" + IDENT_RE$1,
                relevance: 0
            },
            {
                match: [
                    /\bconstructor(?=\s*\()/
                ],
                className: {
                    1: "title.function"
                },
                contains: [
                    PARAMS
                ]
            },
            FUNCTION_CALL,
            UPPER_CASE_CONSTANT,
            CLASS_OR_EXTENDS,
            GETTER_OR_SETTER,
            {
                match: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
            }
        ]
    };
}
/*
Language: TypeScript
Author: Panu Horsmalahti <panu.horsmalahti@iki.fi>
Contributors: Ike Ku <dempfi@yahoo.com>
Description: TypeScript is a strict superset of JavaScript
Website: https://www.typescriptlang.org
Category: common, scripting
*/ /** @type LanguageFn */ function $70cd4182ff0f8a42$var$typescript(hljs) {
    const tsLanguage = $70cd4182ff0f8a42$var$javascript(hljs);
    const IDENT_RE$1 = $70cd4182ff0f8a42$var$IDENT_RE;
    const TYPES = [
        "any",
        "void",
        "number",
        "boolean",
        "string",
        "object",
        "never",
        "symbol",
        "bigint",
        "unknown"
    ];
    const NAMESPACE = {
        beginKeywords: "namespace",
        end: /\{/,
        excludeEnd: true,
        contains: [
            tsLanguage.exports.CLASS_REFERENCE
        ]
    };
    const INTERFACE = {
        beginKeywords: "interface",
        end: /\{/,
        excludeEnd: true,
        keywords: {
            keyword: "interface extends",
            built_in: TYPES
        },
        contains: [
            tsLanguage.exports.CLASS_REFERENCE
        ]
    };
    const USE_STRICT = {
        className: "meta",
        relevance: 10,
        begin: /^\s*['"]use strict['"]/
    };
    const TS_SPECIFIC_KEYWORDS = [
        "type",
        "namespace",
        "interface",
        "public",
        "private",
        "protected",
        "implements",
        "declare",
        "abstract",
        "readonly",
        "enum",
        "override"
    ];
    const KEYWORDS$1 = {
        $pattern: $70cd4182ff0f8a42$var$IDENT_RE,
        keyword: $70cd4182ff0f8a42$var$KEYWORDS.concat(TS_SPECIFIC_KEYWORDS),
        literal: $70cd4182ff0f8a42$var$LITERALS,
        built_in: $70cd4182ff0f8a42$var$BUILT_INS.concat(TYPES),
        "variable.language": $70cd4182ff0f8a42$var$BUILT_IN_VARIABLES
    };
    const DECORATOR = {
        className: "meta",
        begin: "@" + IDENT_RE$1
    };
    const swapMode = (mode, label, replacement)=>{
        const indx = mode.contains.findIndex((m)=>m.label === label);
        if (indx === -1) throw new Error("can not find mode to replace");
        mode.contains.splice(indx, 1, replacement);
    };
    // this should update anywhere keywords is used since
    // it will be the same actual JS object
    Object.assign(tsLanguage.keywords, KEYWORDS$1);
    tsLanguage.exports.PARAMS_CONTAINS.push(DECORATOR);
    tsLanguage.contains = tsLanguage.contains.concat([
        DECORATOR,
        NAMESPACE,
        INTERFACE
    ]);
    // TS gets a simpler shebang rule than JS
    swapMode(tsLanguage, "shebang", hljs.SHEBANG());
    // JS use strict rule purposely excludes `asm` which makes no sense
    swapMode(tsLanguage, "use_strict", USE_STRICT);
    const functionDeclaration = tsLanguage.contains.find((m)=>m.label === "func.def");
    functionDeclaration.relevance = 0; // () => {} is more typical in TypeScript
    Object.assign(tsLanguage, {
        name: "TypeScript",
        aliases: [
            "ts",
            "tsx",
            "mts",
            "cts"
        ]
    });
    return tsLanguage;
}
module.exports = $70cd4182ff0f8a42$var$typescript;

});

parcelRegister("kM5iW", function(module, exports) {
/*
Language: Bash
Author: vah <vahtenberg@gmail.com>
Contributrors: Benjamin Pannell <contact@sierrasoftworks.com>
Website: https://www.gnu.org/software/bash/
Category: common
*/ /** @type LanguageFn */ function $f1fc67b386b99850$var$bash(hljs) {
    const regex = hljs.regex;
    const VAR = {};
    const BRACED_VAR = {
        begin: /\$\{/,
        end: /\}/,
        contains: [
            "self",
            {
                begin: /:-/,
                contains: [
                    VAR
                ]
            } // default values
        ]
    };
    Object.assign(VAR, {
        className: "variable",
        variants: [
            {
                begin: regex.concat(/\$[\w\d#@][\w\d_]*/, // negative look-ahead tries to avoid matching patterns that are not
                // Perl at all like $ident$, @ident@, etc.
                `(?![\\w\\d])(?![$])`)
            },
            BRACED_VAR
        ]
    });
    const SUBST = {
        className: "subst",
        begin: /\$\(/,
        end: /\)/,
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    const HERE_DOC = {
        begin: /<<-?\s*(?=\w+)/,
        starts: {
            contains: [
                hljs.END_SAME_AS_BEGIN({
                    begin: /(\w+)/,
                    end: /(\w+)/,
                    className: "string"
                })
            ]
        }
    };
    const QUOTE_STRING = {
        className: "string",
        begin: /"/,
        end: /"/,
        contains: [
            hljs.BACKSLASH_ESCAPE,
            VAR,
            SUBST
        ]
    };
    SUBST.contains.push(QUOTE_STRING);
    const ESCAPED_QUOTE = {
        match: /\\"/
    };
    const APOS_STRING = {
        className: "string",
        begin: /'/,
        end: /'/
    };
    const ESCAPED_APOS = {
        match: /\\'/
    };
    const ARITHMETIC = {
        begin: /\$?\(\(/,
        end: /\)\)/,
        contains: [
            {
                begin: /\d+#[0-9a-f]+/,
                className: "number"
            },
            hljs.NUMBER_MODE,
            VAR
        ]
    };
    const SH_LIKE_SHELLS = [
        "fish",
        "bash",
        "zsh",
        "sh",
        "csh",
        "ksh",
        "tcsh",
        "dash",
        "scsh"
    ];
    const KNOWN_SHEBANG = hljs.SHEBANG({
        binary: `(${SH_LIKE_SHELLS.join("|")})`,
        relevance: 10
    });
    const FUNCTION = {
        className: "function",
        begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
        returnBegin: true,
        contains: [
            hljs.inherit(hljs.TITLE_MODE, {
                begin: /\w[\w\d_]*/
            })
        ],
        relevance: 0
    };
    const KEYWORDS = [
        "if",
        "then",
        "else",
        "elif",
        "fi",
        "for",
        "while",
        "until",
        "in",
        "do",
        "done",
        "case",
        "esac",
        "function",
        "select"
    ];
    const LITERALS = [
        "true",
        "false"
    ];
    // to consume paths to prevent keyword matches inside them
    const PATH_MODE = {
        match: /(\/[a-z._-]+)+/
    };
    // http://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
    const SHELL_BUILT_INS = [
        "break",
        "cd",
        "continue",
        "eval",
        "exec",
        "exit",
        "export",
        "getopts",
        "hash",
        "pwd",
        "readonly",
        "return",
        "shift",
        "test",
        "times",
        "trap",
        "umask",
        "unset"
    ];
    const BASH_BUILT_INS = [
        "alias",
        "bind",
        "builtin",
        "caller",
        "command",
        "declare",
        "echo",
        "enable",
        "help",
        "let",
        "local",
        "logout",
        "mapfile",
        "printf",
        "read",
        "readarray",
        "source",
        "type",
        "typeset",
        "ulimit",
        "unalias"
    ];
    const ZSH_BUILT_INS = [
        "autoload",
        "bg",
        "bindkey",
        "bye",
        "cap",
        "chdir",
        "clone",
        "comparguments",
        "compcall",
        "compctl",
        "compdescribe",
        "compfiles",
        "compgroups",
        "compquote",
        "comptags",
        "comptry",
        "compvalues",
        "dirs",
        "disable",
        "disown",
        "echotc",
        "echoti",
        "emulate",
        "fc",
        "fg",
        "float",
        "functions",
        "getcap",
        "getln",
        "history",
        "integer",
        "jobs",
        "kill",
        "limit",
        "log",
        "noglob",
        "popd",
        "print",
        "pushd",
        "pushln",
        "rehash",
        "sched",
        "setcap",
        "setopt",
        "stat",
        "suspend",
        "ttyctl",
        "unfunction",
        "unhash",
        "unlimit",
        "unsetopt",
        "vared",
        "wait",
        "whence",
        "where",
        "which",
        "zcompile",
        "zformat",
        "zftp",
        "zle",
        "zmodload",
        "zparseopts",
        "zprof",
        "zpty",
        "zregexparse",
        "zsocket",
        "zstyle",
        "ztcp"
    ];
    const GNU_CORE_UTILS = [
        "chcon",
        "chgrp",
        "chown",
        "chmod",
        "cp",
        "dd",
        "df",
        "dir",
        "dircolors",
        "ln",
        "ls",
        "mkdir",
        "mkfifo",
        "mknod",
        "mktemp",
        "mv",
        "realpath",
        "rm",
        "rmdir",
        "shred",
        "sync",
        "touch",
        "truncate",
        "vdir",
        "b2sum",
        "base32",
        "base64",
        "cat",
        "cksum",
        "comm",
        "csplit",
        "cut",
        "expand",
        "fmt",
        "fold",
        "head",
        "join",
        "md5sum",
        "nl",
        "numfmt",
        "od",
        "paste",
        "ptx",
        "pr",
        "sha1sum",
        "sha224sum",
        "sha256sum",
        "sha384sum",
        "sha512sum",
        "shuf",
        "sort",
        "split",
        "sum",
        "tac",
        "tail",
        "tr",
        "tsort",
        "unexpand",
        "uniq",
        "wc",
        "arch",
        "basename",
        "chroot",
        "date",
        "dirname",
        "du",
        "echo",
        "env",
        "expr",
        "factor",
        // "false", // keyword literal already
        "groups",
        "hostid",
        "id",
        "link",
        "logname",
        "nice",
        "nohup",
        "nproc",
        "pathchk",
        "pinky",
        "printenv",
        "printf",
        "pwd",
        "readlink",
        "runcon",
        "seq",
        "sleep",
        "stat",
        "stdbuf",
        "stty",
        "tee",
        "test",
        "timeout",
        // "true", // keyword literal already
        "tty",
        "uname",
        "unlink",
        "uptime",
        "users",
        "who",
        "whoami",
        "yes"
    ];
    return {
        name: "Bash",
        aliases: [
            "sh"
        ],
        keywords: {
            $pattern: /\b[a-z][a-z0-9._-]+\b/,
            keyword: KEYWORDS,
            literal: LITERALS,
            built_in: [
                ...SHELL_BUILT_INS,
                ...BASH_BUILT_INS,
                // Shell modifiers
                "set",
                "shopt",
                ...ZSH_BUILT_INS,
                ...GNU_CORE_UTILS
            ]
        },
        contains: [
            KNOWN_SHEBANG,
            hljs.SHEBANG(),
            FUNCTION,
            ARITHMETIC,
            hljs.HASH_COMMENT_MODE,
            HERE_DOC,
            PATH_MODE,
            QUOTE_STRING,
            ESCAPED_QUOTE,
            APOS_STRING,
            ESCAPED_APOS,
            VAR
        ]
    };
}
module.exports = $f1fc67b386b99850$var$bash;

});



parcelRegister("c5j4u", function(module, exports) {

$parcel$export(module.exports, "AppModalComponent", function () { return $52b2378e70c9d03d$export$e53757c7022a90d; });

var $4tSb9 = parcelRequire("4tSb9");
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $fXA0k = parcelRequire("fXA0k");
parcelRequire("3IANd");
var $ogP7Y = parcelRequire("ogP7Y");
parcelRequire("2xFp3");
var $aShgn = parcelRequire("aShgn");
parcelRequire("bsGWa");
var $4fw8W = parcelRequire("4fw8W");
parcelRequire("1mUAS");
var $aHFKf = parcelRequire("aHFKf");
var $2qQ1O = parcelRequire("2qQ1O");
var $3bQrU = parcelRequire("3bQrU");

var $eD4R9 = parcelRequire("eD4R9");

var $72ISR = parcelRequire("72ISR");
var $52b2378e70c9d03d$export$a76a9dde4763f6d6;
(function(ModalKinds) {
    ModalKinds["Bare"] = "bare";
    ModalKinds["Modal"] = "modal";
    ModalKinds["Alert"] = "alert";
    ModalKinds["Confirm"] = "confirm";
    ModalKinds["Prompt"] = "prompt";
})($52b2378e70c9d03d$export$a76a9dde4763f6d6 || ($52b2378e70c9d03d$export$a76a9dde4763f6d6 = {}));
let $52b2378e70c9d03d$export$e53757c7022a90d = class AppModalComponent extends (0, $2qQ1O.TiniComponent) {
    static #_ = this.defaultTagName = "app-modal";
    constructor(){
        super();
        this.dialogRef = (0, $aShgn.createRef)();
        this.kind = "modal";
    }
    get result() {
        return {
            context: this.context,
            dialog: this.dialogRef.value
        };
    }
    get opened() {
        return this.dialogRef.value?.open;
    }
    show(context) {
        if (!this.dialogRef.value) return;
        this.context = context;
        this.dialogRef.value.showModal();
    }
    hide() {
        if (!this.dialogRef.value) return;
        this.dialogRef.value.close();
    }
    clickDialog(e) {
        if (!this.backdropClosed) return;
        const backdropClicked = !!e.target?.getAttribute("part");
        if (backdropClicked) this.clickNo();
    }
    clickNo() {
        this.dispatchEvent(new CustomEvent("no", {
            detail: this.result
        }));
    }
    clickYes() {
        this.dispatchEvent(new CustomEvent("yes", {
            detail: this.result
        }));
    }
    render() {
        return (0, $fXA0k.html)`<dialog part="dialog" ${(0, $aShgn.ref)(this.dialogRef)} class="${(0, $ogP7Y.classMap)({
            [this.kind]: true,
            "backdrop-closed": !!this.backdropClosed
        })}" @click="${this.clickDialog}">${this.kind === "bare" ? (0, $fXA0k.nothing) : (0, $fXA0k.html)`<div class="head"><em>${this.titleText || "Modal"}</em> <button @click="${this.clickNo}">✕</button></div>`}<div class="body"><slot></slot></div>${this.kind !== "confirm" && this.kind !== "prompt" ? (0, $fXA0k.html)`<div class="foot"><slot name="foot"></slot></div>` : (0, $fXA0k.html)`<div class="foot"><tini-button color="${this.noButton?.color || (0, $4fw8W.Colors).Medium}" @click="${this.clickNo}">${this.noButton?.text || (this.kind === "prompt" ? "Cancel" : "No")}</tini-button><tini-button color="${this.yesButton?.color || (0, $4fw8W.Colors).Primary}" @click="${this.clickYes}">${this.yesButton?.text || (this.kind === "prompt" ? "OK" : "Yes")}</tini-button></div>`}</dialog>`;
    }
    static #_1 = this.styles = (0, $cZ4os.css)`dialog{position:fixed;padding:0;width:calc(100% - 2rem);max-width:960px;border:none;border-radius:var(--size-radius);box-shadow:var(--shadow-normal);background:var(--color-background);color:var(--color-foreground)}dialog::backdrop{background:rgba(0,0,0,.3)}dialog.backdrop-closed::backdrop{cursor:pointer}dialog.alert,dialog.confirm,dialog.prompt{max-width:480px}.head,.body,.foot{cursor:default;display:flex;box-sizing:border-box;width:100%}.head{justify-content:space-between;align-items:center;border-bottom:1px solid var(--color-background-shade);padding:1rem}.head em{display:block;font-size:1.2rem;font-style:normal;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.head button{display:flex;justify-content:center;align-items:center;width:2rem;height:2rem;padding:0;background:none;border:none;opacity:.5;font-size:1.5rem;cursor:pointer;color:var(--color-foreground)}.head button:hover{opacity:1}.body{padding:1rem;overflow-x:hidden;overflow-y:auto;max-height:75vh;max-height:75dvh}.foot{align-items:center;justify-content:space-between}`;
};
(0, $4tSb9.__decorate)([
    (0, $2qQ1O.Input)({
        type: String
    })
], $52b2378e70c9d03d$export$e53757c7022a90d.prototype, "kind", void 0);
(0, $4tSb9.__decorate)([
    (0, $2qQ1O.Input)({
        type: String
    })
], $52b2378e70c9d03d$export$e53757c7022a90d.prototype, "titleText", void 0);
(0, $4tSb9.__decorate)([
    (0, $2qQ1O.Input)({
        type: Boolean
    })
], $52b2378e70c9d03d$export$e53757c7022a90d.prototype, "backdropClosed", void 0);
(0, $4tSb9.__decorate)([
    (0, $2qQ1O.Input)({
        type: Object
    })
], $52b2378e70c9d03d$export$e53757c7022a90d.prototype, "noButton", void 0);
(0, $4tSb9.__decorate)([
    (0, $2qQ1O.Input)({
        type: Object
    })
], $52b2378e70c9d03d$export$e53757c7022a90d.prototype, "yesButton", void 0);
$52b2378e70c9d03d$export$e53757c7022a90d = (0, $4tSb9.__decorate)([
    (0, $aHFKf.Component)({
        components: [
            (0, $72ISR.TiniButtonComponent)
        ],
        theming: {
            styling: (0, $3bQrU.stylingWithBases)([
                (0, $eD4R9.commonBases),
                (0, $eD4R9.headingsBases),
                (0, $eD4R9.linkBases),
                (0, $eD4R9.textBases),
                (0, $eD4R9.codeBases)
            ])
        }
    })
], $52b2378e70c9d03d$export$e53757c7022a90d);

});

parcelRegister("6EpNK", function(module, exports) {
$parcel$export(module.exports, "styleMap", function () { return (parcelRequire("6MkYW")).styleMap; });
parcelRequire("6MkYW");

});
parcelRegister("6MkYW", function(module, exports) {

$parcel$export(module.exports, "styleMap", function () { return $4ef7805b5da3a00b$export$1e5b4ce2fa884e6a; });

var $fXA0k = parcelRequire("fXA0k");

var $hz9ib = parcelRequire("hz9ib");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $4ef7805b5da3a00b$var$n = "important", $4ef7805b5da3a00b$var$i = " !" + $4ef7805b5da3a00b$var$n, $4ef7805b5da3a00b$export$1e5b4ce2fa884e6a = (0, $hz9ib.directive)(class extends (0, $hz9ib.Directive) {
    constructor(t){
        if (super(t), t.type !== (0, $hz9ib.PartType).ATTRIBUTE || "style" !== t.name || t.strings?.length > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ut) return this.ut = new Set(Object.keys(r)), this.render(r);
        for (const t of this.ut)null == r[t] && (this.ut.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = null);
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ut.add(t);
                const r = "string" == typeof e && e.endsWith($4ef7805b5da3a00b$var$i);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? $4ef7805b5da3a00b$var$n : "") : s[t] = e;
            }
        }
        return 0, $fXA0k.noChange;
    }
});

});


parcelRegister("8u3xy", function(module, exports) {

$parcel$export(module.exports, "buildGithubRawUrl", function () { return $12e95e037c462093$export$f41d5cbc2ed35a9b; });
function $12e95e037c462093$export$f41d5cbc2ed35a9b(repoUrl) {
    const ownerAndRepo = repoUrl.replace(/https?:\/\/github.com\//, "");
    return `https://raw.githubusercontent.com/${ownerAndRepo}`;
}

});

parcelRegister("9qEys", function(module, exports) {

$parcel$export(module.exports, "extractCSSVariables", function () { return $33801b9d5697b90c$export$236b0ad654d4d24f; });
$parcel$export(module.exports, "extractComponentProperties", function () { return $33801b9d5697b90c$export$556f98a071324a27; });

var $apfSk = parcelRequire("apfSk");
async function $33801b9d5697b90c$export$236b0ad654d4d24f(src, scope) {
    const code = await (0, $apfSk.getText)(src);
    const processedCode = !scope ? [
        "",
        code
    ] : code.match(new RegExp(`${scope[0]}([\\s\\S]*?)${scope[1]}`));
    if (!processedCode) return new Map();
    const variableMatchingArr = processedCode[1].replace(/(?:\r\n|\r|\n)/g, "\n").match(/--([\s\S]*?);/g);
    // extract data
    const itemsRecord = Array.from(variableMatchingArr || []).reduce((result, line)=>{
        const [key, value, description] = line.replace(/\n/g, "").replace(/(;$)|(\*\/)/g, "").replace("/*", ":").split(":").map((item)=>item.trim());
        const [category] = description?.match(/\[[a-zA-Z0-9_]+\]/) || [];
        const keyArr = key.split("-").filter((item)=>item);
        const prefix = keyArr.shift();
        const title = !keyArr.length ? "-" : keyArr.map((item)=>item[0].toUpperCase() + item.slice(1)).join(" ");
        result[key] = {
            key: key,
            value: value,
            valueDirect: value,
            prefix: prefix,
            title: title,
            description: ((!category ? description : description?.replace(category, "")) || "").trim(),
            category: category?.replace(/\[|\]/g, "")
        };
        return result;
    }, {});
    // process direct values
    const mapItems = Object.entries(itemsRecord).map(([key, item])=>{
        // replace direct values
        const varMatchingArr = item.value.match(/var\(([\s\S]*?)\)/g);
        varMatchingArr?.forEach((varMatching)=>{
            const varKey = varMatching.replace(/var\(|\)/g, "");
            const varDef = itemsRecord[varKey];
            item.valueDirect = item.valueDirect.replace(varMatching, !varDef?.valueDirect || ~varDef.valueDirect.indexOf("var(") ? "transparent" : varDef.valueDirect);
        });
        // map item
        return [
            key,
            item
        ];
    });
    // result
    return new Map(mapItems);
}
async function $33801b9d5697b90c$export$556f98a071324a27(src) {
    const code = await (0, $apfSk.getText)(src);
    const propsMatchingArr = code.match(/@property\(([\s\S]*?);/g);
    if (!propsMatchingArr) return [];
    return propsMatchingArr.map((item)=>{
        const [, mainContent] = item.split(" declare ");
        const [rawName, ...rest] = mainContent.replace(/readonly|private|public|protected|(;$)/g, "").split(":");
        const isOptional = !!~rawName.indexOf("?");
        const name = (!isOptional ? rawName : rawName.replace(/\?/g, "")).trim();
        const defaultAssignMatching = code.match(new RegExp(`this.${name} = ([\\s\\S]*?);`));
        const defaultValue = !defaultAssignMatching ? "undefined" : defaultAssignMatching[1];
        return {
            name: name,
            type: rest.join("").trim(),
            isOptional: isOptional,
            defaultValue: defaultValue
        };
    });
}

});
parcelRegister("apfSk", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $79b804b5c8722ad9$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "getText", function () { return $79b804b5c8722ad9$export$c72d34660a162238; });
function $79b804b5c8722ad9$export$3988ae62b71be9a3(url, requestInit) {
    return $79b804b5c8722ad9$export$7d6f1c8842f9f527(url, {
        ...requestInit,
        method: "GET"
    });
}
function $79b804b5c8722ad9$export$c72d34660a162238(url, requestInit) {
    return $79b804b5c8722ad9$export$7d6f1c8842f9f527(url, {
        ...requestInit,
        method: "GET"
    }, "text");
}
function $79b804b5c8722ad9$export$8b3ca78f81ec578c(url, requestInit) {
    return $79b804b5c8722ad9$export$7d6f1c8842f9f527(url, {
        ...requestInit,
        method: "GET"
    }, "file");
}
function $79b804b5c8722ad9$export$299ba2dee77727e9(url, requestInit) {
    return $79b804b5c8722ad9$export$7d6f1c8842f9f527(url, {
        ...requestInit,
        method: "POST"
    });
}
function $79b804b5c8722ad9$export$327f7b26ebf455db(url, requestInit) {
    return $79b804b5c8722ad9$export$7d6f1c8842f9f527(url, {
        ...requestInit,
        method: "PUT"
    });
}
function $79b804b5c8722ad9$export$b76953f99ab2be78(url, requestInit) {
    return $79b804b5c8722ad9$export$7d6f1c8842f9f527(url, {
        ...requestInit,
        method: "PATCH"
    });
}
function $79b804b5c8722ad9$export$bb9482f9d3afdd22(url, requestInit) {
    return $79b804b5c8722ad9$export$7d6f1c8842f9f527(url, {
        ...requestInit,
        method: "DELETE"
    });
}
async function $79b804b5c8722ad9$export$7d6f1c8842f9f527(input, requestInit, responseType = "json") {
    const response = await fetch(input, {
        ...requestInit,
        ...requestInit?.method === "GET" ? {} : {
            headers: {
                "Content-Type": "application/json"
            }
        }
    });
    if (!response.ok) throw new Error("Fetch failed!");
    return responseType === "file" ? response.arrayBuffer() : responseType === "text" ? response.text() : response.json();
}

});


parcelRegister("7AtUt", function(module, exports) {

$parcel$export(module.exports, "TiniLinkComponent", function () { return $586318af2774bb36$export$5b43fbdbc8a48e5d; });

var $3mn2W = parcelRequire("3mn2W");

var $7ebxM = parcelRequire("7ebxM");
parcelRequire("bsGWa");
var $aynjv = parcelRequire("aynjv");
var $8Zp5V = parcelRequire("8Zp5V");
var $8gdKM = parcelRequire("8gdKM");
var $4fw8W = parcelRequire("4fw8W");
parcelRequire("lYoPT");
var $fXA0k = parcelRequire("fXA0k");
parcelRequire("4MDiX");
var $asvDI = parcelRequire("asvDI");
parcelRequire("3IANd");
var $ogP7Y = parcelRequire("ogP7Y");
parcelRequire("lgkY5");
var $bc9s1 = parcelRequire("bc9s1");
parcelRequire("2xFp3");
var $aShgn = parcelRequire("aShgn");
var $586318af2774bb36$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $586318af2774bb36$export$5b43fbdbc8a48e5d = class TiniLinkComponent extends (0, $8Zp5V.TiniElement) {
    constructor(){
        super(...arguments);
        this.ROUTER_CHANGE_EVENT = "tini:router:change";
        this.anchorRef = (0, $aShgn.createRef)();
        this.updateActiveStatus = (e)=>{
            if (!this.active || !this.anchorRef.value) return;
            const currentUrl = new URL(!this.href ? "/" : this.href, window.location.origin);
            const eventUrl = e?.detail.url;
            const currentActive = e ? currentUrl.href === `${eventUrl.origin}${eventUrl.pathname}` : currentUrl.href === `${window.location.origin}${window.location.pathname}`;
            // anchor tag
            const partList = this.anchorRef.value.getAttribute("part") || "";
            this.anchorRef.value.setAttribute("part", (currentActive ? `${partList} ${this.active}` : partList.replace(this.active, "")).trim());
            // the host
            this.classList[currentActive ? "add" : "remove"](this.active);
        };
    }
    static #_ = this.defaultTagName = "tini-link";
    static #_1 = this.componentName = "link";
    /* eslint-enable prettier/prettier */ willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        // root classes parts
        this.extendRootClasses({
            raw: {
                italic: !!this.italic,
                underline: !!this.underline
            },
            overridable: {
                [(0, $4fw8W.VaryGroups).Color]: this.color,
                [(0, $4fw8W.VaryGroups).FontType]: this.fontType,
                [(0, $4fw8W.VaryGroups).FontSize]: this.fontSize,
                [(0, $4fw8W.VaryGroups).FontWeight]: this.fontWeight,
                [(0, $4fw8W.VaryGroups).TextTransform]: this.textTransform
            }
        });
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.active) window.addEventListener(this.ROUTER_CHANGE_EVENT, this.updateActiveStatus);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.active) window.removeEventListener(this.ROUTER_CHANGE_EVENT, this.updateActiveStatus);
    }
    updated() {
        if (this.active) this.updateActiveStatus();
    }
    clickLink(e) {
        if (!this.anchorRef.value) return;
        // navigate
        if (this.anchorRef.value.href !== window.location.href) {
            const url = new URL(this.anchorRef.value.href);
            history.pushState({}, "", url.href);
            dispatchEvent(new PopStateEvent("popstate"));
        }
        // default
        e.preventDefault();
        window.scrollTo(0, 0);
    }
    render() {
        return (0, $fXA0k.html)`
      <a
        router-ignore
        ${(0, $aShgn.ref)(this.anchorRef)}
        class=${(0, $ogP7Y.classMap)(this.rootClasses)}
        part=${(0, $aynjv.partAttrMap)(this.rootClasses)}
        href=${this.href || "/"}
        target=${(0, $bc9s1.ifDefined)(this.target)}
        rel=${(0, $bc9s1.ifDefined)(this.rel)}
        @click=${this.clickLink}
      >
        <slot></slot>
      </a>
    `;
    }
};
$586318af2774bb36$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $586318af2774bb36$export$5b43fbdbc8a48e5d.prototype, "href", void 0);
$586318af2774bb36$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $586318af2774bb36$export$5b43fbdbc8a48e5d.prototype, "rel", void 0);
$586318af2774bb36$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $586318af2774bb36$export$5b43fbdbc8a48e5d.prototype, "target", void 0);
$586318af2774bb36$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $586318af2774bb36$export$5b43fbdbc8a48e5d.prototype, "active", void 0);
$586318af2774bb36$var$__decorate([
    (0, $asvDI.property)({
        type: Boolean,
        reflect: true
    })
], $586318af2774bb36$export$5b43fbdbc8a48e5d.prototype, "italic", void 0);
$586318af2774bb36$var$__decorate([
    (0, $asvDI.property)({
        type: Boolean,
        reflect: true
    })
], $586318af2774bb36$export$5b43fbdbc8a48e5d.prototype, "underline", void 0);
$586318af2774bb36$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $586318af2774bb36$export$5b43fbdbc8a48e5d.prototype, "color", void 0);
$586318af2774bb36$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $586318af2774bb36$export$5b43fbdbc8a48e5d.prototype, "fontType", void 0);
$586318af2774bb36$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $586318af2774bb36$export$5b43fbdbc8a48e5d.prototype, "fontSize", void 0);
$586318af2774bb36$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $586318af2774bb36$export$5b43fbdbc8a48e5d.prototype, "fontWeight", void 0);
$586318af2774bb36$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $586318af2774bb36$export$5b43fbdbc8a48e5d.prototype, "textTransform", void 0);
$586318af2774bb36$export$5b43fbdbc8a48e5d = $586318af2774bb36$var$__decorate([
    (0, $8gdKM.TiniElementTheming)({
        styling: {
            bootstrap: [
                (0, $3mn2W.default),
                (0, $7ebxM.linkStyle)
            ]
        },
        scripting: {
            bootstrap: {
                script: (0, $7ebxM.linkScript),
                unscript: (0, $7ebxM.linkUnscript)
            }
        }
    })
], $586318af2774bb36$export$5b43fbdbc8a48e5d);

});
parcelRegister("7ebxM", function(module, exports) {

$parcel$export(module.exports, "linkStyle", function () { return $405fe252079d1563$export$a4c1071d1005664f; });
$parcel$export(module.exports, "linkScript", function () { return $405fe252079d1563$export$da8442aa37a450aa; });
$parcel$export(module.exports, "linkUnscript", function () { return $405fe252079d1563$export$d0fdcd0e1722c164; });
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
parcelRequire("bsGWa");
var $4fw8W = parcelRequire("4fw8W");
const $405fe252079d1563$export$a4c1071d1005664f = (0, $cZ4os.css)`
  :host {
    --link-color: var(--color-primary);
    --link-font-size: var(--size-text);
    --link-font: var(--font-body);
    --link-weight: normal;
    --link-transform: none;
    --link-disabled-color: var(--color-medium);
    --link-disabled-opacity: 0.5;
  }

  :host {
    display: inline;
  }

  /*
   * Root
   */

  a {
    position: relative;
    text-decoration: none;
    font-family: var(--link-font);
    color: var(--link-color);
    font-size: var(--link-font-size);
    font-weight: var(--link-weight);
    text-transform: var(--link-transform);
  }

  a:hover,
  a:focus,
  a:active {
    text-decoration: underline;
  }

  a[target='_blank'] {
    cursor: alias;
  }

  /*
   * [?italic]
   */

  .italic {
    font-style: italic;
  }

  /*
   * [?underline]
   */

  .underline {
    text-decoration: underline;
  }

  /*
   * [color]
   */

  ${(0, $4fw8W.generateColorVaries)(({ name: name, color: color })=>`
    .${(0, $4fw8W.VaryGroups).Color}-${name} {
      --link-color: ${color};
    }
  `)}

  ${(0, $4fw8W.generateGradientVaries)(({ name: name, gradient: gradient })=>`
    .${(0, $4fw8W.VaryGroups).Color}-${name} {
      position: relative;
      background: ${gradient};
      -webkit-background-clip: text;
	    -webkit-text-fill-color: transparent;
    }

    .${(0, $4fw8W.VaryGroups).Color}-${name}::after {
      --underline-height: calc(var(--link-font-size) / 13);
      visibility: hidden;
      content: '';
      position: absolute;
      left: 0;
      bottom: var(--underline-height);
      width: 100%;
      height: var(--underline-height);
      background: ${gradient};
    }

    .${(0, $4fw8W.VaryGroups).Color}-${name}:hover::after,
    .${(0, $4fw8W.VaryGroups).Color}-${name}.underline::after {
      visibility: visible;
    }
  `)}

  /*
   * [font]
   */

  ${(0, $4fw8W.generateFontTypeVaries)(({ fullName: fullName, type: type })=>`
    .${fullName} {
      --link-font: ${type} !important;
    }
  `)}

  /*
   * [fontSize]
   */

  ${(0, $4fw8W.generateFontSizeVaries)(({ fullName: fullName, size: size })=>`
    .${fullName} {
      --link-font-size: ${size};
    }
  `)}

  /*
   * [weight]
   */

  ${(0, $4fw8W.generateFontWeightVaries)(({ fullName: fullName, weight: weight })=>`
    .${fullName} {
      --link-weight: ${weight};
    }
  `)}

  /*
   * [transform]
   */

  ${(0, $4fw8W.generateTextTransformVaries)(({ fullName: fullName, transform: transform })=>`
    .${fullName} {
      --link-transform: ${transform};
    }
  `)}
`;
const $405fe252079d1563$export$da8442aa37a450aa = undefined;
const $405fe252079d1563$export$d0fdcd0e1722c164 = undefined;

});

parcelRegister("lgkY5", function(module, exports) {
$parcel$export(module.exports, "ifDefined", function () { return (parcelRequire("bc9s1")).ifDefined; });
parcelRequire("bc9s1");

});
parcelRegister("bc9s1", function(module, exports) {

$parcel$export(module.exports, "ifDefined", function () { return $8268257b54c9c91b$export$f68dd208b5df064d; });

var $fXA0k = parcelRequire("fXA0k");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8268257b54c9c91b$export$f68dd208b5df064d = (o)=>o ?? (0, $fXA0k.nothing);

});




var $4tSb9 = parcelRequire("4tSb9");
parcelRequire("1mUAS");
var $aHFKf = parcelRequire("aHFKf");
parcelRequire("lYoPT");
var $fXA0k = parcelRequire("fXA0k");
parcelRequire("1mUAS");
var $2qQ1O = parcelRequire("2qQ1O");
parcelRequire("1mUAS");
var $crJS3 = parcelRequire("crJS3");
const $354048ce36008732$export$38c6526d67de94bb = "router";
const $354048ce36008732$export$59dbefa3c1eecdf = `tini:${$354048ce36008732$export$38c6526d67de94bb}`;
const $354048ce36008732$export$7e97b96280519fd9 = (0, $crJS3.GLOBAL_TINI);
const $354048ce36008732$export$3bdf553b2225e8f = (0, $crJS3.TINI_APP_CONTEXT);
const $354048ce36008732$export$173cf5cb5df19fba = `${$354048ce36008732$export$59dbefa3c1eecdf}:change`;
const $354048ce36008732$export$1282c104aa99390b = "router-outlet";
const $354048ce36008732$export$7dba428509c3d64 = "nav-indicator";
const $354048ce36008732$export$f271c0c638fec546 = `app-${$354048ce36008732$export$7dba428509c3d64}`;
const $354048ce36008732$export$72d36ecf3758cb4b = "active";
const $354048ce36008732$export$e07048abb320d9b7 = "Router is not initialized.";
const $354048ce36008732$export$8b070917f63980dc = "Router instance is not provided.";


function $1615f96b4390ee57$export$3b1eb3bad78dcdd4() {
    if (!(0, $354048ce36008732$export$3bdf553b2225e8f).router) throw new Error((0, $354048ce36008732$export$e07048abb320d9b7));
    return (0, $354048ce36008732$export$3bdf553b2225e8f).router;
}
function $1615f96b4390ee57$export$e7a685f330e7752() {
    return $1615f96b4390ee57$export$3b1eb3bad78dcdd4().getActiveRoute();
}
function $1615f96b4390ee57$export$ec161d740909e39d() {
    return $1615f96b4390ee57$export$3b1eb3bad78dcdd4().getParams();
}
function $1615f96b4390ee57$export$ab98794553b8ffcc() {
    return dispatchEvent(new PopStateEvent("popstate"));
}
function $1615f96b4390ee57$export$93bb224d05b3906d(to, replace) {
    const url = new URL(to, location.origin);
    if (url.href === location.href) return;
    history[!replace ? "pushState" : "replaceState"]({}, "", url.href);
    return $1615f96b4390ee57$export$ab98794553b8ffcc();
}
function $1615f96b4390ee57$export$89e12c5b50f7529d(to) {
    return $1615f96b4390ee57$export$93bb224d05b3906d(to, true);
}
function $1615f96b4390ee57$export$7c341cb16fc91138() {
    history.back();
    return $1615f96b4390ee57$export$ab98794553b8ffcc();
}
function $1615f96b4390ee57$export$174bb771924e7eb1() {
    history.forward();
    return $1615f96b4390ee57$export$ab98794553b8ffcc();
}
function $1615f96b4390ee57$export$e989005f3236894() {
    if (!(0, $354048ce36008732$export$7e97b96280519fd9).app) return null;
    const root = (0, $354048ce36008732$export$7e97b96280519fd9).app.renderRoot;
    return root.querySelector((0, $354048ce36008732$export$f271c0c638fec546)) || root.querySelector(`#${(0, $354048ce36008732$export$7dba428509c3d64)}`);
}
function $1615f96b4390ee57$export$f57678c27aa854d7() {
    const node = $1615f96b4390ee57$export$e989005f3236894();
    if (!node) return;
    if (node.show instanceof Function) node.show();
    else node.classList.add((0, $354048ce36008732$export$72d36ecf3758cb4b));
}
function $1615f96b4390ee57$export$cd837d1c635fe677() {
    const node = $1615f96b4390ee57$export$e989005f3236894();
    if (!node) return;
    if (node.hide instanceof Function) node.hide();
    else node.classList.remove((0, $354048ce36008732$export$72d36ecf3758cb4b));
}


function $64ac97a6c73296e1$export$b9d62ff3f19afa30() {
    return function(prototype, propertyName) {
        Object.defineProperty(prototype, propertyName, {
            get: ()=>(0, $1615f96b4390ee57$export$3b1eb3bad78dcdd4)()
        });
    };
}
function $64ac97a6c73296e1$export$2c1541ba392a1f2b() {
    return function(prototype, propertyName) {
        Object.defineProperty(prototype, propertyName, {
            get: ()=>(0, $1615f96b4390ee57$export$e7a685f330e7752)()
        });
    };
}
function $64ac97a6c73296e1$export$9bd8e6e52e7b68fa() {
    return function(prototype, propertyName) {
        Object.defineProperty(prototype, propertyName, {
            get: ()=>(0, $1615f96b4390ee57$export$ec161d740909e39d)()
        });
    };
}
function $64ac97a6c73296e1$export$f21456dda1f432e5() {
    return function(prototype, propertyName) {
        Object.defineProperty(prototype, propertyName, {
            get: ()=>(0, $1615f96b4390ee57$export$e989005f3236894)()
        });
    };
}






/**
 * Tokenize input string.
 */ function $602a88b18bfeeda0$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError('Pattern cannot start with "?" at '.concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $602a88b18bfeeda0$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $602a88b18bfeeda0$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^".concat($602a88b18bfeeda0$var$escapeString(options.delimiter || "/#?"), "]+?");
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $602a88b18bfeeda0$export$ef7acd7185315e22(str, options) {
    return $602a88b18bfeeda0$export$5b9bad9e403cf3d9($602a88b18bfeeda0$export$98e6a39c04603d36(str, options), options);
}
function $602a88b18bfeeda0$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $602a88b18bfeeda0$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError('Expected "'.concat(token.name, '" to not repeat, but got an array'));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError('Expected "'.concat(token.name, '" to not be empty'));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError('Expected all "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError('Expected "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError('Expected "'.concat(token.name, '" to be ').concat(typeOfMessage));
        }
        return path;
    };
}
function $602a88b18bfeeda0$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $602a88b18bfeeda0$export$71304158c7e35877(str, keys, options);
    return $602a88b18bfeeda0$export$968e97c88708237a(re, keys, options);
}
function $602a88b18bfeeda0$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $602a88b18bfeeda0$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $602a88b18bfeeda0$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $602a88b18bfeeda0$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $602a88b18bfeeda0$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $602a88b18bfeeda0$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $602a88b18bfeeda0$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $602a88b18bfeeda0$var$stringToRegexp(path, keys, options) {
    return $602a88b18bfeeda0$export$9a9303716def6456($602a88b18bfeeda0$export$98e6a39c04603d36(path, options), keys, options);
}
function $602a88b18bfeeda0$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($602a88b18bfeeda0$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($602a88b18bfeeda0$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $602a88b18bfeeda0$var$escapeString(encode(token));
        else {
            var prefix = $602a88b18bfeeda0$var$escapeString(encode(token.prefix));
            var suffix = $602a88b18bfeeda0$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else if (token.modifier === "+" || token.modifier === "*") route += "((?:".concat(token.pattern, ")").concat(token.modifier, ")");
                else route += "(".concat(token.pattern, ")").concat(token.modifier);
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $602a88b18bfeeda0$var$flags(options));
}
function $602a88b18bfeeda0$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $602a88b18bfeeda0$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $602a88b18bfeeda0$var$arrayToRegexp(path, keys, options);
    return $602a88b18bfeeda0$var$stringToRegexp(path, keys, options);
}




parcelRequire("lYoPT");
var $kXi80 = parcelRequire("kXi80");
parcelRequire("4MDiX");
var $asvDI = parcelRequire("asvDI");

var $81f82169db31e633$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class $81f82169db31e633$export$a900258fc195edab extends (0, $kXi80.LitElement) {
    connectedCallback() {
        super.connectedCallback();
        if (!this.router) throw new Error((0, $354048ce36008732$export$8b070917f63980dc));
        this.router.setCallback(this.handleRoute.bind(this));
        this.handleRoute(this.router.match(new URL(location.href)));
    }
    async handleRoute(activeRoute) {
        const { layoutRoute: layoutRoute, pageRoute: pageRoute } = activeRoute;
        // lazy load
        if (layoutRoute === null || layoutRoute === void 0 ? void 0 : layoutRoute.action) await layoutRoute.action();
        if (pageRoute === null || pageRoute === void 0 ? void 0 : pageRoute.action) await pageRoute.action();
        // render
        const layoutTagName = layoutRoute === null || layoutRoute === void 0 ? void 0 : layoutRoute.component;
        const pageTagName = pageRoute === null || pageRoute === void 0 ? void 0 : pageRoute.component;
        if (layoutTagName === this.currentLayout && pageTagName === this.currentPage) return;
        if (layoutTagName === this.currentLayout) return this.renderPage(activeRoute, pageTagName);
        return this.renderFull(activeRoute, pageTagName, layoutTagName);
    }
    async renderPage(activeRoute, pageTagName) {
        this.currentPage = pageTagName;
        const rootEl = !this.currentLayout ? this.renderRoot : this.renderRoot.querySelector(this.currentLayout) || this.renderRoot;
        if (!pageTagName || !rootEl) return;
        return this.renderer(activeRoute, rootEl, pageTagName);
    }
    async renderFull(activeRoute, pageTagName, layoutTagName) {
        this.currentLayout = layoutTagName;
        this.currentPage = pageTagName;
        let rootEl = this.renderRoot;
        if (!pageTagName || !rootEl) return;
        // layout
        if (layoutTagName) {
            const layoutEl = await this.renderer(activeRoute, rootEl, layoutTagName);
            if (layoutEl) rootEl = layoutEl;
        }
        // page
        return this.renderer(activeRoute, rootEl, pageTagName);
    }
    async renderer(activeRoute, rootEl, newTagName) {
        const currentEl = rootEl.firstElementChild;
        const newEl = document.createElement(newTagName);
        // hooks
        const currentBeforeLeave = currentEl === null || currentEl === void 0 ? void 0 : currentEl.onBeforeLeave;
        const currentAfterLeave = currentEl === null || currentEl === void 0 ? void 0 : currentEl.onAfterLeave;
        const newBeforeEnter = newEl === null || newEl === void 0 ? void 0 : newEl.onBeforeEnter;
        const newAfterEnter = newEl === null || newEl === void 0 ? void 0 : newEl.onAfterEnter;
        // stage 1
        if (await this.runBeforeHook(currentBeforeLeave, activeRoute, newEl, currentEl)) return;
        if (await this.runBeforeHook(newBeforeEnter, activeRoute, newEl, currentEl)) return;
        // main action
        rootEl.replaceChildren(newEl);
        // stage 2
        await this.runAfterHook(newAfterEnter, activeRoute, newEl, currentEl);
        await this.runAfterHook(currentAfterLeave, activeRoute, newEl, currentEl);
        // continue
        return newEl;
    }
    async runBeforeHook(hook, activeRoute, newEl, currentEl) {
        const hookCommand = !hook ? undefined : await hook(this.router, activeRoute, newEl, currentEl);
        if (!hookCommand) return false;
        if (typeof hookCommand === "string") this.router.redirect(hookCommand);
        else hookCommand();
        return true;
    }
    async runAfterHook(hook, activeRoute, newEl, currentEl) {
        if (hook) await hook(this.router, activeRoute, newEl, currentEl);
        return false;
    }
}
$81f82169db31e633$var$__decorate([
    (0, $asvDI.property)({
        type: Object
    })
], $81f82169db31e633$export$a900258fc195edab.prototype, "router", void 0);


class $40d1dc783c35032f$export$55185c17a0fcbe46 {
    constructor(routes, options = {}){
        this.routes = routes;
        this.options = options;
        this.NOT_FOUND_PATH = "/**";
        this.cache = new Map();
        this.indicatorSchedule = null;
        this.registry = this.buildRegistry(routes);
    }
    init() {
        this.registerOutlet();
        this.registerTriggers();
        return this;
    }
    setCallback(cb) {
        this.callback = cb;
        return this;
    }
    setState(key, state) {
        sessionStorage.setItem(`${(0, $354048ce36008732$export$59dbefa3c1eecdf)}:state-${key}`, state);
        return this;
    }
    getState(key) {
        return sessionStorage.getItem(`${(0, $354048ce36008732$export$59dbefa3c1eecdf)}:state-${key}`);
    }
    go(to, replace) {
        return (0, $1615f96b4390ee57$export$93bb224d05b3906d)(to, replace);
    }
    redirect(to) {
        return (0, $1615f96b4390ee57$export$89e12c5b50f7529d)(to);
    }
    back() {
        return (0, $1615f96b4390ee57$export$7c341cb16fc91138)();
    }
    forward() {
        return (0, $1615f96b4390ee57$export$174bb771924e7eb1)();
    }
    requestChange() {
        return (0, $1615f96b4390ee57$export$ab98794553b8ffcc)();
    }
    getActiveRoute() {
        return this.match(new URL(location.href));
    }
    getParams() {
        var _a;
        return (_a = this.getActiveRoute()) === null || _a === void 0 ? void 0 : _a.params;
    }
    match(url) {
        const path = url.pathname;
        /*
         * 1. check cache
         */ const cachedResult = this.cache.get(path);
        if (cachedResult) return cachedResult;
        /*
         * 2. check routes
         */ const pathSegments = path.split("/");
        let matched;
        let matchedRoutePath;
        let matchedExecResult = null;
        // root
        if (!pathSegments[1] && this.registry["/"]) matched = this.registry["/"];
        else if (this.registry[path]) matched = this.registry[path];
        else for(const routePath in this.registry){
            const route = this.registry[routePath];
            const execResult = !route.regexp ? null : route.regexp.exec(path);
            if (execResult) {
                matched = route;
                matchedRoutePath = routePath;
                matchedExecResult = execResult;
                break;
            }
        }
        // 404
        if (!matched) {
            const notFoundPath = (!pathSegments[1] ? "/" : `/${pathSegments[1]}/`) + this.NOT_FOUND_PATH.replace(/^\//, "");
            matched = this.registry[notFoundPath] || this.registry[this.NOT_FOUND_PATH];
        }
        /*
         * 3. result
         */ const { regexp: regexp, keys: keys, params: params } = !matchedRoutePath || !matchedExecResult ? {} : this.extractParams(matchedRoutePath, matchedExecResult);
        const result = {
            url: url,
            path: path,
            routePath: matchedRoutePath,
            regexp: regexp,
            keys: keys,
            params: params,
            layoutRoute: matched === null || matched === void 0 ? void 0 : matched.layout,
            pageRoute: matched === null || matched === void 0 ? void 0 : matched.page
        };
        if (matched) this.cache.set(path, result);
        return result;
    }
    extractParams(routePath, execResult) {
        const keys = [];
        const regexp = (0, $602a88b18bfeeda0$export$71304158c7e35877)(routePath, keys);
        // extract params
        const params = {};
        for(let i = 1; i < execResult.length; i++){
            const key = keys[i - 1];
            const prop = key.name;
            const value = execResult[i];
            if (value !== undefined || !Object.hasOwnProperty.call(params, prop)) {
                if (key.modifier === "+" || key.modifier === "*") params[prop] = value ? value.split(/[/?#]/).map((item)=>this.decodeParam(item)) : [];
                else params[prop] = value ? this.decodeParam(value) : value;
            }
        }
        // result
        return {
            regexp: regexp,
            keys: keys,
            params: params
        };
    }
    registerOutlet() {
        if (customElements.get((0, $354048ce36008732$export$1282c104aa99390b))) return;
        customElements.define((0, $354048ce36008732$export$1282c104aa99390b), (0, $81f82169db31e633$export$a900258fc195edab));
    }
    registerTriggers() {
        // link trigger
        if (this.options.linkTrigger) addEventListener("click", (e)=>{
            var _a, _b, _c, _d;
            const { origin: locationOrigin, pathname: locationPathname, href: locationHref } = location;
            // pre-check
            if (e.defaultPrevented || // the default action is prevented
            e.button !== 0 || // not with the primary mouse button
            // a modifier key is pressed
            e.shiftKey || e.ctrlKey || e.altKey || e.metaKey) return;
            // process anchor
            let anchor = null;
            const paths = !e.composedPath ? e.path || [] : e.composedPath();
            for(let i = 0; i < paths.length; i++)if (((_b = (_a = paths[i]) === null || _a === void 0 ? void 0 : _a.tagName) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === "a") {
                anchor = paths[i];
                break;
            }
            // validation
            const testTarget = ((_c = anchor === null || anchor === void 0 ? void 0 : anchor.target) === null || _c === void 0 ? void 0 : _c.toLowerCase()) || "";
            const testHref = ((_d = anchor === null || anchor === void 0 ? void 0 : anchor.href) === null || _d === void 0 ? void 0 : _d.toLowerCase()) || "";
            if (!anchor || // no anchor
            testTarget && testTarget !== "_self" || // has target
            /^javascript:(void\(0\);?)|;$/.test(testHref) || // js void
            testHref.startsWith("mailto:") || // mailto protocol
            testHref.startsWith("tel:") || // tel protocol
            anchor.hasAttribute("download") || // has download
            anchor.hasAttribute("router-ignore") || // has router-ignore
            anchor.pathname === locationPathname && anchor.hash !== "" || // a fragment on the current page
            (anchor.origin || this.getAnchorOrigin(anchor)) !== locationOrigin // cross origin
            ) return;
            // do navigation
            if (anchor.href !== locationHref) {
                const url = new URL(anchor.href);
                history.pushState({}, "", url.href);
                this.onRouteChanges(url);
            }
            e.preventDefault();
            scrollTo(0, 0);
        });
        // popstate trigger
        addEventListener("popstate", (e)=>{
            this.onRouteChanges(new URL(location.href));
            e.preventDefault();
        });
    }
    onRouteChanges(url) {
        const detail = this.match(url);
        if (this.callback) this.callback(detail);
        return dispatchEvent(new CustomEvent((0, $354048ce36008732$export$173cf5cb5df19fba), {
            detail: detail
        }));
    }
    getAnchorOrigin(anchor) {
        const port = anchor.port;
        const protocol = anchor.protocol;
        const defaultHttp = protocol === "http:" && port === "80";
        const defaultHttps = protocol === "https:" && port === "443";
        const host = defaultHttp || defaultHttps ? anchor.hostname // without port
         : anchor.host; // with port
        return `${protocol}//${host}`;
    }
    decodeParam(val) {
        try {
            return decodeURIComponent(val);
        } catch (err) {
            return val;
        }
    }
    buildRegistry(routes) {
        const processPath = (path)=>path.replace(/^\/|\/$/g, "");
        const is404Path = (id)=>id.substring(id.length - 3, id.length) === this.NOT_FOUND_PATH;
        return routes.reduce((result, route)=>{
            var _a;
            if (!((_a = route.children) === null || _a === void 0 ? void 0 : _a.length)) {
                const id = `/${processPath(route.path)}`;
                result[id] = {
                    regexp: is404Path(id) ? undefined : (0, $602a88b18bfeeda0$export$71304158c7e35877)(id),
                    page: route
                };
            } else route.children.forEach((child)=>{
                let id = (!route.path ? "" : `/${processPath(route.path)}`) + (!child.path ? "" : `/${processPath(child.path)}`);
                id || (id = "/");
                result[id] = {
                    regexp: is404Path(id) ? undefined : (0, $602a88b18bfeeda0$export$71304158c7e35877)(id),
                    page: child,
                    layout: route
                };
            });
            return result;
        }, {});
    }
}


/* eslint-disable @typescript-eslint/no-explicit-any */ parcelRequire("1mUAS");
var $crJS3 = parcelRequire("crJS3");
var $3bQrU = parcelRequire("3bQrU");



function $3f5fa8c9d192f0ac$export$baddd0131ee8c05b(routes, options = {}) {
    var _a;
    const router = new (0, $40d1dc783c35032f$export$55185c17a0fcbe46)(routes, options).init();
    // handle nav indicator
    if ((_a = (0, $354048ce36008732$export$3bdf553b2225e8f).options) === null || _a === void 0 ? void 0 : _a.navIndicator) {
        router.indicatorSchedule = null;
        // exit
        (0, $3bQrU.registerGlobalHook)((0, $crJS3.ComponentTypes).Page, (0, $crJS3.LifecycleHooks).OnChildrenReady, ()=>{
            if (router.indicatorSchedule === null) return;
            (0, $1615f96b4390ee57$export$cd837d1c635fe677)();
            // cancel schedule (if scheduled)
            clearTimeout(router.indicatorSchedule);
            router.indicatorSchedule = null;
        });
        // entry
        addEventListener((0, $354048ce36008732$export$173cf5cb5df19fba), (e)=>{
            const { url: url } = e.detail;
            if (url.pathname === location.pathname) return;
            router.indicatorSchedule = setTimeout(()=>(0, $1615f96b4390ee57$export$f57678c27aa854d7)(), 500);
        });
    }
    // result
    return (0, $354048ce36008732$export$3bdf553b2225e8f).router = router;
}





var $eoQhH = parcelRequire("eoQhH");
parcelRequire("bsGWa");
var $gKqnD = parcelRequire("gKqnD");

var $eoQhH = parcelRequire("eoQhH");

var $laxZI = parcelRequire("laxZI");
function $40c9d023f846e0bc$var$getKey() {
    return `TiniApp:${(0, $eoQhH.Configurable).getOption("appId")}:theme`;
}
function $40c9d023f846e0bc$var$commitTheme(soulId, skinId) {
    (0, $laxZI.mainStore).commit("activeSoulId", soulId);
    (0, $laxZI.mainStore).commit("activeSkinId", skinId);
    return (0, $gKqnD.setTheme)({
        soulId: soulId,
        skinId: skinId
    });
}
function $40c9d023f846e0bc$export$4c47704ed26c13e8() {
    let themeId = localStorage.getItem($40c9d023f846e0bc$var$getKey());
    if (!themeId) {
        const defaultSoul = (0, $eoQhH.Configurable).getOption("soulList")[0];
        const defaultSkin = defaultSoul.skins[0];
        themeId = `${defaultSoul.id}/${defaultSkin.id}`;
    }
    const [soul, skin] = themeId.split("/");
    return $40c9d023f846e0bc$var$commitTheme(soul, skin);
}
function $40c9d023f846e0bc$export$e6eb54368342cb84(themeId) {
    const [soul, skin] = themeId.split("/");
    localStorage.setItem($40c9d023f846e0bc$var$getKey(), themeId);
    return $40c9d023f846e0bc$var$commitTheme(soul, skin);
}



var $4tSb9 = parcelRequire("4tSb9");
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $fXA0k = parcelRequire("fXA0k");
parcelRequire("1mUAS");
var $aHFKf = parcelRequire("aHFKf");
var $3bQrU = parcelRequire("3bQrU");
var $2qQ1O = parcelRequire("2qQ1O");

var $eD4R9 = parcelRequire("eD4R9");

var $4tSb9 = parcelRequire("4tSb9");
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $fXA0k = parcelRequire("fXA0k");
parcelRequire("3IANd");
var $ogP7Y = parcelRequire("ogP7Y");
parcelRequire("1mUAS");
var $aHFKf = parcelRequire("aHFKf");
var $2qQ1O = parcelRequire("2qQ1O");
var $3bQrU = parcelRequire("3bQrU");
parcelRequire("pLkRZ");
var $9xVr6 = parcelRequire("9xVr6");

var $eD4R9 = parcelRequire("eD4R9");

var $6uvK4 = parcelRequire("6uvK4");
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $fXA0k = parcelRequire("fXA0k");
parcelRequire("4MDiX");
var $asvDI = parcelRequire("asvDI");
parcelRequire("3IANd");
var $ogP7Y = parcelRequire("ogP7Y");
parcelRequire("bsGWa");
var $4fw8W = parcelRequire("4fw8W");
var $aynjv = parcelRequire("aynjv");
var $8Zp5V = parcelRequire("8Zp5V");
var $017c8f393c20ff5d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class $017c8f393c20ff5d$export$e5fbeffb5d035129 extends (0, $8Zp5V.TiniElement) {
    static #_ = this.defaultTagName = "icon-palette";
    static #_1 = this.componentName = "icon";
    static #_2 = this.styles = (0, $cZ4os.css)`:host{--icon-width:var(--scale-md-2x);--icon-height:var(--scale-md-2x);--icon-scheme:none;--icon-image:url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9ImN1cnJlbnRDb2xvciIgY2xhc3M9ImJpIGJpLXBhbGV0dGUiIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTTggNWExLjUgMS41IDAgMSAwIDAtMyAxLjUgMS41IDAgMCAwIDAgM200IDNhMS41IDEuNSAwIDEgMCAwLTMgMS41IDEuNSAwIDAgMCAwIDNNNS41IDdhMS41IDEuNSAwIDEgMS0zIDAgMS41IDEuNSAwIDAgMSAzIDBtLjUgNmExLjUgMS41IDAgMSAwIDAtMyAxLjUgMS41IDAgMCAwIDAgMyIvPjxwYXRoIGQ9Ik0xNiA4YzAgMy4xNS0xLjg2NiAyLjU4NS0zLjU2NyAyLjA3QzExLjQyIDkuNzYzIDEwLjQ2NSA5LjQ3MyAxMCAxMGMtLjYwMy42ODMtLjQ3NSAxLjgxOS0uMzUxIDIuOTJDOS44MjYgMTQuNDk1IDkuOTk2IDE2IDggMTZhOCA4IDAgMSAxIDgtOG0tOCA3Yy42MTEgMCAuNjU0LS4xNzEuNjU1LS4xNzYuMDc4LS4xNDYuMTI0LS40NjQuMDctMS4xMTktLjAxNC0uMTY4LS4wMzctLjM3LS4wNjEtLjU5MS0uMDUyLS40NjQtLjExMi0xLjAwNS0uMTE4LTEuNDYyLS4wMS0uNzA3LjA4My0xLjYxLjcwNC0yLjMxNC4zNjktLjQxNy44NDUtLjU3OCAxLjI3Mi0uNjE4LjQwNC0uMDM4LjgxMi4wMjYgMS4xNi4xMDQuMzQzLjA3Ny43MDIuMTg2IDEuMDI1LjI4NGwuMDI4LjAwOGMuMzQ2LjEwNS42NTguMTk5Ljk1My4yNjYuNjUzLjE0OC45MDQuMDgzLjk5MS4wMjRDMTQuNzE3IDkuMzggMTUgOS4xNjEgMTUgOGE3IDcgMCAxIDAtNyA3Ii8+PC9zdmc+');display:inline-block}i{display:flex;align-items:center;justify-content:center;background-image:var(--icon-image);background-repeat:no-repeat;background-size:contain;background-position:center;width:var(--icon-width);height:var(--icon-height)}.scheme{background:var(--icon-scheme);-webkit-mask-image:var(--icon-image);-webkit-mask-size:var(--icon-width) var(--icon-height);-webkit-mask-repeat:no-repeat;-webkit-mask-position:center;mask-image:var(--icon-image);mask-size:var(--icon-width) var(--icon-height);mask-repeat:no-repeat;mask-position:center}${(0, $4fw8W.generateColorVaries)(({ fullName: fullName, color: color })=>`.${fullName} {--icon-scheme: ${color};}`)}${(0, $4fw8W.generateGradientVaries)(({ fullName: fullName, gradient: gradient })=>`.${fullName} {--icon-scheme: ${gradient};}`)}${(0, $4fw8W.generateScaleVaries)(({ name: name, fullName: fullName })=>`.${fullName} {--icon-width: var(--scale-${name}-2x);--icon-height: var(--scale-${name}-2x);}`)}`;
    willUpdate() {
        this.extendRootClasses({
            raw: {
                scheme: !!this.scheme
            },
            overridable: {
                [(0, $4fw8W.VaryGroups).Scale]: this.scale,
                [(0, $4fw8W.VaryGroups).Scheme]: this.scheme
            }
        });
    }
    render() {
        return (0, $fXA0k.html)`<i class=${(0, $ogP7Y.classMap)(this.rootClasses)} part=${(0, $aynjv.partAttrMap)(this.rootClasses)}></i>`;
    }
}
$017c8f393c20ff5d$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $017c8f393c20ff5d$export$e5fbeffb5d035129.prototype, "scale", void 0);
$017c8f393c20ff5d$var$__decorate([
    (0, $asvDI.property)({
        type: String,
        reflect: true
    })
], $017c8f393c20ff5d$export$e5fbeffb5d035129.prototype, "scheme", void 0); //# sourceMappingURL=palette.js.map



var $eoQhH = parcelRequire("eoQhH");


var $laxZI = parcelRequire("laxZI");

var $4tSb9 = parcelRequire("4tSb9");
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $fXA0k = parcelRequire("fXA0k");
parcelRequire("4MDiX");
var $jcHRM = parcelRequire("jcHRM");
parcelRequire("9aegR");
var $tysjU = parcelRequire("tysjU");
parcelRequire("2xFp3");
var $aShgn = parcelRequire("aShgn");
parcelRequire("1mUAS");
var $aHFKf = parcelRequire("aHFKf");
var $2qQ1O = parcelRequire("2qQ1O");
var $3bQrU = parcelRequire("3bQrU");

var $8108p = parcelRequire("8108p");

var $eD4R9 = parcelRequire("eD4R9");

var $72ISR = parcelRequire("72ISR");

var $10mzZ = parcelRequire("10mzZ");

var $c5j4u = parcelRequire("c5j4u");

var $4tSb9 = parcelRequire("4tSb9");
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $fXA0k = parcelRequire("fXA0k");
parcelRequire("3IANd");
var $ogP7Y = parcelRequire("ogP7Y");
parcelRequire("6EpNK");
var $6MkYW = parcelRequire("6MkYW");
parcelRequire("2xFp3");
var $aShgn = parcelRequire("aShgn");
parcelRequire("1mUAS");
var $aHFKf = parcelRequire("aHFKf");
var $2qQ1O = parcelRequire("2qQ1O");
var $ecjBI = parcelRequire("ecjBI");
var $3bQrU = parcelRequire("3bQrU");
var $867696357e724f83$exports = {};
/*! grapick - 0.1.13 */ !function(e, t) {
    $867696357e724f83$exports = t();
}("undefined" != typeof self ? self : $867696357e724f83$exports, function() {
    return function(e) {
        function t(i) {
            if (n[i]) return n[i].exports;
            var r = n[i] = {
                i: i,
                l: !1,
                exports: {}
            };
            return e[i].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
        }
        var n = {};
        return t.m = e, t.c = n, t.d = function(e, n, i) {
            t.o(e, n) || Object.defineProperty(e, n, {
                configurable: !1,
                enumerable: !0,
                get: i
            });
        }, t.n = function(e) {
            var n = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(n, "a", n), n;
        }, t.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, t.p = "", t(t.s = 1);
    }([
        function(e, t, n) {
            "use strict";
            function i(e, t, n) {
                t = t.split(/\s+/);
                for(var i = 0; i < t.length; ++i)e.addEventListener(t[i], n);
            }
            function r(e, t, n) {
                t = t.split(/\s+/);
                for(var i = 0; i < t.length; ++i)e.removeEventListener(t[i], n);
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.on = i, t.off = r;
            t.isFunction = function(e) {
                return "function" == typeof e;
            }, t.isDef = function(e) {
                return void 0 !== e;
            }, t.getPointerEvent = function(e) {
                return e.touches && e.touches[0] || e;
            };
        },
        function(e, t, n) {
            "use strict";
            var i = n(2), r = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }(i);
            e.exports = function(e) {
                return new r.default(e);
            };
        },
        function(e, t, n) {
            "use strict";
            function i(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            function r(e) {
                if (Array.isArray(e)) {
                    for(var t = 0, n = Array(e.length); t < e.length; t++)n[t] = e[t];
                    return n;
                }
                return Array.from(e);
            }
            function o(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function a(e, t) {
                if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t;
            }
            function l(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var u = function() {
                function e(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var i = t[n];
                        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
                    }
                }
                return function(t, n, i) {
                    return n && e(t.prototype, n), i && e(t, i), t;
                };
            }(), s = n(3), c = i(s), h = n(4), f = i(h), d = n(0), v = function(e, t) {
                return e.position - t.position;
            }, p = function(e) {
                return e + "-gradient(";
            }, g = function(e) {
                function t() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    o(this, t);
                    var n = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
                    e = Object.assign({}, e);
                    var i = {
                        pfx: "grp",
                        el: ".grp",
                        colorEl: "",
                        min: 0,
                        max: 100,
                        direction: "90deg",
                        type: "linear",
                        height: "30px",
                        width: "100%",
                        emptyColor: "#000",
                        onValuePos: function(e) {
                            return parseInt(e);
                        }
                    };
                    for(var r in i)r in e || (e[r] = i[r]);
                    var l = e.el;
                    if (!((l = "string" == typeof l ? document.querySelector(l) : l) instanceof HTMLElement)) throw "Element not found, given " + l;
                    return n.el = l, n.handlers = [], n.options = e, n.on("handler:color:change", function(e, t) {
                        return n.change(t);
                    }), n.on("handler:position:change", function(e, t) {
                        return n.change(t);
                    }), n.on("handler:remove", function(e) {
                        return n.change(1);
                    }), n.on("handler:add", function(e) {
                        return n.change(1);
                    }), n.render(), n;
                }
                return l(t, e), u(t, [
                    {
                        key: "destroy",
                        value: function() {
                            var e = this;
                            this.clear(), this.e = {}, [
                                "el",
                                "handlers",
                                "options",
                                "colorPicker"
                            ].forEach(function(t) {
                                return e[t] = 0;
                            }), [
                                "previewEl",
                                "wrapperEl",
                                "sandEl"
                            ].forEach(function(t) {
                                var n = e[t];
                                n && n.parentNode && n.parentNode.removeChild(n), delete e[t];
                            });
                        }
                    },
                    {
                        key: "setColorPicker",
                        value: function(e) {
                            this.colorPicker = e;
                        }
                    },
                    {
                        key: "getValue",
                        value: function(e, t) {
                            var n = this.getColorValue(), i = e || this.getType(), r = [
                                "top",
                                "left",
                                "bottom",
                                "right",
                                "center"
                            ], o = t || this.getDirection();
                            return [
                                "linear",
                                "repeating-linear"
                            ].indexOf(i) >= 0 && r.indexOf(o) >= 0 && (o = "center" === o ? "to right" : "to " + o), [
                                "radial",
                                "repeating-radial"
                            ].indexOf(i) >= 0 && r.indexOf(o) >= 0 && (o = "circle at " + o), n ? i + "-gradient(" + o + ", " + n + ")" : "";
                        }
                    },
                    {
                        key: "getSafeValue",
                        value: function(e, t) {
                            var n = this.previewEl, i = this.getValue(e, t);
                            if (!this.sandEl && (this.sandEl = document.createElement("div")), !n || !i) return "";
                            for(var o = this.sandEl.style, a = [
                                i
                            ].concat(r(this.getPrefixedValues(e, t))), l = void 0, u = 0; u < a.length && (l = a[u], o.backgroundImage = l, o.backgroundImage != l); u++);
                            return o.backgroundImage;
                        }
                    },
                    {
                        key: "setValue",
                        value: function() {
                            var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, i = this.type, r = this.direction, o = t.indexOf("(") + 1, a = t.lastIndexOf(")"), l = t.substring(o, a), u = l.split(/,(?![^(]*\)) /);
                            if (this.clear(n), !l) return void this.updatePreview();
                            u.length > 2 && (r = u.shift());
                            var s = void 0;
                            [
                                "repeating-linear",
                                "repeating-radial",
                                "linear",
                                "radial"
                            ].forEach(function(e) {
                                t.indexOf(p(e)) > -1 && !s && (s = 1, i = e);
                            }), this.setDirection(r, n), this.setType(i, n), u.forEach(function(t) {
                                var i = t.split(" "), r = parseFloat(i.pop()), o = i.join("");
                                e.addHandler(r, o, 0, n);
                            }), this.updatePreview();
                        }
                    },
                    {
                        key: "getColorValue",
                        value: function() {
                            var e = this.handlers;
                            return e.sort(v), e = 1 == e.length ? [
                                e[0],
                                e[0]
                            ] : e, e.map(function(e) {
                                return e.getValue();
                            }).join(", ");
                        }
                    },
                    {
                        key: "getPrefixedValues",
                        value: function(e, t) {
                            var n = this.getValue(e, t);
                            return [
                                "-moz-",
                                "-webkit-",
                                "-o-",
                                "-ms-"
                            ].map(function(e) {
                                return "" + e + n;
                            });
                        }
                    },
                    {
                        key: "change",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            this.updatePreview(), !t.silent && this.emit("change", e);
                        }
                    },
                    {
                        key: "setDirection",
                        value: function(e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            this.options.direction = e;
                            var n = t.complete, i = void 0 === n ? 1 : n;
                            this.change(i, t);
                        }
                    },
                    {
                        key: "getDirection",
                        value: function() {
                            return this.options.direction;
                        }
                    },
                    {
                        key: "setType",
                        value: function(e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            this.options.type = e;
                            var n = t.complete, i = void 0 === n ? 1 : n;
                            this.change(i, t);
                        }
                    },
                    {
                        key: "getType",
                        value: function() {
                            return this.options.type;
                        }
                    },
                    {
                        key: "addHandler",
                        value: function(e, t) {
                            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, r = new f.default(this, e, t, n, i);
                            return !i.silent && this.emit("handler:add", r), r;
                        }
                    },
                    {
                        key: "getHandler",
                        value: function(e) {
                            return this.handlers[e];
                        }
                    },
                    {
                        key: "getHandlers",
                        value: function() {
                            return this.handlers;
                        }
                    },
                    {
                        key: "clear",
                        value: function() {
                            for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = this.handlers, n = t.length - 1; n >= 0; n--)t[n].remove(e);
                        }
                    },
                    {
                        key: "getSelected",
                        value: function() {
                            for(var e = this.getHandlers(), t = 0; t < e.length; t++){
                                var n = e[t];
                                if (n.isSelected()) return n;
                            }
                            return null;
                        }
                    },
                    {
                        key: "updatePreview",
                        value: function() {
                            var e = this.previewEl;
                            e && (e.style.backgroundImage = this.getValue("linear", "to right"));
                        }
                    },
                    {
                        key: "initEvents",
                        value: function() {
                            var e = this, t = this.previewEl;
                            t && (0, d.on)(t, "click", function(n) {
                                var i = e.options, r = i.min, o = i.max, a = {
                                    w: t.clientWidth,
                                    h: t.clientHeight
                                }, l = n.offsetX - t.clientLeft, u = n.offsetY - t.clientTop, s = l / a.w * 100;
                                if (!(s > o || s < r || u > a.h || u < 0)) {
                                    var c = document.createElement("canvas"), h = c.getContext("2d");
                                    c.width = a.w, c.height = a.h;
                                    var f = h.createLinearGradient(0, 0, a.w, a.h);
                                    e.getHandlers().forEach(function(e) {
                                        return f.addColorStop(e.position / 100, e.color);
                                    }), h.fillStyle = f, h.fillRect(0, 0, c.width, c.height), c.style.background = "black";
                                    var d = c.getContext("2d").getImageData(l, u, 1, 1).data, v = "rgba(" + d[0] + ", " + d[1] + ", " + d[2] + ", " + d[3] + ")", p = "rgba(0, 0, 0, 0)" == v ? i.emptyColor : v;
                                    e.addHandler(s, p);
                                }
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this.options, t = this.el, n = e.pfx, i = e.height, r = e.width;
                            if (t) {
                                var o = n + "-wrapper", a = n + "-preview";
                                t.innerHTML = '\n      <div class="' + o + '">\n        <div class="' + a + '"></div>\n      </div>\n    ';
                                var l = t.querySelector("." + o), u = t.querySelector("." + a), s = l.style;
                                s.position = "relative", this.wrapperEl = l, this.previewEl = u, i && (s.height = i), r && (s.width = r), this.initEvents(), this.updatePreview();
                            }
                        }
                    }
                ]), t;
            }(c.default);
            t.default = g;
        },
        function(e, t, n) {
            "use strict";
            function i(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var r = function() {
                function e(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var i = t[n];
                        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
                    }
                }
                return function(t, n, i) {
                    return n && e(t.prototype, n), i && e(t, i), t;
                };
            }(), o = function() {
                function e() {
                    i(this, e);
                }
                return r(e, [
                    {
                        key: "on",
                        value: function(e, t, n) {
                            var i = this.e || (this.e = {});
                            return (i[e] || (i[e] = [])).push({
                                fn: t,
                                ctx: n
                            }), this;
                        }
                    },
                    {
                        key: "once",
                        value: function(e, t, n) {
                            function i() {
                                r.off(e, i), t.apply(n, arguments);
                            }
                            var r = this;
                            return i._ = t, this.on(e, i, n);
                        }
                    },
                    {
                        key: "emit",
                        value: function(e) {
                            var t = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[e] || []).slice(), i = 0, r = n.length;
                            for(i; i < r; i++)n[i].fn.apply(n[i].ctx, t);
                            return this;
                        }
                    },
                    {
                        key: "off",
                        value: function(e, t) {
                            var n = this.e || (this.e = {}), i = n[e], r = [];
                            if (i && t) for(var o = 0, a = i.length; o < a; o++)i[o].fn !== t && i[o].fn._ !== t && r.push(i[o]);
                            return r.length ? n[e] = r : delete n[e], this;
                        }
                    }
                ]), e;
            }();
            t.default = o;
        },
        function(e, t, n) {
            "use strict";
            function i(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var r = function() {
                function e(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var i = t[n];
                        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
                    }
                }
                return function(t, n, i) {
                    return n && e(t.prototype, n), i && e(t, i), t;
                };
            }(), o = n(0), a = function() {
                function e(t) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "black", o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1, a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
                    i(this, e), t.getHandlers().push(this), this.gp = t, this.position = n, this.color = r, this.selected = 0, this.render(), o && this.select(a);
                }
                return r(e, [
                    {
                        key: "toJSON",
                        value: function() {
                            return {
                                position: this.position,
                                selected: this.selected,
                                color: this.color
                            };
                        }
                    },
                    {
                        key: "setColor",
                        value: function(e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                            this.color = e, this.emit("handler:color:change", this, t);
                        }
                    },
                    {
                        key: "setPosition",
                        value: function(e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = this.getEl();
                            this.position = e, n && (n.style.left = e + "%"), this.emit("handler:position:change", this, t);
                        }
                    },
                    {
                        key: "getColor",
                        value: function() {
                            return this.color;
                        }
                    },
                    {
                        key: "getPosition",
                        value: function() {
                            var e = this.position, t = this.gp, n = t.options.onValuePos;
                            return (0, o.isFunction)(n) ? n(e) : e;
                        }
                    },
                    {
                        key: "isSelected",
                        value: function() {
                            return !!this.selected;
                        }
                    },
                    {
                        key: "getValue",
                        value: function() {
                            return this.getColor() + " " + this.getPosition() + "%";
                        }
                    },
                    {
                        key: "select",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = this.getEl(), n = this.gp.getHandlers();
                            !e.keepSelect && n.forEach(function(e) {
                                return e.deselect();
                            }), this.selected = 1;
                            var i = this.getSelectedCls();
                            t && (t.className += " " + i), this.emit("handler:select", this);
                        }
                    },
                    {
                        key: "deselect",
                        value: function() {
                            var e = this.getEl();
                            this.selected = 0;
                            var t = this.getSelectedCls();
                            e && (e.className = e.className.replace(t, "").trim()), this.emit("handler:deselect", this);
                        }
                    },
                    {
                        key: "getSelectedCls",
                        value: function() {
                            return this.gp.options.pfx + "-handler-selected";
                        }
                    },
                    {
                        key: "remove",
                        value: function() {
                            var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = this.cpFn, i = this.getEl(), r = this.gp.getHandlers(), a = r.splice(r.indexOf(this), 1)[0];
                            return i && i.parentNode.removeChild(i), !t.silent && this.emit("handler:remove", a), (0, o.isFunction)(n) && n(this), [
                                "el",
                                "gp"
                            ].forEach(function(t) {
                                return e[t] = 0;
                            }), a;
                        }
                    },
                    {
                        key: "getEl",
                        value: function() {
                            return this.el;
                        }
                    },
                    {
                        key: "initEvents",
                        value: function() {
                            var e = this, t = this.getEl(), n = this.gp.previewEl, i = this.gp.options, r = i.min, a = i.max, l = t.querySelector("[data-toggle=handler-close]"), u = t.querySelector("[data-toggle=handler-color-c]"), s = t.querySelector("[data-toggle=handler-color-wrap]"), c = t.querySelector("[data-toggle=handler-color]"), h = t.querySelector("[data-toggle=handler-drag]"), f = function(t) {
                                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, i = t.target.value;
                                e.setColor(i, n), s && (s.style.backgroundColor = i);
                            };
                            if (u && (0, o.on)(u, "click", function(e) {
                                return e.stopPropagation();
                            }), l && (0, o.on)(l, "click", function(t) {
                                t.stopPropagation(), e.remove();
                            }), c && ((0, o.on)(c, "change", f), (0, o.on)(c, "input", function(e) {
                                return f(e, 0);
                            })), h) {
                                var d = 0, v = 0, p = 0, g = {}, y = {}, m = {}, k = function(t) {
                                    var n = (0, o.getPointerEvent)(t);
                                    p = 1, m.x = n.clientX - y.x, m.y = n.clientY - y.y, d = 100 * m.x, d /= g.w, d = v + d, d = d < r ? r : d, d = d > a ? a : d, e.setPosition(d, 0), e.emit("handler:drag", e, d), (0, o.isDef)(t.button) && 0 === t.which && b(t);
                                }, b = function t(n) {
                                    (0, o.off)(document, "touchmove mousemove", k), (0, o.off)(document, "touchend mouseup", t), p && (p = 0, e.setPosition(d), e.emit("handler:drag:end", e, d));
                                }, w = function(t) {
                                    if (!(0, o.isDef)(t.button) || 0 === t.button) {
                                        e.select();
                                        var i = (0, o.getPointerEvent)(t);
                                        v = e.position, g.w = n.clientWidth, g.h = n.clientHeight, y.x = i.clientX, y.y = i.clientY, (0, o.on)(document, "touchmove mousemove", k), (0, o.on)(document, "touchend mouseup", b), e.emit("handler:drag:start", e);
                                    }
                                };
                                (0, o.on)(h, "touchstart mousedown", w), (0, o.on)(h, "click", function(e) {
                                    return e.stopPropagation();
                                });
                            }
                        }
                    },
                    {
                        key: "emit",
                        value: function() {
                            var e;
                            (e = this.gp).emit.apply(e, arguments);
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this.gp, t = e.options, n = e.previewEl, i = e.colorPicker, r = t.pfx, o = t.colorEl, a = this.getColor();
                            if (n) {
                                var l = document.createElement("div"), u = l.style, s = r + "-handler";
                                return l.className = s, l.innerHTML = '\n      <div class="' + s + '-close-c">\n        <div class="' + s + '-close" data-toggle="handler-close">&Cross;</div>\n      </div>\n      <div class="' + s + '-drag" data-toggle="handler-drag"></div>\n      <div class="' + s + '-cp-c" data-toggle="handler-color-c">\n        ' + (o || '\n          <div class="' + s + '-cp-wrap" data-toggle="handler-color-wrap" style="background-color: ' + a + '">\n            <input type="color" data-toggle="handler-color" value="' + a + '">\n          </div>') + "\n      </div>\n    ", u.position = "absolute", u.top = 0, u.left = this.position + "%", n.appendChild(l), this.el = l, this.initEvents(), this.cpFn = i && i(this), l;
                            }
                        }
                    }
                ]), e;
            }();
            t.default = a;
        }
    ]);
});



var $eD4R9 = parcelRequire("eD4R9");
// Copyright (c) 2014 Rafael Caricio. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.
var $87b9d64a64ded6fd$export$98e6a39c04603d36;
var $87b9d64a64ded6fd$export$fac44ee5b035f737;
var $87b9d64a64ded6fd$var$GradientParser = $87b9d64a64ded6fd$var$GradientParser || {};
$87b9d64a64ded6fd$var$GradientParser.stringify = function() {
    var visitor = {
        "visit_linear-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_repeating-linear-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_radial-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_repeating-radial-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_gradient": function(node) {
            var orientation = visitor.visit(node.orientation);
            if (orientation) orientation += ", ";
            return node.type + "(" + orientation + visitor.visit(node.colorStops) + ")";
        },
        "visit_shape": function(node) {
            var result = node.value, at = visitor.visit(node.at), style = visitor.visit(node.style);
            if (style) result += " " + style;
            if (at) result += " at " + at;
            return result;
        },
        "visit_default-radial": function(node) {
            var result = "", at = visitor.visit(node.at);
            if (at) result += at;
            return result;
        },
        "visit_extent-keyword": function(node) {
            var result = node.value, at = visitor.visit(node.at);
            if (at) result += " at " + at;
            return result;
        },
        "visit_position-keyword": function(node) {
            return node.value;
        },
        "visit_position": function(node) {
            return visitor.visit(node.value.x) + " " + visitor.visit(node.value.y);
        },
        "visit_%": function(node) {
            return node.value + "%";
        },
        "visit_em": function(node) {
            return node.value + "em";
        },
        "visit_px": function(node) {
            return node.value + "px";
        },
        "visit_literal": function(node) {
            return visitor.visit_color(node.value, node);
        },
        "visit_hex": function(node) {
            return visitor.visit_color("#" + node.value, node);
        },
        "visit_rgb": function(node) {
            return visitor.visit_color("rgb(" + node.value.join(", ") + ")", node);
        },
        "visit_rgba": function(node) {
            return visitor.visit_color("rgba(" + node.value.join(", ") + ")", node);
        },
        "visit_color": function(resultColor, node) {
            var result = resultColor, length = visitor.visit(node.length);
            if (length) result += " " + length;
            return result;
        },
        "visit_angular": function(node) {
            return node.value + "deg";
        },
        "visit_directional": function(node) {
            return "to " + node.value;
        },
        "visit_array": function(elements) {
            var result = "", size = elements.length;
            elements.forEach(function(element, i) {
                result += visitor.visit(element);
                if (i < size - 1) result += ", ";
            });
            return result;
        },
        "visit": function(element) {
            if (!element) return "";
            var result = "";
            if (element instanceof Array) return visitor.visit_array(element, result);
            else if (element.type) {
                var nodeVisitor = visitor["visit_" + element.type];
                if (nodeVisitor) return nodeVisitor(element);
                else throw Error("Missing visitor visit_" + element.type);
            } else throw Error("Invalid node.");
        }
    };
    return function(root) {
        return visitor.visit(root);
    };
}();
// Copyright (c) 2014 Rafael Caricio. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.
var $87b9d64a64ded6fd$var$GradientParser = $87b9d64a64ded6fd$var$GradientParser || {};
$87b9d64a64ded6fd$var$GradientParser.parse = function() {
    var tokens = {
        linearGradient: /^(\-(webkit|o|ms|moz)\-)?(linear\-gradient)/i,
        repeatingLinearGradient: /^(\-(webkit|o|ms|moz)\-)?(repeating\-linear\-gradient)/i,
        radialGradient: /^(\-(webkit|o|ms|moz)\-)?(radial\-gradient)/i,
        repeatingRadialGradient: /^(\-(webkit|o|ms|moz)\-)?(repeating\-radial\-gradient)/i,
        sideOrCorner: /^to (left (top|bottom)|right (top|bottom)|left|right|top|bottom)/i,
        extentKeywords: /^(closest\-side|closest\-corner|farthest\-side|farthest\-corner|contain|cover)/,
        positionKeywords: /^(left|center|right|top|bottom)/i,
        pixelValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))px/,
        percentageValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))\%/,
        emValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))em/,
        angleValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))deg/,
        startCall: /^\(/,
        endCall: /^\)/,
        comma: /^,/,
        hexColor: /^\#([0-9a-fA-F]+)/,
        literalColor: /^([a-zA-Z]+)/,
        rgbColor: /^rgb/i,
        rgbaColor: /^rgba/i,
        number: /^(([0-9]*\.[0-9]+)|([0-9]+\.?))/
    };
    var input = "";
    function error(msg) {
        var err = new Error(input + ": " + msg);
        err.source = input;
        throw err;
    }
    function getAST() {
        var ast = matchListDefinitions();
        if (input.length > 0) error("Invalid input not EOF");
        return ast;
    }
    function matchListDefinitions() {
        return matchListing(matchDefinition);
    }
    function matchDefinition() {
        return matchGradient("linear-gradient", tokens.linearGradient, matchLinearOrientation) || matchGradient("repeating-linear-gradient", tokens.repeatingLinearGradient, matchLinearOrientation) || matchGradient("radial-gradient", tokens.radialGradient, matchListRadialOrientations) || matchGradient("repeating-radial-gradient", tokens.repeatingRadialGradient, matchListRadialOrientations);
    }
    function matchGradient(gradientType, pattern, orientationMatcher) {
        return matchCall(pattern, function(captures) {
            var orientation = orientationMatcher();
            if (orientation) {
                if (!scan(tokens.comma)) error("Missing comma before color stops");
            }
            return {
                type: gradientType,
                orientation: orientation,
                colorStops: matchListing(matchColorStop)
            };
        });
    }
    function matchCall(pattern, callback) {
        var captures = scan(pattern);
        if (captures) {
            if (!scan(tokens.startCall)) error("Missing (");
            var result = callback(captures);
            if (!scan(tokens.endCall)) error("Missing )");
            return result;
        }
    }
    function matchLinearOrientation() {
        return matchSideOrCorner() || matchAngle();
    }
    function matchSideOrCorner() {
        return match("directional", tokens.sideOrCorner, 1);
    }
    function matchAngle() {
        return match("angular", tokens.angleValue, 1);
    }
    function matchListRadialOrientations() {
        var radialOrientations, radialOrientation = matchRadialOrientation(), lookaheadCache;
        if (radialOrientation) {
            radialOrientations = [];
            radialOrientations.push(radialOrientation);
            lookaheadCache = input;
            if (scan(tokens.comma)) {
                radialOrientation = matchRadialOrientation();
                if (radialOrientation) radialOrientations.push(radialOrientation);
                else input = lookaheadCache;
            }
        }
        return radialOrientations;
    }
    function matchRadialOrientation() {
        var radialType = matchCircle() || matchEllipse();
        if (radialType) radialType.at = matchAtPosition();
        else {
            var extent = matchExtentKeyword();
            if (extent) {
                radialType = extent;
                var positionAt = matchAtPosition();
                if (positionAt) radialType.at = positionAt;
            } else {
                var defaultPosition = matchPositioning();
                if (defaultPosition) radialType = {
                    type: "default-radial",
                    at: defaultPosition
                };
            }
        }
        return radialType;
    }
    function matchCircle() {
        var circle = match("shape", /^(circle)/i, 0);
        if (circle) circle.style = matchLength() || matchExtentKeyword();
        return circle;
    }
    function matchEllipse() {
        var ellipse = match("shape", /^(ellipse)/i, 0);
        if (ellipse) ellipse.style = matchDistance() || matchExtentKeyword();
        return ellipse;
    }
    function matchExtentKeyword() {
        return match("extent-keyword", tokens.extentKeywords, 1);
    }
    function matchAtPosition() {
        if (match("position", /^at/, 0)) {
            var positioning = matchPositioning();
            if (!positioning) error("Missing positioning value");
            return positioning;
        }
    }
    function matchPositioning() {
        var location = matchCoordinates();
        if (location.x || location.y) return {
            type: "position",
            value: location
        };
    }
    function matchCoordinates() {
        return {
            x: matchDistance(),
            y: matchDistance()
        };
    }
    function matchListing(matcher) {
        var captures = matcher(), result = [];
        if (captures) {
            result.push(captures);
            while(scan(tokens.comma)){
                captures = matcher();
                if (captures) result.push(captures);
                else error("One extra comma");
            }
        }
        return result;
    }
    function matchColorStop() {
        var color = matchColor();
        if (!color) error("Expected color definition");
        color.length = matchDistance();
        return color;
    }
    function matchColor() {
        return matchHexColor() || matchRGBAColor() || matchRGBColor() || matchLiteralColor();
    }
    function matchLiteralColor() {
        return match("literal", tokens.literalColor, 0);
    }
    function matchHexColor() {
        return match("hex", tokens.hexColor, 1);
    }
    function matchRGBColor() {
        return matchCall(tokens.rgbColor, function() {
            return {
                type: "rgb",
                value: matchListing(matchNumber)
            };
        });
    }
    function matchRGBAColor() {
        return matchCall(tokens.rgbaColor, function() {
            return {
                type: "rgba",
                value: matchListing(matchNumber)
            };
        });
    }
    function matchNumber() {
        return scan(tokens.number)[1];
    }
    function matchDistance() {
        return match("%", tokens.percentageValue, 1) || matchPositionKeyword() || matchLength();
    }
    function matchPositionKeyword() {
        return match("position-keyword", tokens.positionKeywords, 1);
    }
    function matchLength() {
        return match("px", tokens.pixelValue, 1) || match("em", tokens.emValue, 1);
    }
    function match(type, pattern, captureIndex) {
        var captures = scan(pattern);
        if (captures) return {
            type: type,
            value: captures[captureIndex]
        };
    }
    function scan(regexp) {
        var captures, blankCaptures;
        blankCaptures = /^[\n\r\t\s]+/.exec(input);
        if (blankCaptures) consume(blankCaptures[0].length);
        captures = regexp.exec(input);
        if (captures) consume(captures[0].length);
        return captures;
    }
    function consume(size) {
        input = input.substr(size);
    }
    return function(code) {
        input = code.toString();
        return getAST();
    };
}();
$87b9d64a64ded6fd$export$98e6a39c04603d36 = $87b9d64a64ded6fd$var$GradientParser.parse;
$87b9d64a64ded6fd$export$fac44ee5b035f737 = $87b9d64a64ded6fd$var$GradientParser.stringify;


var $e7ad24095803362c$exports = {};
/**
 * chroma.js - JavaScript library for color conversions
 *
 * Copyright (c) 2011-2019, Gregor Aisch
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. The name Gregor Aisch may not be used to endorse or promote products
 * derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * -------------------------------------------------------
 *
 * chroma.js includes colors from colorbrewer2.org, which are released under
 * the following license:
 *
 * Copyright (c) 2002 Cynthia Brewer, Mark Harrower,
 * and The Pennsylvania State University.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
 * either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 *
 * ------------------------------------------------------
 *
 * Named colors are taken from X11 Color Names.
 * http://www.w3.org/TR/css3-color/#svg-color
 *
 * @preserve
 */ (function(global, factory) {
    $e7ad24095803362c$exports = factory();
})($e7ad24095803362c$exports, function() {
    "use strict";
    var limit$2 = function(x, min, max) {
        if (min === void 0) min = 0;
        if (max === void 0) max = 1;
        return x < min ? min : x > max ? max : x;
    };
    var limit$1 = limit$2;
    var clip_rgb$3 = function(rgb) {
        rgb._clipped = false;
        rgb._unclipped = rgb.slice(0);
        for(var i = 0; i <= 3; i++){
            if (i < 3) {
                if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
                rgb[i] = limit$1(rgb[i], 0, 255);
            } else if (i === 3) rgb[i] = limit$1(rgb[i], 0, 1);
        }
        return rgb;
    };
    // ported from jQuery's $.type
    var classToType = {};
    for(var i$1 = 0, list$1 = [
        "Boolean",
        "Number",
        "String",
        "Function",
        "Array",
        "Date",
        "RegExp",
        "Undefined",
        "Null"
    ]; i$1 < list$1.length; i$1 += 1){
        var name = list$1[i$1];
        classToType["[object " + name + "]"] = name.toLowerCase();
    }
    var type$p = function(obj) {
        return classToType[Object.prototype.toString.call(obj)] || "object";
    };
    var type$o = type$p;
    var unpack$B = function(args, keyOrder) {
        if (keyOrder === void 0) keyOrder = null;
        // if called with more than 3 arguments, we return the arguments
        if (args.length >= 3) return Array.prototype.slice.call(args);
        // with less than 3 args we check if first arg is object
        // and use the keyOrder string to extract and sort properties
        if (type$o(args[0]) == "object" && keyOrder) return keyOrder.split("").filter(function(k) {
            return args[0][k] !== undefined;
        }).map(function(k) {
            return args[0][k];
        });
        // otherwise we just return the first argument
        // (which we suppose is an array of args)
        return args[0];
    };
    var type$n = type$p;
    var last$4 = function(args) {
        if (args.length < 2) return null;
        var l = args.length - 1;
        if (type$n(args[l]) == "string") return args[l].toLowerCase();
        return null;
    };
    var PI$2 = Math.PI;
    var utils = {
        clip_rgb: clip_rgb$3,
        limit: limit$2,
        type: type$p,
        unpack: unpack$B,
        last: last$4,
        PI: PI$2,
        TWOPI: PI$2 * 2,
        PITHIRD: PI$2 / 3,
        DEG2RAD: PI$2 / 180,
        RAD2DEG: 180 / PI$2
    };
    var input$h = {
        format: {},
        autodetect: []
    };
    var last$3 = utils.last;
    var clip_rgb$2 = utils.clip_rgb;
    var type$m = utils.type;
    var _input = input$h;
    var Color$D = function Color() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var me = this;
        if (type$m(args[0]) === "object" && args[0].constructor && args[0].constructor === this.constructor) // the argument is already a Color instance
        return args[0];
        // last argument could be the mode
        var mode = last$3(args);
        var autodetect = false;
        if (!mode) {
            autodetect = true;
            if (!_input.sorted) {
                _input.autodetect = _input.autodetect.sort(function(a, b) {
                    return b.p - a.p;
                });
                _input.sorted = true;
            }
            // auto-detect format
            for(var i = 0, list = _input.autodetect; i < list.length; i += 1){
                var chk = list[i];
                mode = chk.test.apply(chk, args);
                if (mode) break;
            }
        }
        if (_input.format[mode]) {
            var rgb = _input.format[mode].apply(null, autodetect ? args : args.slice(0, -1));
            me._rgb = clip_rgb$2(rgb);
        } else throw new Error("unknown format: " + args);
        // add alpha channel
        if (me._rgb.length === 3) me._rgb.push(1);
    };
    Color$D.prototype.toString = function toString() {
        if (type$m(this.hex) == "function") return this.hex();
        return "[" + this._rgb.join(",") + "]";
    };
    var Color_1 = Color$D;
    var chroma$k = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(chroma$k.Color, [
            null
        ].concat(args)));
    };
    chroma$k.Color = Color_1;
    chroma$k.version = "2.4.2";
    var chroma_1 = chroma$k;
    var unpack$A = utils.unpack;
    var max$2 = Math.max;
    var rgb2cmyk$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$A(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r = r / 255;
        g = g / 255;
        b = b / 255;
        var k = 1 - max$2(r, max$2(g, b));
        var f = k < 1 ? 1 / (1 - k) : 0;
        var c = (1 - r - k) * f;
        var m = (1 - g - k) * f;
        var y = (1 - b - k) * f;
        return [
            c,
            m,
            y,
            k
        ];
    };
    var rgb2cmyk_1 = rgb2cmyk$1;
    var unpack$z = utils.unpack;
    var cmyk2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$z(args, "cmyk");
        var c = args[0];
        var m = args[1];
        var y = args[2];
        var k = args[3];
        var alpha = args.length > 4 ? args[4] : 1;
        if (k === 1) return [
            0,
            0,
            0,
            alpha
        ];
        return [
            c >= 1 ? 0 : 255 * (1 - c) * (1 - k),
            m >= 1 ? 0 : 255 * (1 - m) * (1 - k),
            y >= 1 ? 0 : 255 * (1 - y) * (1 - k),
            alpha
        ];
    };
    var cmyk2rgb_1 = cmyk2rgb;
    var chroma$j = chroma_1;
    var Color$C = Color_1;
    var input$g = input$h;
    var unpack$y = utils.unpack;
    var type$l = utils.type;
    var rgb2cmyk = rgb2cmyk_1;
    Color$C.prototype.cmyk = function() {
        return rgb2cmyk(this._rgb);
    };
    chroma$j.cmyk = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$C, [
            null
        ].concat(args, [
            "cmyk"
        ])));
    };
    input$g.format.cmyk = cmyk2rgb_1;
    input$g.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$y(args, "cmyk");
            if (type$l(args) === "array" && args.length === 4) return "cmyk";
        }
    });
    var unpack$x = utils.unpack;
    var last$2 = utils.last;
    var rnd = function(a) {
        return Math.round(a * 100) / 100;
    };
    /*
     * supported arguments:
     * - hsl2css(h,s,l)
     * - hsl2css(h,s,l,a)
     * - hsl2css([h,s,l], mode)
     * - hsl2css([h,s,l,a], mode)
     * - hsl2css({h,s,l,a}, mode)
     */ var hsl2css$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var hsla = unpack$x(args, "hsla");
        var mode = last$2(args) || "lsa";
        hsla[0] = rnd(hsla[0] || 0);
        hsla[1] = rnd(hsla[1] * 100) + "%";
        hsla[2] = rnd(hsla[2] * 100) + "%";
        if (mode === "hsla" || hsla.length > 3 && hsla[3] < 1) {
            hsla[3] = hsla.length > 3 ? hsla[3] : 1;
            mode = "hsla";
        } else hsla.length = 3;
        return mode + "(" + hsla.join(",") + ")";
    };
    var hsl2css_1 = hsl2css$1;
    var unpack$w = utils.unpack;
    /*
     * supported arguments:
     * - rgb2hsl(r,g,b)
     * - rgb2hsl(r,g,b,a)
     * - rgb2hsl([r,g,b])
     * - rgb2hsl([r,g,b,a])
     * - rgb2hsl({r,g,b,a})
     */ var rgb2hsl$3 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$w(args, "rgba");
        var r = args[0];
        var g = args[1];
        var b = args[2];
        r /= 255;
        g /= 255;
        b /= 255;
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var l = (max + min) / 2;
        var s, h;
        if (max === min) {
            s = 0;
            h = Number.NaN;
        } else s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
        if (r == max) h = (g - b) / (max - min);
        else if (g == max) h = 2 + (b - r) / (max - min);
        else if (b == max) h = 4 + (r - g) / (max - min);
        h *= 60;
        if (h < 0) h += 360;
        if (args.length > 3 && args[3] !== undefined) return [
            h,
            s,
            l,
            args[3]
        ];
        return [
            h,
            s,
            l
        ];
    };
    var rgb2hsl_1 = rgb2hsl$3;
    var unpack$v = utils.unpack;
    var last$1 = utils.last;
    var hsl2css = hsl2css_1;
    var rgb2hsl$2 = rgb2hsl_1;
    var round$6 = Math.round;
    /*
     * supported arguments:
     * - rgb2css(r,g,b)
     * - rgb2css(r,g,b,a)
     * - rgb2css([r,g,b], mode)
     * - rgb2css([r,g,b,a], mode)
     * - rgb2css({r,g,b,a}, mode)
     */ var rgb2css$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgba = unpack$v(args, "rgba");
        var mode = last$1(args) || "rgb";
        if (mode.substr(0, 3) == "hsl") return hsl2css(rgb2hsl$2(rgba), mode);
        rgba[0] = round$6(rgba[0]);
        rgba[1] = round$6(rgba[1]);
        rgba[2] = round$6(rgba[2]);
        if (mode === "rgba" || rgba.length > 3 && rgba[3] < 1) {
            rgba[3] = rgba.length > 3 ? rgba[3] : 1;
            mode = "rgba";
        }
        return mode + "(" + rgba.slice(0, mode === "rgb" ? 3 : 4).join(",") + ")";
    };
    var rgb2css_1 = rgb2css$1;
    var unpack$u = utils.unpack;
    var round$5 = Math.round;
    var hsl2rgb$1 = function() {
        var assign;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$u(args, "hsl");
        var h = args[0];
        var s = args[1];
        var l = args[2];
        var r, g, b;
        if (s === 0) r = g = b = l * 255;
        else {
            var t3 = [
                0,
                0,
                0
            ];
            var c = [
                0,
                0,
                0
            ];
            var t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var t1 = 2 * l - t2;
            var h_ = h / 360;
            t3[0] = h_ + 1 / 3;
            t3[1] = h_;
            t3[2] = h_ - 1 / 3;
            for(var i = 0; i < 3; i++){
                if (t3[i] < 0) t3[i] += 1;
                if (t3[i] > 1) t3[i] -= 1;
                if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
                else if (2 * t3[i] < 1) c[i] = t2;
                else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
                else c[i] = t1;
            }
            assign = [
                round$5(c[0] * 255),
                round$5(c[1] * 255),
                round$5(c[2] * 255)
            ], r = assign[0], g = assign[1], b = assign[2];
        }
        if (args.length > 3) // keep alpha channel
        return [
            r,
            g,
            b,
            args[3]
        ];
        return [
            r,
            g,
            b,
            1
        ];
    };
    var hsl2rgb_1 = hsl2rgb$1;
    var hsl2rgb = hsl2rgb_1;
    var input$f = input$h;
    var RE_RGB = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/;
    var RE_RGBA = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_RGB_PCT = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_RGBA_PCT = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_HSL = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_HSLA = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
    var round$4 = Math.round;
    var css2rgb$1 = function(css) {
        css = css.toLowerCase().trim();
        var m;
        if (input$f.format.named) try {
            return input$f.format.named(css);
        } catch (e) {
        // eslint-disable-next-line
        }
        // rgb(250,20,0)
        if (m = css.match(RE_RGB)) {
            var rgb = m.slice(1, 4);
            for(var i = 0; i < 3; i++)rgb[i] = +rgb[i];
            rgb[3] = 1; // default alpha
            return rgb;
        }
        // rgba(250,20,0,0.4)
        if (m = css.match(RE_RGBA)) {
            var rgb$1 = m.slice(1, 5);
            for(var i$1 = 0; i$1 < 4; i$1++)rgb$1[i$1] = +rgb$1[i$1];
            return rgb$1;
        }
        // rgb(100%,0%,0%)
        if (m = css.match(RE_RGB_PCT)) {
            var rgb$2 = m.slice(1, 4);
            for(var i$2 = 0; i$2 < 3; i$2++)rgb$2[i$2] = round$4(rgb$2[i$2] * 2.55);
            rgb$2[3] = 1; // default alpha
            return rgb$2;
        }
        // rgba(100%,0%,0%,0.4)
        if (m = css.match(RE_RGBA_PCT)) {
            var rgb$3 = m.slice(1, 5);
            for(var i$3 = 0; i$3 < 3; i$3++)rgb$3[i$3] = round$4(rgb$3[i$3] * 2.55);
            rgb$3[3] = +rgb$3[3];
            return rgb$3;
        }
        // hsl(0,100%,50%)
        if (m = css.match(RE_HSL)) {
            var hsl = m.slice(1, 4);
            hsl[1] *= 0.01;
            hsl[2] *= 0.01;
            var rgb$4 = hsl2rgb(hsl);
            rgb$4[3] = 1;
            return rgb$4;
        }
        // hsla(0,100%,50%,0.5)
        if (m = css.match(RE_HSLA)) {
            var hsl$1 = m.slice(1, 4);
            hsl$1[1] *= 0.01;
            hsl$1[2] *= 0.01;
            var rgb$5 = hsl2rgb(hsl$1);
            rgb$5[3] = +m[4]; // default alpha = 1
            return rgb$5;
        }
    };
    css2rgb$1.test = function(s) {
        return RE_RGB.test(s) || RE_RGBA.test(s) || RE_RGB_PCT.test(s) || RE_RGBA_PCT.test(s) || RE_HSL.test(s) || RE_HSLA.test(s);
    };
    var css2rgb_1 = css2rgb$1;
    var chroma$i = chroma_1;
    var Color$B = Color_1;
    var input$e = input$h;
    var type$k = utils.type;
    var rgb2css = rgb2css_1;
    var css2rgb = css2rgb_1;
    Color$B.prototype.css = function(mode) {
        return rgb2css(this._rgb, mode);
    };
    chroma$i.css = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$B, [
            null
        ].concat(args, [
            "css"
        ])));
    };
    input$e.format.css = css2rgb;
    input$e.autodetect.push({
        p: 5,
        test: function(h) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            if (!rest.length && type$k(h) === "string" && css2rgb.test(h)) return "css";
        }
    });
    var Color$A = Color_1;
    var chroma$h = chroma_1;
    var input$d = input$h;
    var unpack$t = utils.unpack;
    input$d.format.gl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgb = unpack$t(args, "rgba");
        rgb[0] *= 255;
        rgb[1] *= 255;
        rgb[2] *= 255;
        return rgb;
    };
    chroma$h.gl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$A, [
            null
        ].concat(args, [
            "gl"
        ])));
    };
    Color$A.prototype.gl = function() {
        var rgb = this._rgb;
        return [
            rgb[0] / 255,
            rgb[1] / 255,
            rgb[2] / 255,
            rgb[3]
        ];
    };
    var unpack$s = utils.unpack;
    var rgb2hcg$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$s(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var c = delta * 100 / 255;
        var _g = min / (255 - delta) * 100;
        var h;
        if (delta === 0) h = Number.NaN;
        else {
            if (r === max) h = (g - b) / delta;
            if (g === max) h = 2 + (b - r) / delta;
            if (b === max) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            c,
            _g
        ];
    };
    var rgb2hcg_1 = rgb2hcg$1;
    var unpack$r = utils.unpack;
    var floor$3 = Math.floor;
    /*
     * this is basically just HSV with some minor tweaks
     *
     * hue.. [0..360]
     * chroma .. [0..1]
     * grayness .. [0..1]
     */ var hcg2rgb = function() {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$r(args, "hcg");
        var h = args[0];
        var c = args[1];
        var _g = args[2];
        var r, g, b;
        _g = _g * 255;
        var _c = c * 255;
        if (c === 0) r = g = b = _g;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            var i = floor$3(h);
            var f = h - i;
            var p = _g * (1 - c);
            var q = p + _c * (1 - f);
            var t = p + _c * f;
            var v = p + _c;
            switch(i){
                case 0:
                    assign = [
                        v,
                        t,
                        p
                    ], r = assign[0], g = assign[1], b = assign[2];
                    break;
                case 1:
                    assign$1 = [
                        q,
                        v,
                        p
                    ], r = assign$1[0], g = assign$1[1], b = assign$1[2];
                    break;
                case 2:
                    assign$2 = [
                        p,
                        v,
                        t
                    ], r = assign$2[0], g = assign$2[1], b = assign$2[2];
                    break;
                case 3:
                    assign$3 = [
                        p,
                        q,
                        v
                    ], r = assign$3[0], g = assign$3[1], b = assign$3[2];
                    break;
                case 4:
                    assign$4 = [
                        t,
                        p,
                        v
                    ], r = assign$4[0], g = assign$4[1], b = assign$4[2];
                    break;
                case 5:
                    assign$5 = [
                        v,
                        p,
                        q
                    ], r = assign$5[0], g = assign$5[1], b = assign$5[2];
                    break;
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var hcg2rgb_1 = hcg2rgb;
    var unpack$q = utils.unpack;
    var type$j = utils.type;
    var chroma$g = chroma_1;
    var Color$z = Color_1;
    var input$c = input$h;
    var rgb2hcg = rgb2hcg_1;
    Color$z.prototype.hcg = function() {
        return rgb2hcg(this._rgb);
    };
    chroma$g.hcg = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$z, [
            null
        ].concat(args, [
            "hcg"
        ])));
    };
    input$c.format.hcg = hcg2rgb_1;
    input$c.autodetect.push({
        p: 1,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$q(args, "hcg");
            if (type$j(args) === "array" && args.length === 3) return "hcg";
        }
    });
    var unpack$p = utils.unpack;
    var last = utils.last;
    var round$3 = Math.round;
    var rgb2hex$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$p(args, "rgba");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var a = ref[3];
        var mode = last(args) || "auto";
        if (a === undefined) a = 1;
        if (mode === "auto") mode = a < 1 ? "rgba" : "rgb";
        r = round$3(r);
        g = round$3(g);
        b = round$3(b);
        var u = r << 16 | g << 8 | b;
        var str = "000000" + u.toString(16); //#.toUpperCase();
        str = str.substr(str.length - 6);
        var hxa = "0" + round$3(a * 255).toString(16);
        hxa = hxa.substr(hxa.length - 2);
        switch(mode.toLowerCase()){
            case "rgba":
                return "#" + str + hxa;
            case "argb":
                return "#" + hxa + str;
            default:
                return "#" + str;
        }
    };
    var rgb2hex_1 = rgb2hex$2;
    var RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    var RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;
    var hex2rgb$1 = function(hex) {
        if (hex.match(RE_HEX)) {
            // remove optional leading #
            if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
            // expand short-notation to full six-digit
            if (hex.length === 3) {
                hex = hex.split("");
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }
            var u = parseInt(hex, 16);
            var r = u >> 16;
            var g = u >> 8 & 0xFF;
            var b = u & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        // match rgba hex format, eg #FF000077
        if (hex.match(RE_HEXA)) {
            if (hex.length === 5 || hex.length === 9) // remove optional leading #
            hex = hex.substr(1);
            // expand short-notation to full eight-digit
            if (hex.length === 4) {
                hex = hex.split("");
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
            }
            var u$1 = parseInt(hex, 16);
            var r$1 = u$1 >> 24 & 0xFF;
            var g$1 = u$1 >> 16 & 0xFF;
            var b$1 = u$1 >> 8 & 0xFF;
            var a = Math.round((u$1 & 0xFF) / 0xFF * 100) / 100;
            return [
                r$1,
                g$1,
                b$1,
                a
            ];
        }
        // we used to check for css colors here
        // if _input.css? and rgb = _input.css hex
        //     return rgb
        throw new Error("unknown hex color: " + hex);
    };
    var hex2rgb_1 = hex2rgb$1;
    var chroma$f = chroma_1;
    var Color$y = Color_1;
    var type$i = utils.type;
    var input$b = input$h;
    var rgb2hex$1 = rgb2hex_1;
    Color$y.prototype.hex = function(mode) {
        return rgb2hex$1(this._rgb, mode);
    };
    chroma$f.hex = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$y, [
            null
        ].concat(args, [
            "hex"
        ])));
    };
    input$b.format.hex = hex2rgb_1;
    input$b.autodetect.push({
        p: 4,
        test: function(h) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            if (!rest.length && type$i(h) === "string" && [
                3,
                4,
                5,
                6,
                7,
                8,
                9
            ].indexOf(h.length) >= 0) return "hex";
        }
    });
    var unpack$o = utils.unpack;
    var TWOPI$2 = utils.TWOPI;
    var min$2 = Math.min;
    var sqrt$4 = Math.sqrt;
    var acos = Math.acos;
    var rgb2hsi$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        /*
        borrowed from here:
        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
        */ var ref = unpack$o(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r /= 255;
        g /= 255;
        b /= 255;
        var h;
        var min_ = min$2(r, g, b);
        var i = (r + g + b) / 3;
        var s = i > 0 ? 1 - min_ / i : 0;
        if (s === 0) h = NaN;
        else {
            h = (r - g + (r - b)) / 2;
            h /= sqrt$4((r - g) * (r - g) + (r - b) * (g - b));
            h = acos(h);
            if (b > g) h = TWOPI$2 - h;
            h /= TWOPI$2;
        }
        return [
            h * 360,
            s,
            i
        ];
    };
    var rgb2hsi_1 = rgb2hsi$1;
    var unpack$n = utils.unpack;
    var limit = utils.limit;
    var TWOPI$1 = utils.TWOPI;
    var PITHIRD = utils.PITHIRD;
    var cos$4 = Math.cos;
    /*
     * hue [0..360]
     * saturation [0..1]
     * intensity [0..1]
     */ var hsi2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        /*
        borrowed from here:
        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
        */ args = unpack$n(args, "hsi");
        var h = args[0];
        var s = args[1];
        var i = args[2];
        var r, g, b;
        if (isNaN(h)) h = 0;
        if (isNaN(s)) s = 0;
        // normalize hue
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 360;
        if (h < 1 / 3) {
            b = (1 - s) / 3;
            r = (1 + s * cos$4(TWOPI$1 * h) / cos$4(PITHIRD - TWOPI$1 * h)) / 3;
            g = 1 - (b + r);
        } else if (h < 2 / 3) {
            h -= 1 / 3;
            r = (1 - s) / 3;
            g = (1 + s * cos$4(TWOPI$1 * h) / cos$4(PITHIRD - TWOPI$1 * h)) / 3;
            b = 1 - (r + g);
        } else {
            h -= 2 / 3;
            g = (1 - s) / 3;
            b = (1 + s * cos$4(TWOPI$1 * h) / cos$4(PITHIRD - TWOPI$1 * h)) / 3;
            r = 1 - (g + b);
        }
        r = limit(i * r * 3);
        g = limit(i * g * 3);
        b = limit(i * b * 3);
        return [
            r * 255,
            g * 255,
            b * 255,
            args.length > 3 ? args[3] : 1
        ];
    };
    var hsi2rgb_1 = hsi2rgb;
    var unpack$m = utils.unpack;
    var type$h = utils.type;
    var chroma$e = chroma_1;
    var Color$x = Color_1;
    var input$a = input$h;
    var rgb2hsi = rgb2hsi_1;
    Color$x.prototype.hsi = function() {
        return rgb2hsi(this._rgb);
    };
    chroma$e.hsi = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$x, [
            null
        ].concat(args, [
            "hsi"
        ])));
    };
    input$a.format.hsi = hsi2rgb_1;
    input$a.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$m(args, "hsi");
            if (type$h(args) === "array" && args.length === 3) return "hsi";
        }
    });
    var unpack$l = utils.unpack;
    var type$g = utils.type;
    var chroma$d = chroma_1;
    var Color$w = Color_1;
    var input$9 = input$h;
    var rgb2hsl$1 = rgb2hsl_1;
    Color$w.prototype.hsl = function() {
        return rgb2hsl$1(this._rgb);
    };
    chroma$d.hsl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$w, [
            null
        ].concat(args, [
            "hsl"
        ])));
    };
    input$9.format.hsl = hsl2rgb_1;
    input$9.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$l(args, "hsl");
            if (type$g(args) === "array" && args.length === 3) return "hsl";
        }
    });
    var unpack$k = utils.unpack;
    var min$1 = Math.min;
    var max$1 = Math.max;
    /*
     * supported arguments:
     * - rgb2hsv(r,g,b)
     * - rgb2hsv([r,g,b])
     * - rgb2hsv({r,g,b})
     */ var rgb2hsl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$k(args, "rgb");
        var r = args[0];
        var g = args[1];
        var b = args[2];
        var min_ = min$1(r, g, b);
        var max_ = max$1(r, g, b);
        var delta = max_ - min_;
        var h, s, v;
        v = max_ / 255.0;
        if (max_ === 0) {
            h = Number.NaN;
            s = 0;
        } else {
            s = delta / max_;
            if (r === max_) h = (g - b) / delta;
            if (g === max_) h = 2 + (b - r) / delta;
            if (b === max_) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            s,
            v
        ];
    };
    var rgb2hsv$1 = rgb2hsl;
    var unpack$j = utils.unpack;
    var floor$2 = Math.floor;
    var hsv2rgb = function() {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$j(args, "hsv");
        var h = args[0];
        var s = args[1];
        var v = args[2];
        var r, g, b;
        v *= 255;
        if (s === 0) r = g = b = v;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            var i = floor$2(h);
            var f = h - i;
            var p = v * (1 - s);
            var q = v * (1 - s * f);
            var t = v * (1 - s * (1 - f));
            switch(i){
                case 0:
                    assign = [
                        v,
                        t,
                        p
                    ], r = assign[0], g = assign[1], b = assign[2];
                    break;
                case 1:
                    assign$1 = [
                        q,
                        v,
                        p
                    ], r = assign$1[0], g = assign$1[1], b = assign$1[2];
                    break;
                case 2:
                    assign$2 = [
                        p,
                        v,
                        t
                    ], r = assign$2[0], g = assign$2[1], b = assign$2[2];
                    break;
                case 3:
                    assign$3 = [
                        p,
                        q,
                        v
                    ], r = assign$3[0], g = assign$3[1], b = assign$3[2];
                    break;
                case 4:
                    assign$4 = [
                        t,
                        p,
                        v
                    ], r = assign$4[0], g = assign$4[1], b = assign$4[2];
                    break;
                case 5:
                    assign$5 = [
                        v,
                        p,
                        q
                    ], r = assign$5[0], g = assign$5[1], b = assign$5[2];
                    break;
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var hsv2rgb_1 = hsv2rgb;
    var unpack$i = utils.unpack;
    var type$f = utils.type;
    var chroma$c = chroma_1;
    var Color$v = Color_1;
    var input$8 = input$h;
    var rgb2hsv = rgb2hsv$1;
    Color$v.prototype.hsv = function() {
        return rgb2hsv(this._rgb);
    };
    chroma$c.hsv = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$v, [
            null
        ].concat(args, [
            "hsv"
        ])));
    };
    input$8.format.hsv = hsv2rgb_1;
    input$8.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$i(args, "hsv");
            if (type$f(args) === "array" && args.length === 3) return "hsv";
        }
    });
    var labConstants = {
        // Corresponds roughly to RGB brighter/darker
        Kn: 18,
        // D65 standard referent
        Xn: 0.950470,
        Yn: 1,
        Zn: 1.088830,
        t0: 0.137931034,
        t1: 0.206896552,
        t2: 0.12841855,
        t3: 0.008856452
    };
    var LAB_CONSTANTS$3 = labConstants;
    var unpack$h = utils.unpack;
    var pow$a = Math.pow;
    var rgb2lab$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$h(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2xyz(r, g, b);
        var x = ref$1[0];
        var y = ref$1[1];
        var z = ref$1[2];
        var l = 116 * y - 16;
        return [
            l < 0 ? 0 : l,
            500 * (x - y),
            200 * (y - z)
        ];
    };
    var rgb_xyz = function(r) {
        if ((r /= 255) <= 0.04045) return r / 12.92;
        return pow$a((r + 0.055) / 1.055, 2.4);
    };
    var xyz_lab = function(t) {
        if (t > LAB_CONSTANTS$3.t3) return pow$a(t, 1 / 3);
        return t / LAB_CONSTANTS$3.t2 + LAB_CONSTANTS$3.t0;
    };
    var rgb2xyz = function(r, g, b) {
        r = rgb_xyz(r);
        g = rgb_xyz(g);
        b = rgb_xyz(b);
        var x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / LAB_CONSTANTS$3.Xn);
        var y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / LAB_CONSTANTS$3.Yn);
        var z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / LAB_CONSTANTS$3.Zn);
        return [
            x,
            y,
            z
        ];
    };
    var rgb2lab_1 = rgb2lab$2;
    var LAB_CONSTANTS$2 = labConstants;
    var unpack$g = utils.unpack;
    var pow$9 = Math.pow;
    /*
     * L* [0..100]
     * a [-100..100]
     * b [-100..100]
     */ var lab2rgb$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$g(args, "lab");
        var l = args[0];
        var a = args[1];
        var b = args[2];
        var x, y, z, r, g, b_;
        y = (l + 16) / 116;
        x = isNaN(a) ? y : y + a / 500;
        z = isNaN(b) ? y : y - b / 200;
        y = LAB_CONSTANTS$2.Yn * lab_xyz(y);
        x = LAB_CONSTANTS$2.Xn * lab_xyz(x);
        z = LAB_CONSTANTS$2.Zn * lab_xyz(z);
        r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z); // D65 -> sRGB
        g = xyz_rgb(-0.969266 * x + 1.8760108 * y + 0.0415560 * z);
        b_ = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
        return [
            r,
            g,
            b_,
            args.length > 3 ? args[3] : 1
        ];
    };
    var xyz_rgb = function(r) {
        return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow$9(r, 1 / 2.4) - 0.055);
    };
    var lab_xyz = function(t) {
        return t > LAB_CONSTANTS$2.t1 ? t * t * t : LAB_CONSTANTS$2.t2 * (t - LAB_CONSTANTS$2.t0);
    };
    var lab2rgb_1 = lab2rgb$1;
    var unpack$f = utils.unpack;
    var type$e = utils.type;
    var chroma$b = chroma_1;
    var Color$u = Color_1;
    var input$7 = input$h;
    var rgb2lab$1 = rgb2lab_1;
    Color$u.prototype.lab = function() {
        return rgb2lab$1(this._rgb);
    };
    chroma$b.lab = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$u, [
            null
        ].concat(args, [
            "lab"
        ])));
    };
    input$7.format.lab = lab2rgb_1;
    input$7.autodetect.push({
        p: 2,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$f(args, "lab");
            if (type$e(args) === "array" && args.length === 3) return "lab";
        }
    });
    var unpack$e = utils.unpack;
    var RAD2DEG = utils.RAD2DEG;
    var sqrt$3 = Math.sqrt;
    var atan2$2 = Math.atan2;
    var round$2 = Math.round;
    var lab2lch$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$e(args, "lab");
        var l = ref[0];
        var a = ref[1];
        var b = ref[2];
        var c = sqrt$3(a * a + b * b);
        var h = (atan2$2(b, a) * RAD2DEG + 360) % 360;
        if (round$2(c * 10000) === 0) h = Number.NaN;
        return [
            l,
            c,
            h
        ];
    };
    var lab2lch_1 = lab2lch$2;
    var unpack$d = utils.unpack;
    var rgb2lab = rgb2lab_1;
    var lab2lch$1 = lab2lch_1;
    var rgb2lch$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$d(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2lab(r, g, b);
        var l = ref$1[0];
        var a = ref$1[1];
        var b_ = ref$1[2];
        return lab2lch$1(l, a, b_);
    };
    var rgb2lch_1 = rgb2lch$1;
    var unpack$c = utils.unpack;
    var DEG2RAD = utils.DEG2RAD;
    var sin$3 = Math.sin;
    var cos$3 = Math.cos;
    var lch2lab$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        /*
        Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
        These formulas were invented by David Dalrymple to obtain maximum contrast without going
        out of gamut if the parameters are in the range 0-1.

        A saturation multiplier was added by Gregor Aisch
        */ var ref = unpack$c(args, "lch");
        var l = ref[0];
        var c = ref[1];
        var h = ref[2];
        if (isNaN(h)) h = 0;
        h = h * DEG2RAD;
        return [
            l,
            cos$3(h) * c,
            sin$3(h) * c
        ];
    };
    var lch2lab_1 = lch2lab$2;
    var unpack$b = utils.unpack;
    var lch2lab$1 = lch2lab_1;
    var lab2rgb = lab2rgb_1;
    var lch2rgb$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$b(args, "lch");
        var l = args[0];
        var c = args[1];
        var h = args[2];
        var ref = lch2lab$1(l, c, h);
        var L = ref[0];
        var a = ref[1];
        var b_ = ref[2];
        var ref$1 = lab2rgb(L, a, b_);
        var r = ref$1[0];
        var g = ref$1[1];
        var b = ref$1[2];
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var lch2rgb_1 = lch2rgb$1;
    var unpack$a = utils.unpack;
    var lch2rgb = lch2rgb_1;
    var hcl2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var hcl = unpack$a(args, "hcl").reverse();
        return lch2rgb.apply(void 0, hcl);
    };
    var hcl2rgb_1 = hcl2rgb;
    var unpack$9 = utils.unpack;
    var type$d = utils.type;
    var chroma$a = chroma_1;
    var Color$t = Color_1;
    var input$6 = input$h;
    var rgb2lch = rgb2lch_1;
    Color$t.prototype.lch = function() {
        return rgb2lch(this._rgb);
    };
    Color$t.prototype.hcl = function() {
        return rgb2lch(this._rgb).reverse();
    };
    chroma$a.lch = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$t, [
            null
        ].concat(args, [
            "lch"
        ])));
    };
    chroma$a.hcl = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$t, [
            null
        ].concat(args, [
            "hcl"
        ])));
    };
    input$6.format.lch = lch2rgb_1;
    input$6.format.hcl = hcl2rgb_1;
    [
        "lch",
        "hcl"
    ].forEach(function(m) {
        return input$6.autodetect.push({
            p: 2,
            test: function() {
                var args = [], len = arguments.length;
                while(len--)args[len] = arguments[len];
                args = unpack$9(args, m);
                if (type$d(args) === "array" && args.length === 3) return m;
            }
        });
    });
    /**
    	X11 color names

    	http://www.w3.org/TR/css3-color/#svg-color
    */ var w3cx11$1 = {
        aliceblue: "#f0f8ff",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        aquamarine: "#7fffd4",
        azure: "#f0ffff",
        beige: "#f5f5dc",
        bisque: "#ffe4c4",
        black: "#000000",
        blanchedalmond: "#ffebcd",
        blue: "#0000ff",
        blueviolet: "#8a2be2",
        brown: "#a52a2a",
        burlywood: "#deb887",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        cornflower: "#6495ed",
        cornflowerblue: "#6495ed",
        cornsilk: "#fff8dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        darkkhaki: "#bdb76b",
        darkmagenta: "#8b008b",
        darkolivegreen: "#556b2f",
        darkorange: "#ff8c00",
        darkorchid: "#9932cc",
        darkred: "#8b0000",
        darksalmon: "#e9967a",
        darkseagreen: "#8fbc8f",
        darkslateblue: "#483d8b",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        darkturquoise: "#00ced1",
        darkviolet: "#9400d3",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        dimgray: "#696969",
        dimgrey: "#696969",
        dodgerblue: "#1e90ff",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        forestgreen: "#228b22",
        fuchsia: "#ff00ff",
        gainsboro: "#dcdcdc",
        ghostwhite: "#f8f8ff",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gray: "#808080",
        green: "#008000",
        greenyellow: "#adff2f",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        ivory: "#fffff0",
        khaki: "#f0e68c",
        laserlemon: "#ffff54",
        lavender: "#e6e6fa",
        lavenderblush: "#fff0f5",
        lawngreen: "#7cfc00",
        lemonchiffon: "#fffacd",
        lightblue: "#add8e6",
        lightcoral: "#f08080",
        lightcyan: "#e0ffff",
        lightgoldenrod: "#fafad2",
        lightgoldenrodyellow: "#fafad2",
        lightgray: "#d3d3d3",
        lightgreen: "#90ee90",
        lightgrey: "#d3d3d3",
        lightpink: "#ffb6c1",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        lightskyblue: "#87cefa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        lightsteelblue: "#b0c4de",
        lightyellow: "#ffffe0",
        lime: "#00ff00",
        limegreen: "#32cd32",
        linen: "#faf0e6",
        magenta: "#ff00ff",
        maroon: "#800000",
        maroon2: "#7f0000",
        maroon3: "#b03060",
        mediumaquamarine: "#66cdaa",
        mediumblue: "#0000cd",
        mediumorchid: "#ba55d3",
        mediumpurple: "#9370db",
        mediumseagreen: "#3cb371",
        mediumslateblue: "#7b68ee",
        mediumspringgreen: "#00fa9a",
        mediumturquoise: "#48d1cc",
        mediumvioletred: "#c71585",
        midnightblue: "#191970",
        mintcream: "#f5fffa",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        navajowhite: "#ffdead",
        navy: "#000080",
        oldlace: "#fdf5e6",
        olive: "#808000",
        olivedrab: "#6b8e23",
        orange: "#ffa500",
        orangered: "#ff4500",
        orchid: "#da70d6",
        palegoldenrod: "#eee8aa",
        palegreen: "#98fb98",
        paleturquoise: "#afeeee",
        palevioletred: "#db7093",
        papayawhip: "#ffefd5",
        peachpuff: "#ffdab9",
        peru: "#cd853f",
        pink: "#ffc0cb",
        plum: "#dda0dd",
        powderblue: "#b0e0e6",
        purple: "#800080",
        purple2: "#7f007f",
        purple3: "#a020f0",
        rebeccapurple: "#663399",
        red: "#ff0000",
        rosybrown: "#bc8f8f",
        royalblue: "#4169e1",
        saddlebrown: "#8b4513",
        salmon: "#fa8072",
        sandybrown: "#f4a460",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        sienna: "#a0522d",
        silver: "#c0c0c0",
        skyblue: "#87ceeb",
        slateblue: "#6a5acd",
        slategray: "#708090",
        slategrey: "#708090",
        snow: "#fffafa",
        springgreen: "#00ff7f",
        steelblue: "#4682b4",
        tan: "#d2b48c",
        teal: "#008080",
        thistle: "#d8bfd8",
        tomato: "#ff6347",
        turquoise: "#40e0d0",
        violet: "#ee82ee",
        wheat: "#f5deb3",
        white: "#ffffff",
        whitesmoke: "#f5f5f5",
        yellow: "#ffff00",
        yellowgreen: "#9acd32"
    };
    var w3cx11_1 = w3cx11$1;
    var Color$s = Color_1;
    var input$5 = input$h;
    var type$c = utils.type;
    var w3cx11 = w3cx11_1;
    var hex2rgb = hex2rgb_1;
    var rgb2hex = rgb2hex_1;
    Color$s.prototype.name = function() {
        var hex = rgb2hex(this._rgb, "rgb");
        for(var i = 0, list = Object.keys(w3cx11); i < list.length; i += 1){
            var n = list[i];
            if (w3cx11[n] === hex) return n.toLowerCase();
        }
        return hex;
    };
    input$5.format.named = function(name) {
        name = name.toLowerCase();
        if (w3cx11[name]) return hex2rgb(w3cx11[name]);
        throw new Error("unknown color name: " + name);
    };
    input$5.autodetect.push({
        p: 5,
        test: function(h) {
            var rest = [], len = arguments.length - 1;
            while(len-- > 0)rest[len] = arguments[len + 1];
            if (!rest.length && type$c(h) === "string" && w3cx11[h.toLowerCase()]) return "named";
        }
    });
    var unpack$8 = utils.unpack;
    var rgb2num$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$8(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        return (r << 16) + (g << 8) + b;
    };
    var rgb2num_1 = rgb2num$1;
    var type$b = utils.type;
    var num2rgb = function(num) {
        if (type$b(num) == "number" && num >= 0 && num <= 0xFFFFFF) {
            var r = num >> 16;
            var g = num >> 8 & 0xFF;
            var b = num & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        throw new Error("unknown num color: " + num);
    };
    var num2rgb_1 = num2rgb;
    var chroma$9 = chroma_1;
    var Color$r = Color_1;
    var input$4 = input$h;
    var type$a = utils.type;
    var rgb2num = rgb2num_1;
    Color$r.prototype.num = function() {
        return rgb2num(this._rgb);
    };
    chroma$9.num = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$r, [
            null
        ].concat(args, [
            "num"
        ])));
    };
    input$4.format.num = num2rgb_1;
    input$4.autodetect.push({
        p: 5,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            if (args.length === 1 && type$a(args[0]) === "number" && args[0] >= 0 && args[0] <= 0xFFFFFF) return "num";
        }
    });
    var chroma$8 = chroma_1;
    var Color$q = Color_1;
    var input$3 = input$h;
    var unpack$7 = utils.unpack;
    var type$9 = utils.type;
    var round$1 = Math.round;
    Color$q.prototype.rgb = function(rnd) {
        if (rnd === void 0) rnd = true;
        if (rnd === false) return this._rgb.slice(0, 3);
        return this._rgb.slice(0, 3).map(round$1);
    };
    Color$q.prototype.rgba = function(rnd) {
        if (rnd === void 0) rnd = true;
        return this._rgb.slice(0, 4).map(function(v, i) {
            return i < 3 ? rnd === false ? v : round$1(v) : v;
        });
    };
    chroma$8.rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$q, [
            null
        ].concat(args, [
            "rgb"
        ])));
    };
    input$3.format.rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgba = unpack$7(args, "rgba");
        if (rgba[3] === undefined) rgba[3] = 1;
        return rgba;
    };
    input$3.autodetect.push({
        p: 3,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$7(args, "rgba");
            if (type$9(args) === "array" && (args.length === 3 || args.length === 4 && type$9(args[3]) == "number" && args[3] >= 0 && args[3] <= 1)) return "rgb";
        }
    });
    /*
     * Based on implementation by Neil Bartlett
     * https://github.com/neilbartlett/color-temperature
     */ var log$1 = Math.log;
    var temperature2rgb$1 = function(kelvin) {
        var temp = kelvin / 100;
        var r, g, b;
        if (temp < 66) {
            r = 255;
            g = temp < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * log$1(g);
            b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * log$1(b);
        } else {
            r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * log$1(r);
            g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * log$1(g);
            b = 255;
        }
        return [
            r,
            g,
            b,
            1
        ];
    };
    var temperature2rgb_1 = temperature2rgb$1;
    /*
     * Based on implementation by Neil Bartlett
     * https://github.com/neilbartlett/color-temperature
     **/ var temperature2rgb = temperature2rgb_1;
    var unpack$6 = utils.unpack;
    var round = Math.round;
    var rgb2temperature$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var rgb = unpack$6(args, "rgb");
        var r = rgb[0], b = rgb[2];
        var minTemp = 1000;
        var maxTemp = 40000;
        var eps = 0.4;
        var temp;
        while(maxTemp - minTemp > eps){
            temp = (maxTemp + minTemp) * 0.5;
            var rgb$1 = temperature2rgb(temp);
            if (rgb$1[2] / rgb$1[0] >= b / r) maxTemp = temp;
            else minTemp = temp;
        }
        return round(temp);
    };
    var rgb2temperature_1 = rgb2temperature$1;
    var chroma$7 = chroma_1;
    var Color$p = Color_1;
    var input$2 = input$h;
    var rgb2temperature = rgb2temperature_1;
    Color$p.prototype.temp = Color$p.prototype.kelvin = Color$p.prototype.temperature = function() {
        return rgb2temperature(this._rgb);
    };
    chroma$7.temp = chroma$7.kelvin = chroma$7.temperature = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$p, [
            null
        ].concat(args, [
            "temp"
        ])));
    };
    input$2.format.temp = input$2.format.kelvin = input$2.format.temperature = temperature2rgb_1;
    var unpack$5 = utils.unpack;
    var cbrt = Math.cbrt;
    var pow$8 = Math.pow;
    var sign$1 = Math.sign;
    var rgb2oklab$2 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        // OKLab color space implementation taken from
        // https://bottosson.github.io/posts/oklab/
        var ref = unpack$5(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = [
            rgb2lrgb(r / 255),
            rgb2lrgb(g / 255),
            rgb2lrgb(b / 255)
        ];
        var lr = ref$1[0];
        var lg = ref$1[1];
        var lb = ref$1[2];
        var l = cbrt(0.4122214708 * lr + 0.5363325363 * lg + 0.0514459929 * lb);
        var m = cbrt(0.2119034982 * lr + 0.6806995451 * lg + 0.1073969566 * lb);
        var s = cbrt(0.0883024619 * lr + 0.2817188376 * lg + 0.6299787005 * lb);
        return [
            0.2104542553 * l + 0.793617785 * m - 0.0040720468 * s,
            1.9779984951 * l - 2.428592205 * m + 0.4505937099 * s,
            0.0259040371 * l + 0.7827717662 * m - 0.808675766 * s
        ];
    };
    var rgb2oklab_1 = rgb2oklab$2;
    function rgb2lrgb(c) {
        var abs = Math.abs(c);
        if (abs < 0.04045) return c / 12.92;
        return (sign$1(c) || 1) * pow$8((abs + 0.055) / 1.055, 2.4);
    }
    var unpack$4 = utils.unpack;
    var pow$7 = Math.pow;
    var sign = Math.sign;
    /*
     * L* [0..100]
     * a [-100..100]
     * b [-100..100]
     */ var oklab2rgb$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$4(args, "lab");
        var L = args[0];
        var a = args[1];
        var b = args[2];
        var l = pow$7(L + 0.3963377774 * a + 0.2158037573 * b, 3);
        var m = pow$7(L - 0.1055613458 * a - 0.0638541728 * b, 3);
        var s = pow$7(L - 0.0894841775 * a - 1.291485548 * b, 3);
        return [
            255 * lrgb2rgb(4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s),
            255 * lrgb2rgb(-1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s),
            255 * lrgb2rgb(-0.0041960863 * l - 0.7034186147 * m + 1.707614701 * s),
            args.length > 3 ? args[3] : 1
        ];
    };
    var oklab2rgb_1 = oklab2rgb$1;
    function lrgb2rgb(c) {
        var abs = Math.abs(c);
        if (abs > 0.0031308) return (sign(c) || 1) * (1.055 * pow$7(abs, 1 / 2.4) - 0.055);
        return c * 12.92;
    }
    var unpack$3 = utils.unpack;
    var type$8 = utils.type;
    var chroma$6 = chroma_1;
    var Color$o = Color_1;
    var input$1 = input$h;
    var rgb2oklab$1 = rgb2oklab_1;
    Color$o.prototype.oklab = function() {
        return rgb2oklab$1(this._rgb);
    };
    chroma$6.oklab = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$o, [
            null
        ].concat(args, [
            "oklab"
        ])));
    };
    input$1.format.oklab = oklab2rgb_1;
    input$1.autodetect.push({
        p: 3,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack$3(args, "oklab");
            if (type$8(args) === "array" && args.length === 3) return "oklab";
        }
    });
    var unpack$2 = utils.unpack;
    var rgb2oklab = rgb2oklab_1;
    var lab2lch = lab2lch_1;
    var rgb2oklch$1 = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        var ref = unpack$2(args, "rgb");
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2oklab(r, g, b);
        var l = ref$1[0];
        var a = ref$1[1];
        var b_ = ref$1[2];
        return lab2lch(l, a, b_);
    };
    var rgb2oklch_1 = rgb2oklch$1;
    var unpack$1 = utils.unpack;
    var lch2lab = lch2lab_1;
    var oklab2rgb = oklab2rgb_1;
    var oklch2rgb = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        args = unpack$1(args, "lch");
        var l = args[0];
        var c = args[1];
        var h = args[2];
        var ref = lch2lab(l, c, h);
        var L = ref[0];
        var a = ref[1];
        var b_ = ref[2];
        var ref$1 = oklab2rgb(L, a, b_);
        var r = ref$1[0];
        var g = ref$1[1];
        var b = ref$1[2];
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    var oklch2rgb_1 = oklch2rgb;
    var unpack = utils.unpack;
    var type$7 = utils.type;
    var chroma$5 = chroma_1;
    var Color$n = Color_1;
    var input = input$h;
    var rgb2oklch = rgb2oklch_1;
    Color$n.prototype.oklch = function() {
        return rgb2oklch(this._rgb);
    };
    chroma$5.oklch = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return new (Function.prototype.bind.apply(Color$n, [
            null
        ].concat(args, [
            "oklch"
        ])));
    };
    input.format.oklch = oklch2rgb_1;
    input.autodetect.push({
        p: 3,
        test: function() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            args = unpack(args, "oklch");
            if (type$7(args) === "array" && args.length === 3) return "oklch";
        }
    });
    var Color$m = Color_1;
    var type$6 = utils.type;
    Color$m.prototype.alpha = function(a, mutate) {
        if (mutate === void 0) mutate = false;
        if (a !== undefined && type$6(a) === "number") {
            if (mutate) {
                this._rgb[3] = a;
                return this;
            }
            return new Color$m([
                this._rgb[0],
                this._rgb[1],
                this._rgb[2],
                a
            ], "rgb");
        }
        return this._rgb[3];
    };
    var Color$l = Color_1;
    Color$l.prototype.clipped = function() {
        return this._rgb._clipped || false;
    };
    var Color$k = Color_1;
    var LAB_CONSTANTS$1 = labConstants;
    Color$k.prototype.darken = function(amount) {
        if (amount === void 0) amount = 1;
        var me = this;
        var lab = me.lab();
        lab[0] -= LAB_CONSTANTS$1.Kn * amount;
        return new Color$k(lab, "lab").alpha(me.alpha(), true);
    };
    Color$k.prototype.brighten = function(amount) {
        if (amount === void 0) amount = 1;
        return this.darken(-amount);
    };
    Color$k.prototype.darker = Color$k.prototype.darken;
    Color$k.prototype.brighter = Color$k.prototype.brighten;
    var Color$j = Color_1;
    Color$j.prototype.get = function(mc) {
        var ref = mc.split(".");
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel) - (mode.substr(0, 2) === "ok" ? 2 : 0);
            if (i > -1) return src[i];
            throw new Error("unknown channel " + channel + " in mode " + mode);
        } else return src;
    };
    var Color$i = Color_1;
    var type$5 = utils.type;
    var pow$6 = Math.pow;
    var EPS = 1e-7;
    var MAX_ITER = 20;
    Color$i.prototype.luminance = function(lum) {
        if (lum !== undefined && type$5(lum) === "number") {
            if (lum === 0) // return pure black
            return new Color$i([
                0,
                0,
                0,
                this._rgb[3]
            ], "rgb");
            if (lum === 1) // return pure white
            return new Color$i([
                255,
                255,
                255,
                this._rgb[3]
            ], "rgb");
            // compute new color using...
            var cur_lum = this.luminance();
            var mode = "rgb";
            var max_iter = MAX_ITER;
            var test = function(low, high) {
                var mid = low.interpolate(high, 0.5, mode);
                var lm = mid.luminance();
                if (Math.abs(lum - lm) < EPS || !max_iter--) // close enough
                return mid;
                return lm > lum ? test(low, mid) : test(mid, high);
            };
            var rgb = (cur_lum > lum ? test(new Color$i([
                0,
                0,
                0
            ]), this) : test(this, new Color$i([
                255,
                255,
                255
            ]))).rgb();
            return new Color$i(rgb.concat([
                this._rgb[3]
            ]));
        }
        return rgb2luminance.apply(void 0, this._rgb.slice(0, 3));
    };
    var rgb2luminance = function(r, g, b) {
        // relative luminance
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        r = luminance_x(r);
        g = luminance_x(g);
        b = luminance_x(b);
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };
    var luminance_x = function(x) {
        x /= 255;
        return x <= 0.03928 ? x / 12.92 : pow$6((x + 0.055) / 1.055, 2.4);
    };
    var interpolator$1 = {};
    var Color$h = Color_1;
    var type$4 = utils.type;
    var interpolator = interpolator$1;
    var mix$1 = function(col1, col2, f) {
        if (f === void 0) f = 0.5;
        var rest = [], len = arguments.length - 3;
        while(len-- > 0)rest[len] = arguments[len + 3];
        var mode = rest[0] || "lrgb";
        if (!interpolator[mode] && !rest.length) // fall back to the first supported mode
        mode = Object.keys(interpolator)[0];
        if (!interpolator[mode]) throw new Error("interpolation mode " + mode + " is not defined");
        if (type$4(col1) !== "object") col1 = new Color$h(col1);
        if (type$4(col2) !== "object") col2 = new Color$h(col2);
        return interpolator[mode](col1, col2, f).alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
    };
    var Color$g = Color_1;
    var mix = mix$1;
    Color$g.prototype.mix = Color$g.prototype.interpolate = function(col2, f) {
        if (f === void 0) f = 0.5;
        var rest = [], len = arguments.length - 2;
        while(len-- > 0)rest[len] = arguments[len + 2];
        return mix.apply(void 0, [
            this,
            col2,
            f
        ].concat(rest));
    };
    var Color$f = Color_1;
    Color$f.prototype.premultiply = function(mutate) {
        if (mutate === void 0) mutate = false;
        var rgb = this._rgb;
        var a = rgb[3];
        if (mutate) {
            this._rgb = [
                rgb[0] * a,
                rgb[1] * a,
                rgb[2] * a,
                a
            ];
            return this;
        } else return new Color$f([
            rgb[0] * a,
            rgb[1] * a,
            rgb[2] * a,
            a
        ], "rgb");
    };
    var Color$e = Color_1;
    var LAB_CONSTANTS = labConstants;
    Color$e.prototype.saturate = function(amount) {
        if (amount === void 0) amount = 1;
        var me = this;
        var lch = me.lch();
        lch[1] += LAB_CONSTANTS.Kn * amount;
        if (lch[1] < 0) lch[1] = 0;
        return new Color$e(lch, "lch").alpha(me.alpha(), true);
    };
    Color$e.prototype.desaturate = function(amount) {
        if (amount === void 0) amount = 1;
        return this.saturate(-amount);
    };
    var Color$d = Color_1;
    var type$3 = utils.type;
    Color$d.prototype.set = function(mc, value, mutate) {
        if (mutate === void 0) mutate = false;
        var ref = mc.split(".");
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel) - (mode.substr(0, 2) === "ok" ? 2 : 0);
            if (i > -1) {
                if (type$3(value) == "string") switch(value.charAt(0)){
                    case "+":
                        src[i] += +value;
                        break;
                    case "-":
                        src[i] += +value;
                        break;
                    case "*":
                        src[i] *= +value.substr(1);
                        break;
                    case "/":
                        src[i] /= +value.substr(1);
                        break;
                    default:
                        src[i] = +value;
                }
                else if (type$3(value) === "number") src[i] = value;
                else throw new Error("unsupported value for Color.set");
                var out = new Color$d(src, mode);
                if (mutate) {
                    this._rgb = out._rgb;
                    return this;
                }
                return out;
            }
            throw new Error("unknown channel " + channel + " in mode " + mode);
        } else return src;
    };
    var Color$c = Color_1;
    var rgb = function(col1, col2, f) {
        var xyz0 = col1._rgb;
        var xyz1 = col2._rgb;
        return new Color$c(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), "rgb");
    };
    // register interpolator
    interpolator$1.rgb = rgb;
    var Color$b = Color_1;
    var sqrt$2 = Math.sqrt;
    var pow$5 = Math.pow;
    var lrgb = function(col1, col2, f) {
        var ref = col1._rgb;
        var x1 = ref[0];
        var y1 = ref[1];
        var z1 = ref[2];
        var ref$1 = col2._rgb;
        var x2 = ref$1[0];
        var y2 = ref$1[1];
        var z2 = ref$1[2];
        return new Color$b(sqrt$2(pow$5(x1, 2) * (1 - f) + pow$5(x2, 2) * f), sqrt$2(pow$5(y1, 2) * (1 - f) + pow$5(y2, 2) * f), sqrt$2(pow$5(z1, 2) * (1 - f) + pow$5(z2, 2) * f), "rgb");
    };
    // register interpolator
    interpolator$1.lrgb = lrgb;
    var Color$a = Color_1;
    var lab = function(col1, col2, f) {
        var xyz0 = col1.lab();
        var xyz1 = col2.lab();
        return new Color$a(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), "lab");
    };
    // register interpolator
    interpolator$1.lab = lab;
    var Color$9 = Color_1;
    var _hsx = function(col1, col2, f, m) {
        var assign, assign$1;
        var xyz0, xyz1;
        if (m === "hsl") {
            xyz0 = col1.hsl();
            xyz1 = col2.hsl();
        } else if (m === "hsv") {
            xyz0 = col1.hsv();
            xyz1 = col2.hsv();
        } else if (m === "hcg") {
            xyz0 = col1.hcg();
            xyz1 = col2.hcg();
        } else if (m === "hsi") {
            xyz0 = col1.hsi();
            xyz1 = col2.hsi();
        } else if (m === "lch" || m === "hcl") {
            m = "hcl";
            xyz0 = col1.hcl();
            xyz1 = col2.hcl();
        } else if (m === "oklch") {
            xyz0 = col1.oklch().reverse();
            xyz1 = col2.oklch().reverse();
        }
        var hue0, hue1, sat0, sat1, lbv0, lbv1;
        if (m.substr(0, 1) === "h" || m === "oklch") {
            assign = xyz0, hue0 = assign[0], sat0 = assign[1], lbv0 = assign[2];
            assign$1 = xyz1, hue1 = assign$1[0], sat1 = assign$1[1], lbv1 = assign$1[2];
        }
        var sat, hue, lbv, dh;
        if (!isNaN(hue0) && !isNaN(hue1)) {
            // both colors have hue
            if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
            else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
            else dh = hue1 - hue0;
            hue = hue0 + f * dh;
        } else if (!isNaN(hue0)) {
            hue = hue0;
            if ((lbv1 == 1 || lbv1 == 0) && m != "hsv") sat = sat0;
        } else if (!isNaN(hue1)) {
            hue = hue1;
            if ((lbv0 == 1 || lbv0 == 0) && m != "hsv") sat = sat1;
        } else hue = Number.NaN;
        if (sat === undefined) sat = sat0 + f * (sat1 - sat0);
        lbv = lbv0 + f * (lbv1 - lbv0);
        return m === "oklch" ? new Color$9([
            lbv,
            sat,
            hue
        ], m) : new Color$9([
            hue,
            sat,
            lbv
        ], m);
    };
    var interpolate_hsx$5 = _hsx;
    var lch = function(col1, col2, f) {
        return interpolate_hsx$5(col1, col2, f, "lch");
    };
    // register interpolator
    interpolator$1.lch = lch;
    interpolator$1.hcl = lch;
    var Color$8 = Color_1;
    var num = function(col1, col2, f) {
        var c1 = col1.num();
        var c2 = col2.num();
        return new Color$8(c1 + f * (c2 - c1), "num");
    };
    // register interpolator
    interpolator$1.num = num;
    var interpolate_hsx$4 = _hsx;
    var hcg = function(col1, col2, f) {
        return interpolate_hsx$4(col1, col2, f, "hcg");
    };
    // register interpolator
    interpolator$1.hcg = hcg;
    var interpolate_hsx$3 = _hsx;
    var hsi = function(col1, col2, f) {
        return interpolate_hsx$3(col1, col2, f, "hsi");
    };
    // register interpolator
    interpolator$1.hsi = hsi;
    var interpolate_hsx$2 = _hsx;
    var hsl = function(col1, col2, f) {
        return interpolate_hsx$2(col1, col2, f, "hsl");
    };
    // register interpolator
    interpolator$1.hsl = hsl;
    var interpolate_hsx$1 = _hsx;
    var hsv = function(col1, col2, f) {
        return interpolate_hsx$1(col1, col2, f, "hsv");
    };
    // register interpolator
    interpolator$1.hsv = hsv;
    var Color$7 = Color_1;
    var oklab = function(col1, col2, f) {
        var xyz0 = col1.oklab();
        var xyz1 = col2.oklab();
        return new Color$7(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), "oklab");
    };
    // register interpolator
    interpolator$1.oklab = oklab;
    var interpolate_hsx = _hsx;
    var oklch = function(col1, col2, f) {
        return interpolate_hsx(col1, col2, f, "oklch");
    };
    // register interpolator
    interpolator$1.oklch = oklch;
    var Color$6 = Color_1;
    var clip_rgb$1 = utils.clip_rgb;
    var pow$4 = Math.pow;
    var sqrt$1 = Math.sqrt;
    var PI$1 = Math.PI;
    var cos$2 = Math.cos;
    var sin$2 = Math.sin;
    var atan2$1 = Math.atan2;
    var average = function(colors, mode, weights) {
        if (mode === void 0) mode = "lrgb";
        if (weights === void 0) weights = null;
        var l = colors.length;
        if (!weights) weights = Array.from(new Array(l)).map(function() {
            return 1;
        });
        // normalize weights
        var k = l / weights.reduce(function(a, b) {
            return a + b;
        });
        weights.forEach(function(w, i) {
            weights[i] *= k;
        });
        // convert colors to Color objects
        colors = colors.map(function(c) {
            return new Color$6(c);
        });
        if (mode === "lrgb") return _average_lrgb(colors, weights);
        var first = colors.shift();
        var xyz = first.get(mode);
        var cnt = [];
        var dx = 0;
        var dy = 0;
        // initial color
        for(var i = 0; i < xyz.length; i++){
            xyz[i] = (xyz[i] || 0) * weights[0];
            cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
            if (mode.charAt(i) === "h" && !isNaN(xyz[i])) {
                var A = xyz[i] / 180 * PI$1;
                dx += cos$2(A) * weights[0];
                dy += sin$2(A) * weights[0];
            }
        }
        var alpha = first.alpha() * weights[0];
        colors.forEach(function(c, ci) {
            var xyz2 = c.get(mode);
            alpha += c.alpha() * weights[ci + 1];
            for(var i = 0; i < xyz.length; i++)if (!isNaN(xyz2[i])) {
                cnt[i] += weights[ci + 1];
                if (mode.charAt(i) === "h") {
                    var A = xyz2[i] / 180 * PI$1;
                    dx += cos$2(A) * weights[ci + 1];
                    dy += sin$2(A) * weights[ci + 1];
                } else xyz[i] += xyz2[i] * weights[ci + 1];
            }
        });
        for(var i$1 = 0; i$1 < xyz.length; i$1++)if (mode.charAt(i$1) === "h") {
            var A$1 = atan2$1(dy / cnt[i$1], dx / cnt[i$1]) / PI$1 * 180;
            while(A$1 < 0)A$1 += 360;
            while(A$1 >= 360)A$1 -= 360;
            xyz[i$1] = A$1;
        } else xyz[i$1] = xyz[i$1] / cnt[i$1];
        alpha /= l;
        return new Color$6(xyz, mode).alpha(alpha > 0.99999 ? 1 : alpha, true);
    };
    var _average_lrgb = function(colors, weights) {
        var l = colors.length;
        var xyz = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0; i < colors.length; i++){
            var col = colors[i];
            var f = weights[i] / l;
            var rgb = col._rgb;
            xyz[0] += pow$4(rgb[0], 2) * f;
            xyz[1] += pow$4(rgb[1], 2) * f;
            xyz[2] += pow$4(rgb[2], 2) * f;
            xyz[3] += rgb[3] * f;
        }
        xyz[0] = sqrt$1(xyz[0]);
        xyz[1] = sqrt$1(xyz[1]);
        xyz[2] = sqrt$1(xyz[2]);
        if (xyz[3] > 0.9999999) xyz[3] = 1;
        return new Color$6(clip_rgb$1(xyz));
    };
    // minimal multi-purpose interface
    // @requires utils color analyze
    var chroma$4 = chroma_1;
    var type$2 = utils.type;
    var pow$3 = Math.pow;
    var scale$2 = function(colors) {
        // constructor
        var _mode = "rgb";
        var _nacol = chroma$4("#ccc");
        var _spread = 0;
        // const _fixed = false;
        var _domain = [
            0,
            1
        ];
        var _pos = [];
        var _padding = [
            0,
            0
        ];
        var _classes = false;
        var _colors = [];
        var _out = false;
        var _min = 0;
        var _max = 1;
        var _correctLightness = false;
        var _colorCache = {};
        var _useCache = true;
        var _gamma = 1;
        // private methods
        var setColors = function(colors) {
            colors = colors || [
                "#fff",
                "#000"
            ];
            if (colors && type$2(colors) === "string" && chroma$4.brewer && chroma$4.brewer[colors.toLowerCase()]) colors = chroma$4.brewer[colors.toLowerCase()];
            if (type$2(colors) === "array") {
                // handle single color
                if (colors.length === 1) colors = [
                    colors[0],
                    colors[0]
                ];
                // make a copy of the colors
                colors = colors.slice(0);
                // convert to chroma classes
                for(var c = 0; c < colors.length; c++)colors[c] = chroma$4(colors[c]);
                // auto-fill color position
                _pos.length = 0;
                for(var c$1 = 0; c$1 < colors.length; c$1++)_pos.push(c$1 / (colors.length - 1));
            }
            resetCache();
            return _colors = colors;
        };
        var getClass = function(value) {
            if (_classes != null) {
                var n = _classes.length - 1;
                var i = 0;
                while(i < n && value >= _classes[i])i++;
                return i - 1;
            }
            return 0;
        };
        var tMapLightness = function(t) {
            return t;
        };
        var tMapDomain = function(t) {
            return t;
        };
        // const classifyValue = function(value) {
        //     let val = value;
        //     if (_classes.length > 2) {
        //         const n = _classes.length-1;
        //         const i = getClass(value);
        //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
        //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
        //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
        //     }
        //     return val;
        // };
        var getColor = function(val, bypassMap) {
            var col, t;
            if (bypassMap == null) bypassMap = false;
            if (isNaN(val) || val === null) return _nacol;
            if (!bypassMap) {
                if (_classes && _classes.length > 2) {
                    // find the class
                    var c = getClass(val);
                    t = c / (_classes.length - 2);
                } else if (_max !== _min) // just interpolate between min/max
                t = (val - _min) / (_max - _min);
                else t = 1;
            } else t = val;
            // domain map
            t = tMapDomain(t);
            if (!bypassMap) t = tMapLightness(t); // lightness correction
            if (_gamma !== 1) t = pow$3(t, _gamma);
            t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
            t = Math.min(1, Math.max(0, t));
            var k = Math.floor(t * 10000);
            if (_useCache && _colorCache[k]) col = _colorCache[k];
            else {
                if (type$2(_colors) === "array") //for i in [0.._pos.length-1]
                for(var i = 0; i < _pos.length; i++){
                    var p = _pos[i];
                    if (t <= p) {
                        col = _colors[i];
                        break;
                    }
                    if (t >= p && i === _pos.length - 1) {
                        col = _colors[i];
                        break;
                    }
                    if (t > p && t < _pos[i + 1]) {
                        t = (t - p) / (_pos[i + 1] - p);
                        col = chroma$4.interpolate(_colors[i], _colors[i + 1], t, _mode);
                        break;
                    }
                }
                else if (type$2(_colors) === "function") col = _colors(t);
                if (_useCache) _colorCache[k] = col;
            }
            return col;
        };
        var resetCache = function() {
            return _colorCache = {};
        };
        setColors(colors);
        // public interface
        var f = function(v) {
            var c = chroma$4(getColor(v));
            if (_out && c[_out]) return c[_out]();
            else return c;
        };
        f.classes = function(classes) {
            if (classes != null) {
                if (type$2(classes) === "array") {
                    _classes = classes;
                    _domain = [
                        classes[0],
                        classes[classes.length - 1]
                    ];
                } else {
                    var d = chroma$4.analyze(_domain);
                    if (classes === 0) _classes = [
                        d.min,
                        d.max
                    ];
                    else _classes = chroma$4.limits(d, "e", classes);
                }
                return f;
            }
            return _classes;
        };
        f.domain = function(domain) {
            if (!arguments.length) return _domain;
            _min = domain[0];
            _max = domain[domain.length - 1];
            _pos = [];
            var k = _colors.length;
            if (domain.length === k && _min !== _max) // update positions
            for(var i = 0, list = Array.from(domain); i < list.length; i += 1){
                var d = list[i];
                _pos.push((d - _min) / (_max - _min));
            }
            else {
                for(var c = 0; c < k; c++)_pos.push(c / (k - 1));
                if (domain.length > 2) {
                    // set domain map
                    var tOut = domain.map(function(d, i) {
                        return i / (domain.length - 1);
                    });
                    var tBreaks = domain.map(function(d) {
                        return (d - _min) / (_max - _min);
                    });
                    if (!tBreaks.every(function(val, i) {
                        return tOut[i] === val;
                    })) tMapDomain = function(t) {
                        if (t <= 0 || t >= 1) return t;
                        var i = 0;
                        while(t >= tBreaks[i + 1])i++;
                        var f = (t - tBreaks[i]) / (tBreaks[i + 1] - tBreaks[i]);
                        var out = tOut[i] + f * (tOut[i + 1] - tOut[i]);
                        return out;
                    };
                }
            }
            _domain = [
                _min,
                _max
            ];
            return f;
        };
        f.mode = function(_m) {
            if (!arguments.length) return _mode;
            _mode = _m;
            resetCache();
            return f;
        };
        f.range = function(colors, _pos) {
            setColors(colors);
            return f;
        };
        f.out = function(_o) {
            _out = _o;
            return f;
        };
        f.spread = function(val) {
            if (!arguments.length) return _spread;
            _spread = val;
            return f;
        };
        f.correctLightness = function(v) {
            if (v == null) v = true;
            _correctLightness = v;
            resetCache();
            if (_correctLightness) tMapLightness = function(t) {
                var L0 = getColor(0, true).lab()[0];
                var L1 = getColor(1, true).lab()[0];
                var pol = L0 > L1;
                var L_actual = getColor(t, true).lab()[0];
                var L_ideal = L0 + (L1 - L0) * t;
                var L_diff = L_actual - L_ideal;
                var t0 = 0;
                var t1 = 1;
                var max_iter = 20;
                while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                    if (pol) L_diff *= -1;
                    if (L_diff < 0) {
                        t0 = t;
                        t += (t1 - t) * 0.5;
                    } else {
                        t1 = t;
                        t += (t0 - t) * 0.5;
                    }
                    L_actual = getColor(t, true).lab()[0];
                    return L_diff = L_actual - L_ideal;
                })();
                return t;
            };
            else tMapLightness = function(t) {
                return t;
            };
            return f;
        };
        f.padding = function(p) {
            if (p != null) {
                if (type$2(p) === "number") p = [
                    p,
                    p
                ];
                _padding = p;
                return f;
            } else return _padding;
        };
        f.colors = function(numColors, out) {
            // If no arguments are given, return the original colors that were provided
            if (arguments.length < 2) out = "hex";
            var result = [];
            if (arguments.length === 0) result = _colors.slice(0);
            else if (numColors === 1) result = [
                f(0.5)
            ];
            else if (numColors > 1) {
                var dm = _domain[0];
                var dd = _domain[1] - dm;
                result = __range__(0, numColors, false).map(function(i) {
                    return f(dm + i / (numColors - 1) * dd);
                });
            } else {
                colors = [];
                var samples = [];
                if (_classes && _classes.length > 2) for(var i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
                else samples = _domain;
                result = samples.map(function(v) {
                    return f(v);
                });
            }
            if (chroma$4[out]) result = result.map(function(c) {
                return c[out]();
            });
            return result;
        };
        f.cache = function(c) {
            if (c != null) {
                _useCache = c;
                return f;
            } else return _useCache;
        };
        f.gamma = function(g) {
            if (g != null) {
                _gamma = g;
                return f;
            } else return _gamma;
        };
        f.nodata = function(d) {
            if (d != null) {
                _nacol = chroma$4(d);
                return f;
            } else return _nacol;
        };
        return f;
    };
    function __range__(left, right, inclusive) {
        var range = [];
        var ascending = left < right;
        var end = !inclusive ? right : ascending ? right + 1 : right - 1;
        for(var i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
        return range;
    }
    //
    // interpolates between a set of colors uzing a bezier spline
    //
    // @requires utils lab
    var Color$5 = Color_1;
    var scale$1 = scale$2;
    // nth row of the pascal triangle
    var binom_row = function(n) {
        var row = [
            1,
            1
        ];
        for(var i = 1; i < n; i++){
            var newrow = [
                1
            ];
            for(var j = 1; j <= row.length; j++)newrow[j] = (row[j] || 0) + row[j - 1];
            row = newrow;
        }
        return row;
    };
    var bezier = function(colors) {
        var assign, assign$1, assign$2;
        var I, lab0, lab1, lab2;
        colors = colors.map(function(c) {
            return new Color$5(c);
        });
        if (colors.length === 2) {
            // linear interpolation
            assign = colors.map(function(c) {
                return c.lab();
            }), lab0 = assign[0], lab1 = assign[1];
            I = function(t) {
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return lab0[i] + t * (lab1[i] - lab0[i]);
                });
                return new Color$5(lab, "lab");
            };
        } else if (colors.length === 3) {
            // quadratic bezier interpolation
            assign$1 = colors.map(function(c) {
                return c.lab();
            }), lab0 = assign$1[0], lab1 = assign$1[1], lab2 = assign$1[2];
            I = function(t) {
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return (1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i];
                });
                return new Color$5(lab, "lab");
            };
        } else if (colors.length === 4) {
            // cubic bezier interpolation
            var lab3;
            assign$2 = colors.map(function(c) {
                return c.lab();
            }), lab0 = assign$2[0], lab1 = assign$2[1], lab2 = assign$2[2], lab3 = assign$2[3];
            I = function(t) {
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return (1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i];
                });
                return new Color$5(lab, "lab");
            };
        } else if (colors.length >= 5) {
            // general case (degree n bezier)
            var labs, row, n;
            labs = colors.map(function(c) {
                return c.lab();
            });
            n = colors.length - 1;
            row = binom_row(n);
            I = function(t) {
                var u = 1 - t;
                var lab = [
                    0,
                    1,
                    2
                ].map(function(i) {
                    return labs.reduce(function(sum, el, j) {
                        return sum + row[j] * Math.pow(u, n - j) * Math.pow(t, j) * el[i];
                    }, 0);
                });
                return new Color$5(lab, "lab");
            };
        } else throw new RangeError("No point in running bezier with only one color.");
        return I;
    };
    var bezier_1 = function(colors) {
        var f = bezier(colors);
        f.scale = function() {
            return scale$1(f);
        };
        return f;
    };
    /*
     * interpolates between a set of colors uzing a bezier spline
     * blend mode formulas taken from http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
     */ var chroma$3 = chroma_1;
    var blend = function(bottom, top, mode) {
        if (!blend[mode]) throw new Error("unknown blend mode " + mode);
        return blend[mode](bottom, top);
    };
    var blend_f = function(f) {
        return function(bottom, top) {
            var c0 = chroma$3(top).rgb();
            var c1 = chroma$3(bottom).rgb();
            return chroma$3.rgb(f(c0, c1));
        };
    };
    var each = function(f) {
        return function(c0, c1) {
            var out = [];
            out[0] = f(c0[0], c1[0]);
            out[1] = f(c0[1], c1[1]);
            out[2] = f(c0[2], c1[2]);
            return out;
        };
    };
    var normal = function(a) {
        return a;
    };
    var multiply = function(a, b) {
        return a * b / 255;
    };
    var darken = function(a, b) {
        return a > b ? b : a;
    };
    var lighten = function(a, b) {
        return a > b ? a : b;
    };
    var screen = function(a, b) {
        return 255 * (1 - (1 - a / 255) * (1 - b / 255));
    };
    var overlay = function(a, b) {
        return b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
    };
    var burn = function(a, b) {
        return 255 * (1 - (1 - b / 255) / (a / 255));
    };
    var dodge = function(a, b) {
        if (a === 255) return 255;
        a = 255 * (b / 255) / (1 - a / 255);
        return a > 255 ? 255 : a;
    };
    // # add = (a,b) ->
    // #     if (a + b > 255) then 255 else a + b
    blend.normal = blend_f(each(normal));
    blend.multiply = blend_f(each(multiply));
    blend.screen = blend_f(each(screen));
    blend.overlay = blend_f(each(overlay));
    blend.darken = blend_f(each(darken));
    blend.lighten = blend_f(each(lighten));
    blend.dodge = blend_f(each(dodge));
    blend.burn = blend_f(each(burn));
    // blend.add = blend_f(each(add));
    var blend_1 = blend;
    // cubehelix interpolation
    // based on D.A. Green "A colour scheme for the display of astronomical intensity images"
    // http://astron-soc.in/bulletin/11June/289392011.pdf
    var type$1 = utils.type;
    var clip_rgb = utils.clip_rgb;
    var TWOPI = utils.TWOPI;
    var pow$2 = Math.pow;
    var sin$1 = Math.sin;
    var cos$1 = Math.cos;
    var chroma$2 = chroma_1;
    var cubehelix = function(start, rotations, hue, gamma, lightness) {
        if (start === void 0) start = 300;
        if (rotations === void 0) rotations = -1.5;
        if (hue === void 0) hue = 1;
        if (gamma === void 0) gamma = 1;
        if (lightness === void 0) lightness = [
            0,
            1
        ];
        var dh = 0, dl;
        if (type$1(lightness) === "array") dl = lightness[1] - lightness[0];
        else {
            dl = 0;
            lightness = [
                lightness,
                lightness
            ];
        }
        var f = function(fract) {
            var a = TWOPI * ((start + 120) / 360 + rotations * fract);
            var l = pow$2(lightness[0] + dl * fract, gamma);
            var h = dh !== 0 ? hue[0] + fract * dh : hue;
            var amp = h * l * (1 - l) / 2;
            var cos_a = cos$1(a);
            var sin_a = sin$1(a);
            var r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
            var g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
            var b = l + amp * (1.97294 * cos_a);
            return chroma$2(clip_rgb([
                r * 255,
                g * 255,
                b * 255,
                1
            ]));
        };
        f.start = function(s) {
            if (s == null) return start;
            start = s;
            return f;
        };
        f.rotations = function(r) {
            if (r == null) return rotations;
            rotations = r;
            return f;
        };
        f.gamma = function(g) {
            if (g == null) return gamma;
            gamma = g;
            return f;
        };
        f.hue = function(h) {
            if (h == null) return hue;
            hue = h;
            if (type$1(hue) === "array") {
                dh = hue[1] - hue[0];
                if (dh === 0) hue = hue[1];
            } else dh = 0;
            return f;
        };
        f.lightness = function(h) {
            if (h == null) return lightness;
            if (type$1(h) === "array") {
                lightness = h;
                dl = h[1] - h[0];
            } else {
                lightness = [
                    h,
                    h
                ];
                dl = 0;
            }
            return f;
        };
        f.scale = function() {
            return chroma$2.scale(f);
        };
        f.hue(hue);
        return f;
    };
    var Color$4 = Color_1;
    var digits = "0123456789abcdef";
    var floor$1 = Math.floor;
    var random = Math.random;
    var random_1 = function() {
        var code = "#";
        for(var i = 0; i < 6; i++)code += digits.charAt(floor$1(random() * 16));
        return new Color$4(code, "hex");
    };
    var type = type$p;
    var log = Math.log;
    var pow$1 = Math.pow;
    var floor = Math.floor;
    var abs$1 = Math.abs;
    var analyze = function(data, key) {
        if (key === void 0) key = null;
        var r = {
            min: Number.MAX_VALUE,
            max: Number.MAX_VALUE * -1,
            sum: 0,
            values: [],
            count: 0
        };
        if (type(data) === "object") data = Object.values(data);
        data.forEach(function(val) {
            if (key && type(val) === "object") val = val[key];
            if (val !== undefined && val !== null && !isNaN(val)) {
                r.values.push(val);
                r.sum += val;
                if (val < r.min) r.min = val;
                if (val > r.max) r.max = val;
                r.count += 1;
            }
        });
        r.domain = [
            r.min,
            r.max
        ];
        r.limits = function(mode, num) {
            return limits(r, mode, num);
        };
        return r;
    };
    var limits = function(data, mode, num) {
        if (mode === void 0) mode = "equal";
        if (num === void 0) num = 7;
        if (type(data) == "array") data = analyze(data);
        var min = data.min;
        var max = data.max;
        var values = data.values.sort(function(a, b) {
            return a - b;
        });
        if (num === 1) return [
            min,
            max
        ];
        var limits = [];
        if (mode.substr(0, 1) === "c") {
            limits.push(min);
            limits.push(max);
        }
        if (mode.substr(0, 1) === "e") {
            limits.push(min);
            for(var i = 1; i < num; i++)limits.push(min + i / num * (max - min));
            limits.push(max);
        } else if (mode.substr(0, 1) === "l") {
            if (min <= 0) throw new Error("Logarithmic scales are only possible for values > 0");
            var min_log = Math.LOG10E * log(min);
            var max_log = Math.LOG10E * log(max);
            limits.push(min);
            for(var i$1 = 1; i$1 < num; i$1++)limits.push(pow$1(10, min_log + i$1 / num * (max_log - min_log)));
            limits.push(max);
        } else if (mode.substr(0, 1) === "q") {
            limits.push(min);
            for(var i$2 = 1; i$2 < num; i$2++){
                var p = (values.length - 1) * i$2 / num;
                var pb = floor(p);
                if (pb === p) limits.push(values[pb]);
                else {
                    var pr = p - pb;
                    limits.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
                }
            }
            limits.push(max);
        } else if (mode.substr(0, 1) === "k") {
            /*
            implementation based on
            http://code.google.com/p/figue/source/browse/trunk/figue.js#336
            simplified for 1-d input values
            */ var cluster;
            var n = values.length;
            var assignments = new Array(n);
            var clusterSizes = new Array(num);
            var repeat = true;
            var nb_iters = 0;
            var centroids = null;
            // get seed values
            centroids = [];
            centroids.push(min);
            for(var i$3 = 1; i$3 < num; i$3++)centroids.push(min + i$3 / num * (max - min));
            centroids.push(max);
            while(repeat){
                // assignment step
                for(var j = 0; j < num; j++)clusterSizes[j] = 0;
                for(var i$4 = 0; i$4 < n; i$4++){
                    var value = values[i$4];
                    var mindist = Number.MAX_VALUE;
                    var best = void 0;
                    for(var j$1 = 0; j$1 < num; j$1++){
                        var dist = abs$1(centroids[j$1] - value);
                        if (dist < mindist) {
                            mindist = dist;
                            best = j$1;
                        }
                        clusterSizes[best]++;
                        assignments[i$4] = best;
                    }
                }
                // update centroids step
                var newCentroids = new Array(num);
                for(var j$2 = 0; j$2 < num; j$2++)newCentroids[j$2] = null;
                for(var i$5 = 0; i$5 < n; i$5++){
                    cluster = assignments[i$5];
                    if (newCentroids[cluster] === null) newCentroids[cluster] = values[i$5];
                    else newCentroids[cluster] += values[i$5];
                }
                for(var j$3 = 0; j$3 < num; j$3++)newCentroids[j$3] *= 1 / clusterSizes[j$3];
                // check convergence
                repeat = false;
                for(var j$4 = 0; j$4 < num; j$4++)if (newCentroids[j$4] !== centroids[j$4]) {
                    repeat = true;
                    break;
                }
                centroids = newCentroids;
                nb_iters++;
                if (nb_iters > 200) repeat = false;
            }
            // finished k-means clustering
            // the next part is borrowed from gabrielflor.it
            var kClusters = {};
            for(var j$5 = 0; j$5 < num; j$5++)kClusters[j$5] = [];
            for(var i$6 = 0; i$6 < n; i$6++){
                cluster = assignments[i$6];
                kClusters[cluster].push(values[i$6]);
            }
            var tmpKMeansBreaks = [];
            for(var j$6 = 0; j$6 < num; j$6++){
                tmpKMeansBreaks.push(kClusters[j$6][0]);
                tmpKMeansBreaks.push(kClusters[j$6][kClusters[j$6].length - 1]);
            }
            tmpKMeansBreaks = tmpKMeansBreaks.sort(function(a, b) {
                return a - b;
            });
            limits.push(tmpKMeansBreaks[0]);
            for(var i$7 = 1; i$7 < tmpKMeansBreaks.length; i$7 += 2){
                var v = tmpKMeansBreaks[i$7];
                if (!isNaN(v) && limits.indexOf(v) === -1) limits.push(v);
            }
        }
        return limits;
    };
    var analyze_1 = {
        analyze: analyze,
        limits: limits
    };
    var Color$3 = Color_1;
    var contrast = function(a, b) {
        // WCAG contrast ratio
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
        a = new Color$3(a);
        b = new Color$3(b);
        var l1 = a.luminance();
        var l2 = b.luminance();
        return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
    };
    var Color$2 = Color_1;
    var sqrt = Math.sqrt;
    var pow = Math.pow;
    var min = Math.min;
    var max = Math.max;
    var atan2 = Math.atan2;
    var abs = Math.abs;
    var cos = Math.cos;
    var sin = Math.sin;
    var exp = Math.exp;
    var PI = Math.PI;
    var deltaE = function(a, b, Kl, Kc, Kh) {
        if (Kl === void 0) Kl = 1;
        if (Kc === void 0) Kc = 1;
        if (Kh === void 0) Kh = 1;
        // Delta E (CIE 2000)
        // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CIE2000.html
        var rad2deg = function(rad) {
            return 360 * rad / (2 * PI);
        };
        var deg2rad = function(deg) {
            return 2 * PI * deg / 360;
        };
        a = new Color$2(a);
        b = new Color$2(b);
        var ref = Array.from(a.lab());
        var L1 = ref[0];
        var a1 = ref[1];
        var b1 = ref[2];
        var ref$1 = Array.from(b.lab());
        var L2 = ref$1[0];
        var a2 = ref$1[1];
        var b2 = ref$1[2];
        var avgL = (L1 + L2) / 2;
        var C1 = sqrt(pow(a1, 2) + pow(b1, 2));
        var C2 = sqrt(pow(a2, 2) + pow(b2, 2));
        var avgC = (C1 + C2) / 2;
        var G = 0.5 * (1 - sqrt(pow(avgC, 7) / (pow(avgC, 7) + pow(25, 7))));
        var a1p = a1 * (1 + G);
        var a2p = a2 * (1 + G);
        var C1p = sqrt(pow(a1p, 2) + pow(b1, 2));
        var C2p = sqrt(pow(a2p, 2) + pow(b2, 2));
        var avgCp = (C1p + C2p) / 2;
        var arctan1 = rad2deg(atan2(b1, a1p));
        var arctan2 = rad2deg(atan2(b2, a2p));
        var h1p = arctan1 >= 0 ? arctan1 : arctan1 + 360;
        var h2p = arctan2 >= 0 ? arctan2 : arctan2 + 360;
        var avgHp = abs(h1p - h2p) > 180 ? (h1p + h2p + 360) / 2 : (h1p + h2p) / 2;
        var T = 1 - 0.17 * cos(deg2rad(avgHp - 30)) + 0.24 * cos(deg2rad(2 * avgHp)) + 0.32 * cos(deg2rad(3 * avgHp + 6)) - 0.2 * cos(deg2rad(4 * avgHp - 63));
        var deltaHp = h2p - h1p;
        deltaHp = abs(deltaHp) <= 180 ? deltaHp : h2p <= h1p ? deltaHp + 360 : deltaHp - 360;
        deltaHp = 2 * sqrt(C1p * C2p) * sin(deg2rad(deltaHp) / 2);
        var deltaL = L2 - L1;
        var deltaCp = C2p - C1p;
        var sl = 1 + 0.015 * pow(avgL - 50, 2) / sqrt(20 + pow(avgL - 50, 2));
        var sc = 1 + 0.045 * avgCp;
        var sh = 1 + 0.015 * avgCp * T;
        var deltaTheta = 30 * exp(-pow((avgHp - 275) / 25, 2));
        var Rc = 2 * sqrt(pow(avgCp, 7) / (pow(avgCp, 7) + pow(25, 7)));
        var Rt = -Rc * sin(2 * deg2rad(deltaTheta));
        var result = sqrt(pow(deltaL / (Kl * sl), 2) + pow(deltaCp / (Kc * sc), 2) + pow(deltaHp / (Kh * sh), 2) + Rt * (deltaCp / (Kc * sc)) * (deltaHp / (Kh * sh)));
        return max(0, min(100, result));
    };
    var Color$1 = Color_1;
    // simple Euclidean distance
    var distance = function(a, b, mode) {
        if (mode === void 0) mode = "lab";
        // Delta E (CIE 1976)
        // see http://www.brucelindbloom.com/index.html?Equations.html
        a = new Color$1(a);
        b = new Color$1(b);
        var l1 = a.get(mode);
        var l2 = b.get(mode);
        var sum_sq = 0;
        for(var i in l1){
            var d = (l1[i] || 0) - (l2[i] || 0);
            sum_sq += d * d;
        }
        return Math.sqrt(sum_sq);
    };
    var Color = Color_1;
    var valid = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        try {
            new (Function.prototype.bind.apply(Color, [
                null
            ].concat(args)));
            return true;
        } catch (e) {
            return false;
        }
    };
    // some pre-defined color scales:
    var chroma$1 = chroma_1;
    var scale = scale$2;
    var scales = {
        cool: function cool() {
            return scale([
                chroma$1.hsl(180, 1, .9),
                chroma$1.hsl(250, .7, .4)
            ]);
        },
        hot: function hot() {
            return scale([
                "#000",
                "#f00",
                "#ff0",
                "#fff"
            ]).mode("rgb");
        }
    };
    /**
        ColorBrewer colors for chroma.js

        Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
        Pennsylvania State University.

        Licensed under the Apache License, Version 2.0 (the "License");
        you may not use this file except in compliance with the License.
        You may obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0

        Unless required by applicable law or agreed to in writing, software distributed
        under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
        CONDITIONS OF ANY KIND, either express or implied. See the License for the
        specific language governing permissions and limitations under the License.
    */ var colorbrewer = {
        // sequential
        OrRd: [
            "#fff7ec",
            "#fee8c8",
            "#fdd49e",
            "#fdbb84",
            "#fc8d59",
            "#ef6548",
            "#d7301f",
            "#b30000",
            "#7f0000"
        ],
        PuBu: [
            "#fff7fb",
            "#ece7f2",
            "#d0d1e6",
            "#a6bddb",
            "#74a9cf",
            "#3690c0",
            "#0570b0",
            "#045a8d",
            "#023858"
        ],
        BuPu: [
            "#f7fcfd",
            "#e0ecf4",
            "#bfd3e6",
            "#9ebcda",
            "#8c96c6",
            "#8c6bb1",
            "#88419d",
            "#810f7c",
            "#4d004b"
        ],
        Oranges: [
            "#fff5eb",
            "#fee6ce",
            "#fdd0a2",
            "#fdae6b",
            "#fd8d3c",
            "#f16913",
            "#d94801",
            "#a63603",
            "#7f2704"
        ],
        BuGn: [
            "#f7fcfd",
            "#e5f5f9",
            "#ccece6",
            "#99d8c9",
            "#66c2a4",
            "#41ae76",
            "#238b45",
            "#006d2c",
            "#00441b"
        ],
        YlOrBr: [
            "#ffffe5",
            "#fff7bc",
            "#fee391",
            "#fec44f",
            "#fe9929",
            "#ec7014",
            "#cc4c02",
            "#993404",
            "#662506"
        ],
        YlGn: [
            "#ffffe5",
            "#f7fcb9",
            "#d9f0a3",
            "#addd8e",
            "#78c679",
            "#41ab5d",
            "#238443",
            "#006837",
            "#004529"
        ],
        Reds: [
            "#fff5f0",
            "#fee0d2",
            "#fcbba1",
            "#fc9272",
            "#fb6a4a",
            "#ef3b2c",
            "#cb181d",
            "#a50f15",
            "#67000d"
        ],
        RdPu: [
            "#fff7f3",
            "#fde0dd",
            "#fcc5c0",
            "#fa9fb5",
            "#f768a1",
            "#dd3497",
            "#ae017e",
            "#7a0177",
            "#49006a"
        ],
        Greens: [
            "#f7fcf5",
            "#e5f5e0",
            "#c7e9c0",
            "#a1d99b",
            "#74c476",
            "#41ab5d",
            "#238b45",
            "#006d2c",
            "#00441b"
        ],
        YlGnBu: [
            "#ffffd9",
            "#edf8b1",
            "#c7e9b4",
            "#7fcdbb",
            "#41b6c4",
            "#1d91c0",
            "#225ea8",
            "#253494",
            "#081d58"
        ],
        Purples: [
            "#fcfbfd",
            "#efedf5",
            "#dadaeb",
            "#bcbddc",
            "#9e9ac8",
            "#807dba",
            "#6a51a3",
            "#54278f",
            "#3f007d"
        ],
        GnBu: [
            "#f7fcf0",
            "#e0f3db",
            "#ccebc5",
            "#a8ddb5",
            "#7bccc4",
            "#4eb3d3",
            "#2b8cbe",
            "#0868ac",
            "#084081"
        ],
        Greys: [
            "#ffffff",
            "#f0f0f0",
            "#d9d9d9",
            "#bdbdbd",
            "#969696",
            "#737373",
            "#525252",
            "#252525",
            "#000000"
        ],
        YlOrRd: [
            "#ffffcc",
            "#ffeda0",
            "#fed976",
            "#feb24c",
            "#fd8d3c",
            "#fc4e2a",
            "#e31a1c",
            "#bd0026",
            "#800026"
        ],
        PuRd: [
            "#f7f4f9",
            "#e7e1ef",
            "#d4b9da",
            "#c994c7",
            "#df65b0",
            "#e7298a",
            "#ce1256",
            "#980043",
            "#67001f"
        ],
        Blues: [
            "#f7fbff",
            "#deebf7",
            "#c6dbef",
            "#9ecae1",
            "#6baed6",
            "#4292c6",
            "#2171b5",
            "#08519c",
            "#08306b"
        ],
        PuBuGn: [
            "#fff7fb",
            "#ece2f0",
            "#d0d1e6",
            "#a6bddb",
            "#67a9cf",
            "#3690c0",
            "#02818a",
            "#016c59",
            "#014636"
        ],
        Viridis: [
            "#440154",
            "#482777",
            "#3f4a8a",
            "#31678e",
            "#26838f",
            "#1f9d8a",
            "#6cce5a",
            "#b6de2b",
            "#fee825"
        ],
        // diverging
        Spectral: [
            "#9e0142",
            "#d53e4f",
            "#f46d43",
            "#fdae61",
            "#fee08b",
            "#ffffbf",
            "#e6f598",
            "#abdda4",
            "#66c2a5",
            "#3288bd",
            "#5e4fa2"
        ],
        RdYlGn: [
            "#a50026",
            "#d73027",
            "#f46d43",
            "#fdae61",
            "#fee08b",
            "#ffffbf",
            "#d9ef8b",
            "#a6d96a",
            "#66bd63",
            "#1a9850",
            "#006837"
        ],
        RdBu: [
            "#67001f",
            "#b2182b",
            "#d6604d",
            "#f4a582",
            "#fddbc7",
            "#f7f7f7",
            "#d1e5f0",
            "#92c5de",
            "#4393c3",
            "#2166ac",
            "#053061"
        ],
        PiYG: [
            "#8e0152",
            "#c51b7d",
            "#de77ae",
            "#f1b6da",
            "#fde0ef",
            "#f7f7f7",
            "#e6f5d0",
            "#b8e186",
            "#7fbc41",
            "#4d9221",
            "#276419"
        ],
        PRGn: [
            "#40004b",
            "#762a83",
            "#9970ab",
            "#c2a5cf",
            "#e7d4e8",
            "#f7f7f7",
            "#d9f0d3",
            "#a6dba0",
            "#5aae61",
            "#1b7837",
            "#00441b"
        ],
        RdYlBu: [
            "#a50026",
            "#d73027",
            "#f46d43",
            "#fdae61",
            "#fee090",
            "#ffffbf",
            "#e0f3f8",
            "#abd9e9",
            "#74add1",
            "#4575b4",
            "#313695"
        ],
        BrBG: [
            "#543005",
            "#8c510a",
            "#bf812d",
            "#dfc27d",
            "#f6e8c3",
            "#f5f5f5",
            "#c7eae5",
            "#80cdc1",
            "#35978f",
            "#01665e",
            "#003c30"
        ],
        RdGy: [
            "#67001f",
            "#b2182b",
            "#d6604d",
            "#f4a582",
            "#fddbc7",
            "#ffffff",
            "#e0e0e0",
            "#bababa",
            "#878787",
            "#4d4d4d",
            "#1a1a1a"
        ],
        PuOr: [
            "#7f3b08",
            "#b35806",
            "#e08214",
            "#fdb863",
            "#fee0b6",
            "#f7f7f7",
            "#d8daeb",
            "#b2abd2",
            "#8073ac",
            "#542788",
            "#2d004b"
        ],
        // qualitative
        Set2: [
            "#66c2a5",
            "#fc8d62",
            "#8da0cb",
            "#e78ac3",
            "#a6d854",
            "#ffd92f",
            "#e5c494",
            "#b3b3b3"
        ],
        Accent: [
            "#7fc97f",
            "#beaed4",
            "#fdc086",
            "#ffff99",
            "#386cb0",
            "#f0027f",
            "#bf5b17",
            "#666666"
        ],
        Set1: [
            "#e41a1c",
            "#377eb8",
            "#4daf4a",
            "#984ea3",
            "#ff7f00",
            "#ffff33",
            "#a65628",
            "#f781bf",
            "#999999"
        ],
        Set3: [
            "#8dd3c7",
            "#ffffb3",
            "#bebada",
            "#fb8072",
            "#80b1d3",
            "#fdb462",
            "#b3de69",
            "#fccde5",
            "#d9d9d9",
            "#bc80bd",
            "#ccebc5",
            "#ffed6f"
        ],
        Dark2: [
            "#1b9e77",
            "#d95f02",
            "#7570b3",
            "#e7298a",
            "#66a61e",
            "#e6ab02",
            "#a6761d",
            "#666666"
        ],
        Paired: [
            "#a6cee3",
            "#1f78b4",
            "#b2df8a",
            "#33a02c",
            "#fb9a99",
            "#e31a1c",
            "#fdbf6f",
            "#ff7f00",
            "#cab2d6",
            "#6a3d9a",
            "#ffff99",
            "#b15928"
        ],
        Pastel2: [
            "#b3e2cd",
            "#fdcdac",
            "#cbd5e8",
            "#f4cae4",
            "#e6f5c9",
            "#fff2ae",
            "#f1e2cc",
            "#cccccc"
        ],
        Pastel1: [
            "#fbb4ae",
            "#b3cde3",
            "#ccebc5",
            "#decbe4",
            "#fed9a6",
            "#ffffcc",
            "#e5d8bd",
            "#fddaec",
            "#f2f2f2"
        ]
    };
    // add lowercase aliases for case-insensitive matches
    for(var i = 0, list = Object.keys(colorbrewer); i < list.length; i += 1){
        var key = list[i];
        colorbrewer[key.toLowerCase()] = colorbrewer[key];
    }
    var colorbrewer_1 = colorbrewer;
    var chroma = chroma_1;
    // feel free to comment out anything to rollup
    // a smaller chroma.js built
    // io --> convert colors
    // operators --> modify existing Colors
    // interpolators
    // generators -- > create new colors
    chroma.average = average;
    chroma.bezier = bezier_1;
    chroma.blend = blend_1;
    chroma.cubehelix = cubehelix;
    chroma.mix = chroma.interpolate = mix$1;
    chroma.random = random_1;
    chroma.scale = scale$2;
    // other utility methods
    chroma.analyze = analyze_1.analyze;
    chroma.contrast = contrast;
    chroma.deltaE = deltaE;
    chroma.distance = distance;
    chroma.limits = analyze_1.limits;
    chroma.valid = valid;
    // scale
    chroma.scales = scales;
    // colors
    chroma.colors = w3cx11_1;
    chroma.brewer = colorbrewer_1;
    var chroma_js = chroma;
    return chroma_js;
});


function $2c074f1619da40af$export$1089ae7f4d02cd2e(value) {
    // parse
    const [gradientNode] = (0, $87b9d64a64ded6fd$export$98e6a39c04603d36)(value);
    // process
    const type = ~gradientNode.type.indexOf("radial") ? "radial" : "linear";
    let direction = "bottom";
    let radialDirection = "center center";
    if (gradientNode.orientation) {
        const orientation = gradientNode.orientation;
        if (orientation.type === "angular") {
            const angle = orientation.value;
            if (angle >= 0 && angle < 45) direction = "top";
            else if (angle >= 45 && angle < 135) direction = "right";
            else if (angle >= 135 && angle < 225) direction = "bottom";
            else if (angle >= 225 && angle < 315) direction = "left";
            else direction = "top";
        } else if (orientation.type === "directional") direction = orientation.value;
        else if (orientation[0].type === "shape") {
            const x = orientation[0].at?.value?.x?.value || "center";
            const y = orientation[0].at?.value?.y?.value || "center";
            direction = y;
            radialDirection = `${x} ${y}`;
        }
    }
    const colors = gradientNode.colorStops.map(({ type: type, value: value, length: length })=>{
        const color = type === "hex" ? `#${value}` : value;
        return {
            color: color,
            position: +(length?.value || 0)
        };
    });
    // result
    return {
        type: type,
        direction: direction,
        radialDirection: radialDirection,
        colors: colors
    };
}
function $2c074f1619da40af$export$fa3c2aee2bc4649c(parsedResult) {
    const { type: type, direction: direction, radialDirection: radialDirection, colors: colors } = parsedResult;
    const linearDirectionMap = {
        top: "to top",
        right: "to right",
        center: "to right",
        bottom: "to bottom",
        left: "to left"
    };
    return `${type}-gradient(${type === "radial" ? `circle at ${radialDirection}` : linearDirectionMap[direction]}, ${colors.map(({ color: color, position: position })=>`${color} ${position}%`).join(", ")})`;
}
function $2c074f1619da40af$export$dd72788916672863(baseGradient) {
    const parsedResult = $2c074f1619da40af$export$1089ae7f4d02cd2e(baseGradient);
    // base
    const baseColors = parsedResult.colors.map(({ color: color, position: position })=>({
            color: $e7ad24095803362c$exports(color).hex(),
            position: position
        }));
    const base = $2c074f1619da40af$export$fa3c2aee2bc4649c({
        ...parsedResult,
        colors: baseColors
    });
    // subtle
    const subtleColors = parsedResult.colors.map(({ color: color, position: position })=>({
            color: $e7ad24095803362c$exports(color).alpha(0.2).hex(),
            position: position
        }));
    const subtle = $2c074f1619da40af$export$fa3c2aee2bc4649c({
        ...parsedResult,
        colors: subtleColors
    });
    // contrast
    const allContrastColors = parsedResult.colors.map(({ color: color, position: position })=>({
            color: $e7ad24095803362c$exports(color).luminance() > 0.5 ? "#000000" : "#ffffff",
            position: position
        }));
    const contrastColors = allContrastColors.map(({ position: position }, i)=>{
        const base = allContrastColors[0];
        if (i === 0) return base;
        else {
            const color = base.color;
            const chromeColor = $e7ad24095803362c$exports(color);
            const offsetColor = color === "#000000" ? chromeColor.brighten(i + 1).hex() : chromeColor.darken(i + 1).hex();
            return {
                color: offsetColor,
                position: position
            };
        }
    });
    const contrast = $2c074f1619da40af$export$fa3c2aee2bc4649c({
        ...parsedResult,
        colors: contrastColors
    });
    // shade
    const shadeColors = parsedResult.colors.map(({ color: color, position: position })=>({
            color: $e7ad24095803362c$exports(color).darken(0.75).hex(),
            position: position
        }));
    const shade = $2c074f1619da40af$export$fa3c2aee2bc4649c({
        ...parsedResult,
        colors: shadeColors
    });
    // tint
    const tintColors = parsedResult.colors.map(({ color: color, position: position })=>({
            color: $e7ad24095803362c$exports(color).brighten(0.75).hex(),
            position: position
        }));
    const tint = $2c074f1619da40af$export$fa3c2aee2bc4649c({
        ...parsedResult,
        colors: tintColors
    });
    // result
    return {
        base: base,
        subtle: subtle,
        contrast: contrast,
        shade: shade,
        tint: tint
    };
}


let $47a5cf95f263be1c$export$703737d08d9378a3 = class AppGradientPickerComponent extends (0, $2qQ1O.TiniComponent) {
    static #_ = this.defaultTagName = "app-gradient-picker";
    onCreate() {
        addEventListener("click", this.onGlobalClicked);
    }
    onDestroy() {
        removeEventListener("click", this.onGlobalClicked);
    }
    onReady() {
        if (!this.grapickRef.value) return;
        this.grapickInstance = new $867696357e724f83$exports({
            el: this.grapickRef.value
        });
        try {
            const { type: type, direction: direction, colors: colors } = (0, $2c074f1619da40af$export$1089ae7f4d02cd2e)(this.value);
            this.grapickInstance.setType(type);
            this.typeSelectRef.value.value = type;
            this.grapickInstance.setDirection(direction);
            this.directionSelectRef.value.value = direction;
            colors.forEach(({ color: color, position: position })=>{
                this.grapickInstance.addHandler(position, color);
            });
        } catch (err) {
            alert(err.message || "Load gradient failed");
        }
        this.grapickInstance.on("change", ()=>this.valueChanged(this.grapickInstance.getSafeValue()));
    }
    valueChanged(value) {
        this.value = value;
        this.change.emit(value);
    }
    changeType(e) {
        const value = e.target.value;
        this.grapickInstance.setType(value);
    }
    changeDirection(e) {
        const value = e.target.value;
        this.grapickInstance.setDirection(value);
    }
    render() {
        return (0, $fXA0k.html)`<button ${(0, $aShgn.ref)(this.togglerRef)} class="toggler" @click="${()=>this.showed = !this.showed}" style="${(0, $6MkYW.styleMap)({
            background: this.value
        })}"></button><div ${(0, $aShgn.ref)(this.containerRef)} class="${(0, $ogP7Y.classMap)({
            "picker-container": true,
            showed: this.showed
        })}"><div class="grapick"><div ${(0, $aShgn.ref)(this.grapickRef)}></div></div><div class="options"><select ${(0, $aShgn.ref)(this.typeSelectRef)} @change="${this.changeType}"><optgroup label="Type"><option value="linear">Linear</option><option value="radial">Radial</option></optgroup></select> <select ${(0, $aShgn.ref)(this.directionSelectRef)} @change="${this.changeDirection}"><optgroup label="Direction"><option value="top">Top</option><option value="right">Right</option><option value="center">Center</option><option value="bottom">Bottom</option><option value="left">Left</option></optgroup></select></div></div>`;
    }
    static #_1 = this.styles = (0, $cZ4os.css)`.grp-wrapper{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==")}.grp-preview{position:absolute;top:0;left:0;width:100%;height:100%;cursor:crosshair}.grp-handler{width:4px;margin-left:-2px;user-select:none;-webkit-user-select:none;-moz-user-select:none;height:100%}.grp-handler-close{color:rgba(0,0,0,.4);border-radius:100%;box-shadow:0 2px 10px rgba(0,0,0,.25);background-color:#fff;text-align:center;width:15px;height:15px;margin-left:-5px;line-height:10px;font-size:21px;cursor:pointer}.grp-handler-close-c{position:absolute;top:-17px}.grp-handler-drag{background-color:rgba(255,255,255,.35);cursor:col-resize;width:100%;height:100%}.grp-handler-selected .grp-handler-drag{background-color:rgba(255,255,255,.7)}.grp-handler-cp-c{display:none}.grp-handler-selected .grp-handler-cp-c{display:block}.grp-handler-cp-wrap{box-sizing:content-box;width:15px;height:15px;margin-left:-8px;border:3px solid #fff;box-shadow:0 2px 10px rgba(0,0,0,.25);overflow:hidden;border-radius:100%;cursor:pointer}.grp-handler-cp-wrap input[type=color]{opacity:0;cursor:pointer}:host{display:inline;position:relative}.toggler{cursor:pointer;width:50px;height:27px;outline:var(--size-border) solid var(--color-medium);border:4px solid var(--color-background-tint);border-radius:var(--size-radius)}.picker-container{box-sizing:border-box;display:none;position:absolute;top:30px;right:0;background:var(--color-dark-tint);width:230px;border:1px solid var(--color-light-tint);border-radius:var(--size-border);box-shadow:0 0 20px rgba(0,0,0,.3);z-index:101}.picker-container.showed{display:block}.picker-container .grapick{padding:2rem 1.5rem}.picker-container .options{display:flex;justify-content:space-between;gap:.5rem;padding:1rem;background:var(--color-background-tint)}.picker-container .options select{max-width:calc(50% - .5rem);background:var(--color-background-tint);border:var(--size-border) solid var(--color-medium);border-radius:var(--size-radius);padding:var(--size-space-0_25x) var(--size-space-0_5x)}`;
    constructor(...args){
        super(...args);
        this.value = "none";
        this.showed = false;
        this.togglerRef = (0, $aShgn.createRef)();
        this.containerRef = (0, $aShgn.createRef)();
        this.grapickRef = (0, $aShgn.createRef)();
        this.typeSelectRef = (0, $aShgn.createRef)();
        this.directionSelectRef = (0, $aShgn.createRef)();
        this.onGlobalClicked = (e)=>{
            const togglerNode = this.togglerRef.value;
            const containerNode = this.containerRef.value;
            if (!this.showed || !togglerNode || !containerNode) return;
            const togglerRange = togglerNode.getBoundingClientRect();
            const menuContainerRange = containerNode.getBoundingClientRect();
            const isInsideToggler = togglerRange.left <= e.clientX && togglerRange.right >= e.clientX && togglerRange.top <= e.clientY && togglerRange.bottom >= e.clientY;
            const isInsideMenu = menuContainerRange.left <= e.clientX && menuContainerRange.right >= e.clientX && menuContainerRange.top <= e.clientY && menuContainerRange.bottom >= e.clientY;
            this.showed = isInsideToggler || isInsideMenu;
        };
    }
};
(0, $4tSb9.__decorate)([
    (0, $2qQ1O.Input)({
        type: String
    })
], $47a5cf95f263be1c$export$703737d08d9378a3.prototype, "name", void 0);
(0, $4tSb9.__decorate)([
    (0, $2qQ1O.Input)({
        type: String
    })
], $47a5cf95f263be1c$export$703737d08d9378a3.prototype, "value", void 0);
(0, $4tSb9.__decorate)([
    (0, $ecjBI.Output)()
], $47a5cf95f263be1c$export$703737d08d9378a3.prototype, "change", void 0);
(0, $4tSb9.__decorate)([
    (0, $2qQ1O.Reactive)()
], $47a5cf95f263be1c$export$703737d08d9378a3.prototype, "showed", void 0);
$47a5cf95f263be1c$export$703737d08d9378a3 = (0, $4tSb9.__decorate)([
    (0, $aHFKf.Component)({
        theming: {
            styling: (0, $3bQrU.stylingWithBases)([
                (0, $eD4R9.commonBases),
                (0, $eD4R9.formBases)
            ])
        }
    })
], $47a5cf95f263be1c$export$703737d08d9378a3);



var $eoQhH = parcelRequire("eoQhH");
const $b9aad6726b3f5330$export$826128ff895ed268 = [
    // web safe fonts
    [
        "'Arial', sans-serif",
        true
    ],
    [
        "'Verdana', sans-serif",
        true
    ],
    [
        "'Tahoma', sans-serif",
        true
    ],
    [
        "'Trebuchet MS', sans-serif",
        true
    ],
    [
        "'Helvetica', sans-serif",
        true
    ],
    [
        "'Times New Roman', serif",
        true
    ],
    [
        "'Georgia', serif",
        true
    ],
    [
        "'Garamond', serif",
        true
    ],
    [
        "'Palatino', serif",
        true
    ],
    [
        "'Baskerville', serif",
        true
    ],
    [
        "'Brush Script MT', cursive",
        true
    ],
    [
        "'Comic Sans MS', cursive",
        true
    ],
    [
        "'Bradley Hand', cursive",
        true
    ],
    [
        "'Courier', monospace",
        true
    ],
    [
        "'Lucida', monospace",
        true
    ],
    [
        "'Monaco', monospace",
        true
    ],
    // Google fonts
    [
        "'Roboto', sans-serif"
    ],
    [
        "'Open Sans', sans-serif"
    ],
    [
        "'Montserrat', sans-serif"
    ],
    [
        "'Poppins', sans-serif"
    ],
    [
        "'Lato', sans-serif"
    ],
    [
        "'Roboto Slab', serif"
    ],
    [
        "'Playfair Display', serif"
    ],
    [
        "'Merriweather', serif"
    ],
    [
        "'Lora', serif"
    ],
    [
        "'Noto Serif', serif"
    ],
    [
        "'Dancing Script', cursive"
    ],
    [
        "'Pacifico', cursive"
    ],
    [
        "'Lobster', cursive"
    ],
    [
        "'Caveat', cursive"
    ],
    [
        "'Satisfy', cursive"
    ],
    [
        "'Roboto Mono', monospace"
    ],
    [
        "'Source Code Pro', monospace"
    ],
    [
        "'Space Mono', monospace"
    ],
    [
        "'IBM Plex Mono', monospace"
    ],
    [
        "'Ubuntu Mono', monospace"
    ]
];



var $8u3xy = parcelRequire("8u3xy");

const $dea607272d760966$var$debounceAwaiters = {};
function $dea607272d760966$export$12bf26cb720cb002(key, delay, callback) {
    clearTimeout($dea607272d760966$var$debounceAwaiters[key]);
    $dea607272d760966$var$debounceAwaiters[key] = setTimeout(()=>{
        $dea607272d760966$var$debounceAwaiters[key] = null;
        callback();
    }, delay);
}



var $9qEys = parcelRequire("9qEys");

function $2603a2cd6c639d5c$export$36cb45cfcae320ad(rgba, rgb) {
    const result = [
        0,
        0,
        0
    ];
    // default
    rgb = rgb || [
        255,
        255,
        255
    ];
    rgba[3] = rgba[3] || 1;
    // calculate
    result[0] = (1 - rgba[3]) * rgb[0] + rgba[3] * rgba[0];
    result[1] = (1 - rgba[3]) * rgb[1] + rgba[3] * rgba[1];
    result[2] = (1 - rgba[3]) * rgb[2] + rgba[3] * rgba[2];
    // validate
    result[0] = result[0] > 255 ? 255 : result[0];
    result[1] = result[1] > 255 ? 255 : result[1];
    result[2] = result[2] > 255 ? 255 : result[2];
    // result
    return $e7ad24095803362c$exports.rgb(result[0], result[1], result[2]);
}
function $2603a2cd6c639d5c$export$ed4c99a6872b047f(baseColor) {
    const color = $e7ad24095803362c$exports(baseColor);
    const base = color.hex();
    const subtle = color.alpha(0.2).hex();
    const contrast = color.luminance() > 0.5 ? "#000000" : "#ffffff";
    const shade = color.darken(0.75).hex();
    const tint = color.brighten(0.75).hex();
    return {
        base: base,
        subtle: subtle,
        contrast: contrast,
        shade: shade,
        tint: tint
    };
}




const $dead0bd85482d07c$var$FONT_SUPPLIERS_RECORD = (0, $b9aad6726b3f5330$export$826128ff895ed268).reduce((result, [font, webSafe])=>{
    result[font] = webSafe ? "classic" : "google";
    return result;
}, {});
function $dead0bd85482d07c$export$ded0cd93aa1d51d(fonts) {
    const content = fonts.map(({ font: font, weights: weights = [
        "400",
        "700"
    ] })=>{
        const family = font.split(",")[0].replace(/'|"/g, "").replace(/ /g, "+");
        return `family=${family}:wght@${weights.join(";")}`;
    }).join("&");
    return `https://fonts.googleapis.com/css2?${content}&display=swap`;
}
function $dead0bd85482d07c$export$20d54463a2ad43d4(font) {
    return $dead0bd85482d07c$var$FONT_SUPPLIERS_RECORD[font] === "google";
}
function $dead0bd85482d07c$export$a04aa5812aee780d(font, weights) {
    return new Promise((resolve, reject)=>{
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = $dead0bd85482d07c$export$ded0cd93aa1d51d([
            {
                font: font,
                weights: weights
            }
        ]);
        link.addEventListener("load", resolve);
        link.addEventListener("error", reject);
        document.head.appendChild(link);
    });
}



var $laxZI = parcelRequire("laxZI");
let $403498851d023e0c$export$6a145c067349d657 = class AppSkinEditorComponent extends (0, $2qQ1O.TiniComponent) {
    static #_ = this.defaultTagName = "app-skin-editor";
    async onCreate() {
        await this.fetchSkinVariables();
    }
    onChanges() {
        this.groupedSkinVariables = this.buildGroupedSkinVariables();
    }
    buildGroupedSkinVariables() {
        const result = [
            {
                name: "Fonts",
                items: []
            },
            {
                name: "Colors",
                items: []
            },
            {
                name: "Gradients",
                items: []
            },
            {
                name: "Sizes",
                items: []
            },
            {
                name: "Scales",
                items: []
            },
            {
                name: "Wides",
                items: []
            },
            {
                name: "Shadows",
                items: []
            }
        ];
        // group variables
        for (const item of this.variablesMap){
            const [key, def] = item;
            if (key.startsWith("--font")) result[0].items.push(def);
            else if (key.startsWith("--color")) {
                if (!~key.indexOf("-subtle") && !~key.indexOf("-contrast") && !~key.indexOf("-shade") && !~key.indexOf("-tint")) result[1].items.push(def);
            } else if (key.startsWith("--gradient")) {
                if (!~key.indexOf("-subtle") && !~key.indexOf("-contrast") && !~key.indexOf("-shade") && !~key.indexOf("-tint")) result[2].items.push(def);
            } else if (key.startsWith("--size")) result[3].items.push(def);
            else if (key.startsWith("--scale")) result[4].items.push(def);
            else if (key.startsWith("--wide")) result[5].items.push(def);
            else if (key.startsWith("--shadow")) result[6].items.push(def);
        }
        // result
        return result;
    }
    getCurrentTheme() {
        const { theme: theme } = document.body.dataset;
        if (!theme) throw new Error("Invalid theme setup.");
        const [soul, skin] = theme.split("/");
        return {
            soul: soul,
            skin: skin
        };
    }
    async fetchSkinVariables() {
        const { soul: soul, skin: skin } = this.getCurrentTheme();
        this.variablesMap = await (0, $9qEys.extractCSSVariables)(!this.SKIN_URL_RESOLVER ? `${(0, $8u3xy.buildGithubRawUrl)(this.REPO_URL)}/main/styles/${soul}/skins/${skin}.css` : this.SKIN_URL_RESOLVER(soul, skin));
    }
    async changeSoul(e) {
        const soul = this.SOUL_LIST.find((soul)=>soul.id === e.target.value);
        if (soul) {
            await this.fetchSkinVariables();
            (0, $40c9d023f846e0bc$export$e6eb54368342cb84)(`${soul.id}/${soul.skins[0].id}`);
            this.resetSkin();
        }
    }
    resetSkin() {
        document.body.style.cssText = "";
        this.changedVariablesMap.clear();
        this.allInputs.forEach((item)=>{
            const input = item;
            input.value = this.variablesMap.get(input.name)?.valueDirect || "";
        });
    }
    resetSkinWithConfirmation() {
        if (!confirm("All values will be reset?")) return;
        return this.resetSkin();
    }
    showModal() {
        const skinId = this.skinTitle.replace(/[\W_]+/g, "-").toLowerCase();
        const themeId = `${(0, $laxZI.mainStore).activeSoulId}/${skinId}`;
        // extract google fonts and code
        const googleFonts = [];
        const allVariables = [];
        for (const [key, def] of this.variablesMap){
            const value = this.changedVariablesMap.get(key) || def.value;
            allVariables.push(`${key}: ${value};`);
            if (key.startsWith("--font-") && (0, $dead0bd85482d07c$export$20d54463a2ad43d4)(value)) googleFonts.push({
                font: value
            });
        }
        const googleFontCode = !googleFonts.length ? null : `<link rel="stylesheet" href="${(0, $dead0bd85482d07c$export$ded0cd93aa1d51d)(googleFonts)}">`;
        const skinCode = `[data-theme="${themeId}"] {\n  ${allVariables.join("\n  ")}\n}\n`;
        // render modal content
        (0, $fXA0k.render)((0, $fXA0k.html)`
        ${!googleFontCode ? (0, $fXA0k.nothing) : (0, $fXA0k.html)`
              <p>
                Include Google Font stylesheet globally, you can add more
                weights or include italics if needed:
              </p>
              <app-code .code=${googleFontCode}></app-code>
            `}
        <p>
          Copy the code below and save as <code>${skinId}.css</code>. You can
          edit the values further if you wish.
        </p>
        <p>
          To make it the default theme, set the body:
          <code>&lt;body data-theme=&quot;${themeId}&quot;&gt;</code>
        </p>
        <app-code .code=${skinCode}></app-code>
        <div style="width: 100%; height: 2rem"></div>
      `, this.modalContentRef.value);
        // show modal
        this.modalRef.value?.show();
    }
    hideModal() {
        this.modalRef.value?.hide();
        (0, $fXA0k.render)((0, $fXA0k.nothing), this.modalContentRef.value);
    }
    updateVariables(values) {
        values.forEach(([key, value])=>{
            this.changedVariablesMap.set(key, value);
            document.body.style.setProperty(key, value);
        });
    }
    async changeFont(e) {
        const input = e.target;
        const key = input.name;
        const value = input.value;
        if ((0, $dead0bd85482d07c$export$20d54463a2ad43d4)(value)) await (0, $dead0bd85482d07c$export$a04aa5812aee780d)(value);
        this.updateVariables([
            [
                key,
                value
            ]
        ]);
    }
    changeColor(e) {
        const input = e.target;
        const key = input.name;
        const value = input.value;
        return (0, $dea607272d760966$export$12bf26cb720cb002)("AppSkinEditorComponent:change_color", 100, ()=>{
            const { base: base, contrast: contrast, subtle: subtle, shade: shade, tint: tint } = (0, $2603a2cd6c639d5c$export$ed4c99a6872b047f)(value);
            this.updateVariables([
                [
                    key,
                    base
                ],
                [
                    `${key}-subtle`,
                    subtle
                ],
                [
                    `${key}-contrast`,
                    contrast
                ],
                [
                    `${key}-shade`,
                    shade
                ],
                [
                    `${key}-tint`,
                    tint
                ]
            ]);
        });
    }
    changeGradient(e) {
        const input = e.target;
        const key = input.name;
        const value = e.detail;
        return (0, $dea607272d760966$export$12bf26cb720cb002)("AppSkinEditorComponent:change_gradient", 100, ()=>{
            const { base: base, subtle: subtle, contrast: contrast, shade: shade, tint: tint } = (0, $2c074f1619da40af$export$dd72788916672863)(value);
            this.updateVariables([
                [
                    key,
                    base
                ],
                [
                    `${key}-subtle`,
                    subtle
                ],
                [
                    `${key}-contrast`,
                    contrast
                ],
                [
                    `${key}-shade`,
                    shade
                ],
                [
                    `${key}-tint`,
                    tint
                ]
            ]);
        });
    }
    changeValue(e) {
        const input = e.target;
        const key = input.name;
        const value = input.value;
        return (0, $dea607272d760966$export$12bf26cb720cb002)("AppSkinEditorComponent:change_value", 100, ()=>this.updateVariables([
                [
                    key,
                    value
                ]
            ]));
    }
    render() {
        return (0, $fXA0k.html)`<div class="head"><strong class="title">Skin Editor</strong> <button class="reset" @click="${this.resetSkinWithConfirmation}">Reset</button> <button class="close" @click="${()=>(0, $laxZI.mainStore).commit("skinEditorShown", false)}">✕</button></div><div class="body"><section class="naming"><div class="content"><label><span>Custom skin for soul?</span> <select @change="${this.changeSoul}">${this.SOUL_LIST.map((soul)=>(0, $fXA0k.html)`<option value="${soul.id}">${soul.name}</option>`)}</select></label> <label><span>Name your skin:</span> <input type="text" value="${this.skinTitle}" @input="${(e)=>this.skinTitle = e.target.value}"></label></div></section><section class="properties"><strong>Properties</strong><ul class="content">${(0, $tysjU.repeat)(this.groupedSkinVariables, (item)=>item.name, (group)=>(0, $fXA0k.html)`<li class="group"><strong class="group-title">${group.name}</strong><ul>${(0, $tysjU.repeat)(group.items, (item)=>item.key, (item)=>{
                return (0, $fXA0k.html)`<li><div class="key">${item.title}</div><div class="value">${group.name === "Fonts" ? (0, $fXA0k.html)`<select class="field" name="${item.key}" @change="${this.changeFont}"><optgroup label="Classic Fonts">${(0, $b9aad6726b3f5330$export$826128ff895ed268).filter(([, webSafe])=>webSafe).map(([font])=>(0, $fXA0k.html)`<option .value="${font}" .selected="${item.valueDirect === font}">${font.replace(/'|"/g, "")}</option>`)}</optgroup><optgroup label="Google Fonts">${(0, $b9aad6726b3f5330$export$826128ff895ed268).filter(([, webSafe])=>!webSafe).map(([font])=>(0, $fXA0k.html)`<option .value="${font}" .selected="${item.valueDirect === font}">${font.replace(/'|"/g, "")}</option>`)}</optgroup></select>` : group.name === "Colors" ? (0, $fXA0k.html)`<input type="color" class="field" name="${item.key}" .value="${item.valueDirect}" @input="${this.changeColor}">` : group.name === "Gradients" ? (0, $fXA0k.html)`<app-gradient-picker class="field" name="${item.key}" .value="${item.valueDirect}" @change="${this.changeGradient}"></app-gradient-picker>` : (0, $fXA0k.html)`<input type="text" class="field" name="${item.key}" .value="${item.valueDirect}" @input="${this.changeValue}">`}</div></li>`;
            })}
                  </ul>
                </li>
              `)}
          </ul>
        </section>
      </div>

      <div class="foot">
        <tini-button
          class="show-code"
          scheme="primary"
          @click=${this.showModal}
        >
          <icon-code scheme="primary-contrast" scale="sm"></icon-code>
          <span>Show code</span>
        </tini-button>
      </div>

      <app-modal
        ${(0, $aShgn.ref)(this.modalRef)}
        titleText="Custom skin code"
        @no=${this.hideModal}
      >
        <div ${(0, $aShgn.ref)(this.modalContentRef)} class="modal-body"></div>
      </app-modal>
    `;
    }
    static #_1 = this.styles = (0, $cZ4os.css)`:host{--head-height: 50px;--foot-height: 50px;height:100%}.head{display:flex;align-items:center;height:var(--head-height);padding:var(--size-space-0_75x);border-bottom:var(--size-border) solid var(--color-background-shade)}.head .title{flex:1}.head .reset{cursor:pointer;display:flex;align-items:center;padding:var(--size-space-0_4x) var(--size-space-0_8x);margin-right:var(--size-space-2x);background:var(--color-background);color:var(--color-foreground);border:var(--size-border) solid var(--color-foreground);border-radius:var(--size-radius);font-size:var(--size-text-0_9x);line-height:1}.head .reset:hover{background:var(--color-background-shade)}.head .close{cursor:pointer;display:flex;align-items:center;justify-content:center;background:var(--color-background);border:none;opacity:.5}.head .close:hover{opacity:1}.body{height:calc(100% - var(--head-height) - var(--foot-height));height:calc(100% - var(--head-height) - var(--foot-height));overflow-x:hidden;overflow-y:scroll}.body section>strong{display:block;padding:var(--size-space-0_5x);border:var(--size-border) solid var(--color-background-shade);border-left:none;border-right:none;text-align:center}.body section .content{padding:var(--size-space-0_5x);margin-bottom:0}.body .naming{padding:var(--size-space-0_5x);padding-bottom:0}.body .naming label{display:block;margin-bottom:var(--size-space)}.body .naming label span{color:var(--color-medium)}.body .naming label input,.body .naming label select{width:100%;margin-top:var(--size-space-0_25x);background:var(--color-background-tint);border:var(--size-border) solid var(--color-medium);border-radius:var(--size-radius);padding:var(--size-space-0_25x) var(--size-space-0_5x)}.body .properties .group{padding:var(--size-space-0_5x);margin-bottom:var(--size-space)}.body .properties .group .group-title{color:var(--color-medium);text-transform:uppercase}.body .properties .group ul{list-style:none;padding:0;margin:var(--size-space) 0 0}.body .properties .group ul li{display:flex;align-items:center;justify-content:space-between;margin-left:var(--size-space);margin-right:var(--size-space-0_5x);margin-bottom:var(--size-space-0_5x);padding:var(--size-space-0_25x) 0 var(--size-space-0_75x);border-bottom:var(--size-border) solid var(--color-background-shade)}.body .properties .group ul li .value input,.body .properties .group ul li .value select{background:var(--color-background-tint);border:var(--size-border) solid var(--color-medium);border-radius:var(--size-radius);padding:var(--size-space-0_25x) var(--size-space-0_5x)}.body .properties .group ul li .value input{max-width:100px}.body .properties .group ul li .value select{max-width:150px}.body .properties .group ul li .value input[type=color]{padding:0 2px}.body .properties .group ul li .value select,.body .properties .group ul li .value input[type=color]{cursor:pointer}.foot{box-sizing:border-box;display:flex;align-items:center;justify-content:space-between;width:100%;height:var(--foot-height);position:absolute;bottom:0;left:0;border-top:var(--size-border) solid var(--color-background-shade);padding:var(--size-space-0_5x)}.foot tini-button.show-code,.foot tini-button.show-code::part(root){width:100%}.foot tini-button.show-code span{margin-left:var(--size-space-0_5x)}.modal-body{display:block;width:100%;padding:0 2rem}`;
    constructor(...args){
        super(...args);
        this.REPO_URL = (0, $eoQhH.Configurable).getOption("repoUrl");
        this.SOUL_LIST = (0, $eoQhH.Configurable).getOption("soulList");
        this.SKIN_URL_RESOLVER = (0, $eoQhH.Configurable).getOption("skinUrlResolver");
        this.modalRef = (0, $aShgn.createRef)();
        this.modalContentRef = (0, $aShgn.createRef)();
        this.variablesMap = new Map();
        this.changedVariablesMap = new Map();
        this.skinTitle = "Untitled";
    }
};
(0, $4tSb9.__decorate)([
    (0, $2qQ1O.Reactive)()
], $403498851d023e0c$export$6a145c067349d657.prototype, "variablesMap", void 0);
(0, $4tSb9.__decorate)([
    (0, $jcHRM.queryAll)(".field")
], $403498851d023e0c$export$6a145c067349d657.prototype, "allInputs", void 0);
$403498851d023e0c$export$6a145c067349d657 = (0, $4tSb9.__decorate)([
    (0, $aHFKf.Component)({
        components: [
            (0, $8108p.IconCodeComponent),
            (0, $72ISR.TiniButtonComponent),
            (0, $10mzZ.AppCodeComponent),
            (0, $c5j4u.AppModalComponent),
            (0, $47a5cf95f263be1c$export$703737d08d9378a3)
        ],
        theming: {
            styling: (0, $3bQrU.stylingWithBases)([
                (0, $eD4R9.commonBases),
                (0, $eD4R9.buttonBases),
                (0, $eD4R9.codeBases),
                (0, $eD4R9.formBases)
            ])
        }
    })
], $403498851d023e0c$export$6a145c067349d657);


let $d4cd8c7cb248b243$export$cc932d0d04f8c124 = class AppHeaderComponent extends (0, $2qQ1O.TiniComponent) {
    static #_ = this.defaultTagName = "app-header";
    isThemeActivated(soul, skin) {
        return `${soul}/${skin}` === `${this.activeSoulId}/${this.activeSkinId}`;
    }
    switchTheme(e) {
        return (0, $40c9d023f846e0bc$export$e6eb54368342cb84)(e.target.value);
    }
    toggleSkinEditor() {
        return (0, $laxZI.mainStore).commit("skinEditorShown", !(0, $laxZI.mainStore).skinEditorShown);
    }
    render() {
        return (0, $fXA0k.html)`<header><div class="brand"><a href="/"><img src="${this.LOGO_URL}" alt="${this.APP_NAME}"><h1>${this.APP_NAME}<sup>α</sup></h1></a></div><div class="menu"><select class="theme-select" @change="${this.switchTheme}">${this.SOUL_LIST.map(({ id: soulId, name: soulName, skins: skins })=>(0, $fXA0k.html)`<optgroup label="${soulName}">${skins.map(({ id: skinId, name: skinName })=>(0, $fXA0k.html)`<option value="${`${soulId}/${skinId}`}" ?selected="${this.isThemeActivated(soulId, skinId)}">${skinName}</option>`)}</optgroup>`)}</select> <button class="skin-editor-toggler" @click="${this.toggleSkinEditor}"><icon-palette scheme="primary-contrast" scale="sm"></icon-palette><span>Skin Editor</span></button> <a href="${this.REPO_URL}" target="_blank" rel="noopener"><icon-github scheme="primary-contrast" scale="sm"></icon-github></a></div></header><div class="${(0, $ogP7Y.classMap)({
            "skin-editor-container": true,
            showed: this.skinEditorShown
        })}"><app-skin-editor></app-skin-editor></div>`;
    }
    static #_1 = this.styles = (0, $cZ4os.css)`:host{--header-height: 60px}header{display:flex;justify-content:space-between;align-items:center;height:var(--header-height);padding:var(--size-space);background-color:var(--color-primary);color:var(--color-light);box-shadow:var(--shadow-normal)}.brand a{display:flex;flex-wrap:nowrap;align-items:center;color:var(--color-primary-contrast);text-decoration:none;font-family:var(--font-head)}.brand a img{width:1.5rem;height:auto}.brand a h1{margin:0 0 0 .5rem;font-size:1.25rem}.brand a sup{display:inline-block;font-size:var(--size-text-0_85x);margin-left:var(--size-space-0_5x)}.menu{display:flex;align-items:center;gap:var(--size-space-1_5x)}.menu>*{color:var(--color-light);text-decoration:none;background:none;padding:var(--size-space-0_5x);border-radius:var(--size-radius)}.menu>*:hover{background:var(--color-primary-shade)}.theme-select{cursor:pointer;border:var(--size-border) solid var(--color-primary-contrast);color:var(--color-primary-contrast)}.skin-editor-toggler{cursor:pointer;display:flex;align-items:center;background:none;border:none;color:var(--color-primary-contrast)}.skin-editor-toggler span{margin-left:var(--size-space-0_5x)}.skin-editor-container{display:none;box-sizing:border-box;position:fixed;top:var(--header-height);right:0;width:310px;height:calc(100vh - var(--header-height));height:calc(100dvh - var(--header-height));background:var(--color-background);border:var(--size-border) solid var(--color-background-shade);box-shadow:var(--shadow-normal)}.skin-editor-container.showed{display:block}`;
    constructor(...args){
        super(...args);
        this.APP_NAME = (0, $eoQhH.Configurable).getOption("appName");
        this.LOGO_URL = (0, $eoQhH.Configurable).getOption("logoUrl");
        this.REPO_URL = (0, $eoQhH.Configurable).getOption("repoUrl");
        this.SOUL_LIST = (0, $eoQhH.Configurable).getOption("soulList");
        this.activeSoulId = (0, $laxZI.mainStore).activeSoulId;
        this.activeSkinId = (0, $laxZI.mainStore).activeSkinId;
        this.skinEditorShown = (0, $laxZI.mainStore).skinEditorShown;
    }
};
(0, $4tSb9.__decorate)([
    (0, $9xVr6.Subscribe)((0, $laxZI.mainStore)),
    (0, $2qQ1O.Reactive)()
], $d4cd8c7cb248b243$export$cc932d0d04f8c124.prototype, "activeSoulId", void 0);
(0, $4tSb9.__decorate)([
    (0, $9xVr6.Subscribe)((0, $laxZI.mainStore)),
    (0, $2qQ1O.Reactive)()
], $d4cd8c7cb248b243$export$cc932d0d04f8c124.prototype, "activeSkinId", void 0);
(0, $4tSb9.__decorate)([
    (0, $9xVr6.Subscribe)((0, $laxZI.mainStore)),
    (0, $2qQ1O.Reactive)()
], $d4cd8c7cb248b243$export$cc932d0d04f8c124.prototype, "skinEditorShown", void 0);
$d4cd8c7cb248b243$export$cc932d0d04f8c124 = (0, $4tSb9.__decorate)([
    (0, $aHFKf.Component)({
        components: [
            (0, $6uvK4.IconGithubComponent),
            (0, $017c8f393c20ff5d$export$e5fbeffb5d035129),
            (0, $403498851d023e0c$export$6a145c067349d657)
        ],
        theming: {
            styling: (0, $3bQrU.stylingWithBases)([
                (0, $eD4R9.commonBases),
                (0, $eD4R9.linkBases),
                (0, $eD4R9.buttonBases),
                (0, $eD4R9.formBases)
            ])
        }
    })
], $d4cd8c7cb248b243$export$cc932d0d04f8c124);



var $4tSb9 = parcelRequire("4tSb9");
parcelRequire("lYoPT");
var $cZ4os = parcelRequire("cZ4os");
var $fXA0k = parcelRequire("fXA0k");
parcelRequire("1mUAS");
var $aHFKf = parcelRequire("aHFKf");
var $3bQrU = parcelRequire("3bQrU");
var $2qQ1O = parcelRequire("2qQ1O");

var $eD4R9 = parcelRequire("eD4R9");

var $7AtUt = parcelRequire("7AtUt");

var $eoQhH = parcelRequire("eoQhH");
let $fdb490ee5a2ea435$export$3b78413f8883078d = class AppMenuComponent extends (0, $2qQ1O.TiniComponent) {
    static #_ = this.defaultTagName = "app-menu";
    buildMenu() {
        const processRoute = ({ path: path, title: title })=>{
            const pathSegments = path.split("/").filter(Boolean);
            const linkTitle = title || (pathSegments[pathSegments.length - 1] || "untitled").replace(/-|_/g, " ").split(" ").map((word)=>word[0].toUpperCase() + word.slice(1)).join(" ");
            for (const groupName of this.GROUP_NAMES){
                if (!this.groups[groupName]) this.groups[groupName] = {
                    title: groupName === "top" ? undefined : groupName.toUpperCase(),
                    items: []
                };
                if (path !== "**" && (~path.indexOf(`${groupName}/`) || groupName === "top" && pathSegments.length < 2)) {
                    this.groups[groupName]?.items.push({
                        title: linkTitle,
                        href: !path ? "/" : `/${path}`
                    });
                    break;
                }
            }
        };
        this.ROUTES.forEach((route)=>{
            if (!route.children?.length) processRoute(route);
            else route.children.forEach((child)=>processRoute(child));
        });
    }
    onCreate() {
        this.buildMenu();
    }
    render() {
        return (0, $fXA0k.html)`<h4>Documentation</h4><ul>${Object.entries(this.groups).map(([groupName, { title: title, items: items }])=>{
            return !title ? (0, $fXA0k.html)`${items.map(({ title: title, href: href })=>(0, $fXA0k.html)`<li><tini-link href="${href}" active="active">${title}</tini-link></li>`)}` : (0, $fXA0k.html)`<li><strong class="title">${title}</strong><ul>${items.map(({ title: title, href: href })=>(0, $fXA0k.html)`<li><tini-link href="${href}" active="active">${title}</tini-link></li>`)}</ul></li>`;
        })}
      </ul>
    `;
    }
    static #_1 = this.styles = (0, $cZ4os.css)`:host{padding:1rem}ul{margin:0;padding:0;list-style:none}li{padding:.75rem 1rem}li .title{display:block;margin-bottom:.5rem;color:var(--color-medium)}tini-link::part(root){color:var(--color-foreground)}tini-link.active::part(root){font-weight:bold;text-decoration:underline}`;
    constructor(...args){
        super(...args);
        this.ROUTES = (0, $eoQhH.Configurable).getOption("routes");
        this.GROUP_NAMES = [
            "top",
            "guides",
            "components",
            "icons"
        ];
        this.groups = {};
    }
};
$fdb490ee5a2ea435$export$3b78413f8883078d = (0, $4tSb9.__decorate)([
    (0, $aHFKf.Component)({
        components: [
            (0, $7AtUt.TiniLinkComponent)
        ],
        theming: {
            styling: (0, $3bQrU.stylingWithBases)([
                (0, $eD4R9.commonBases),
                (0, $eD4R9.headingsBases),
                (0, $eD4R9.linkBases),
                (0, $eD4R9.textBases)
            ])
        }
    })
], $fdb490ee5a2ea435$export$3b78413f8883078d);


let $9fa597fde14d0b34$export$6d75a7f5adc96338 = class AppLayoutDefault extends (0, $2qQ1O.TiniComponent) {
    render() {
        return (0, $fXA0k.html)`<header class="header"><app-header></app-header></header><nav class="menu"><app-menu></app-menu></nav><main class="page"><slot></slot></main>`;
    }
    static #_ = this.styles = (0, $cZ4os.css)`:host{--header-height: 60px;display:grid;grid:"header header header" var(--header-height) "menu page ads" auto/1fr 4fr 1fr}.header{grid-area:header;position:sticky;top:0;left:0;z-index:1;height:60px}.menu,.page{height:calc(100vh - var(--header-height));height:calc(100dvh - var(--header-height));overflow-x:hidden;overflow-y:scroll;-ms-overflow-style:none;scrollbar-width:none}.menu::-webkit-scrollbar,.page::-webkit-scrollbar{display:none}.menu{grid-area:menu;border-right:1px solid var(--color-background-shade);box-shadow:var(--shadow-normal)}.page{grid-area:page;padding:1rem 7rem}`;
};
$9fa597fde14d0b34$export$6d75a7f5adc96338 = (0, $4tSb9.__decorate)([
    (0, $aHFKf.Layout)({
        name: "app-layout-default",
        components: [
            (0, $d4cd8c7cb248b243$export$cc932d0d04f8c124),
            (0, $fdb490ee5a2ea435$export$3b78413f8883078d)
        ],
        theming: {
            styling: (0, $3bQrU.stylingWithBases)([
                (0, $eD4R9.commonBases)
            ])
        }
    })
], $9fa597fde14d0b34$export$6d75a7f5adc96338);


class $ea56f1c2a7b79337$export$9bb29da23d7034a8 extends (0, $2qQ1O.TiniComponent) {
    onCreate() {
        (0, $40c9d023f846e0bc$export$4c47704ed26c13e8)();
    }
    render() {
        return (0, $fXA0k.html)`<router-outlet .router="${this.router}"></router-outlet>`;
    }
    constructor(...args){
        super(...args);
        this.router = (0, $3f5fa8c9d192f0ac$export$baddd0131ee8c05b)((0, $eoQhH.Configurable).getOption("routes"), {
            linkTrigger: true
        });
    }
}


let $d7654d56d5edcac7$export$410da74226573775 = class AppRoot extends (0, $ea56f1c2a7b79337$export$9bb29da23d7034a8) {
};
$d7654d56d5edcac7$export$410da74226573775 = (0, $4tSb9.__decorate)([
    (0, $aHFKf.App)({
    })
], $d7654d56d5edcac7$export$410da74226573775);

})();
//# sourceMappingURL=index.e64c078a.js.map
